import { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** Decimal custom scalar that returns string */
  Decimal: { input: any; output: any; }
};

export enum AcademicLevel {
  HIGH_SCHOOL = 'HIGH_SCHOOL',
  PRIMARY = 'PRIMARY',
  UNIVERSITY = 'UNIVERSITY'
}

export type AccessLoggerAndroidDataType = {
  __typename?: 'AccessLoggerAndroidDataType';
  androidId?: Maybe<Scalars['String']['output']>;
  board?: Maybe<Scalars['String']['output']>;
  bootloader?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  hardware?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isPhysicalDevice?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  supported32BitAbis?: Maybe<Array<Scalars['String']['output']>>;
  supported64BitAbis?: Maybe<Array<Scalars['String']['output']>>;
  supportedAbis?: Maybe<Array<Scalars['String']['output']>>;
  systemFeatures?: Maybe<Array<Scalars['String']['output']>>;
  tags?: Maybe<Scalars['String']['output']>;
  versionBaseOS?: Maybe<Scalars['String']['output']>;
  versionCodename?: Maybe<Scalars['String']['output']>;
  versionIncremental?: Maybe<Scalars['String']['output']>;
  versionPreviewSdkInt?: Maybe<Scalars['String']['output']>;
  versionRelease?: Maybe<Scalars['String']['output']>;
  versionSdkInt?: Maybe<Scalars['String']['output']>;
  versionSecurityPatch?: Maybe<Scalars['String']['output']>;
};

export type AccessLoggerClientDataType = {
  __typename?: 'AccessLoggerClientDataType';
  clientType?: Maybe<Scalars['String']['output']>;
  engine?: Maybe<Scalars['String']['output']>;
  engineVersion?: Maybe<Scalars['String']['output']>;
  family?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type AccessLoggerDeviceDataType = {
  __typename?: 'AccessLoggerDeviceDataType';
  androidData: AccessLoggerAndroidDataType;
  client: AccessLoggerClientDataType;
  device: AccessLoggerMachineDataType;
  iosData: AccessLoggerIosDataType;
  os: AccessLoggerOperatingSystemDataType;
};

export type AccessLoggerIosDataType = {
  __typename?: 'AccessLoggerIosDataType';
  identifierForVendor?: Maybe<Scalars['String']['output']>;
  isPhysicalDevice?: Maybe<Scalars['String']['output']>;
  localizedModel?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  systemName?: Maybe<Scalars['String']['output']>;
  systemVersion?: Maybe<Scalars['String']['output']>;
  utsnameMachine?: Maybe<Scalars['String']['output']>;
  utsnameNodename?: Maybe<Scalars['String']['output']>;
  utsnameRelease?: Maybe<Scalars['String']['output']>;
  utsnameSysname?: Maybe<Scalars['String']['output']>;
  utsnameVersion?: Maybe<Scalars['String']['output']>;
};

export type AccessLoggerMachineDataType = {
  __typename?: 'AccessLoggerMachineDataType';
  brand?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
};

export type AccessLoggerOperatingSystemDataType = {
  __typename?: 'AccessLoggerOperatingSystemDataType';
  brand?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type AccessLoggerRequestType = {
  __typename?: 'AccessLoggerRequestType';
  host?: Maybe<Scalars['String']['output']>;
  hostname?: Maybe<Scalars['String']['output']>;
  operationName: Scalars['String']['output'];
  origin?: Maybe<Scalars['String']['output']>;
  pathname?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['String']['output']>;
  protocol?: Maybe<Scalars['String']['output']>;
  query: Scalars['String']['output'];
  referer?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  variables?: Maybe<Scalars['String']['output']>;
};

export type AccountInput = {
  expiresAt: Scalars['DateTime']['input'];
  permissions?: InputMaybe<Array<Scalars['ID']['input']>>;
  target: TargetAciInput;
  user: Scalars['ID']['input'];
};

export type AccountPaginateType = {
  __typename?: 'AccountPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<AccountType>;
};

export type AccountType = {
  __typename?: 'AccountType';
  createdAt: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  permission?: Maybe<PermissionType>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type AccountUpdateInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  permissions?: InputMaybe<Array<Scalars['ID']['input']>>;
  target?: InputMaybe<TargetAciInput>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type AccountsByRoleCountType = {
  __typename?: 'AccountsByRoleCountType';
  numberOfAccounts: Scalars['Int']['output'];
  role: UserRole;
};

export type AccountsCountType = {
  __typename?: 'AccountsCountType';
  total: Scalars['Int']['output'];
  totalNumberOfManufacturerAccounts: Scalars['Int']['output'];
  totalNumberOfPosAccounts: Scalars['Int']['output'];
  totalNumberOfWholesalerAccounts: Scalars['Int']['output'];
};

export type AccountsWithStatsType = {
  __typename?: 'AccountsWithStatsType';
  createdAt: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  hours?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['ID']['output'];
  permission?: Maybe<PermissionType>;
  progress?: Maybe<Scalars['Decimal']['output']>;
  target: TargetType;
  tasks?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type ActionType = {
  __typename?: 'ActionType';
  activity?: Maybe<Scalars['String']['output']>;
  adhocNotification?: Maybe<AdhocNotificationType>;
  adhocOrder?: Maybe<Scalars['String']['output']>;
  booking?: Maybe<BookingType>;
  internalProduct?: Maybe<Scalars['String']['output']>;
  onsite?: Maybe<NotificationOnsiteConverterType>;
  order?: Maybe<Scalars['String']['output']>;
  quest?: Maybe<Scalars['String']['output']>;
  reputationLoss?: Maybe<Scalars['Float']['output']>;
  subscription?: Maybe<Scalars['String']['output']>;
  table?: Maybe<Scalars['String']['output']>;
};

export enum ActionTypeEnum {
  APPLE_LOGIN = 'APPLE_LOGIN',
  COUPON_REDEEMED = 'COUPON_REDEEMED',
  EMPTY_SHOPPING_CART_FOR_TARGET = 'EMPTY_SHOPPING_CART_FOR_TARGET',
  FACEBOOK_LOGIN = 'FACEBOOK_LOGIN',
  GOOGLE_LOGIN = 'GOOGLE_LOGIN',
  LINK_USER_ACCOUNT = 'LINK_USER_ACCOUNT',
  LOGGED_OUT_BY_TARGET = 'LOGGED_OUT_BY_TARGET',
  LOGGED_OUT_FOR_TARGET = 'LOGGED_OUT_FOR_TARGET',
  LOGIN = 'LOGIN',
  LOGIN_BY_TARGET = 'LOGIN_BY_TARGET',
  LOGIN_FOR_APP = 'LOGIN_FOR_APP',
  LOGIN_FOR_TARGET = 'LOGIN_FOR_TARGET',
  ORDER_CANCELED = 'ORDER_CANCELED',
  ORDER_CREATED = 'ORDER_CREATED',
  ORDER_CREATED_AND_USER_REGISTERED_FOR_TARGET = 'ORDER_CREATED_AND_USER_REGISTERED_FOR_TARGET',
  ORDER_CREATED_FOR_GUEST_USER = 'ORDER_CREATED_FOR_GUEST_USER',
  ORDER_PAID = 'ORDER_PAID',
  PRODUCTS_ADDED_TO_SHOPPING_CART = 'PRODUCTS_ADDED_TO_SHOPPING_CART',
  PRODUCTS_REMOVED_FROM_SHOPPING_CART = 'PRODUCTS_REMOVED_FROM_SHOPPING_CART',
  PRODUCT_CANCELED = 'PRODUCT_CANCELED',
  PRODUCT_CONFIRMED = 'PRODUCT_CONFIRMED',
  PRODUCT_DELIVERED = 'PRODUCT_DELIVERED',
  PRODUCT_OPENED = 'PRODUCT_OPENED',
  PRODUCT_RATED = 'PRODUCT_RATED',
  REGISTER = 'REGISTER',
  REGISTER_FOR_APP = 'REGISTER_FOR_APP',
  REGISTER_FOR_TARGET = 'REGISTER_FOR_TARGET',
  REGISTER_FOR_TARGET_WITH_ONBOARD = 'REGISTER_FOR_TARGET_WITH_ONBOARD',
  SEND_FORGOT_PASSWORD_MAIL_TO_TARGET = 'SEND_FORGOT_PASSWORD_MAIL_TO_TARGET',
  SEND_FORGOT_PASSWORD_SMS_TO_TARGET = 'SEND_FORGOT_PASSWORD_SMS_TO_TARGET',
  SEND_VALIDATION_EMAIL_LOG = 'SEND_VALIDATION_EMAIL_LOG',
  SEND_VALIDATION_SMS_LOG = 'SEND_VALIDATION_SMS_LOG',
  UPDATE_PASSWORD_FOR_TARGET = 'UPDATE_PASSWORD_FOR_TARGET',
  UPDATE_USER = 'UPDATE_USER',
  VALIDATE_EMAIL_FOR_TARGET = 'VALIDATE_EMAIL_FOR_TARGET',
  VALIDATE_SMS_CODE = 'VALIDATE_SMS_CODE'
}

export type ActivityLogActionType = {
  __typename?: 'ActivityLogActionType';
  activity?: Maybe<QuestActivityType>;
  order?: Maybe<MarketPlaceOrderDtoType>;
  quest?: Maybe<QuestType>;
};

export type ActivityLogAffectedType = {
  __typename?: 'ActivityLogAffectedType';
  manufacturer?: Maybe<ManufacturerType>;
  pos?: Maybe<PointOfSaleType>;
  user?: Maybe<UserType>;
  wholesaler?: Maybe<WholesalerType>;
};

export type ActivityLogBalanceAmountType = {
  __typename?: 'ActivityLogBalanceAmountType';
  qualitative?: Maybe<Scalars['Decimal']['output']>;
  quantitative?: Maybe<Scalars['Decimal']['output']>;
};

export type ActivityLogBalanceType = {
  __typename?: 'ActivityLogBalanceType';
  amount?: Maybe<ActivityLogBalanceAmountType>;
  sign: TaxSignEnum;
};

export type ActivityLogType = {
  __typename?: 'ActivityLogType';
  action?: Maybe<ActivityLogActionType>;
  activityType?: Maybe<ActivityLogTypeEnum>;
  affected?: Maybe<ActivityLogAffectedType>;
  balance?: Maybe<ActivityLogBalanceType>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  target?: Maybe<ActivityLogAffectedType>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ActivityLogTypeEnum {
  CONVERSION = 'CONVERSION',
  DEAL_ORDER_ADDED = 'DEAL_ORDER_ADDED',
  MOBILE_ONSITE_ACTIVITY = 'MOBILE_ONSITE_ACTIVITY',
  ORDER_ADDED = 'ORDER_ADDED',
  PHYSICAL_ONSITE_ACTIVITY = 'PHYSICAL_ONSITE_ACTIVITY',
  QUEST_FULFILLED = 'QUEST_FULFILLED',
  REDEEM = 'REDEEM',
  REPUTATION_LOST = 'REPUTATION_LOST',
  WALLET_TOPUP = 'WALLET_TOPUP',
  WEB_ONSITE_ACTIVITY = 'WEB_ONSITE_ACTIVITY'
}

export type ActivityTypeDonationInput = {
  cause?: InputMaybe<Scalars['ID']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityTypeDonationType = {
  __typename?: 'ActivityTypeDonationType';
  cause?: Maybe<CauseType>;
  enable?: Maybe<Scalars['Boolean']['output']>;
};

export type ActivityTypeInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<ActivityTypeDonationInput>;
  icon?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  predefined?: InputMaybe<PredefinedActionInput>;
  target?: InputMaybe<TargetAciInput>;
  theme?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityTypePaginateType = {
  __typename?: 'ActivityTypePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ActivityTypeType>;
};

export type ActivityTypeType = {
  __typename?: 'ActivityTypeType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  donation?: Maybe<ActivityTypeDonationType>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<MediaType>;
  predefined?: Maybe<PredefinedActionType>;
  target?: Maybe<TargetType>;
  theme?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ActivityTypeUpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<ActivityTypeDonationInput>;
  icon?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  predefined?: InputMaybe<PredefinedActionInput>;
  target?: InputMaybe<TargetAciInput>;
  theme?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityTypeWithActiveStatusPaginateType = {
  __typename?: 'ActivityTypeWithActiveStatusPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ActivityTypeWithActiveStatusType>;
};

export type ActivityTypeWithActiveStatusType = {
  __typename?: 'ActivityTypeWithActiveStatusType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  donation?: Maybe<ActivityTypeDonationType>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<MediaType>;
  predefined?: Maybe<PredefinedActionType>;
  theme?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AddReputationInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  frequencyGoalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  inactivityCycle?: InputMaybe<Scalars['Int']['input']>;
  lossAmount?: InputMaybe<Scalars['Int']['input']>;
  lossPoints?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<Scalars['Int']['input']>;
  perks?: InputMaybe<PerksInput>;
  picture?: InputMaybe<PictureInput>;
  points?: InputMaybe<Scalars['Int']['input']>;
  reputationLevel?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  translation?: InputMaybe<Array<ReputationTranslationInput>>;
  turnoverGoalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  turnoverPoints?: InputMaybe<Scalars['Int']['input']>;
};

export type AdhocCorporateNotificationTestType = {
  __typename?: 'AdhocCorporateNotificationTestType';
  action?: Maybe<CorporateActionType>;
  event?: Maybe<EventTypeEnum>;
  executed?: Maybe<Scalars['Boolean']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  seen?: Maybe<Scalars['Boolean']['output']>;
};

export type AdhocCorporateNotificationType = {
  __typename?: 'AdhocCorporateNotificationType';
  description?: Maybe<Scalars['String']['output']>;
  executed?: Maybe<Scalars['Boolean']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  picture?: Maybe<PictureType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AdhocNotificationTestType = {
  __typename?: 'AdhocNotificationTestType';
  action?: Maybe<ActionType>;
  event?: Maybe<EventTypeEnum>;
  executed?: Maybe<Scalars['Boolean']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  seen?: Maybe<Scalars['Boolean']['output']>;
};

export type AdhocNotificationType = {
  __typename?: 'AdhocNotificationType';
  description?: Maybe<Scalars['String']['output']>;
  executed?: Maybe<Scalars['Boolean']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  picture?: Maybe<PictureType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AmountPercentageDecimalType = {
  __typename?: 'AmountPercentageDecimalType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  percentage?: Maybe<Scalars['Decimal']['output']>;
};

export type AnalyticsAudienceMetricsChartType = {
  __typename?: 'AnalyticsAudienceMetricsChartType';
  conversions: Array<Scalars['Decimal']['output']>;
  impressions: Array<Scalars['Decimal']['output']>;
};

export type AnalyticsAudienceSessionsByCountryChartDataType = {
  __typename?: 'AnalyticsAudienceSessionsByCountryChartDataType';
  value?: Maybe<Scalars['Int']['output']>;
  week?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsRateCompareType = {
  __typename?: 'AnalyticsRateCompareType';
  compare: Scalars['Decimal']['output'];
  rate: Scalars['Decimal']['output'];
};

export type AnalyticsStatsInfoType = {
  __typename?: 'AnalyticsStatsInfoType';
  percentage: Scalars['Decimal']['output'];
  value: Scalars['Decimal']['output'];
};

export type AnalyticsTopOperatingSystemSegmentType = {
  __typename?: 'AnalyticsTopOperatingSystemSegmentType';
  color: Scalars['String']['output'];
  source: Scalars['String']['output'];
  value: Scalars['Decimal']['output'];
};

export type AnalyticsUsersByCountryLayersType = {
  __typename?: 'AnalyticsUsersByCountryLayersType';
  coordination?: Maybe<LatLngType>;
  radius?: Maybe<Scalars['Float']['output']>;
};

export type AnalyticsUsersByCountrySegmentsType = {
  __typename?: 'AnalyticsUsersByCountrySegmentsType';
  conversions?: Maybe<Scalars['Float']['output']>;
  country: CountryType;
  impressions?: Maybe<Scalars['Float']['output']>;
};

export type AnalyticsUsersByDeviceDeviceType = {
  __typename?: 'AnalyticsUsersByDeviceDeviceType';
  compare: Scalars['Decimal']['output'];
  value: Scalars['Int']['output'];
};

export type AndroidDataType = {
  __typename?: 'AndroidDataType';
  androidId?: Maybe<Scalars['String']['output']>;
  board?: Maybe<Scalars['String']['output']>;
  bootloader?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  hardware?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isPhysicalDevice?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  supported32BitAbis?: Maybe<Array<Scalars['String']['output']>>;
  supported64BitAbis?: Maybe<Array<Scalars['String']['output']>>;
  supportedAbis?: Maybe<Array<Scalars['String']['output']>>;
  systemFeatures?: Maybe<Array<Scalars['String']['output']>>;
  tags?: Maybe<Scalars['String']['output']>;
  versionBaseOS?: Maybe<Scalars['String']['output']>;
  versionCodename?: Maybe<Scalars['String']['output']>;
  versionIncremental?: Maybe<Scalars['String']['output']>;
  versionPreviewSdkInt?: Maybe<Scalars['String']['output']>;
  versionRelease?: Maybe<Scalars['String']['output']>;
  versionSdkInt?: Maybe<Scalars['String']['output']>;
  versionSecurityPatch?: Maybe<Scalars['String']['output']>;
};

export type AnswerDtoType = {
  __typename?: 'AnswerDtoType';
  answers: ResponseAnswerType;
  count: Scalars['Int']['output'];
};

export enum ApiMethods {
  DELETE = 'DELETE',
  GET = 'GET',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS',
  PATCH = 'PATCH',
  POST = 'POST',
  PUT = 'PUT'
}

export type ApiReturnType = {
  __typename?: 'ApiReturnType';
  headers: Scalars['String']['output'];
  request: Scalars['String']['output'];
  status: Scalars['Float']['output'];
  statusText: Scalars['String']['output'];
};

export type ApiTargetType = {
  __typename?: 'ApiTargetType';
  coach?: Maybe<Scalars['Int']['output']>;
  player?: Maybe<Scalars['Int']['output']>;
};

export enum App {
  BOSK = 'BOSK',
  COCKPIT = 'COCKPIT',
  DIKTUP = 'DIKTUP',
  FIGAMY = 'FIGAMY',
  MAGARI = 'MAGARI',
  QUENEY = 'QUENEY',
  RECOLDA = 'RECOLDA',
  SIFCA = 'SIFCA',
  SKUAD = 'SKUAD'
}

export type AppFollowTopChartType = {
  __typename?: 'AppFollowTopChartType';
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  genre?: Maybe<TopChartGenreType>;
  id: Scalars['ID']['output'];
  leaderboard?: Maybe<Array<TopChartLeaderboardType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AppTweakTopChartLeaderboardType = {
  __typename?: 'AppTweakTopChartLeaderboardType';
  developer?: Maybe<Scalars['String']['output']>;
  devices?: Maybe<Array<Scalars['String']['output']>>;
  genres?: Maybe<Array<Scalars['String']['output']>>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  in_apps?: Maybe<Scalars['Boolean']['output']>;
  power?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  ratings_count?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AppTweakTopChartType = {
  __typename?: 'AppTweakTopChartType';
  appType: ChartAppTypeEnum;
  country: CountryType;
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  genre?: Maybe<TopChartGenreType>;
  id: Scalars['ID']['output'];
  leaderboard?: Maybe<Array<AppTweakTopChartLeaderboardType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AppleDataType = {
  __typename?: 'AppleDataType';
  authorizationCode?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  identityToken: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  userIdentifier?: Maybe<Scalars['String']['output']>;
};

export type AssigneeDtoType = {
  __typename?: 'AssigneeDtoType';
  manufacturer?: Maybe<ManufacturerType>;
  pos?: Maybe<PointOfSaleType>;
  user?: Maybe<UserType>;
  wholesaler?: Maybe<WholesalerType>;
};

export type AttributeBaseType = {
  __typename?: 'AttributeBaseType';
  createdAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isMultipleChoice?: Maybe<Scalars['Boolean']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  pixel?: Maybe<AttributePixelType>;
  translation?: Maybe<Array<AttributeTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  variety?: Maybe<ProductVarietyEnum>;
};

export type AttributePixelType = {
  __typename?: 'AttributePixelType';
  pixelAttribute?: Maybe<Scalars['String']['output']>;
};

export type AttributeRawBaseType = {
  __typename?: 'AttributeRawBaseType';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type AttributeTranslationContentType = {
  __typename?: 'AttributeTranslationContentType';
  label: Scalars['String']['output'];
};

export type AttributeTranslationType = {
  __typename?: 'AttributeTranslationType';
  content: AttributeTranslationContentType;
  language: LanguageType;
};

export type AttributeType = {
  __typename?: 'AttributeType';
  createdAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isMultipleChoice?: Maybe<Scalars['Boolean']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  pixel?: Maybe<AttributePixelType>;
  target?: Maybe<TargetType>;
  translation?: Maybe<Array<AttributeTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  variety?: Maybe<ProductVarietyEnum>;
};

export type AttributeValueBaseRawType = {
  __typename?: 'AttributeValueBaseRawType';
  attribute: AttributeBaseType;
  createdAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
  publicPrice?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<AttributeValueTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AttributeValueBaseType = {
  __typename?: 'AttributeValueBaseType';
  createdAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
  publicPrice?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<AttributeValueTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AttributeValueFilterType = {
  __typename?: 'AttributeValueFilterType';
  attribute: AttributeRawBaseType;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
  publicPrice?: Maybe<Scalars['Decimal']['output']>;
};

export type AttributeValueTranslationContentType = {
  __typename?: 'AttributeValueTranslationContentType';
  label: Scalars['String']['output'];
};

export type AttributeValueTranslationType = {
  __typename?: 'AttributeValueTranslationType';
  content: AttributeValueTranslationContentType;
  language: LanguageType;
};

export type AttributeValueType = {
  __typename?: 'AttributeValueType';
  attribute: AttributeType;
  createdAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
  publicPrice?: Maybe<Scalars['Decimal']['output']>;
  target: TargetType;
  translation?: Maybe<Array<AttributeValueTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AttributeWithAttributeValueType = {
  __typename?: 'AttributeWithAttributeValueType';
  createdAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isMultipleChoice?: Maybe<Scalars['Boolean']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  pixel?: Maybe<AttributePixelType>;
  productAttributesValues?: Maybe<Array<AttributeValueBaseType>>;
  target?: Maybe<TargetType>;
  translation?: Maybe<Array<AttributeTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  variety?: Maybe<ProductVarietyEnum>;
};

export type AttributeWithValueFilterType = {
  __typename?: 'AttributeWithValueFilterType';
  attributeValues?: Maybe<Array<FilterLabelFieldType>>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type AttributesValidationType = {
  __typename?: 'AttributesValidationType';
  headersValid?: Maybe<Scalars['Boolean']['output']>;
  isIdComplete?: Maybe<Scalars['Boolean']['output']>;
  isLabelComplete?: Maybe<Scalars['Boolean']['output']>;
  isMultipleComplete?: Maybe<Scalars['Boolean']['output']>;
  isRequiredComplete?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  overallValidation?: Maybe<Scalars['Boolean']['output']>;
};

export type AttributesValuesValidationType = {
  __typename?: 'AttributesValuesValidationType';
  headersValid?: Maybe<Scalars['Boolean']['output']>;
  isAttributeComplete?: Maybe<Scalars['Boolean']['output']>;
  isIdComplete?: Maybe<Scalars['Boolean']['output']>;
  isValueComplete?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  overallValidation?: Maybe<Scalars['Boolean']['output']>;
};

export enum AudienceCriteriaFieldEnum {
  ABANDONED_CARTS = 'ABANDONED_CARTS',
  ACTIVITY_FREQUENCY = 'ACTIVITY_FREQUENCY',
  AGE = 'AGE',
  BIG_SPENDERS = 'BIG_SPENDERS',
  COUNTRY = 'COUNTRY',
  DISCOUNT_SEEKER = 'DISCOUNT_SEEKER',
  EDUCATION = 'EDUCATION',
  FREQUENT_SHOPPERS = 'FREQUENT_SHOPPERS',
  GENDER = 'GENDER',
  HOBBIES = 'HOBBIES',
  INTERESTS = 'INTERESTS',
  JOIN_DATE = 'JOIN_DATE',
  JOIN_DURATION = 'JOIN_DURATION',
  LANGUAGE = 'LANGUAGE',
  LAPSED_CUSTOMERS = 'LAPSED_CUSTOMERS',
  LOCATION = 'LOCATION',
  MARITAL_STATUS = 'MARITAL_STATUS',
  OCCUPATION = 'OCCUPATION',
  PRODUCT_CATEGORY = 'PRODUCT_CATEGORY',
  QUANTITATIVE_CURRENT = 'QUANTITATIVE_CURRENT',
  QUANTITATIVE_OVERALL = 'QUANTITATIVE_OVERALL',
  QUEST_ACTION = 'QUEST_ACTION',
  REPUTATION_LEVEL = 'REPUTATION_LEVEL',
  SEASONAL_SHOPPERS = 'SEASONAL_SHOPPERS',
  STATE = 'STATE'
}

export type AudienceCriteriaFieldInput = {
  field?: InputMaybe<AudienceCriteriaFieldEnum>;
  operators?: InputMaybe<Array<OperatorEnum>>;
};

export type AudienceCriteriaFieldType = {
  __typename?: 'AudienceCriteriaFieldType';
  field?: Maybe<AudienceCriteriaFieldEnum>;
  operators?: Maybe<Array<OperatorEnum>>;
};

export type AudienceCriteriaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<Array<AudienceCriteriaFieldInput>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  style?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AudienceCriteriaPaginateType = {
  __typename?: 'AudienceCriteriaPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<AudienceCriteriaType>;
};

export type AudienceCriteriaType = {
  __typename?: 'AudienceCriteriaType';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enable?: Maybe<Scalars['Boolean']['output']>;
  fields?: Maybe<Array<AudienceCriteriaFieldType>>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<MediaType>;
  style?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AudienceInput = {
  advertiser?: InputMaybe<TargetAciInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  questType?: InputMaybe<Scalars['ID']['input']>;
  segments: Array<AudienceSegmentInput>;
  target?: InputMaybe<TargetAciInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AudiencePaginateType = {
  __typename?: 'AudiencePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<AudienceType>;
};

export type AudienceReachInput = {
  reach?: InputMaybe<Scalars['Int']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
};

export type AudienceReachType = {
  __typename?: 'AudienceReachType';
  reach?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum AudienceRelationEnum {
  AND = 'AND',
  OR = 'OR'
}

export type AudienceSegmentFilterFieldInput = {
  value?: InputMaybe<AudienceCriteriaFieldEnum>;
};

export type AudienceSegmentFilterFieldType = {
  __typename?: 'AudienceSegmentFilterFieldType';
  value?: Maybe<AudienceCriteriaFieldEnum>;
};

export type AudienceSegmentFilterInput = {
  field?: InputMaybe<AudienceSegmentFilterFieldInput>;
  operator?: InputMaybe<OperatorEnum>;
};

export type AudienceSegmentFilterType = {
  __typename?: 'AudienceSegmentFilterType';
  field?: Maybe<AudienceSegmentFilterFieldType>;
  operator?: Maybe<OperatorEnum>;
};

export type AudienceSegmentFilterValueInput = {
  catalogueCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  countries?: InputMaybe<Array<Scalars['ID']['input']>>;
  duration?: InputMaybe<QuestAudienceSegmentFrequencyInput>;
  educations?: InputMaybe<Array<AcademicLevel>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  frequency?: InputMaybe<QuestAudienceSegmentFrequencyInput>;
  genders?: InputMaybe<Array<Gender>>;
  languages?: InputMaybe<Array<Scalars['ID']['input']>>;
  maritalStatuses?: InputMaybe<Array<MaritalStatus>>;
  maxValue?: InputMaybe<Scalars['String']['input']>;
  minValue?: InputMaybe<Scalars['String']['input']>;
  quest?: InputMaybe<AudienceSegmentFilterValuesQuestInput>;
  reputations?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  states?: InputMaybe<Array<Scalars['ID']['input']>>;
  transactionsReasons?: InputMaybe<Array<TransactionTypeEnum>>;
  value?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
  zone?: InputMaybe<AudienceSegmentFilterZoneInput>;
};

export type AudienceSegmentFilterValuesQuestActionInput = {
  api?: InputMaybe<QuestActionActionPerformedInput>;
  appDownload?: InputMaybe<QuestActionActionPerformedInput>;
  button?: InputMaybe<QuestActionActionPerformedInput>;
  form?: InputMaybe<AudienceSegmentFilterValuesQuestFormInput>;
  game?: InputMaybe<QuestActionActionGameInput>;
  lead?: InputMaybe<QuestActionActionPerformedInput>;
  socialMedia?: InputMaybe<QuestActionActionPerformedInput>;
  video?: InputMaybe<QuestActionActionPerformedInput>;
};

export type AudienceSegmentFilterValuesQuestActionType = {
  __typename?: 'AudienceSegmentFilterValuesQuestActionType';
  api?: Maybe<QuestActionActionPerformedType>;
  appDownload?: Maybe<QuestActionActionPerformedType>;
  form?: Maybe<AudienceSegmentFilterValuesQuestFormType>;
  game?: Maybe<QuestActionActionGamePerformedType>;
  lead?: Maybe<QuestActionActionPerformedType>;
  socialMedia?: Maybe<QuestActionActionPerformedType>;
  video?: Maybe<QuestActionActionPerformedType>;
};

export type AudienceSegmentFilterValuesQuestAnswersType = {
  __typename?: 'AudienceSegmentFilterValuesQuestAnswersType';
  date?: Maybe<TimeFromToType>;
  multipleChoices?: Maybe<Array<Scalars['String']['output']>>;
  number?: Maybe<QuestAudienceSegmentFilterValuesAnswersNumberType>;
  paragraph?: Maybe<Array<Scalars['String']['output']>>;
  rating?: Maybe<Array<Scalars['Int']['output']>>;
  shortAnswer?: Maybe<Array<Scalars['String']['output']>>;
  singleChoice?: Maybe<Array<Scalars['String']['output']>>;
  smiley?: Maybe<Array<ResponseAnswerSmileyObjType>>;
};

export type AudienceSegmentFilterValuesQuestFormInput = {
  answers?: InputMaybe<QuestAudienceSegmentFilterValuesAnswersInput>;
  question?: InputMaybe<Scalars['ID']['input']>;
};

export type AudienceSegmentFilterValuesQuestFormType = {
  __typename?: 'AudienceSegmentFilterValuesQuestFormType';
  answers?: Maybe<AudienceSegmentFilterValuesQuestAnswersType>;
  question?: Maybe<QuestionDtoType>;
};

export type AudienceSegmentFilterValuesQuestInput = {
  action?: InputMaybe<AudienceSegmentFilterValuesQuestActionInput>;
  activity?: InputMaybe<Scalars['ID']['input']>;
};

export type AudienceSegmentFilterValuesQuestType = {
  __typename?: 'AudienceSegmentFilterValuesQuestType';
  action?: Maybe<AudienceSegmentFilterValuesQuestActionType>;
  activity?: Maybe<QuestActivityType>;
};

export type AudienceSegmentFilterValuesType = {
  __typename?: 'AudienceSegmentFilterValuesType';
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  countries?: Maybe<Array<CountryType>>;
  duration?: Maybe<QuestAudienceSegmentFrequencyType>;
  educations?: Maybe<Array<AcademicLevel>>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  frequency?: Maybe<QuestAudienceSegmentFrequencyType>;
  genders?: Maybe<Array<Gender>>;
  languages?: Maybe<Array<LanguageType>>;
  maritalStatuses?: Maybe<Array<MaritalStatus>>;
  maxValue?: Maybe<Scalars['String']['output']>;
  minValue?: Maybe<Scalars['String']['output']>;
  quest?: Maybe<AudienceSegmentFilterValuesQuestType>;
  reputations?: Maybe<Array<ReputationType>>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  states?: Maybe<Array<StateType>>;
  transactionsReasons?: Maybe<Array<TransactionTypeEnum>>;
  value?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Scalars['String']['output']>>;
  zone?: Maybe<AudienceSegmentFilterZoneType>;
};

export type AudienceSegmentFilterZoneInput = {
  paths?: InputMaybe<Array<DeliveryZonePathInput>>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<ZoneTypesEnum>;
};

export type AudienceSegmentFilterZoneType = {
  __typename?: 'AudienceSegmentFilterZoneType';
  paths?: Maybe<Array<DeliveryZonePathType>>;
  radius?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<ZoneTypesEnum>;
};

export type AudienceSegmentInput = {
  definitions: Array<SegmentsDefinitionsInput>;
  reach?: InputMaybe<AudienceReachInput>;
  relation?: InputMaybe<AudienceRelationEnum>;
};

export type AudienceSegmentType = {
  __typename?: 'AudienceSegmentType';
  definitions: Array<SegmentsDefinitionsType>;
  reach?: Maybe<AudienceReachType>;
  relation?: Maybe<AudienceRelationEnum>;
};

export type AudienceType = {
  __typename?: 'AudienceType';
  advertiser?: Maybe<TargetType>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<MediaType>;
  questType?: Maybe<QuestTypeType>;
  reach?: Maybe<AudienceReachType>;
  segments?: Maybe<Array<AudienceSegmentType>>;
  target?: Maybe<TargetType>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AudienceUpdateInput = {
  advertiser?: InputMaybe<TargetAciInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  questType?: InputMaybe<Scalars['ID']['input']>;
  segments?: InputMaybe<Array<AudienceSegmentInput>>;
  target?: InputMaybe<TargetAciInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AuthDashboardAgeByAppType = {
  __typename?: 'AuthDashboardAgeByAppType';
  ageRange: Scalars['String']['output'];
  app: App;
  count: Scalars['Int']['output'];
};

export type AuthDashboardAgeType = {
  __typename?: 'AuthDashboardAgeType';
  ageRange: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type AuthDashboardGenderByAppType = {
  __typename?: 'AuthDashboardGenderByAppType';
  app: App;
  count: Scalars['Int']['output'];
  gender: Gender;
};

export type AuthDashboardGenderType = {
  __typename?: 'AuthDashboardGenderType';
  count: Scalars['Int']['output'];
  gender: Gender;
};

export type AuthDashboardMailValidationByAppType = {
  __typename?: 'AuthDashboardMailValidationByAppType';
  app: App;
  count: Scalars['Int']['output'];
  isMailValid: Scalars['Boolean']['output'];
};

export type AuthDashboardMailValidationType = {
  __typename?: 'AuthDashboardMailValidationType';
  count: Scalars['Int']['output'];
  isMailValid: Scalars['Boolean']['output'];
};

export type AuthDashboardMaritalStatusByAppType = {
  __typename?: 'AuthDashboardMaritalStatusByAppType';
  app: App;
  count: Scalars['Int']['output'];
  maritalStatus: MaritalStatus;
};

export type AuthDashboardMaritalStatusType = {
  __typename?: 'AuthDashboardMaritalStatusType';
  count: Scalars['Int']['output'];
  maritalStatus: MaritalStatus;
};

export type AuthDashboardRoleByAppType = {
  __typename?: 'AuthDashboardRoleByAppType';
  app: App;
  count: Scalars['Int']['output'];
  role: UserRole;
};

export type AuthDashboardRoleType = {
  __typename?: 'AuthDashboardRoleType';
  count: Scalars['Int']['output'];
  role: UserRole;
};

export type AuthDashboardUsersByAppsType = {
  __typename?: 'AuthDashboardUsersByAppsType';
  app: App;
  count: Scalars['Int']['output'];
};

export type AuthDashboardUsersByRegionByAppType = {
  __typename?: 'AuthDashboardUsersByRegionByAppType';
  app: App;
  count: Scalars['Int']['output'];
  region: CountryEnum;
};

export type AuthDashboardUsersByRegionType = {
  __typename?: 'AuthDashboardUsersByRegionType';
  count: Scalars['Int']['output'];
  region: CountryEnum;
};

export type AuthorizationDataInput = {
  authorizationCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  identityToken: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  userIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type BadgeDefinitionRemunerationType = {
  __typename?: 'BadgeDefinitionRemunerationType';
  qualitative?: Maybe<Scalars['Decimal']['output']>;
  quantitative?: Maybe<Scalars['Decimal']['output']>;
};

export type BadgeDefinitionType = {
  __typename?: 'BadgeDefinitionType';
  explanation?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  rank: Scalars['Int']['output'];
  remuneration?: Maybe<BadgeDefinitionRemunerationType>;
};

export type BadgeType = {
  __typename?: 'BadgeType';
  createdAt: Scalars['DateTime']['output'];
  definition?: Maybe<BadgeDefinitionType>;
  explanation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BankDetailsHolderInput = {
  address?: InputMaybe<FullAddressInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BankDetailsHolderTypeEnum>;
};

export type BankDetailsHolderType = {
  __typename?: 'BankDetailsHolderType';
  address: FullAddressType;
  name: Scalars['String']['output'];
  type?: Maybe<BankDetailsHolderTypeEnum>;
};

export enum BankDetailsHolderTypeEnum {
  COMPANY = 'COMPANY',
  PRIVATE = 'PRIVATE'
}

export type BankDetailsInput = {
  account: Scalars['String']['input'];
  bank: Scalars['ID']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  holder: BankDetailsHolderInput;
  iban?: InputMaybe<Scalars['String']['input']>;
};

export type BankDetailsPaginatedType = {
  __typename?: 'BankDetailsPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<BankDetailsType>;
};

export type BankDetailsType = {
  __typename?: 'BankDetailsType';
  account: Scalars['String']['output'];
  bank: BankType;
  createdAt: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  holder: BankDetailsHolderType;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BankInput = {
  address?: InputMaybe<FullAddressInput>;
  bic?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<BrowserLogoInput>;
  name: Scalars['String']['input'];
};

export type BankPaginatedType = {
  __typename?: 'BankPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<BankType>;
};

export type BankType = {
  __typename?: 'BankType';
  address?: Maybe<FullAddressType>;
  bic?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  logo?: Maybe<BrowserLogoType>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BarcodeBaseRawType = {
  __typename?: 'BarcodeBaseRawType';
  barcode: Scalars['String']['output'];
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<DiscountDtoType>;
  id: Scalars['ID']['output'];
  maintenance?: Maybe<InternalProductMaintenanceType>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  pixel?: Maybe<PixelBarcodeType>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceCredit?: Maybe<Array<BarcodePeriodCreditType>>;
  priceList?: Maybe<Array<ProductPriceListType>>;
  prices?: Maybe<Array<BarcodePricesType>>;
  productAttributesValues?: Maybe<InternalProductAttributesValuesBaseType>;
  status?: Maybe<ProductStatusEnum>;
  supplier?: Maybe<CompanyType>;
  taxes?: Maybe<Array<ProductTaxesType>>;
  translation?: Maybe<Array<BarcodeTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BarcodeFilterInput = {
  barcode?: InputMaybe<Array<Scalars['String']['input']>>;
  condition?: InputMaybe<Array<ProductConditionEnum>>;
  status?: InputMaybe<Array<ProductStatusEnum>>;
};

export type BarcodeFilterResponseType = {
  __typename?: 'BarcodeFilterResponseType';
  /** list of catalogueCategories */
  catalogueCategories?: Maybe<Array<FilterNameFieldType>>;
  createdAtRange?: Maybe<DateRangeType>;
  priceRange?: Maybe<PriceRangeType>;
};

export type BarcodeFindInput = {
  internalProduct?: InputMaybe<Scalars['ID']['input']>;
  product?: InputMaybe<Scalars['ID']['input']>;
  productAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  productAttributesValues?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BarcodeInput = {
  barcode: Scalars['String']['input'];
  catalogueCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  condition?: InputMaybe<ProductConditionEnum>;
  discount?: InputMaybe<DiscountDtoInput>;
  internalProduct?: InputMaybe<Scalars['ID']['input']>;
  maintenance?: InputMaybe<InternalProductMaintenanceInput>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  pixel?: InputMaybe<PixelBarcodeInput>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  priceCredit?: InputMaybe<Array<BarcodePeriodCreditInput>>;
  priceList?: InputMaybe<Array<ProductPriceListInput>>;
  prices?: InputMaybe<Array<BarcodePricesInput>>;
  product?: InputMaybe<Scalars['ID']['input']>;
  productAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  productAttributesValues?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<ProductStatusEnum>;
  supplier?: InputMaybe<Scalars['ID']['input']>;
  taxes?: InputMaybe<Array<ProductTaxesInput>>;
  translation?: InputMaybe<Array<BarcodeTranslationInput>>;
};

export type BarcodePaginateType = {
  __typename?: 'BarcodePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<BarcodeType>;
};

export type BarcodePeriodCreditInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  periodCycle: RecurrenceType;
  periodValue: Scalars['Int']['input'];
};

export type BarcodePeriodCreditType = {
  __typename?: 'BarcodePeriodCreditType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  periodCycle: RecurrenceType;
  periodValue: Scalars['Int']['output'];
};

export type BarcodePricesInput = {
  currency?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
};

export type BarcodePricesType = {
  __typename?: 'BarcodePricesType';
  currency?: Maybe<CurrencyType>;
  price?: Maybe<Scalars['Decimal']['output']>;
};

export enum BarcodeRepresentationTyeEnum {
  AZTECCODE = 'AZTECCODE',
  CODABAR = 'CODABAR',
  CODE11 = 'CODE11',
  CODE39 = 'CODE39',
  CODE93 = 'CODE93',
  CODE128 = 'CODE128',
  DATAMATRIX = 'DATAMATRIX',
  EAN8 = 'EAN8',
  EAN13 = 'EAN13',
  GRIDMATRIX = 'GRIDMATRIX',
  GS1 = 'GS1',
  ITF14 = 'ITF14',
  MAXICODE = 'MAXICODE',
  PATCHCODE = 'PATCHCODE',
  PDF417 = 'PDF417',
  PHARMACODE = 'PHARMACODE',
  UPCA = 'UPCA',
  UPCE = 'UPCE'
}

export type BarcodeTranslationContentInput = {
  name: Scalars['String']['input'];
};

export type BarcodeTranslationContentType = {
  __typename?: 'BarcodeTranslationContentType';
  name: Scalars['String']['output'];
};

export type BarcodeTranslationInput = {
  content: BarcodeTranslationContentInput;
  language: Scalars['ID']['input'];
};

export type BarcodeTranslationType = {
  __typename?: 'BarcodeTranslationType';
  content: BarcodeTranslationContentType;
  language: LanguageType;
};

export type BarcodeType = {
  __typename?: 'BarcodeType';
  barcode: Scalars['String']['output'];
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<DiscountDtoType>;
  id: Scalars['ID']['output'];
  internalProduct?: Maybe<InternalProductType>;
  maintenance?: Maybe<InternalProductMaintenanceType>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  pixel?: Maybe<PixelBarcodeType>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceCredit?: Maybe<Array<BarcodePeriodCreditType>>;
  priceList?: Maybe<Array<ProductPriceListType>>;
  prices?: Maybe<Array<BarcodePricesType>>;
  product?: Maybe<ProductType>;
  productAttributes?: Maybe<Array<AttributeWithAttributeValueType>>;
  productAttributesValues?: Maybe<InternalProductAttributesValuesType>;
  status?: Maybe<ProductStatusEnum>;
  supplier?: Maybe<CompanyType>;
  taxes?: Maybe<Array<ProductTaxesType>>;
  translation?: Maybe<Array<BarcodeTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BarcodeUpdateInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  catalogueCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  condition?: InputMaybe<ProductConditionEnum>;
  discount?: InputMaybe<DiscountDtoInput>;
  id: Scalars['ID']['input'];
  internalProduct?: InputMaybe<Scalars['ID']['input']>;
  maintenance?: InputMaybe<InternalProductMaintenanceInput>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  pixel?: InputMaybe<PixelBarcodeInput>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  priceCredit?: InputMaybe<Array<BarcodePeriodCreditInput>>;
  priceList?: InputMaybe<Array<ProductPriceListInput>>;
  prices?: InputMaybe<Array<BarcodePricesInput>>;
  product?: InputMaybe<Scalars['ID']['input']>;
  productAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  productAttributesValues?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<ProductStatusEnum>;
  supplier?: InputMaybe<Scalars['ID']['input']>;
  taxes?: InputMaybe<Array<ProductTaxesInput>>;
  translation?: InputMaybe<Array<BarcodeTranslationInput>>;
};

export type BarcodeValidationType = {
  __typename?: 'BarcodeValidationType';
  headersValid?: Maybe<Scalars['Boolean']['output']>;
  isIdComplete?: Maybe<Scalars['Boolean']['output']>;
  isNameComplete?: Maybe<Scalars['Boolean']['output']>;
  isPricesComplete?: Maybe<Scalars['Boolean']['output']>;
  isProductsComplete?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  numBarcodesWithAttributes?: Maybe<Scalars['Int']['output']>;
  overallValidation?: Maybe<Scalars['Boolean']['output']>;
};

export type BarcodeWithPublicPriceFullType = {
  __typename?: 'BarcodeWithPublicPriceFullType';
  barcode: Scalars['String']['output'];
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<DiscountDtoType>;
  id: Scalars['ID']['output'];
  internalProduct?: Maybe<InternalProductType>;
  maintenance?: Maybe<InternalProductMaintenanceType>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  pixel?: Maybe<PixelBarcodeType>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceCredit?: Maybe<Array<BarcodePeriodCreditType>>;
  priceList?: Maybe<Array<ProductPriceListType>>;
  prices?: Maybe<Array<BarcodePricesType>>;
  product?: Maybe<ProductType>;
  productAttributes?: Maybe<Array<AttributeWithAttributeValueType>>;
  productAttributesValues?: Maybe<InternalProductAttributesValuesType>;
  publicPrice?: Maybe<Scalars['Decimal']['output']>;
  publicPriceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  status?: Maybe<ProductStatusEnum>;
  supplier?: Maybe<CompanyType>;
  taxes?: Maybe<Array<ProductTaxesType>>;
  translation?: Maybe<Array<BarcodeTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BarcodeWithPublicPricePaginateType = {
  __typename?: 'BarcodeWithPublicPricePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<BarcodeWithPublicPriceFullType>;
};

export type BarcodeWithPublicPriceType = {
  __typename?: 'BarcodeWithPublicPriceType';
  barcode: Scalars['String']['output'];
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<DiscountDtoType>;
  id: Scalars['ID']['output'];
  internalProduct?: Maybe<InternalProductType>;
  maintenance?: Maybe<InternalProductMaintenanceType>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  pixel?: Maybe<PixelBarcodeType>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceCredit?: Maybe<Array<BarcodePeriodCreditType>>;
  priceList?: Maybe<Array<ProductPriceListType>>;
  prices?: Maybe<Array<BarcodePricesType>>;
  product?: Maybe<ProductType>;
  productAttributes?: Maybe<Array<AttributeWithAttributeValueType>>;
  productAttributesValues?: Maybe<InternalProductAttributesValuesType>;
  publicPrice?: Maybe<Scalars['Decimal']['output']>;
  publicPriceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  status?: Maybe<ProductStatusEnum>;
  supplier?: Maybe<CompanyType>;
  translation?: Maybe<Array<BarcodeTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BarcodeWithStockDataType = {
  __typename?: 'BarcodeWithStockDataType';
  barcode: Scalars['String']['output'];
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  currentStock?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<DiscountDtoType>;
  id: Scalars['ID']['output'];
  internalProduct?: Maybe<InternalProductType>;
  maintenance?: Maybe<InternalProductMaintenanceType>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  outOfStock?: Maybe<Scalars['Boolean']['output']>;
  pixel?: Maybe<PixelBarcodeType>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceCredit?: Maybe<Array<BarcodePeriodCreditType>>;
  priceList?: Maybe<Array<ProductPriceListType>>;
  prices?: Maybe<Array<BarcodePricesType>>;
  product?: Maybe<ProductType>;
  productAttributes?: Maybe<Array<AttributeWithAttributeValueType>>;
  productAttributesValues?: Maybe<InternalProductAttributesValuesType>;
  status?: Maybe<ProductStatusEnum>;
  supplier?: Maybe<CompanyType>;
  taxes?: Maybe<Array<ProductTaxesType>>;
  translation?: Maybe<Array<BarcodeTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BarcodeWithStockPaginatedType = {
  __typename?: 'BarcodeWithStockPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<BarcodeWithStockType>;
};

export type BarcodeWithStockType = {
  __typename?: 'BarcodeWithStockType';
  barcode: Scalars['String']['output'];
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<DiscountDtoType>;
  id: Scalars['ID']['output'];
  internalProduct?: Maybe<InternalProductType>;
  maintenance?: Maybe<InternalProductMaintenanceType>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  pixel?: Maybe<PixelBarcodeType>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceCredit?: Maybe<Array<BarcodePeriodCreditType>>;
  priceList?: Maybe<Array<ProductPriceListType>>;
  prices?: Maybe<Array<BarcodePricesType>>;
  product?: Maybe<ProductType>;
  productAttributes?: Maybe<Array<AttributeWithAttributeValueType>>;
  productAttributesValues?: Maybe<InternalProductAttributesValuesType>;
  status?: Maybe<ProductStatusEnum>;
  stock?: Maybe<StockRawType>;
  supplier?: Maybe<CompanyType>;
  taxes?: Maybe<Array<ProductTaxesType>>;
  translation?: Maybe<Array<BarcodeTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BarcodeWithVarietyAndStructureFilterInput = {
  barcode?: InputMaybe<Array<Scalars['String']['input']>>;
  condition?: InputMaybe<Array<ProductConditionEnum>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ProductStatusEnum>>;
  structure?: InputMaybe<Array<ProductStructureEnum>>;
  variety?: InputMaybe<Array<ProductVarietyEnum>>;
};

export type BarcodesFilterInput = {
  /** list of catalogueCategories ids */
  catalogueCategory?: InputMaybe<Array<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  fromPrice?: InputMaybe<Scalars['Decimal']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  toPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type BarcodesPaginatedWithFilterType = {
  __typename?: 'BarcodesPaginatedWithFilterType';
  count?: Maybe<Scalars['Int']['output']>;
  filter?: Maybe<BarcodeFilterResponseType>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<BarcodeType>;
};

export type BetOrderInput = {
  bets: Array<BetOrderOddsInput>;
};

export type BetOrderOddsInput = {
  fixture: Scalars['Int']['input'];
  odds: Array<BetOrderOddsOddsInput>;
};

export type BetOrderOddsOddsInput = {
  bet: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  odd: Scalars['Decimal']['input'];
  value: Scalars['String']['input'];
};

export type BetOrderOddsOddsType = {
  __typename?: 'BetOrderOddsOddsType';
  bet: Scalars['Float']['output'];
  gains?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  odd: Scalars['Decimal']['output'];
  status?: Maybe<OddStatusEnum>;
  value: Scalars['String']['output'];
};

export type BetOrderPaginateType = {
  __typename?: 'BetOrderPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<BetOrderType>;
};

export type BetOrderType = {
  __typename?: 'BetOrderType';
  createdAt: Scalars['DateTime']['output'];
  finalWin?: Maybe<Scalars['Decimal']['output']>;
  fixture: FixtureType;
  id: Scalars['ID']['output'];
  maxWin: Scalars['Float']['output'];
  odds: Array<BetOrderOddsOddsType>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type BetsBookmakersPaginateType = {
  __typename?: 'BetsBookmakersPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<BetsBookmakersType>;
};

export type BetsBookmakersType = {
  __typename?: 'BetsBookmakersType';
  createdAt: Scalars['DateTime']['output'];
  extId?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BlogDataType = {
  __typename?: 'BlogDataType';
  sectionContent?: Maybe<Scalars['String']['output']>;
  sectionPictures?: Maybe<Array<PictureType>>;
  sectionReference?: Maybe<Scalars['String']['output']>;
  sectionTitle?: Maybe<Scalars['String']['output']>;
};

export type BlogTranslationContentType = {
  __typename?: 'BlogTranslationContentType';
  sectionData: Array<BlogDataType>;
  title: Scalars['String']['output'];
};

export type BlogTranslationType = {
  __typename?: 'BlogTranslationType';
  content: BlogTranslationContentType;
  language: LanguageType;
};

export type BlogType = {
  __typename?: 'BlogType';
  author: UserType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  pictures?: Maybe<Array<PictureType>>;
  sectionData?: Maybe<Array<BlogDataType>>;
  seo?: Maybe<SeoComponentType>;
  status: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  title: Scalars['String']['output'];
  translation?: Maybe<Array<BlogTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type BoardCardForListType = {
  __typename?: 'BoardCardForListType';
  archived?: Maybe<Scalars['Boolean']['output']>;
  assignedTo?: Maybe<Array<UserType>>;
  attachments?: Maybe<Array<DocumentType>>;
  barcode?: Maybe<BarcodeType>;
  budget?: Maybe<Array<Scalars['Decimal']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<CompanyType>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  labels?: Maybe<Array<LabelType>>;
  pictures?: Maybe<Array<PictureType>>;
  priority?: Maybe<BoardCardPriorityEnum>;
  procedure?: Maybe<Array<BoardCardProcedureType>>;
  project?: Maybe<ProjectType>;
  rank?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tasks?: Maybe<Array<BoardCardTasksType>>;
  tasksStats?: Maybe<TasksStatsType>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum BoardCardPriorityEnum {
  CRITICAL = 'CRITICAL',
  HIGH = 'HIGH',
  LOW = 'LOW',
  NORMAL = 'NORMAL'
}

export enum BoardCardProcedureEnum {
  CALL = 'CALL',
  CHAT = 'CHAT',
  CONFERENCE = 'CONFERENCE',
  DEMO = 'DEMO',
  MEETING = 'MEETING'
}

export type BoardCardProcedureType = {
  __typename?: 'BoardCardProcedureType';
  task?: Maybe<BoardCardProcedureEnum>;
  time?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BoardCardTasksType = {
  __typename?: 'BoardCardTasksType';
  done?: Maybe<Scalars['Boolean']['output']>;
  task?: Maybe<Scalars['String']['output']>;
};

export type BoardCardType = {
  __typename?: 'BoardCardType';
  archived?: Maybe<Scalars['Boolean']['output']>;
  assignedTo?: Maybe<Array<UserType>>;
  attachments?: Maybe<Array<DocumentType>>;
  barcode?: Maybe<BarcodeType>;
  boardList: BoardListType;
  budget?: Maybe<Array<Scalars['Decimal']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<CompanyType>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  labels?: Maybe<Array<LabelType>>;
  pictures?: Maybe<Array<PictureType>>;
  priority?: Maybe<BoardCardPriorityEnum>;
  procedure?: Maybe<Array<BoardCardProcedureType>>;
  project?: Maybe<ProjectType>;
  rank?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tasks?: Maybe<Array<BoardCardTasksType>>;
  tasksStats?: Maybe<TasksStatsType>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BoardCardsStatsType = {
  __typename?: 'BoardCardsStatsType';
  archived: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum BoardCategoryEnum {
  CRM = 'CRM',
  MAINTENANCE = 'MAINTENANCE',
  PROJECTS = 'PROJECTS'
}

export type BoardListType = {
  __typename?: 'BoardListType';
  board: BoardType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  identifier?: Maybe<MaintenanceBoardListEnum>;
  name: Scalars['String']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  theme?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BoardType = {
  __typename?: 'BoardType';
  boardCardsStats?: Maybe<BoardCardsStatsType>;
  category?: Maybe<BoardCategoryEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  members?: Maybe<Array<UserType>>;
  projects?: Maybe<Array<ProjectType>>;
  target: TargetType;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BookingAttributeType = {
  __typename?: 'BookingAttributeType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum BookingStatusEnum {
  CANCELED = 'CANCELED',
  CLOSED = 'CLOSED',
  CONFIRMED = 'CONFIRMED',
  OPEN = 'OPEN'
}

export type BookingType = {
  __typename?: 'BookingType';
  attributes?: Maybe<Array<SettingsAttributeType>>;
  bookingNumber?: Maybe<Scalars['Float']['output']>;
  bookingTime?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  people?: Maybe<Scalars['Int']['output']>;
  pos: PointOfSaleType;
  status?: Maybe<BookingStatusEnum>;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type BookingTypeType = {
  __typename?: 'BookingTypeType';
  createdAt: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BookingsCountType = {
  __typename?: 'BookingsCountType';
  bookingSources: BookingsSourcesCountType;
  bookingStatuses: BookingsStatusesCountType;
  numberOfPeople: Array<NumberOfPeopleCountType>;
  total: Scalars['Int']['output'];
};

export type BookingsSourcesCountType = {
  __typename?: 'BookingsSourcesCountType';
  APP: Scalars['Int']['output'];
  EMAIL: Scalars['Int']['output'];
  FACEBOOK: Scalars['Int']['output'];
  INSTAGRAM: Scalars['Int']['output'];
  PHONE: Scalars['Int']['output'];
};

export type BookingsStatusesCountType = {
  __typename?: 'BookingsStatusesCountType';
  CANCELED: Scalars['Int']['output'];
  CLOSED: Scalars['Int']['output'];
  CONFIRMED: Scalars['Int']['output'];
  OPEN: Scalars['Int']['output'];
};

export type BooleanCheckType = {
  __typename?: 'BooleanCheckType';
  response: Scalars['Boolean']['output'];
};

export type BrandType = {
  __typename?: 'BrandType';
  createdAt: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  manufacturer?: Maybe<ManufacturerType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type BrandValidationType = {
  __typename?: 'BrandValidationType';
  headersValid: Scalars['Boolean']['output'];
  isIdComplete: Scalars['Boolean']['output'];
  isNameComplete: Scalars['Boolean']['output'];
  length: Scalars['Int']['output'];
  overallValidation: Scalars['Boolean']['output'];
};

export type BrowserLogoInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  png?: InputMaybe<BrowserLogoPngInput>;
  svg?: InputMaybe<PictureInput>;
};

export type BrowserLogoPngInput = {
  default?: InputMaybe<PictureInput>;
  size16?: InputMaybe<PictureInput>;
  size24?: InputMaybe<PictureInput>;
  size32?: InputMaybe<PictureInput>;
  size48?: InputMaybe<PictureInput>;
  size64?: InputMaybe<PictureInput>;
  size128?: InputMaybe<PictureInput>;
  size256?: InputMaybe<PictureInput>;
  size512?: InputMaybe<PictureInput>;
};

export type BrowserLogoPngType = {
  __typename?: 'BrowserLogoPngType';
  default?: Maybe<PictureType>;
  size16?: Maybe<PictureType>;
  size24?: Maybe<PictureType>;
  size32?: Maybe<PictureType>;
  size48?: Maybe<PictureType>;
  size64?: Maybe<PictureType>;
  size128?: Maybe<PictureType>;
  size256?: Maybe<PictureType>;
  size512?: Maybe<PictureType>;
};

export type BrowserLogoType = {
  __typename?: 'BrowserLogoType';
  icon?: Maybe<Scalars['String']['output']>;
  png?: Maybe<BrowserLogoPngType>;
  svg?: Maybe<PictureType>;
};

export type BrowserType = {
  __typename?: 'BrowserType';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  logo?: Maybe<BrowserLogoType>;
  name?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ByMarkRatingType = {
  __typename?: 'ByMarkRatingType';
  count: Scalars['Int']['output'];
  mark: Scalars['Int']['output'];
};

export enum CardRepresentationEnum {
  CARD = 'CARD',
  EMAIL = 'EMAIL',
  IDENTIFIER = 'IDENTIFIER',
  PHONE = 'PHONE'
}

export enum CardTypeEnum {
  PHYSICAL = 'PHYSICAL',
  VIRTUAL = 'VIRTUAL'
}

export type CartProductForTargetType = {
  __typename?: 'CartProductForTargetType';
  barcode?: Maybe<BarcodeWithPublicPriceType>;
  price: ProductPriceType;
  priceCredit?: Maybe<PriceCreditType>;
  quantity: Scalars['Int']['output'];
  taxValue: TaxValueType;
};

export type CartProductType = {
  __typename?: 'CartProductType';
  barcode?: Maybe<BarcodeWithPublicPriceType>;
  price: ProductPriceType;
  priceCredit?: Maybe<PriceCreditType>;
  productAttributesValues?: Maybe<Array<AttributeValueType>>;
  quantity: Scalars['Int']['output'];
  rent?: Maybe<RentalRefType>;
  taxValue: TaxValueType;
};

export type CatalogueCategoryBaseType = {
  __typename?: 'CatalogueCategoryBaseType';
  booking?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  delivery?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  hasChildren: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  layer: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<CatalogueCategoryBaseType>;
  pickup?: Maybe<Scalars['Boolean']['output']>;
  pictures?: Maybe<Array<PictureType>>;
  portal?: Maybe<Scalars['Boolean']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  translation?: Maybe<Array<CatalogueCategoryTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  variety?: Maybe<ProductVarietyEnum>;
};

export type CatalogueCategoryBulkInput = {
  booking?: InputMaybe<Scalars['Boolean']['input']>;
  delivery?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  hasChildren: Scalars['Boolean']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  layer: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['ID']['input']>;
  pickup?: InputMaybe<Scalars['Boolean']['input']>;
  pictures?: InputMaybe<Array<PictureInput>>;
  portal?: InputMaybe<Scalars['Boolean']['input']>;
  rank: Scalars['Int']['input'];
  seo?: InputMaybe<CatalogueCategorySeoInput>;
  target: TargetAciInput;
  translation?: InputMaybe<Array<CatalogueCategoryTranslationInput>>;
  variety?: InputMaybe<ProductVarietyEnum>;
};

export type CatalogueCategoryInput = {
  booking?: InputMaybe<Scalars['Boolean']['input']>;
  delivery?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  layer: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['String']['input']>;
  pickup?: InputMaybe<Scalars['Boolean']['input']>;
  pictures?: InputMaybe<Array<PictureInput>>;
  portal?: InputMaybe<Scalars['Boolean']['input']>;
  seo?: InputMaybe<CatalogueCategorySeoInput>;
  target: TargetAciInput;
  translation?: InputMaybe<Array<CatalogueCategoryTranslationInput>>;
  variety?: InputMaybe<ProductVarietyEnum>;
};

export type CatalogueCategoryPaginateType = {
  __typename?: 'CatalogueCategoryPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CatalogueCategoryType>;
};

export type CatalogueCategorySeoInput = {
  metaDesription?: InputMaybe<Scalars['String']['input']>;
  metaKeywords?: InputMaybe<Array<MetaKeywordsInput>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  urlKey?: InputMaybe<Scalars['String']['input']>;
};

export type CatalogueCategorySeoType = {
  __typename?: 'CatalogueCategorySeoType';
  metaDesription?: Maybe<Scalars['String']['output']>;
  metaKeywords?: Maybe<Array<MetaKeywordsType>>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  urlKey?: Maybe<Scalars['String']['output']>;
};

export type CatalogueCategoryTranslationContentInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CatalogueCategoryTranslationContentType = {
  __typename?: 'CatalogueCategoryTranslationContentType';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CatalogueCategoryTranslationInput = {
  content: CatalogueCategoryTranslationContentInput;
  language: Scalars['ID']['input'];
};

export type CatalogueCategoryTranslationType = {
  __typename?: 'CatalogueCategoryTranslationType';
  content: CatalogueCategoryTranslationContentType;
  language: LanguageType;
};

export type CatalogueCategoryType = {
  __typename?: 'CatalogueCategoryType';
  booking?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  delivery?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  hasChildren: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  layer: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<CatalogueCategoryBaseType>;
  pickup?: Maybe<Scalars['Boolean']['output']>;
  pictures?: Maybe<Array<PictureType>>;
  portal?: Maybe<Scalars['Boolean']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  target: TargetType;
  translation?: Maybe<Array<CatalogueCategoryTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  variety?: Maybe<ProductVarietyEnum>;
};

export type CatalogueCategoryUpdateInput = {
  booking?: InputMaybe<Scalars['Boolean']['input']>;
  delivery?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  layer?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['String']['input']>;
  pickup?: InputMaybe<Scalars['Boolean']['input']>;
  pictures?: InputMaybe<Array<PictureInput>>;
  portal?: InputMaybe<Scalars['Boolean']['input']>;
  seo?: InputMaybe<CatalogueCategorySeoInput>;
  translation?: InputMaybe<Array<CatalogueCategoryTranslationInput>>;
  variety?: InputMaybe<ProductVarietyEnum>;
};

export type CatalogueCategoryWithChildrenType = {
  __typename?: 'CatalogueCategoryWithChildrenType';
  booking?: Maybe<Scalars['Boolean']['output']>;
  children?: Maybe<Array<CatalogueCategoryWithChildrenType>>;
  createdAt: Scalars['DateTime']['output'];
  delivery?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  hasChildren: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  layer: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<CatalogueCategoryBaseType>;
  pickup?: Maybe<Scalars['Boolean']['output']>;
  pictures?: Maybe<Array<PictureType>>;
  portal?: Maybe<Scalars['Boolean']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  target: TargetType;
  translation?: Maybe<Array<CatalogueCategoryTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  variety?: Maybe<ProductVarietyEnum>;
};

export type CategoriesValidationType = {
  __typename?: 'CategoriesValidationType';
  headersValid?: Maybe<Scalars['Boolean']['output']>;
  isIdComplete?: Maybe<Scalars['Boolean']['output']>;
  isLayerComplete?: Maybe<Scalars['Boolean']['output']>;
  isNameComplete?: Maybe<Scalars['Boolean']['output']>;
  isParentComplete?: Maybe<Scalars['Boolean']['output']>;
  isRankComplete?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  overallValidation?: Maybe<Scalars['Boolean']['output']>;
};

export type CauseType = {
  __typename?: 'CauseType';
  code?: Maybe<Scalars['String']['output']>;
  coin?: Maybe<CoinType>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<MediaType>;
  organization?: Maybe<TargetType>;
  qualitativeRatio?: Maybe<Scalars['Decimal']['output']>;
  target: TargetType;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ChallengeActivitiesInput = {
  activityType?: InputMaybe<TransactionChallengeTypeEnum>;
  predefined?: InputMaybe<Scalars['ID']['input']>;
};

export type ChallengeActivitiesType = {
  __typename?: 'ChallengeActivitiesType';
  activityType?: Maybe<TransactionChallengeTypeEnum>;
  predefined?: Maybe<PredefinedType>;
};

export type ChallengeByAudienceFilterInput = {
  isDonation?: InputMaybe<Scalars['Boolean']['input']>;
  target: TargetAciInput;
};

export type ChallengeDonationInput = {
  donation?: InputMaybe<Scalars['ID']['input']>;
  objective?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ChallengeDonationType = {
  __typename?: 'ChallengeDonationType';
  currentAmount?: Maybe<Scalars['Decimal']['output']>;
  donation?: Maybe<ActivityTypeType>;
  numberOfParticipants?: Maybe<Scalars['Int']['output']>;
  objective?: Maybe<Scalars['Decimal']['output']>;
  progress?: Maybe<Scalars['Decimal']['output']>;
};

export type ChallengeFilterInput = {
  endDate?: InputMaybe<FromToInput>;
  startDate?: InputMaybe<FromToInput>;
  status?: InputMaybe<Array<ChallengeStatusEnum>>;
};

export type ChallengeInput = {
  activities?: InputMaybe<Array<ChallengeActivitiesInput>>;
  audience?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<ChallengeDonationInput>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  leaderboard?: InputMaybe<ChallengeLeaderboardInput>;
  media?: InputMaybe<MediaInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ChallengeStatusEnum>;
  target?: InputMaybe<TargetAciInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  winners?: InputMaybe<Array<ChallengeInputWinner>>;
};

export type ChallengeInputWinner = {
  rank: Scalars['Int']['input'];
  reward?: InputMaybe<Scalars['ID']['input']>;
};

export type ChallengeLeaderboardInput = {
  blur: Scalars['Boolean']['input'];
};

export type ChallengeLeaderboardType = {
  __typename?: 'ChallengeLeaderboardType';
  blur: Scalars['Boolean']['output'];
};

export type ChallengePaginateType = {
  __typename?: 'ChallengePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ChallengeType>;
};

export enum ChallengeStatusEnum {
  DRAFT = 'DRAFT',
  FINISHED = 'FINISHED',
  ONGOING = 'ONGOING'
}

export type ChallengeType = {
  __typename?: 'ChallengeType';
  activities?: Maybe<Array<ChallengeActivitiesType>>;
  audience?: Maybe<AudienceType>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  description?: Maybe<Scalars['String']['output']>;
  donation?: Maybe<ChallengeDonationType>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  leaderboard: ChallengeLeaderboardType;
  media?: Maybe<MediaType>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ChallengeStatusEnum>;
  target?: Maybe<TargetType>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  winners?: Maybe<Array<ChallengeTypeWinner>>;
};

export type ChallengeTypeWinner = {
  __typename?: 'ChallengeTypeWinner';
  rank: Scalars['Int']['output'];
  reward?: Maybe<BarcodeType>;
  user?: Maybe<UserType>;
};

export type ChallengeWithLinkedAccountsType = {
  __typename?: 'ChallengeWithLinkedAccountsType';
  activities?: Maybe<Array<ChallengeActivitiesType>>;
  audience?: Maybe<AudienceType>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  description?: Maybe<Scalars['String']['output']>;
  donation?: Maybe<ChallengeDonationType>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isAccountLinked?: Maybe<Scalars['Boolean']['output']>;
  leaderboard: ChallengeLeaderboardType;
  media?: Maybe<MediaType>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ChallengeStatusEnum>;
  target?: Maybe<TargetType>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  winners?: Maybe<Array<ChallengeTypeWinner>>;
};

export enum ChannelEnum {
  EMAIL = 'EMAIL',
  PUSH = 'PUSH',
  SMS = 'SMS',
  WIDGET = 'WIDGET'
}

export enum ChartAppTypeEnum {
  FREE = 'FREE',
  GROSSING = 'GROSSING',
  PAID = 'PAID'
}

export enum ChartPlatformEnum {
  AMAZON = 'AMAZON',
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  IPAD = 'IPAD',
  IPHONE = 'IPHONE'
}

export type CheckWalletAndReputationType = {
  __typename?: 'CheckWalletAndReputationType';
  currentReputation: ReputationSimpleType;
  wallet: WalletCheckType;
};

export type ClientDataType = {
  __typename?: 'ClientDataType';
  clientType?: Maybe<Scalars['String']['output']>;
  engine?: Maybe<Scalars['String']['output']>;
  engineVersion?: Maybe<Scalars['String']['output']>;
  family?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type CloudinaryResourceType = {
  __typename?: 'CloudinaryResourceType';
  bytes?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  public_id?: Maybe<Scalars['String']['output']>;
  resource_type?: Maybe<Scalars['String']['output']>;
  secure_url?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};

export type CloudinarySignatureType = {
  __typename?: 'CloudinarySignatureType';
  folder?: Maybe<Scalars['String']['output']>;
  public_id?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Float']['output']>;
};

export type CoachsBirthType = {
  __typename?: 'CoachsBirthType';
  country?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  place?: Maybe<Scalars['String']['output']>;
};

export type CoachsCareerType = {
  __typename?: 'CoachsCareerType';
  end?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
  team?: Maybe<CoachsTeamType>;
};

export type CoachsPaginateType = {
  __typename?: 'CoachsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CoachsType>;
};

export type CoachsTeamType = {
  __typename?: 'CoachsTeamType';
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CoachsType = {
  __typename?: 'CoachsType';
  age?: Maybe<Scalars['Float']['output']>;
  birth?: Maybe<CoachsBirthType>;
  career?: Maybe<Array<CoachsCareerType>>;
  coachId?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  firstname?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  photo64?: Maybe<Scalars['String']['output']>;
  team?: Maybe<CoachsTeamType>;
  updatedAt: Scalars['DateTime']['output'];
  weight?: Maybe<Scalars['String']['output']>;
};

export enum CodeFormatEnum {
  ALPHANUMERIC = 'ALPHANUMERIC',
  NUMERIC = 'NUMERIC'
}

export enum CodeRepresentationEnum {
  BARCODE = 'BARCODE',
  QRCODE = 'QRCODE'
}

export type CoinApiCheckInput = {
  headers: Array<CoinApiHeadersInput>;
  link: Scalars['String']['input'];
  method: ApiMethods;
  params: Array<CoinApiHeadersInput>;
};

export type CoinApiCheckType = {
  __typename?: 'CoinApiCheckType';
  headers?: Maybe<Array<CoinApiHeadersType>>;
  link?: Maybe<Scalars['String']['output']>;
  method?: Maybe<ApiMethods>;
  params?: Maybe<Array<CoinApiHeadersType>>;
};

export type CoinApiHeadersInput = {
  key: Scalars['String']['input'];
  user: Scalars['Boolean']['input'];
  value: Scalars['String']['input'];
};

export type CoinApiHeadersType = {
  __typename?: 'CoinApiHeadersType';
  key?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CoinApiInput = {
  check?: InputMaybe<CoinApiCheckInput>;
  deduct?: InputMaybe<CoinApiMethodInput>;
  push?: InputMaybe<CoinApiMethodInput>;
};

export type CoinApiMethodInput = {
  headers: Array<CoinApiParamsInput>;
  link: Scalars['String']['input'];
  method: ApiMethods;
  params: Array<CoinApiParamsInput>;
};

export type CoinApiMethodType = {
  __typename?: 'CoinApiMethodType';
  headers?: Maybe<Array<CoinApiParamsType>>;
  link?: Maybe<Scalars['String']['output']>;
  method?: Maybe<ApiMethods>;
  params?: Maybe<Array<CoinApiParamsType>>;
};

export type CoinApiParamsInput = {
  amount: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  user: Scalars['Boolean']['input'];
  value: Scalars['String']['input'];
};

export type CoinApiParamsType = {
  __typename?: 'CoinApiParamsType';
  amount?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CoinApiType = {
  __typename?: 'CoinApiType';
  check?: Maybe<CoinApiCheckType>;
  deduct?: Maybe<CoinApiMethodType>;
  push?: Maybe<CoinApiMethodType>;
};

export enum CoinCategoryEnum {
  CLASSIC = 'CLASSIC',
  CRYPTO = 'CRYPTO'
}

export enum CoinHandleEnum {
  API = 'API',
  INTERNAL = 'INTERNAL'
}

export type CoinInput = {
  api?: InputMaybe<CoinApiInput>;
  category?: InputMaybe<CoinCategoryEnum>;
  code?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['ID']['input']>;
  handle?: InputMaybe<CoinHandleEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<TargetAciInput>;
  picture?: InputMaybe<PictureInput>;
  unitValue?: InputMaybe<CoinValueInput>;
};

export type CoinPaginateType = {
  __typename?: 'CoinPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CoinType>;
};

export type CoinSimpleType = {
  __typename?: 'CoinSimpleType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  picture?: Maybe<PictureType>;
  unitValue?: Maybe<CoinValueType>;
};

export type CoinType = {
  __typename?: 'CoinType';
  api?: Maybe<CoinApiType>;
  category?: Maybe<CoinCategoryEnum>;
  code?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryType>;
  createdAt: Scalars['DateTime']['output'];
  handle?: Maybe<CoinHandleEnum>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner?: Maybe<TargetType>;
  picture?: Maybe<PictureType>;
  unitValue?: Maybe<CoinValueType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CoinValueInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  currency?: InputMaybe<Scalars['ID']['input']>;
};

export type CoinValueType = {
  __typename?: 'CoinValueType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  currency?: Maybe<CurrencyType>;
};

export type CollaborationAnalyticsProjectsOverviewChartType = {
  __typename?: 'CollaborationAnalyticsProjectsOverviewChartType';
  activeProjects?: Maybe<Array<Scalars['Int']['output']>>;
  revenue?: Maybe<Array<Scalars['Decimal']['output']>>;
  totalProjects?: Maybe<Array<Scalars['Int']['output']>>;
};

export type CollaborationAnalyticsProjectsStatusChartDetailType = {
  __typename?: 'CollaborationAnalyticsProjectsStatusChartDetailType';
  count?: Maybe<Scalars['Int']['output']>;
  hours?: Maybe<Scalars['Int']['output']>;
};

export type CollaborationAnalyticsProjectsStatusChartType = {
  __typename?: 'CollaborationAnalyticsProjectsStatusChartType';
  ACTIVE?: Maybe<CollaborationAnalyticsProjectsStatusChartDetailType>;
  BLOCKED?: Maybe<CollaborationAnalyticsProjectsStatusChartDetailType>;
  CANCELLED?: Maybe<CollaborationAnalyticsProjectsStatusChartDetailType>;
  DELIVERED?: Maybe<CollaborationAnalyticsProjectsStatusChartDetailType>;
};

export type CommentBaseType = {
  __typename?: 'CommentBaseType';
  attachments?: Maybe<Array<DocumentType>>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  holder?: Maybe<CommentHolderType>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type CommentHolderType = {
  __typename?: 'CommentHolderType';
  card?: Maybe<BoardCardType>;
  project?: Maybe<ProjectType>;
  purchaseDeliveryNote?: Maybe<PurchaseDeliveryNoteType>;
  purchaseInvoice?: Maybe<PurchaseInvoiceType>;
  purchaseOrder?: Maybe<PurchaseOrderType>;
  quotation?: Maybe<QuotationType>;
  saleDeliveryNote?: Maybe<SaleDeliveryNoteType>;
  saleInvoice?: Maybe<SaleInvoiceType>;
  saleIssueNote?: Maybe<SaleIssueNoteType>;
  saleOrder?: Maybe<SaleOrderType>;
  ticket?: Maybe<TicketType>;
};

export type CommentType = {
  __typename?: 'CommentType';
  attachments?: Maybe<Array<DocumentType>>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  firstReply?: Maybe<FirstReplyType>;
  holder?: Maybe<CommentHolderType>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type CompanyContactDetailsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<PhoneInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyContactDetailsType = {
  __typename?: 'CompanyContactDetailsType';
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<PhoneType>;
  website?: Maybe<Scalars['String']['output']>;
};

export type CompanyContactType = {
  __typename?: 'CompanyContactType';
  address?: Maybe<FullAddressType>;
  chatContact?: Maybe<Array<SocialValueType>>;
  company?: Maybe<CompanyType>;
  createdAt: Scalars['DateTime']['output'];
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastContacted?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  leadScore?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  phone?: Maybe<IPhoneType>;
  socialMedia?: Maybe<Array<SocialValueType>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CompanyCustomerInput = {
  phase?: InputMaybe<CustomerPhaseEnum>;
  score?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyCustomerType = {
  __typename?: 'CompanyCustomerType';
  phase?: Maybe<CustomerPhaseEnum>;
  score?: Maybe<Scalars['String']['output']>;
};

export type CompanyInput = {
  address?: InputMaybe<FullAddressInput>;
  banks?: InputMaybe<Array<Scalars['String']['input']>>;
  contact?: InputMaybe<CompanyContactDetailsInput>;
  customer?: InputMaybe<CompanyCustomerInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  legal?: InputMaybe<CompanyLegalInput>;
  logistic?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<CompanySupplierInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  target?: InputMaybe<TargetAciInput>;
};

export type CompanyLegalInput = {
  licence?: InputMaybe<Scalars['String']['input']>;
  register?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyLegalType = {
  __typename?: 'CompanyLegalType';
  licence?: Maybe<Scalars['String']['output']>;
  register?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['String']['output']>;
};

export type CompanyPaginateType = {
  __typename?: 'CompanyPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CompanyType>;
};

export type CompanySupplierInput = {
  kind?: InputMaybe<SupplierTypeEnum>;
};

export type CompanySupplierType = {
  __typename?: 'CompanySupplierType';
  kind?: Maybe<SupplierTypeEnum>;
};

export type CompanyType = {
  __typename?: 'CompanyType';
  address?: Maybe<FullAddressType>;
  banks?: Maybe<Array<BankDetailsType>>;
  contact?: Maybe<CompanyContactDetailsType>;
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<CompanyCustomerType>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  legal?: Maybe<CompanyLegalType>;
  logistic?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<CompanySupplierType>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CompanyUpdateInput = {
  address?: InputMaybe<FullAddressInput>;
  banks?: InputMaybe<Array<Scalars['String']['input']>>;
  contact?: InputMaybe<CompanyContactDetailsInput>;
  customer?: InputMaybe<CompanyCustomerInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  legal?: InputMaybe<CompanyLegalInput>;
  logistic?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<CompanySupplierInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CompareProductType = {
  __typename?: 'CompareProductType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  products: InternalProductType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type CompareRankType = {
  __typename?: 'CompareRankType';
  change: Scalars['Int']['output'];
  direction: LeaderboardCompareEnum;
};

export type ComplaintTargetType = {
  __typename?: 'ComplaintTargetType';
  manufacturer?: Maybe<ManufacturerType>;
  pos?: Maybe<PointOfSaleType>;
  user?: Maybe<UserType>;
  wholesaler?: Maybe<WholesalerType>;
};

export type ComplaintType = {
  __typename?: 'ComplaintType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  report: Scalars['String']['output'];
  reporter: UserType;
  target: ComplaintTargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ContentTypeImageFormatType = {
  __typename?: 'ContentTypeImageFormatType';
  png?: Maybe<PictureType>;
  svg?: Maybe<PictureType>;
};

export type ContentTypeImageType = {
  __typename?: 'ContentTypeImageType';
  background?: Maybe<ContentTypeImageFormatType>;
  black?: Maybe<ContentTypeImageFormatType>;
  icon?: Maybe<Scalars['String']['output']>;
  white?: Maybe<ContentTypeImageFormatType>;
};

export type ContentTypeType = {
  __typename?: 'ContentTypeType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<ContentTypeImageType>;
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ConversionsFieldType = {
  __typename?: 'ConversionsFieldType';
  current: Scalars['Int']['output'];
  percentage?: Maybe<Scalars['Decimal']['output']>;
  previous: Scalars['Int']['output'];
  weeklyConversions: Array<PeriodStatsType>;
};

export type CorporateActionType = {
  __typename?: 'CorporateActionType';
  activity?: Maybe<Scalars['String']['output']>;
  adhocNotification?: Maybe<AdhocCorporateNotificationType>;
  adhocOrder?: Maybe<Scalars['String']['output']>;
  booking?: Maybe<BookingType>;
  currentPoints?: Maybe<Scalars['Float']['output']>;
  internalProduct?: Maybe<Scalars['String']['output']>;
  onsite?: Maybe<CorporateNotificationOnsiteConverterType>;
  order?: Maybe<Scalars['String']['output']>;
  outboundId?: Maybe<Scalars['String']['output']>;
  quest?: Maybe<Scalars['String']['output']>;
  redeemAmount?: Maybe<Scalars['Decimal']['output']>;
  reputationLoss?: Maybe<Scalars['Float']['output']>;
  reputationLossDate?: Maybe<Scalars['DateTime']['output']>;
  subscription?: Maybe<Scalars['String']['output']>;
  table?: Maybe<Scalars['String']['output']>;
  turnoverPoints?: Maybe<Scalars['Float']['output']>;
};

export type CorporateEmailTempInput = {
  attachments?: InputMaybe<Array<MailAttachmentInput>>;
  content?: InputMaybe<EmailContentInput>;
  langauge?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  target: TargetAciInput;
  template?: InputMaybe<EmailTemplateTypeEnum>;
  to: Array<Scalars['String']['input']>;
  variables?: InputMaybe<EmailTempVariablesInput>;
};

export type CorporateEmailTemplateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<EmailTemplateTypeEnum>;
  picture?: InputMaybe<PictureInput>;
  style?: InputMaybe<CorporateEmailTemplateStyleInput>;
  target?: InputMaybe<TargetAciInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Array<CorporateEmailTemplateTranslationInput>>;
};

export type CorporateEmailTemplatePaginateType = {
  __typename?: 'CorporateEmailTemplatePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CorporateEmailTemplateType>;
};

export type CorporateEmailTemplateStyleInput = {
  desktop?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
};

export type CorporateEmailTemplateStyleType = {
  __typename?: 'CorporateEmailTemplateStyleType';
  desktop?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
};

export type CorporateEmailTemplateTranslationInput = {
  content: Scalars['String']['input'];
  language: Scalars['ID']['input'];
};

export type CorporateEmailTemplateTranslationType = {
  __typename?: 'CorporateEmailTemplateTranslationType';
  content: Scalars['String']['output'];
  language: LanguageType;
};

export type CorporateEmailTemplateType = {
  __typename?: 'CorporateEmailTemplateType';
  color?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<EmailTemplateTypeEnum>;
  picture?: Maybe<PictureType>;
  style?: Maybe<CorporateEmailTemplateStyleType>;
  target?: Maybe<TargetType>;
  title?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Array<CorporateEmailTemplateTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CorporateLoginType = {
  __typename?: 'CorporateLoginType';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Float']['output'];
  user?: Maybe<CorporateUserType>;
};

export type CorporateLoginWithActionTypeType = {
  __typename?: 'CorporateLoginWithActionTypeType';
  accessToken: Scalars['String']['output'];
  actionType?: Maybe<ActionTypeEnum>;
  expiresIn: Scalars['Float']['output'];
  user?: Maybe<CorporateUserType>;
};

export type CorporateNotificationFullType = {
  __typename?: 'CorporateNotificationFullType';
  action?: Maybe<CorporateActionType>;
  audience?: Maybe<AudienceType>;
  createdAt: Scalars['DateTime']['output'];
  event?: Maybe<EventTypeEnum>;
  executed?: Maybe<Scalars['Boolean']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  seen?: Maybe<Scalars['Boolean']['output']>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type CorporateNotificationInput = {
  audience?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  executedAt?: InputMaybe<Scalars['DateTime']['input']>;
  picture?: InputMaybe<PictureInput>;
  target?: InputMaybe<TargetAciInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CorporateNotificationOnsiteConverterType = {
  __typename?: 'CorporateNotificationOnsiteConverterType';
  qualitativeAmount: Scalars['Decimal']['output'];
  quantitativeAmount: Scalars['Decimal']['output'];
  source: Scalars['String']['output'];
};

export type CorporateNotificationPaginateType = {
  __typename?: 'CorporateNotificationPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CorporateNotificationType>;
};

export type CorporateNotificationResponse = {
  __typename?: 'CorporateNotificationResponse';
  success: Scalars['Boolean']['output'];
};

export type CorporateNotificationType = {
  __typename?: 'CorporateNotificationType';
  action?: Maybe<CorporateActionType>;
  audience?: Maybe<AudienceType>;
  createdAt: Scalars['DateTime']['output'];
  event?: Maybe<EventTypeEnum>;
  executed?: Maybe<Scalars['Boolean']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  seen?: Maybe<Scalars['Boolean']['output']>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type CorporateOutboundNotificationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  outbound?: InputMaybe<Scalars['ID']['input']>;
  picture?: InputMaybe<PictureInput>;
  target?: InputMaybe<TargetAciInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorporateRatingAssignmentType = {
  __typename?: 'CorporateRatingAssignmentType';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  reviewDefinition?: Maybe<CorporateRatingDefinitionType>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CorporateRatingDefinitionType = {
  __typename?: 'CorporateRatingDefinitionType';
  id?: Maybe<Scalars['ID']['output']>;
  reviewType?: Maybe<Scalars['String']['output']>;
};

export type CorporateRatingType = {
  __typename?: 'CorporateRatingType';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mark: Scalars['Int']['output'];
  product?: Maybe<InternalProductType>;
  reviewType: CorporateRatingDefinitionType;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type CorporateUserCardFilterInput = {
  cardType?: InputMaybe<Array<CardTypeEnum>>;
  validUntil?: InputMaybe<FromToInput>;
};

export type CorporateUserCardFullPaginatedType = {
  __typename?: 'CorporateUserCardFullPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CorporateUserCardType>;
};

export type CorporateUserCardFullWithReputationPaginatedType = {
  __typename?: 'CorporateUserCardFullWithReputationPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CorporateUserCardWithReputationType>;
};

export type CorporateUserCardType = {
  __typename?: 'CorporateUserCardType';
  cardType: CardTypeEnum;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
  validUntil: Scalars['DateTime']['output'];
};

export type CorporateUserCardWithExtrasType = {
  __typename?: 'CorporateUserCardWithExtrasType';
  cardType: CardTypeEnum;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  prelevel?: Maybe<LoyaltySettingsPrelevelType>;
  reputationLevels?: Maybe<Array<ReputationWithoutTargetType>>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
  validUntil: Scalars['DateTime']['output'];
  visualRepresentation?: Maybe<CodeRepresentationEnum>;
  walletAmount?: Maybe<Scalars['Decimal']['output']>;
};

export type CorporateUserCardWithReputationType = {
  __typename?: 'CorporateUserCardWithReputationType';
  cardType: CardTypeEnum;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
  validUntil: Scalars['DateTime']['output'];
  wallet?: Maybe<WalletBaseType>;
};

export type CorporateUserExistType = {
  __typename?: 'CorporateUserExistType';
  exist: Scalars['Boolean']['output'];
  user?: Maybe<CorporateUserType>;
};

export type CorporateUserPaginateType = {
  __typename?: 'CorporateUserPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CorporateUserType>;
};

export type CorporateUserType = {
  __typename?: 'CorporateUserType';
  about?: Maybe<Scalars['String']['output']>;
  apps?: Maybe<Array<App>>;
  billingAddress?: Maybe<Array<FullAddressType>>;
  chatContact?: Maybe<Array<SocialValueType>>;
  covers?: Maybe<Array<PictureType>>;
  createdAt: Scalars['DateTime']['output'];
  custom?: Maybe<Array<UserCustomType>>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  education?: Maybe<Array<UserEducationType>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  hasAutoGeneratedEmail?: Maybe<Scalars['Boolean']['output']>;
  hobbies?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  interests?: Maybe<Array<Scalars['String']['output']>>;
  isMailValid?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<LanguageType>>;
  lastName?: Maybe<Scalars['String']['output']>;
  lived?: Maybe<Array<StateType>>;
  locale?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<MaritalStatus>;
  mobileTheme?: Maybe<MobileThemesEnum>;
  nationality?: Maybe<CountryType>;
  newsletterSubs?: Maybe<Scalars['Boolean']['output']>;
  permission?: Maybe<PermissionType>;
  phone?: Maybe<PhoneType>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  placeOfBirth?: Maybe<Scalars['String']['output']>;
  plugged?: Maybe<Scalars['Boolean']['output']>;
  residentialAddress?: Maybe<Array<FullAddressType>>;
  roles?: Maybe<Array<UserRole>>;
  shippingAddress?: Maybe<Array<FullAddressType>>;
  socialLoginData?: Maybe<SocialLoginDataType>;
  socialMedia?: Maybe<Array<SocialValueType>>;
  source?: Maybe<SourcesEnum>;
  status?: Maybe<UserStatus>;
  target?: Maybe<TargetType>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
  widget?: Maybe<Scalars['Boolean']['output']>;
  work?: Maybe<Array<UserWorkType>>;
};

export type CorporateUsersStatsType = {
  __typename?: 'CorporateUsersStatsType';
  current: Scalars['Int']['output'];
  percentage?: Maybe<Scalars['Decimal']['output']>;
  previous: Scalars['Int']['output'];
};

export enum CountryEnum {
  AFGHANISTAN = 'AFGHANISTAN',
  ALBANIA = 'ALBANIA',
  ALGERIA = 'ALGERIA',
  ANDORRA = 'ANDORRA',
  ANGOLA = 'ANGOLA',
  ANTIGUA_AND_BARBUDA = 'ANTIGUA_AND_BARBUDA',
  ARGENTINA = 'ARGENTINA',
  ARMENIA = 'ARMENIA',
  AUSTRALIA = 'AUSTRALIA',
  AUSTRIA = 'AUSTRIA',
  AZERBAIJAN = 'AZERBAIJAN',
  BAHAMAS = 'BAHAMAS',
  BAHRAIN = 'BAHRAIN',
  BANGLADESH = 'BANGLADESH',
  BARBADOS = 'BARBADOS',
  BELARUS = 'BELARUS',
  BELGIUM = 'BELGIUM',
  BELIZE = 'BELIZE',
  BENIN = 'BENIN',
  BHUTAN = 'BHUTAN',
  BOLIVIA = 'BOLIVIA',
  BOSNIA_AND_HERZEGOVINA = 'BOSNIA_AND_HERZEGOVINA',
  BOTSWANA = 'BOTSWANA',
  BRAZIL = 'BRAZIL',
  BRUNEI = 'BRUNEI',
  BULGARIA = 'BULGARIA',
  BURKINA_FASO = 'BURKINA_FASO',
  BURUNDI = 'BURUNDI',
  CABO_VERDE = 'CABO_VERDE',
  CAMBODIA = 'CAMBODIA',
  CAMEROON = 'CAMEROON',
  CANADA = 'CANADA',
  CENTRALA_FRICAN_REPUBLIC = 'CENTRALA_FRICAN_REPUBLIC',
  CHAD = 'CHAD',
  CHILE = 'CHILE',
  CHINA = 'CHINA',
  COLOMBIA = 'COLOMBIA',
  COMOROS = 'COMOROS',
  CONGO_BRAZZAVILLE = 'CONGO_BRAZZAVILLE',
  COSTA_RICA = 'COSTA_RICA',
  CROATIA = 'CROATIA',
  CUBA = 'CUBA',
  CYPRUS = 'CYPRUS',
  CZECH_REPUBLIC = 'CZECH_REPUBLIC',
  DEMOCRATIC_REPUBLIC_OF_THE_CONGO = 'DEMOCRATIC_REPUBLIC_OF_THE_CONGO',
  DENMARK = 'DENMARK',
  DJIBOUTI = 'DJIBOUTI',
  DOMINICA = 'DOMINICA',
  DOMINICAN_REPUBLIC = 'DOMINICAN_REPUBLIC',
  ECUADOR = 'ECUADOR',
  EGYPT = 'EGYPT',
  EL_SALVADOR = 'EL_SALVADOR',
  EQUATORIAL_GUINEA = 'EQUATORIAL_GUINEA',
  ERITREA = 'ERITREA',
  ESTONIA = 'ESTONIA',
  ESWATINI = 'ESWATINI',
  ETHIOPIA = 'ETHIOPIA',
  FIJI = 'FIJI',
  FINLAND = 'FINLAND',
  FRANCE = 'FRANCE',
  GABON = 'GABON',
  GAMBIA = 'GAMBIA',
  GEORGIA = 'GEORGIA',
  GERMANY = 'GERMANY',
  GHANA = 'GHANA',
  GREECE = 'GREECE',
  GRENADA = 'GRENADA',
  GUATEMALA = 'GUATEMALA',
  GUINEA = 'GUINEA',
  GUINEA_BISSAU = 'GUINEA_BISSAU',
  GUYANA = 'GUYANA',
  HAITI = 'HAITI',
  HOLY_SEE = 'HOLY_SEE',
  HONDURAS = 'HONDURAS',
  HUNGARY = 'HUNGARY',
  ICELAND = 'ICELAND',
  INDIA = 'INDIA',
  INDONESIA = 'INDONESIA',
  IRAN = 'IRAN',
  IRAQ = 'IRAQ',
  IRELAND = 'IRELAND',
  ISRAEL = 'ISRAEL',
  ITALY = 'ITALY',
  IVORY_COAST = 'IVORY_COAST',
  JAMAICA = 'JAMAICA',
  JAPAN = 'JAPAN',
  JORDAN = 'JORDAN',
  KAZAKHSTAN = 'KAZAKHSTAN',
  KENYA = 'KENYA',
  KIRIBATI = 'KIRIBATI',
  KUWAIT = 'KUWAIT',
  KYRGYZSTAN = 'KYRGYZSTAN',
  LAOS = 'LAOS',
  LATVIA = 'LATVIA',
  LEBANON = 'LEBANON',
  LESOTHO = 'LESOTHO',
  LIBERIA = 'LIBERIA',
  LIBYA = 'LIBYA',
  LIECHTENSTEIN = 'LIECHTENSTEIN',
  LITHUANIA = 'LITHUANIA',
  LUXEMBOURG = 'LUXEMBOURG',
  MADAGASCAR = 'MADAGASCAR',
  MALAWI = 'MALAWI',
  MALAYSIA = 'MALAYSIA',
  MALDIVES = 'MALDIVES',
  MALI = 'MALI',
  MALTA = 'MALTA',
  MARSHALL_ISLANDS = 'MARSHALL_ISLANDS',
  MAURITANIA = 'MAURITANIA',
  MAURITIUS = 'MAURITIUS',
  MEXICO = 'MEXICO',
  MICRONESIA = 'MICRONESIA',
  MOLDOVA = 'MOLDOVA',
  MONACO = 'MONACO',
  MONGOLIA = 'MONGOLIA',
  MONTENEGRO = 'MONTENEGRO',
  MOROCCO = 'MOROCCO',
  MOZAMBIQUE = 'MOZAMBIQUE',
  MYANMAR = 'MYANMAR',
  NAMIBIA = 'NAMIBIA',
  NAURU = 'NAURU',
  NEPAL = 'NEPAL',
  NETHERLANDS = 'NETHERLANDS',
  NEW_ZEALAND = 'NEW_ZEALAND',
  NICARAGUA = 'NICARAGUA',
  NIGER = 'NIGER',
  NIGERIA = 'NIGERIA',
  NORTH_KOREA = 'NORTH_KOREA',
  NORTH_MACEDONIA = 'NORTH_MACEDONIA',
  NORWAY = 'NORWAY',
  NOT_SPECIFIED = 'NOT_SPECIFIED',
  OMAN = 'OMAN',
  PAKISTAN = 'PAKISTAN',
  PALAU = 'PALAU',
  PALESTINE_STATE = 'PALESTINE_STATE',
  PANAMA = 'PANAMA',
  PAPUA_NEW_GUINEA = 'PAPUA_NEW_GUINEA',
  PARAGUAY = 'PARAGUAY',
  PERU = 'PERU',
  PHILIPPINES = 'PHILIPPINES',
  POLAND = 'POLAND',
  PORTUGAL = 'PORTUGAL',
  QATAR = 'QATAR',
  ROMANIA = 'ROMANIA',
  RUSSIA = 'RUSSIA',
  RWANDA = 'RWANDA',
  SAINT_KITTS_AND_NEVIS = 'SAINT_KITTS_AND_NEVIS',
  SAINT_LUCIA = 'SAINT_LUCIA',
  SAINT_VINCENT_AND_THE_GRENADINES = 'SAINT_VINCENT_AND_THE_GRENADINES',
  SAMOA = 'SAMOA',
  SAN_MARINO = 'SAN_MARINO',
  SAO_TOME_AND_PRINCIPE = 'SAO_TOME_AND_PRINCIPE',
  SAUDI_ARABIA = 'SAUDI_ARABIA',
  SENEGAL = 'SENEGAL',
  SERBIA = 'SERBIA',
  SEYCHELLES = 'SEYCHELLES',
  SIERRA_LEONE = 'SIERRA_LEONE',
  SINGAPORE = 'SINGAPORE',
  SLOVAKIA = 'SLOVAKIA',
  SLOVENIA = 'SLOVENIA',
  SOLOMON_ISLANDS = 'SOLOMON_ISLANDS',
  SOMALIA = 'SOMALIA',
  SOUTH_AFRICA = 'SOUTH_AFRICA',
  SOUTH_KOREA = 'SOUTH_KOREA',
  SOUTH_SUDAN = 'SOUTH_SUDAN',
  SPAIN = 'SPAIN',
  SRI_LANKA = 'SRI_LANKA',
  SUDAN = 'SUDAN',
  SURINAME = 'SURINAME',
  SWEDEN = 'SWEDEN',
  SWITZERLAND = 'SWITZERLAND',
  SYRIA = 'SYRIA',
  TAJIKISTAN = 'TAJIKISTAN',
  TANZANIA = 'TANZANIA',
  THAILAND = 'THAILAND',
  TIMOR_LESTE = 'TIMOR_LESTE',
  TOGO = 'TOGO',
  TONGA = 'TONGA',
  TRINIDAD_AND_TOBAGO = 'TRINIDAD_AND_TOBAGO',
  TUNISIA = 'TUNISIA',
  TURKEY = 'TURKEY',
  TURKMENISTAN = 'TURKMENISTAN',
  TUVALU = 'TUVALU',
  UGANDA = 'UGANDA',
  UKRAINE = 'UKRAINE',
  UNITED_ARAB_EMIRATES = 'UNITED_ARAB_EMIRATES',
  UNITED_KINGDOM = 'UNITED_KINGDOM',
  UNITED_STATES_OF_AMERICA = 'UNITED_STATES_OF_AMERICA',
  URUGUAY = 'URUGUAY',
  UZBEKISTAN = 'UZBEKISTAN',
  VANUATU = 'VANUATU',
  VENEZUELA = 'VENEZUELA',
  VIETNAM = 'VIETNAM',
  YEMEN = 'YEMEN',
  ZAMBIA = 'ZAMBIA',
  ZIMBABWE = 'ZIMBABWE'
}

export type CountryInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  dialCode?: InputMaybe<Scalars['String']['input']>;
  flagSquare?: InputMaybe<PictureInput>;
  flagWide?: InputMaybe<PictureInput>;
  iconFlag?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CountryPaginatedType = {
  __typename?: 'CountryPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CountryType>;
};

export type CountryProviderInput = {
  code?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CountryProviderPaginateType = {
  __typename?: 'CountryProviderPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CountryProviderType>;
};

export type CountryProviderType = {
  __typename?: 'CountryProviderType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  flag?: Maybe<Scalars['String']['output']>;
  flag64?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CountryType = {
  __typename?: 'CountryType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dialCode?: Maybe<Scalars['String']['output']>;
  flagSquare?: Maybe<PictureType>;
  flagWide?: Maybe<PictureType>;
  iconFlag?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CouponType = {
  __typename?: 'CouponType';
  couponCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<DiscountDtoType>;
  from?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  redeemed?: Maybe<Scalars['Boolean']['output']>;
  target: TargetType;
  to?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type CoverageType = {
  __typename?: 'CoverageType';
  fixtures?: Maybe<LeagueFixtureType>;
  injuries?: Maybe<Scalars['Boolean']['output']>;
  odds?: Maybe<Scalars['Boolean']['output']>;
  players?: Maybe<Scalars['Boolean']['output']>;
  predictions?: Maybe<Scalars['Boolean']['output']>;
  standings?: Maybe<Scalars['Boolean']['output']>;
  top_assists?: Maybe<Scalars['Boolean']['output']>;
  top_cards?: Maybe<Scalars['Boolean']['output']>;
  top_scorers?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateCustomInternalProductInput = {
  /** list of barcodes ids */
  barcodes?: InputMaybe<Array<Scalars['ID']['input']>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  catalogueCategory: Array<Scalars['String']['input']>;
  classification?: InputMaybe<Array<ProductClassEnum>>;
  condition?: InputMaybe<ProductConditionEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionList?: InputMaybe<Array<Scalars['String']['input']>>;
  discount?: InputMaybe<DiscountDtoInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Array<ProductFlagEnum>>;
  globalCategory?: InputMaybe<GlobalCategoryInput>;
  internalProductAttributes?: InputMaybe<InternalProductAttributeInput>;
  longdesc?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  price: Scalars['Decimal']['input'];
  product?: InputMaybe<Scalars['String']['input']>;
  productInput?: InputMaybe<ProductInput>;
  rent?: InputMaybe<Scalars['Boolean']['input']>;
  seo?: InputMaybe<CatalogueCategorySeoInput>;
  sku?: InputMaybe<Scalars['String']['input']>;
  specs?: InputMaybe<Array<ProductSpecsInput>>;
  status?: InputMaybe<ProductStatusEnum>;
  structure?: InputMaybe<ProductStructureEnum>;
  /** list of suppliers ids */
  suppliers?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  target: TargetAciInput;
  translation?: InputMaybe<Array<InternalProductTranslationInput>>;
  url?: InputMaybe<Scalars['String']['input']>;
  variety?: InputMaybe<ProductVarietyEnum>;
};

export type CreateFormInput = {
  description: Scalars['String']['input'];
  owner: FormOwnerInput;
  status?: InputMaybe<FormStatus>;
  title: Scalars['String']['input'];
  type?: InputMaybe<FormType>;
};

export type CreateInternalProductInput = {
  /** list of barcodes ids */
  barcodes?: InputMaybe<Array<Scalars['ID']['input']>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  catalogueCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  classification?: InputMaybe<Array<ProductClassEnum>>;
  condition?: InputMaybe<ProductConditionEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionList?: InputMaybe<Array<Scalars['String']['input']>>;
  discount?: InputMaybe<DiscountDtoInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Array<ProductFlagEnum>>;
  globalCategory?: InputMaybe<GlobalCategoryInput>;
  internalProductAttributes?: InputMaybe<InternalProductAttributeInput>;
  longdesc?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  product: Scalars['String']['input'];
  rent?: InputMaybe<Scalars['Boolean']['input']>;
  seo?: InputMaybe<CatalogueCategorySeoInput>;
  sku?: InputMaybe<Scalars['String']['input']>;
  specs?: InputMaybe<Array<ProductSpecsInput>>;
  status?: InputMaybe<ProductStatusEnum>;
  structure?: InputMaybe<ProductStructureEnum>;
  /** list of suppliers ids */
  suppliers?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  target: TargetAciInput;
  translation?: InputMaybe<Array<InternalProductTranslationInput>>;
  url?: InputMaybe<Scalars['String']['input']>;
  variety?: InputMaybe<ProductVarietyEnum>;
};

export type CreateSimpleProductInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  catalogueCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  classification?: InputMaybe<Array<ProductClassEnum>>;
  condition?: InputMaybe<ProductConditionEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionList?: InputMaybe<Array<Scalars['String']['input']>>;
  discount?: InputMaybe<DiscountDtoInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Array<ProductFlagEnum>>;
  globalCategory?: InputMaybe<GlobalCategoryInput>;
  longdesc?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  rent?: InputMaybe<Scalars['Boolean']['input']>;
  seo?: InputMaybe<CatalogueCategorySeoInput>;
  sku?: InputMaybe<Scalars['String']['input']>;
  specs?: InputMaybe<Array<ProductSpecsInput>>;
  status?: InputMaybe<ProductStatusEnum>;
  structure?: InputMaybe<ProductStructureEnum>;
  /** list of suppliers ids */
  suppliers?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  target: TargetAciInput;
  translation?: InputMaybe<Array<InternalProductTranslationInput>>;
  url?: InputMaybe<Scalars['String']['input']>;
  variety?: InputMaybe<ProductVarietyEnum>;
};

export type CrmAnalyticsBalanceOverviewChartType = {
  __typename?: 'CrmAnalyticsBalanceOverviewChartType';
  data?: Maybe<Array<Scalars['Decimal']['output']>>;
  kind?: Maybe<CrmKindEnum>;
};

export enum CrmKindEnum {
  PENDING = 'PENDING',
  REVENUE = 'REVENUE'
}

export type CurrencyInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  flagSquare?: InputMaybe<PictureInput>;
  flagWide?: InputMaybe<PictureInput>;
  iconFlag?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  symbol?: InputMaybe<Scalars['String']['input']>;
};

export type CurrencyPaginatedType = {
  __typename?: 'CurrencyPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<CurrencyType>;
};

export type CurrencyType = {
  __typename?: 'CurrencyType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  flagSquare?: Maybe<PictureType>;
  flagWide?: Maybe<PictureType>;
  iconFlag?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  symbol?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CurrentPreviousPercentageType = {
  __typename?: 'CurrentPreviousPercentageType';
  current?: Maybe<Scalars['Decimal']['output']>;
  percentage?: Maybe<Scalars['Decimal']['output']>;
  previous?: Maybe<Scalars['Decimal']['output']>;
};

export type CurrentPreviousType = {
  __typename?: 'CurrentPreviousType';
  current: PriceCountType;
  difference?: Maybe<DifferenceType>;
  previous?: Maybe<PriceCountType>;
};

export type CurrentUserReputationsLossDateType = {
  __typename?: 'CurrentUserReputationsLossDateType';
  lossAmount?: Maybe<Scalars['Int']['output']>;
  lossDate?: Maybe<Scalars['DateTime']['output']>;
};

export type CurrentUserReputationsTurnoverLossDateType = {
  __typename?: 'CurrentUserReputationsTurnoverLossDateType';
  currentPoints?: Maybe<Scalars['Int']['output']>;
  lossAmount?: Maybe<Scalars['Int']['output']>;
  lossDate?: Maybe<Scalars['DateTime']['output']>;
  turnoverPoints?: Maybe<Scalars['Int']['output']>;
};

export type CustomMessageType = {
  __typename?: 'CustomMessageType';
  id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum CustomerPhaseEnum {
  CUSTOMER = 'CUSTOMER',
  LEAD = 'LEAD',
  TERMINATION = 'TERMINATION'
}

export type DailyCountType = {
  __typename?: 'DailyCountType';
  date: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type DateRangeType = {
  __typename?: 'DateRangeType';
  max?: Maybe<Scalars['DateTime']['output']>;
  min?: Maybe<Scalars['DateTime']['output']>;
};

export type DateStatsType = {
  __typename?: 'DateStatsType';
  current: Scalars['Decimal']['output'];
  percentage: Scalars['Decimal']['output'];
  previous: Scalars['Decimal']['output'];
};

export type DateValueChartType = {
  __typename?: 'DateValueChartType';
  chart: Array<Array<Scalars['Float']['output']>>;
};

export enum DayEnum {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY'
}

export type DebitorWalletWithStringCoinType = {
  __typename?: 'DebitorWalletWithStringCoinType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  coin?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentReputationLevel?: Maybe<ReputationWithoutTargetType>;
  fee?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  nextReputationLevel?: Maybe<ReputationWithoutTargetType>;
  owner?: Maybe<SimpleTargetWithUserType>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  walletType?: Maybe<WalletTypeEnum>;
};

export type DefaultAudienceInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  segments: Array<AudienceSegmentInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DefaultAudiencePaginateType = {
  __typename?: 'DefaultAudiencePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<DefaultAudienceType>;
};

export type DefaultAudienceType = {
  __typename?: 'DefaultAudienceType';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<MediaType>;
  reach?: Maybe<AudienceReachType>;
  segments?: Maybe<Array<AudienceSegmentType>>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DeleteResponseDtoType = {
  __typename?: 'DeleteResponseDtoType';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum DeleteUserReasonEnum {
  LACK_OF_CONTENT = 'LACK_OF_CONTENT',
  SIZE_AND_COMPATIBILITY = 'SIZE_AND_COMPATIBILITY',
  SOMETHING_IS_BROKEN = 'SOMETHING_IS_BROKEN'
}

export type DeliveryZonePathInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  order: Scalars['Float']['input'];
};

export type DeliveryZonePathType = {
  __typename?: 'DeliveryZonePathType';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  order: Scalars['Float']['output'];
};

export type DepartmentBaseType = {
  __typename?: 'DepartmentBaseType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DepartmentType = {
  __typename?: 'DepartmentType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type DeviceBrandLogoPngType = {
  __typename?: 'DeviceBrandLogoPngType';
  default?: Maybe<PictureType>;
  size16?: Maybe<PictureType>;
  size24?: Maybe<PictureType>;
  size32?: Maybe<PictureType>;
  size48?: Maybe<PictureType>;
  size64?: Maybe<PictureType>;
  size128?: Maybe<PictureType>;
  size256?: Maybe<PictureType>;
  size512?: Maybe<PictureType>;
};

export type DeviceBrandLogoType = {
  __typename?: 'DeviceBrandLogoType';
  icon?: Maybe<Scalars['String']['output']>;
  png?: Maybe<DeviceBrandLogoPngType>;
  svg?: Maybe<PictureType>;
};

export type DeviceDataType = {
  __typename?: 'DeviceDataType';
  androidData: AndroidDataType;
  client: ClientDataType;
  device: MachineDataType;
  iosData: IosDataType;
  os: OperatingSystemDataType;
};

export enum DeviceTypeEnum {
  CAMERA = 'CAMERA',
  CAR_BROWSER = 'CAR_BROWSER',
  CONSOLE = 'CONSOLE',
  DESKTOP = 'DESKTOP',
  FEATURE_PHONE = 'FEATURE_PHONE',
  NO_DATA = 'NO_DATA',
  PERIPHERAL = 'PERIPHERAL',
  PHABLET = 'PHABLET',
  PORTABLE_MEDIA_PLAYER = 'PORTABLE_MEDIA_PLAYER',
  SMARTPHONE = 'SMARTPHONE',
  SMART_DISPLAY = 'SMART_DISPLAY',
  SMART_SPEAKER = 'SMART_SPEAKER',
  TABLET = 'TABLET',
  TV = 'TV',
  WEARABLE = 'WEARABLE'
}

export type DifferenceType = {
  __typename?: 'DifferenceType';
  count?: Maybe<AmountPercentageDecimalType>;
  price?: Maybe<AmountPercentageDecimalType>;
};

export type DiscountDtoInput = {
  amount: Scalars['Decimal']['input'];
  discountType: DiscountType;
};

export type DiscountDtoType = {
  __typename?: 'DiscountDtoType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  discountType?: Maybe<DiscountType>;
};

export enum DiscountType {
  AMOUNT = 'AMOUNT',
  PERCENTAGE = 'PERCENTAGE'
}

export type DocumentContentType = {
  __typename?: 'DocumentContentType';
  base64?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ContentTypeType>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum DocumentReferenceModelEnum {
  WITHOUT_PREFIX = 'WITHOUT_PREFIX',
  WITH_DATE = 'WITH_DATE',
  WITH_DATE_WITHOUT_HYPHEN = 'WITH_DATE_WITHOUT_HYPHEN',
  WITH_PREFIX = 'WITH_PREFIX',
  WITH_PREFIX_AND_DATE = 'WITH_PREFIX_AND_DATE'
}

export type DocumentType = {
  __typename?: 'DocumentType';
  content?: Maybe<DocumentContentType>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner?: Maybe<UserType>;
  size?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type EcommerceAnalyticsBestSellerType = {
  __typename?: 'EcommerceAnalyticsBestSellerType';
  amount: Scalars['Decimal']['output'];
  barcode: BarcodeType;
  orders: Scalars['Decimal']['output'];
  stock: Scalars['Decimal']['output'];
};

export type EmailContentInput = {
  base64?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};

export type EmailIntegrationInput = {
  server?: InputMaybe<EmailIntegrationServerInput>;
  target?: InputMaybe<TargetAciInput>;
};

export type EmailIntegrationServerAuthInput = {
  pass?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type EmailIntegrationServerAuthType = {
  __typename?: 'EmailIntegrationServerAuthType';
  pass?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type EmailIntegrationServerInput = {
  auth?: InputMaybe<EmailIntegrationServerAuthInput>;
  host?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  secure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmailIntegrationServerType = {
  __typename?: 'EmailIntegrationServerType';
  auth?: Maybe<EmailIntegrationServerAuthType>;
  host?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
  secure?: Maybe<Scalars['Boolean']['output']>;
};

export type EmailIntegrationType = {
  __typename?: 'EmailIntegrationType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  server?: Maybe<EmailIntegrationServerType>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type EmailTempInput = {
  attachments?: InputMaybe<Array<MailAttachmentInput>>;
  content?: InputMaybe<EmailContentInput>;
  subject: Scalars['String']['input'];
  template?: InputMaybe<EmailTemplateTypeEnum>;
  to: Array<Scalars['String']['input']>;
  variables?: InputMaybe<EmailTempVariablesInput>;
};

export type EmailTempVariablesBrandInput = {
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type EmailTempVariablesCompanyInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type EmailTempVariablesDocumentInput = {
  category: SequenceCategoryEnum;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type EmailTempVariablesInput = {
  actionUrl?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<EmailTempVariablesBrandInput>;
  company?: InputMaybe<EmailTempVariablesCompanyInput>;
  document?: InputMaybe<EmailTempVariablesDocumentInput>;
  user?: InputMaybe<EmailTempVariablesUserInput>;
  variables?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EmailTempVariablesUserInput = {
  billingAddress?: InputMaybe<FullAddressInput>;
  deliveryAddress?: InputMaybe<FullAddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type EmailTemplateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: EmailTemplateTypeEnum;
};

export type EmailTemplateType = {
  __typename?: 'EmailTemplateType';
  color?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name: EmailTemplateTypeEnum;
};

export enum EmailTemplateTypeEnum {
  ARTICLE_CANCELED = 'ARTICLE_CANCELED',
  ARTICLE_CONFIRMED = 'ARTICLE_CONFIRMED',
  ARTICLE_DELIVERED = 'ARTICLE_DELIVERED',
  ARTICLE_READY_FOR_PICKUP = 'ARTICLE_READY_FOR_PICKUP',
  BLOG = 'BLOG',
  CONFIRM_PASSWORD = 'CONFIRM_PASSWORD',
  CONTACT_REQUEST = 'CONTACT_REQUEST',
  DEMO_BOOKING = 'DEMO_BOOKING',
  DOCUMENT = 'DOCUMENT',
  EXPORT = 'EXPORT',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  FORM_EXPORT = 'FORM_EXPORT',
  INVOICE = 'INVOICE',
  LINK_ACCOUNT = 'LINK_ACCOUNT',
  MERGE_ACCOUNTS = 'MERGE_ACCOUNTS',
  NEWSLETTER = 'NEWSLETTER',
  OTHER = 'OTHER',
  PARTNERSHIP_REFERRAL = 'PARTNERSHIP_REFERRAL',
  PARTNERSHIP_REQUEST = 'PARTNERSHIP_REQUEST',
  PAYMENT_CONFIRMED = 'PAYMENT_CONFIRMED',
  PAYMENT_DECLINED = 'PAYMENT_DECLINED',
  POS_CONTACT_REQUEST = 'POS_CONTACT_REQUEST',
  PROMOTION = 'PROMOTION',
  STYLE = 'STYLE',
  SUBSCRIPTION = 'SUBSCRIPTION',
  TABLE_GUIDANCE = 'TABLE_GUIDANCE',
  VALIDATE_EMAIL = 'VALIDATE_EMAIL',
  WELCOME_USER = 'WELCOME_USER'
}

export type EnableableFieldInput = {
  enable: Scalars['Boolean']['input'];
};

export type EnableableFieldType = {
  __typename?: 'EnableableFieldType';
  enable: Scalars['Boolean']['output'];
};

export enum ErpElementsEnum {
  CONTACTS = 'CONTACTS',
  CUSTOMERS = 'CUSTOMERS',
  EQUIPMENTS = 'EQUIPMENTS',
  PRODUCTS = 'PRODUCTS',
  PURCHASE_DELIVERY_NOTES = 'PURCHASE_DELIVERY_NOTES',
  PURCHASE_INVOICES = 'PURCHASE_INVOICES',
  PURCHASE_ORDERS = 'PURCHASE_ORDERS',
  QUOTATIONS = 'QUOTATIONS',
  SALE_DELIVERY_NOTES = 'SALE_DELIVERY_NOTES',
  SALE_INVOICES = 'SALE_INVOICES',
  SALE_ISSUE_NOTES = 'SALE_ISSUE_NOTES',
  SALE_ORDERS = 'SALE_ORDERS',
  SERVICES = 'SERVICES',
  SUPPLIERS = 'SUPPLIERS'
}

export type ErpIntegrationEventType = {
  __typename?: 'ErpIntegrationEventType';
  active: Scalars['Boolean']['output'];
  event: ErpElementsEnum;
};

export type EventDurationType = {
  __typename?: 'EventDurationType';
  amount?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<PeriodCycleEnum>;
};

export enum EventInviteStatusEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type EventInviteType = {
  __typename?: 'EventInviteType';
  createdAt: Scalars['DateTime']['output'];
  from?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invitee: UserType;
  invitor: EventInvitorType;
  status: EventInviteStatusEnum;
  target?: Maybe<TargetType>;
  title: Scalars['String']['output'];
  to?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type EventInvitorType = {
  __typename?: 'EventInvitorType';
  program?: Maybe<ProgramType>;
  user?: Maybe<UserType>;
};

export type EventLogBaseType = {
  __typename?: 'EventLogBaseType';
  barcode?: Maybe<BarcodeType>;
  coupon?: Maybe<CouponType>;
  email?: Maybe<Scalars['String']['output']>;
  event: ActionTypeEnum;
  fields?: Maybe<Array<Scalars['String']['output']>>;
  order?: Maybe<MarketPlaceOrderDtoType>;
  phone?: Maybe<IPhoneType>;
  productRating?: Maybe<CorporateRatingType>;
  products?: Maybe<Array<EventLogProductType>>;
  source: UserEventsSourceEnum;
  target: TargetType;
  user?: Maybe<UserType>;
};

export type EventLogPaginateType = {
  __typename?: 'EventLogPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<EventLogType>;
};

export type EventLogProductType = {
  __typename?: 'EventLogProductType';
  barcode: BarcodeType;
  quantity: Scalars['Int']['output'];
};

export type EventLogType = {
  __typename?: 'EventLogType';
  barcode?: Maybe<BarcodeType>;
  coupon?: Maybe<CouponType>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  event: ActionTypeEnum;
  fields?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  order?: Maybe<MarketPlaceOrderDtoType>;
  phone?: Maybe<IPhoneType>;
  productRating?: Maybe<CorporateRatingType>;
  products?: Maybe<Array<EventLogProductType>>;
  source: UserEventsSourceEnum;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export enum EventProgramStatusEnum {
  AVAILABLE = 'AVAILABLE',
  CLOSED = 'CLOSED'
}

export type EventSegmentType = {
  __typename?: 'EventSegmentType';
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  title?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Array<EventSegmentsTranslationType>>;
};

export type EventSegmentsTranslationType = {
  __typename?: 'EventSegmentsTranslationType';
  description?: Maybe<Scalars['String']['output']>;
  language?: Maybe<LanguageType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type EventSubscriptionInput = {
  fixture: Scalars['ID']['input'];
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type EventSubscriptionType = {
  __typename?: 'EventSubscriptionType';
  createdAt: Scalars['DateTime']['output'];
  fixture: FixtureType;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export enum EventTicketStatusEnum {
  ATTENDED = 'ATTENDED',
  OPEN = 'OPEN',
  PAID = 'PAID'
}

export type EventTicketType = {
  __typename?: 'EventTicketType';
  createdAt: Scalars['DateTime']['output'];
  event: EventType;
  id: Scalars['ID']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
  reference: Scalars['String']['output'];
  status: EventTicketStatusEnum;
  target?: Maybe<TargetType>;
  ticketUser: EventTicketUserType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type EventTicketUserType = {
  __typename?: 'EventTicketUserType';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type EventTranslationType = {
  __typename?: 'EventTranslationType';
  description?: Maybe<Scalars['String']['output']>;
  emailSubject?: Maybe<Scalars['String']['output']>;
  emailTemplate?: Maybe<Scalars['String']['output']>;
  language?: Maybe<LanguageType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type EventType = {
  __typename?: 'EventType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<EventDurationType>;
  emailSubject?: Maybe<Scalars['String']['output']>;
  emailTemplate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  picture?: Maybe<PictureType>;
  segments?: Maybe<Array<EventSegmentType>>;
  target?: Maybe<TargetType>;
  title?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Array<EventTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum EventTypeEnum {
  ADHOC_NOTIFICATION = 'ADHOC_NOTIFICATION',
  APP_LOG = 'APP_LOG',
  BOOKING_CANCELLED_BY_CONSUMER = 'BOOKING_CANCELLED_BY_CONSUMER',
  BOOKING_CANCELLED_BY_POS = 'BOOKING_CANCELLED_BY_POS',
  BOOKING_CONFIRMED = 'BOOKING_CONFIRMED',
  BOOKING_CREATED = 'BOOKING_CREATED',
  CALL_WAITER_FOR_CHECK = 'CALL_WAITER_FOR_CHECK',
  CHALLENGE_WON = 'CHALLENGE_WON',
  DEAL_CONFIRMED = 'DEAL_CONFIRMED',
  DELIVERY_MAN_ASSIGNED = 'DELIVERY_MAN_ASSIGNED',
  ORDER_CREATED = 'ORDER_CREATED',
  OUTBOUND_WIDGET = 'OUTBOUND_WIDGET',
  PRODUCT_CANCELLED = 'PRODUCT_CANCELLED',
  PRODUCT_PAYMENT_STATUS_UPDATED = 'PRODUCT_PAYMENT_STATUS_UPDATED',
  PRODUCT_STATUS_UPDATED = 'PRODUCT_STATUS_UPDATED',
  PUSH_AMOUNT = 'PUSH_AMOUNT',
  QUEST_ACTIVITY_FULFILLED = 'QUEST_ACTIVITY_FULFILLED',
  QUEST_FULFILLED = 'QUEST_FULFILLED',
  REDEEM = 'REDEEM',
  REPUTATION_ALMOST_LOST = 'REPUTATION_ALMOST_LOST',
  REPUTATION_LOST = 'REPUTATION_LOST',
  SUBSCRIPTION_APPROVED = 'SUBSCRIPTION_APPROVED',
  SUBSCRIPTION_REJECTED = 'SUBSCRIPTION_REJECTED',
  SUBSCRIPTION_REQUESTED = 'SUBSCRIPTION_REQUESTED',
  TURNOVER_ALMOST_LOST = 'TURNOVER_ALMOST_LOST',
  TURNOVER_LOST = 'TURNOVER_LOST',
  TURNOVER_MAINTAINED = 'TURNOVER_MAINTAINED',
  WAITER_CALLED = 'WAITER_CALLED',
  WALLET_TOPUP = 'WALLET_TOPUP',
  WALLET_TOPUP_CONFIRMED = 'WALLET_TOPUP_CONFIRMED',
  WALLET_TOPUP_DELIVERED = 'WALLET_TOPUP_DELIVERED'
}

export type EventsPaginateType = {
  __typename?: 'EventsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<EventsType>;
};

export type EventsPlayerType = {
  __typename?: 'EventsPlayerType';
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type EventsTeamType = {
  __typename?: 'EventsTeamType';
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type EventsTimeType = {
  __typename?: 'EventsTimeType';
  elapsed?: Maybe<Scalars['Float']['output']>;
  extra?: Maybe<Scalars['Float']['output']>;
};

export type EventsType = {
  __typename?: 'EventsType';
  assist?: Maybe<EventsPlayerType>;
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  fixture?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  player?: Maybe<EventsPlayerType>;
  team?: Maybe<EventsTeamType>;
  time?: Maybe<EventsTimeType>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ExternalIdType = {
  __typename?: 'ExternalIdType';
  reference?: Maybe<Scalars['String']['output']>;
  target?: Maybe<TargetType>;
};

export type FbCatalogSyncAttributesType = {
  __typename?: 'FBCatalogSyncAttributesType';
  active: Scalars['Boolean']['output'];
  ageGroup: Scalars['Boolean']['output'];
  color: Scalars['Boolean']['output'];
  gender: Scalars['Boolean']['output'];
  material: Scalars['Boolean']['output'];
  pattern: Scalars['Boolean']['output'];
  size: Scalars['Boolean']['output'];
};

export type FbCatalogSyncShippingType = {
  __typename?: 'FBCatalogSyncShippingType';
  active: Scalars['Boolean']['output'];
  country?: Maybe<CountryType>;
  price?: Maybe<Scalars['Decimal']['output']>;
  service?: Maybe<Scalars['String']['output']>;
};

export type FbPixelEventType = {
  __typename?: 'FBPixelEventType';
  active: Scalars['Boolean']['output'];
  event: PixelRecommendedEventsEnum;
};

export type FacebookDataType = {
  __typename?: 'FacebookDataType';
  email: Scalars['String']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type FacebookProfileAuditDataType = {
  __typename?: 'FacebookProfileAuditDataType';
  address?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  checkins?: Maybe<Scalars['String']['output']>;
  delivery_options?: Maybe<Scalars['String']['output']>;
  delivery_settings?: Maybe<FacebookProfileAuditDeliverySettingsType>;
  email?: Maybe<Scalars['String']['output']>;
  formatted_cuisines?: Maybe<Scalars['String']['output']>;
  impressum?: Maybe<Array<Scalars['String']['output']>>;
  info?: Maybe<Array<Scalars['String']['output']>>;
  instagram?: Maybe<Scalars['String']['output']>;
  is_delegate_page_with_linked_profile?: Maybe<Scalars['Boolean']['output']>;
  likes?: Maybe<Scalars['Float']['output']>;
  menu?: Maybe<FacebookProfileAuditMenuType>;
  messenger?: Maybe<Scalars['String']['output']>;
  mission?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  overview?: Maybe<Array<Scalars['String']['output']>>;
  pageId?: Maybe<Scalars['String']['output']>;
  pageName?: Maybe<Scalars['String']['output']>;
  pageUrl?: Maybe<Scalars['String']['output']>;
  payment?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  posts?: Maybe<Array<FacebookProfilePostsType>>;
  priceRange?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Scalars['String']['output']>>;
  rating?: Maybe<Scalars['String']['output']>;
  reviews?: Maybe<Array<FacebookProfileAuditReviewType>>;
  services?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  transit?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  wifi?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type FacebookProfileAuditDeliverySettingsType = {
  __typename?: 'FacebookProfileAuditDeliverySettingsType';
  delivery_details?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type FacebookProfileAuditMenuImagesPhotosImageType = {
  __typename?: 'FacebookProfileAuditMenuImagesPhotosImageType';
  height?: Maybe<Scalars['Float']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type FacebookProfileAuditMenuImagesPhotosOwnerType = {
  __typename?: 'FacebookProfileAuditMenuImagesPhotosOwnerType';
  additional_profile_has_taggable_products?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type FacebookProfileAuditMenuImagesPhotosType = {
  __typename?: 'FacebookProfileAuditMenuImagesPhotosType';
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<FacebookProfileAuditMenuImagesPhotosImageType>;
  isPlayable?: Maybe<Scalars['Boolean']['output']>;
  likes?: Maybe<Scalars['Float']['output']>;
  ocrText?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<FacebookProfileAuditMenuImagesPhotosOwnerType>;
  timestamp?: Maybe<Scalars['Float']['output']>;
};

export type FacebookProfileAuditMenuImagesType = {
  __typename?: 'FacebookProfileAuditMenuImagesType';
  id?: Maybe<Scalars['String']['output']>;
  menu_image_title?: Maybe<Scalars['String']['output']>;
  menu_photo?: Maybe<FacebookProfileAuditMenuImagesPhotosType>;
};

export type FacebookProfileAuditMenuType = {
  __typename?: 'FacebookProfileAuditMenuType';
  id?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<FacebookProfileAuditMenuImagesType>>;
  share_page_menu_link?: Maybe<Scalars['String']['output']>;
  structured_menu_program?: Maybe<Scalars['String']['output']>;
};

export type FacebookProfileAuditReviewType = {
  __typename?: 'FacebookProfileAuditReviewType';
  commentsCount?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  legacyId?: Maybe<Scalars['String']['output']>;
  likesCount?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user?: Maybe<FacebookProfileAuditReviewUserType>;
};

export type FacebookProfileAuditReviewUserType = {
  __typename?: 'FacebookProfileAuditReviewUserType';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profilePic?: Maybe<Scalars['String']['output']>;
  profileUrl?: Maybe<Scalars['String']['output']>;
};

export type FacebookProfilePostsCommentsType = {
  __typename?: 'FacebookProfilePostsCommentsType';
  count?: Maybe<Scalars['Float']['output']>;
};

export type FacebookProfilePostsStatsType = {
  __typename?: 'FacebookProfilePostsStatsType';
  comments?: Maybe<Scalars['Float']['output']>;
  likes?: Maybe<Scalars['Float']['output']>;
  shares?: Maybe<Scalars['Float']['output']>;
};

export type FacebookProfilePostsType = {
  __typename?: 'FacebookProfilePostsType';
  alt?: Maybe<Scalars['String']['output']>;
  postComments?: Maybe<FacebookProfilePostsCommentsType>;
  postDate?: Maybe<Scalars['DateTime']['output']>;
  postId?: Maybe<Scalars['String']['output']>;
  postLinks?: Maybe<Array<Scalars['String']['output']>>;
  postStats?: Maybe<FacebookProfilePostsStatsType>;
  postText?: Maybe<Scalars['String']['output']>;
  postUrl?: Maybe<Scalars['String']['output']>;
  postsImages?: Maybe<Array<Scalars['String']['output']>>;
  timestamp?: Maybe<Scalars['Float']['output']>;
};

export type FavoriteLeagueDefinitionPaginateType = {
  __typename?: 'FavoriteLeagueDefinitionPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<FavoriteLeagueDefinitionType>;
};

export type FavoriteLeagueDefinitionType = {
  __typename?: 'FavoriteLeagueDefinitionType';
  createdAt: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  league?: Maybe<LeagueType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FavoriteLeagueInput = {
  league: Scalars['Int']['input'];
  user: Scalars['ID']['input'];
};

export type FavoriteLeaguePaginateType = {
  __typename?: 'FavoriteLeaguePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<FavoriteLeagueType>;
};

export type FavoriteLeagueType = {
  __typename?: 'FavoriteLeagueType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  league: LeagueType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type FavoriteTeamDefinitionPaginateType = {
  __typename?: 'FavoriteTeamDefinitionPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<FavoriteTeamDefinitionType>;
};

export type FavoriteTeamDefinitionType = {
  __typename?: 'FavoriteTeamDefinitionType';
  createdAt: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  teamInformation?: Maybe<TeamInformationType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FavoriteTeamInput = {
  team: Scalars['Int']['input'];
  user: Scalars['ID']['input'];
};

export type FavoriteTeamPaginateType = {
  __typename?: 'FavoriteTeamPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<FavoriteTeamType>;
};

export type FavoriteTeamType = {
  __typename?: 'FavoriteTeamType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  team: TeamInformationType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type FeaturedCorporateType = {
  __typename?: 'FeaturedCorporateType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  manufacturer?: Maybe<ManufacturerType>;
  pos?: Maybe<PointOfSaleType>;
  rank: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  wholesaler?: Maybe<WholesalerType>;
};

export type FigamyIntegratioConverterType = {
  __typename?: 'FigamyIntegratioConverterType';
  active: Scalars['Boolean']['output'];
  rate?: Maybe<Scalars['String']['output']>;
};

export type FigamyIntegratioMarketplaceType = {
  __typename?: 'FigamyIntegratioMarketplaceType';
  active?: Maybe<Scalars['Boolean']['output']>;
  comission?: Maybe<Scalars['String']['output']>;
  paymentCycle?: Maybe<RecurrenceType>;
};

export type FigamyIntegrationAuthType = {
  __typename?: 'FigamyIntegrationAuthType';
  publicKey?: Maybe<Scalars['String']['output']>;
  secretKey?: Maybe<Scalars['String']['output']>;
};

export type FigamyIntegrationAuthenticationLoginType = {
  __typename?: 'FigamyIntegrationAuthenticationLoginType';
  active: Scalars['Boolean']['output'];
};

export type FigamyIntegrationAuthenticationType = {
  __typename?: 'FigamyIntegrationAuthenticationType';
  active: Scalars['Boolean']['output'];
  appAuth?: Maybe<FigamyIntegrationAuthType>;
  figamyAuth?: Maybe<FigamyIntegrationAuthType>;
  login?: Maybe<FigamyIntegrationAuthenticationLoginType>;
};

export type FigamyIntegrationCatalogType = {
  __typename?: 'FigamyIntegrationCatalogType';
  active: Scalars['Boolean']['output'];
  auth?: Maybe<FigamyIntegrationAuthType>;
  sale: Scalars['Boolean']['output'];
  sell: Scalars['Boolean']['output'];
  shipping: Scalars['Boolean']['output'];
  syncTime?: Maybe<RecurrenceType>;
};

export type FigamyIntegrationDealsType = {
  __typename?: 'FigamyIntegrationDealsType';
  active: Scalars['Boolean']['output'];
  monthlyAmount?: Maybe<Scalars['String']['output']>;
  selfManaging: Scalars['Boolean']['output'];
};

export type FigamyIntegrationWalletReputationType = {
  __typename?: 'FigamyIntegrationWalletReputationType';
  active: Scalars['Boolean']['output'];
  inactivityCycle: Scalars['Boolean']['output'];
  lossAmount: Scalars['Boolean']['output'];
  perks: Scalars['Boolean']['output'];
};

export type FigamyIntegrationWalletType = {
  __typename?: 'FigamyIntegrationWalletType';
  active: Scalars['Boolean']['output'];
  qualitative?: Maybe<FigamyIntegrationAuthenticationLoginType>;
  quantitative?: Maybe<FigamyIntegrationAuthenticationLoginType>;
  reputation?: Maybe<FigamyIntegrationWalletReputationType>;
};

export type FilterLabelFieldType = {
  __typename?: 'FilterLabelFieldType';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type FilterNameFieldType = {
  __typename?: 'FilterNameFieldType';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type FilterNamePictureFieldType = {
  __typename?: 'FilterNamePictureFieldType';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
};

export type FirstReplyType = {
  __typename?: 'FirstReplyType';
  hasMoreReplies: Scalars['Boolean']['output'];
  reply?: Maybe<CommentBaseType>;
};

export type FixtureFilterInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Array<Scalars['Int']['input']>>;
  league?: InputMaybe<Array<Scalars['Int']['input']>>;
  season?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<Array<FixtureStatusEnum>>;
  team?: InputMaybe<Array<Scalars['Int']['input']>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FixtureGoalsType = {
  __typename?: 'FixtureGoalsType';
  away?: Maybe<Scalars['Float']['output']>;
  home?: Maybe<Scalars['Float']['output']>;
};

export type FixtureHaType = {
  __typename?: 'FixtureHAType';
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logo64?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  winner?: Maybe<Scalars['Boolean']['output']>;
};

export type FixtureLeagueType = {
  __typename?: 'FixtureLeagueType';
  country?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Scalars['String']['output']>;
  flag64?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logo64?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  round?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
};

export type FixturePaginateType = {
  __typename?: 'FixturePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<FixtureType>;
};

export type FixturePeriodType = {
  __typename?: 'FixturePeriodType';
  first?: Maybe<Scalars['Float']['output']>;
  second?: Maybe<Scalars['String']['output']>;
};

export type FixtureScoreType = {
  __typename?: 'FixtureScoreType';
  extratime?: Maybe<FixtureGoalsType>;
  fulltime?: Maybe<FixtureGoalsType>;
  halftime?: Maybe<FixtureGoalsType>;
  penalty?: Maybe<FixtureGoalsType>;
};

export enum FixtureStatusEnum {
  ABD = 'ABD',
  AET = 'AET',
  AWD = 'AWD',
  BT = 'BT',
  CANC = 'CANC',
  ET = 'ET',
  FT = 'FT',
  HT = 'HT',
  INT = 'INT',
  LIVE = 'LIVE',
  NS = 'NS',
  P = 'P',
  PEN = 'PEN',
  PST = 'PST',
  SUSP = 'SUSP',
  TBD = 'TBD',
  WO = 'WO'
}

export type FixtureStatusType = {
  __typename?: 'FixtureStatusType';
  elapsed?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  short?: Maybe<Scalars['String']['output']>;
};

export type FixtureSubType = {
  __typename?: 'FixtureSubType';
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  periods?: Maybe<FixturePeriodType>;
  referee?: Maybe<Scalars['String']['output']>;
  status?: Maybe<FixtureStatusType>;
  timestamp?: Maybe<Scalars['Float']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  venue?: Maybe<FixtureVenueType>;
};

export type FixtureTeamsType = {
  __typename?: 'FixtureTeamsType';
  away?: Maybe<FixtureHaType>;
  home?: Maybe<FixtureHaType>;
};

export type FixtureType = {
  __typename?: 'FixtureType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fixture?: Maybe<FixtureSubType>;
  goals?: Maybe<FixtureGoalsType>;
  id: Scalars['ID']['output'];
  isUserSubscribedToFixtureEvents?: Maybe<Scalars['Boolean']['output']>;
  league?: Maybe<FixtureLeagueType>;
  score?: Maybe<FixtureScoreType>;
  teams?: Maybe<FixtureTeamsType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FixtureVenueType = {
  __typename?: 'FixtureVenueType';
  city?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FixtureWithOddsPaginateType = {
  __typename?: 'FixtureWithOddsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<FixtureWithOddsType>;
};

export type FixtureWithOddsType = {
  __typename?: 'FixtureWithOddsType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fixture?: Maybe<FixtureSubType>;
  goals?: Maybe<FixtureGoalsType>;
  id: Scalars['ID']['output'];
  isUserSubscribedToFixtureEvents?: Maybe<Scalars['Boolean']['output']>;
  league?: Maybe<FixtureLeagueType>;
  odds?: Maybe<OddsBookmakersBetsType>;
  score?: Maybe<FixtureScoreType>;
  teams?: Maybe<FixtureTeamsType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum FlowAudienceTriggerEnum {
  JOIN = 'JOIN',
  LEAVE = 'LEAVE'
}

export enum FlowCategoryEnum {
  BADGE = 'BADGE',
  DEFAULT = 'DEFAULT'
}

export enum FlowDateTriggerEnum {
  BIRTHDATE = 'BIRTHDATE',
  CREATED = 'CREATED',
  FIRST_ACTIVE = 'FIRST_ACTIVE'
}

export type FlowFlowActionActionEmailType = {
  __typename?: 'FlowFlowActionActionEmailType';
  content?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type FlowFlowActionActionInternalType = {
  __typename?: 'FlowFlowActionActionInternalType';
  content?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type FlowFlowActionActionProfilePropertyCustomType = {
  __typename?: 'FlowFlowActionActionProfilePropertyCustomType';
  category?: Maybe<FlowProfileCategoryEnum>;
  label?: Maybe<Scalars['String']['output']>;
};

export type FlowFlowActionActionProfilePropertyType = {
  __typename?: 'FlowFlowActionActionProfilePropertyType';
  custom?: Maybe<FlowFlowActionActionProfilePropertyCustomType>;
  existing?: Maybe<FlowProfilePropertyEnum>;
};

export type FlowFlowActionActionProfileType = {
  __typename?: 'FlowFlowActionActionProfileType';
  action?: Maybe<FlowProfileActionEnum>;
  property?: Maybe<FlowFlowActionActionProfilePropertyType>;
  value?: Maybe<FlowFlowActionActionProfileValueType>;
};

export type FlowFlowActionActionProfileValueType = {
  __typename?: 'FlowFlowActionActionProfileValueType';
  custom?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
};

export type FlowFlowActionActionPushType = {
  __typename?: 'FlowFlowActionActionPushType';
  description?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type FlowFlowActionActionSmsType = {
  __typename?: 'FlowFlowActionActionSmsType';
  content?: Maybe<Scalars['String']['output']>;
};

export type FlowFlowActionActionType = {
  __typename?: 'FlowFlowActionActionType';
  email?: Maybe<FlowFlowActionActionEmailType>;
  internal?: Maybe<FlowFlowActionActionInternalType>;
  profile?: Maybe<Array<FlowFlowActionActionProfileType>>;
  push?: Maybe<FlowFlowActionActionPushType>;
  sms?: Maybe<FlowFlowActionActionSmsType>;
};

export type FlowFlowActionLogicType = {
  __typename?: 'FlowFlowActionLogicType';
  condition?: Maybe<Array<AudienceSegmentType>>;
  no?: Maybe<Array<FlowFlowActionType>>;
  rejoin?: Maybe<Array<FlowFlowActionType>>;
  yes?: Maybe<Array<FlowFlowActionType>>;
};

export type FlowFlowActionType = {
  __typename?: 'FlowFlowActionType';
  action?: Maybe<FlowFlowActionActionType>;
  logic?: Maybe<FlowFlowActionLogicType>;
  timing?: Maybe<Scalars['Int']['output']>;
};

export type FlowFlowTriggerAudienceType = {
  __typename?: 'FlowFlowTriggerAudienceType';
  audience?: Maybe<AudienceType>;
  trigger?: Maybe<FlowAudienceTriggerEnum>;
};

export type FlowFlowTriggerDateExecutionScheduleType = {
  __typename?: 'FlowFlowTriggerDateExecutionScheduleType';
  schedule?: Maybe<FlowScheduleTriggerEnum>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type FlowFlowTriggerDateExecutionType = {
  __typename?: 'FlowFlowTriggerDateExecutionType';
  instant?: Maybe<Scalars['Boolean']['output']>;
  schedule?: Maybe<FlowFlowTriggerDateExecutionScheduleType>;
};

export type FlowFlowTriggerDateType = {
  __typename?: 'FlowFlowTriggerDateType';
  date?: Maybe<FlowDateTriggerEnum>;
  execution?: Maybe<FlowFlowTriggerDateExecutionType>;
};

export type FlowFlowTriggerMetricType = {
  __typename?: 'FlowFlowTriggerMetricType';
  metric?: Maybe<FlowMetricTriggerEnum>;
};

export type FlowFlowTriggerReputationType = {
  __typename?: 'FlowFlowTriggerReputationType';
  reputation?: Maybe<ReputationType>;
  trigger?: Maybe<FlowReputationTriggerEnum>;
};

export type FlowFlowTriggerType = {
  __typename?: 'FlowFlowTriggerType';
  audience?: Maybe<FlowFlowTriggerAudienceType>;
  date?: Maybe<FlowFlowTriggerDateType>;
  metric?: Maybe<FlowFlowTriggerMetricType>;
  reputation?: Maybe<FlowFlowTriggerReputationType>;
};

export type FlowFlowType = {
  __typename?: 'FlowFlowType';
  actions?: Maybe<Array<FlowFlowActionType>>;
  trigger?: Maybe<FlowFlowTriggerType>;
};

export enum FlowMetricTriggerEnum {
  MOBILE_ORDER = 'MOBILE_ORDER',
  ORDER = 'ORDER',
  PHYSICAL_ORDER = 'PHYSICAL_ORDER',
  WEB_ORDER = 'WEB_ORDER'
}

export enum FlowProfileActionEnum {
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  UPDATE = 'UPDATE'
}

export enum FlowProfileCategoryEnum {
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  LIST = 'LIST',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT'
}

export enum FlowProfilePropertyEnum {
  CREATED = 'CREATED',
  EMAIL = 'EMAIL',
  FIRST_ACTIVE = 'FIRST_ACTIVE',
  FIRST_NAME = 'FIRST_NAME',
  LAST_ACTIVE = 'LAST_ACTIVE',
  LAST_NAME = 'LAST_NAME',
  ORGANIZATION = 'ORGANIZATION',
  PHONE_NUMBER = 'PHONE_NUMBER',
  TITLE = 'TITLE'
}

export enum FlowReputationTriggerEnum {
  LOST = 'LOST',
  WON = 'WON'
}

export enum FlowScheduleTriggerEnum {
  DAYS = 'DAYS',
  HOURS = 'HOURS',
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS'
}

export enum FlowStatusEnum {
  ARCHIVED = 'ARCHIVED',
  DRAFT = 'DRAFT',
  LIVE = 'LIVE'
}

export type FlowType = {
  __typename?: 'FlowType';
  category?: Maybe<FlowCategoryEnum>;
  conversion?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  flow?: Maybe<FlowFlowType>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  picture?: Maybe<PictureType>;
  status?: Maybe<FlowStatusEnum>;
  target?: Maybe<TargetType>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FollowType = {
  __typename?: 'FollowType';
  id: Scalars['ID']['output'];
  target: TargetWithGroupType;
  user: UserType;
};

export type FollowerType = {
  __typename?: 'FollowerType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type FontType = {
  __typename?: 'FontType';
  createdAt: Scalars['DateTime']['output'];
  family?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  preview?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type FormDtoType = {
  __typename?: 'FormDtoType';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  owner: FormOwnerDtoType;
  status?: Maybe<FormStatus>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<FormType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FormFiltersInput = {
  owner?: InputMaybe<FormOwnerFilterInput>;
  statuses?: InputMaybe<Array<FormStatus>>;
  types?: InputMaybe<Array<FormType>>;
};

export type FormOwnerDtoType = {
  __typename?: 'FormOwnerDtoType';
  manufacturer?: Maybe<ManufacturerType>;
  pos?: Maybe<PointOfSaleType>;
  wholesaler?: Maybe<WholesalerType>;
};

export type FormOwnerFilterInput = {
  manufacturers?: InputMaybe<Array<Scalars['String']['input']>>;
  pos?: InputMaybe<Array<Scalars['String']['input']>>;
  wholesaler?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FormOwnerInput = {
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  pos?: InputMaybe<Scalars['String']['input']>;
  wholesaler?: InputMaybe<Scalars['String']['input']>;
};

export type FormPaginateType = {
  __typename?: 'FormPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<FormResponseType>;
};

export type FormResponseType = {
  __typename?: 'FormResponseType';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owner: FormOwnerDtoType;
  questions: Array<QuestionDtoType>;
  status: FormStatus;
  title: Scalars['String']['output'];
  type: FormType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum FormStatus {
  CHECKED = 'CHECKED',
  DRAFT = 'DRAFT',
  FINISHED = 'FINISHED',
  ONGOING = 'ONGOING'
}

export enum FormType {
  AUTONOMOUS = 'AUTONOMOUS',
  GUIDED = 'GUIDED'
}

export type FromToInput = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type FullAddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<LonLatInput>;
  owner?: InputMaybe<FullAddressOwnerInput>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['ID']['input']>;
};

export type FullAddressOwnerInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<FullAddressOwnerPhoneInput>;
};

export type FullAddressOwnerPhoneInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
};

export type FullAddressOwnerPhoneType = {
  __typename?: 'FullAddressOwnerPhoneType';
  countryCode?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type FullAddressOwnerType = {
  __typename?: 'FullAddressOwnerType';
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<FullAddressOwnerPhoneType>;
};

export type FullAddressType = {
  __typename?: 'FullAddressType';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryType>;
  location?: Maybe<LonLatType>;
  owner?: Maybe<FullAddressOwnerType>;
  postCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<StateType>;
};

export enum GaRecommendedEventsEnum {
  ADD_PAYMENT_INFO = 'ADD_PAYMENT_INFO',
  ADD_SHIPPING_INFO = 'ADD_SHIPPING_INFO',
  ADD_TO_CART = 'ADD_TO_CART',
  ADD_TO_WISHLIST = 'ADD_TO_WISHLIST',
  BEGIN_CHECKOUT = 'BEGIN_CHECKOUT',
  EARN_VIRTUAL_CURRENCY = 'EARN_VIRTUAL_CURRENCY',
  GENERATE_LEAD = 'GENERATE_LEAD',
  LOGIN = 'LOGIN',
  PURCHASE = 'PURCHASE',
  REFUND = 'REFUND',
  REMOVE_FROM_CART = 'REMOVE_FROM_CART',
  SEARCH = 'SEARCH',
  SELECT_ITEM = 'SELECT_ITEM',
  SELECT_PROMOTION = 'SELECT_PROMOTION',
  SHARE = 'SHARE',
  SIGN_UP = 'SIGN_UP',
  SPEND_VIRTUAL_CURRENCY = 'SPEND_VIRTUAL_CURRENCY',
  VIEW_CART = 'VIEW_CART',
  VIEW_ITEM = 'VIEW_ITEM',
  VIEW_PROMOTION = 'VIEW_PROMOTION'
}

export type GameContentInput = {
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type GameContentType = {
  __typename?: 'GameContentType';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type GameInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  point?: InputMaybe<GamePointInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Array<GameTranslationInput>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type GameIntegrationInput = {
  games?: InputMaybe<Array<GameIntegrationSettingsInput>>;
};

export type GameIntegrationLeaderboardInput = {
  active?: Scalars['Boolean']['input'];
  blur?: Scalars['Boolean']['input'];
  daily?: Scalars['Boolean']['input'];
  monthly?: Scalars['Boolean']['input'];
  overall?: Scalars['Boolean']['input'];
  weekly?: Scalars['Boolean']['input'];
};

export type GameIntegrationLeaderboardType = {
  __typename?: 'GameIntegrationLeaderboardType';
  active: Scalars['Boolean']['output'];
  blur: Scalars['Boolean']['output'];
  daily: Scalars['Boolean']['output'];
  monthly: Scalars['Boolean']['output'];
  overall: Scalars['Boolean']['output'];
  weekly: Scalars['Boolean']['output'];
};

export type GameIntegrationOneRewardsType = {
  __typename?: 'GameIntegrationOneRewardsType';
  createdAt: Scalars['DateTime']['output'];
  enable?: Maybe<Scalars['Boolean']['output']>;
  game?: Maybe<GameType>;
  id: Scalars['ID']['output'];
  leaderboard?: Maybe<GameIntegrationLeaderboardType>;
  rewards?: Maybe<Array<GameIntegrationRewardInnerType>>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type GameIntegrationRewardInnerInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  rank?: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GameIntegrationRewardInnerType = {
  __typename?: 'GameIntegrationRewardInnerType';
  description?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  rank: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type GameIntegrationSettingsGameType = {
  __typename?: 'GameIntegrationSettingsGameType';
  enable?: Maybe<Scalars['Boolean']['output']>;
  game?: Maybe<GameType>;
  id: Scalars['ID']['output'];
  leaderboard?: Maybe<GameIntegrationLeaderboardType>;
  rewards?: Maybe<Array<GameIntegrationRewardInnerType>>;
};

export type GameIntegrationSettingsInput = {
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  game?: InputMaybe<Scalars['String']['input']>;
  leaderboard?: InputMaybe<GameIntegrationLeaderboardInput>;
};

export type GameIntegrationSettingsType = {
  __typename?: 'GameIntegrationSettingsType';
  enable?: Maybe<Scalars['Boolean']['output']>;
  game?: Maybe<GameType>;
  leaderboard?: Maybe<GameIntegrationLeaderboardType>;
};

export type GameIntegrationType = {
  __typename?: 'GameIntegrationType';
  createdAt: Scalars['DateTime']['output'];
  games?: Maybe<Array<GameIntegrationSettingsType>>;
  id: Scalars['ID']['output'];
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type GamePaginateType = {
  __typename?: 'GamePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<GameType>;
};

export type GamePointInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
  picture: PictureInput;
};

export type GamePointType = {
  __typename?: 'GamePointType';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  picture: PictureType;
};

export enum GameTimerEnum {
  FIVE_MINUTES = 'FIVE_MINUTES',
  HALF_MINUTE = 'HALF_MINUTE',
  MINUTE = 'MINUTE',
  TWO_MINUTES = 'TWO_MINUTES'
}

export type GameTranslationInput = {
  content: GameContentInput;
  language: Scalars['ID']['input'];
};

export type GameTranslationType = {
  __typename?: 'GameTranslationType';
  content: GameContentType;
  language: LanguageType;
};

export type GameType = {
  __typename?: 'GameType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<MediaType>;
  point: GamePointType;
  title?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Array<GameTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export enum GameTypeEnum {
  FIND_HIDDEN_OBJECT = 'FIND_HIDDEN_OBJECT',
  GUESS_MISSING_ELEMENT = 'GUESS_MISSING_ELEMENT',
  GUESS_THE_PRICE = 'GUESS_THE_PRICE',
  JIGSAW = 'JIGSAW',
  MEMORY_GAME = 'MEMORY_GAME',
  SLIDING = 'SLIDING',
  TRIVIA_QUIZ = 'TRIVIA_QUIZ'
}

export type GameUpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  point?: InputMaybe<GamePointInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Array<GameTranslationInput>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type GamificationDashboardKycCompletedType = {
  __typename?: 'GamificationDashboardKYCCompletedType';
  count: Scalars['Int']['output'];
  percentage: Scalars['String']['output'];
};

export type GamificationDashboardKycIncompletedType = {
  __typename?: 'GamificationDashboardKYCIncompletedType';
  average: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  percentage: Scalars['String']['output'];
};

export type GamificationDashboardKycTotalType = {
  __typename?: 'GamificationDashboardKYCTotalType';
  average: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type GamificationDashboardKycType = {
  __typename?: 'GamificationDashboardKYCType';
  KYCIndex: Scalars['String']['output'];
  completed: GamificationDashboardKycCompletedType;
  inactiveIncompleted: GamificationDashboardKycIncompletedType;
  incompleted: GamificationDashboardKycIncompletedType;
  total: GamificationDashboardKycTotalType;
};

export type GamificationEngagmentPointsEarnedPerActivityDashboardType = {
  __typename?: 'GamificationEngagmentPointsEarnedPerActivityDashboardType';
  activity: TransactionTypeEnum;
  points: Scalars['Decimal']['output'];
};

export type GamificationEngagmentStatsDashboardType = {
  __typename?: 'GamificationEngagmentStatsDashboardType';
  averageDailyUsersEarnings: Scalars['Decimal']['output'];
  averageDailyUsersPercentage: Scalars['Decimal']['output'];
  averageQualitativePoints: Scalars['Decimal']['output'];
  averageQuantitativePoints: Scalars['Decimal']['output'];
  quantitativePointsRedemptionRate: Scalars['Decimal']['output'];
};

export type GamificationUserDistributionsByLevelDashboardType = {
  __typename?: 'GamificationUserDistributionsByLevelDashboardType';
  color: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  level: Scalars['String']['output'];
  percentage: Scalars['String']['output'];
};

export type GamificationUserDistributionsByStateDashboardType = {
  __typename?: 'GamificationUserDistributionsByStateDashboardType';
  layers: Array<AnalyticsUsersByCountryLayersType>;
  segments: Array<UserByStatesType>;
  total: Scalars['Int']['output'];
};

export type GamificationUsersMissingFieldsDashboardType = {
  __typename?: 'GamificationUsersMissingFieldsDashboardType';
  missingBirthdate: AmountPercentageDecimalType;
  missingCity: AmountPercentageDecimalType;
  missingCountry: AmountPercentageDecimalType;
  missingEducation: AmountPercentageDecimalType;
  missingHobbies: AmountPercentageDecimalType;
  missingInterests: AmountPercentageDecimalType;
  missingLocation: AmountPercentageDecimalType;
  missingMaritalStatus: AmountPercentageDecimalType;
  missingPhone: AmountPercentageDecimalType;
  missingWork: AmountPercentageDecimalType;
  total: Scalars['Decimal']['output'];
};

export type GamificationUsersProfilesCompletnessByStageDashboardType = {
  __typename?: 'GamificationUsersProfilesCompletnessByStageDashboardType';
  p0_25: AmountPercentageDecimalType;
  p25_50: AmountPercentageDecimalType;
  p50_75: AmountPercentageDecimalType;
  p75_100: AmountPercentageDecimalType;
};

export enum Gender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY'
}

export enum GenericInvoicingStatusEnum {
  CANCELED = 'CANCELED',
  CONFIRMED = 'CONFIRMED',
  DELIVERED = 'DELIVERED',
  DRAFT = 'DRAFT',
  ISSUED = 'ISSUED',
  NEGOCIATION = 'NEGOCIATION',
  OPEN = 'OPEN'
}

export type GenericTaskType = {
  __typename?: 'GenericTaskType';
  archived: Scalars['Boolean']['output'];
  completed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  priority: TaskPriorityEnum;
  rank: Scalars['Int']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type GetFixturesFromProviderInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  round?: InputMaybe<Scalars['String']['input']>;
  season: Scalars['Int']['input'];
  team?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GetGameIntegrationAddRewardInput = {
  cycle: LeaderboardCycleEnum;
  cycleNumber: Scalars['Int']['input'];
  game: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  reward: Array<GameIntegrationRewardInnerInput>;
  year: Scalars['Int']['input'];
};

export type GetGameIntegrationWithFilterInput = {
  cycle: LeaderboardCycleEnum;
  cycleNumber: Scalars['Int']['input'];
  game: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export type GetInternalProductForPartnershipNetworkWithFilterPaginatedInput = {
  filter?: InputMaybe<InternalProductForPartnershipNetworkFilterInput>;
  language?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ProductSortInput>>;
  target: TargetAciInput;
};

export type GetInternalProductWithFilterPaginatedInput = {
  filter?: InputMaybe<GetSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusInput>;
  language?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ProductSortInput>>;
};

export type GetLeaderboardByDatesAndCycleInput = {
  cycle: LeaderboardCycleEnum;
  end: Scalars['String']['input'];
  game?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['String']['input'];
  target: TargetAciInput;
};

export type GetQuestionResponsesPaginateType = {
  __typename?: 'GetQuestionResponsesPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  question?: Maybe<QuestionDtoType>;
  results: Array<AnswerDtoType>;
};

export type GetSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusInput = {
  /** list of catalogueCategories ids */
  catalogueCategory?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** list of internalProduct classes */
  classification?: InputMaybe<Array<ProductClassEnum>>;
  condition?: InputMaybe<Array<ProductConditionEnum>>;
  rent?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<ProductStatusEnum>>;
  structure?: InputMaybe<Array<ProductStructureEnum>>;
  target: TargetsInput;
  variety?: InputMaybe<Array<ProductVarietyEnum>>;
};

export type GetStandingsInput = {
  league?: InputMaybe<Scalars['Int']['input']>;
  season: Scalars['Int']['input'];
  team?: InputMaybe<Scalars['Int']['input']>;
};

export type GetTargetSubscribersByExcelInput = {
  isPrelevel?: InputMaybe<Scalars['Boolean']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  reputationsLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<SubscriptionStatus>>;
  target: TargetAciInput;
};

export type GetWidgetForTargetType = {
  __typename?: 'GetWidgetForTargetType';
  loyaltySettings?: Maybe<LoyaltySettingsType>;
  visuals?: Maybe<WidgetVisualsPaginateType>;
  widgetIntegrationSettings?: Maybe<WidgetIntegrationType>;
};

export type GetWidgetGuestUserForTargetType = {
  __typename?: 'GetWidgetGuestUserForTargetType';
  clientIp: Scalars['String']['output'];
  outbound?: Maybe<OutboundType>;
};

export type GetWidgetUserForTargetType = {
  __typename?: 'GetWidgetUserForTargetType';
  clientIp: Scalars['String']['output'];
  currentUser: UserType;
  notificationsCount: Scalars['Int']['output'];
  outbound?: Maybe<OutboundType>;
  predefinedQuests?: Maybe<Array<QuestWithRepeatDateType>>;
  wallet?: Maybe<WalletWithReputationDtoType>;
};

export type GlobalCategoryInput = {
  facebookCategory?: InputMaybe<Scalars['ID']['input']>;
  googleCategory?: InputMaybe<Scalars['ID']['input']>;
};

export type GlobalCategoryProductType = {
  __typename?: 'GlobalCategoryProductType';
  facebookCategory?: Maybe<GlobalCategoryType>;
  googleCategory?: Maybe<GlobalCategoryType>;
};

export enum GlobalCategoryProviderEnum {
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE'
}

export type GlobalCategoryType = {
  __typename?: 'GlobalCategoryType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  identifier: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  provider?: Maybe<GlobalCategoryProviderEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export type GmailDraftType = {
  __typename?: 'GmailDraftType';
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<GmailMessageType>;
};

export type GmailHeaderType = {
  __typename?: 'GmailHeaderType';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GmailMessagePartBodyType = {
  __typename?: 'GmailMessagePartBodyType';
  data?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
};

export type GmailMessagePartType = {
  __typename?: 'GmailMessagePartType';
  body?: Maybe<GmailMessagePartBodyType>;
  filename?: Maybe<Scalars['String']['output']>;
  headers?: Maybe<Array<GmailHeaderType>>;
  mimeType?: Maybe<Scalars['String']['output']>;
  partId?: Maybe<Scalars['String']['output']>;
  parts?: Maybe<Array<GmailMessagePartType>>;
};

export type GmailMessageType = {
  __typename?: 'GmailMessageType';
  historyId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  internalDate?: Maybe<Scalars['String']['output']>;
  labelIds?: Maybe<Array<Scalars['String']['output']>>;
  payload?: Maybe<GmailMessagePartType>;
  raw?: Maybe<Scalars['String']['output']>;
  sizeEstimate?: Maybe<Scalars['Int']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
};

export type GmailThreadType = {
  __typename?: 'GmailThreadType';
  historyId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  messages?: Maybe<Array<GmailMessageType>>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type GoogleAnalyticsEventType = {
  __typename?: 'GoogleAnalyticsEventType';
  active: Scalars['Boolean']['output'];
  event: GaRecommendedEventsEnum;
};

export type GoogleCalendarBackForType = {
  __typename?: 'GoogleCalendarBackForType';
  background: Scalars['String']['output'];
  foreground?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarConferencePropertiesType = {
  __typename?: 'GoogleCalendarConferencePropertiesType';
  allowedConferenceSolutionTypes: Array<Scalars['String']['output']>;
};

export type GoogleCalendarDefaultReminderType = {
  __typename?: 'GoogleCalendarDefaultReminderType';
  method: Scalars['String']['output'];
  minutes?: Maybe<Scalars['Int']['output']>;
};

export type GoogleCalendarEventAttachmentType = {
  __typename?: 'GoogleCalendarEventAttachmentType';
  fileId?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  iconLink?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarEventAttendeeType = {
  __typename?: 'GoogleCalendarEventAttendeeType';
  additionalGuests?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  optional?: Maybe<Scalars['Boolean']['output']>;
  organizer?: Maybe<Scalars['Boolean']['output']>;
  resource?: Maybe<Scalars['Boolean']['output']>;
  responseStatus?: Maybe<Scalars['String']['output']>;
  self?: Maybe<Scalars['Boolean']['output']>;
};

export type GoogleCalendarEventConferenceDataConferenceSolutionKeyType = {
  __typename?: 'GoogleCalendarEventConferenceDataConferenceSolutionKeyType';
  type?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarEventConferenceDataConferenceSolutionType = {
  __typename?: 'GoogleCalendarEventConferenceDataConferenceSolutionType';
  iconUri?: Maybe<Scalars['String']['output']>;
  key?: Maybe<GoogleCalendarEventConferenceDataConferenceSolutionKeyType>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarEventConferenceDataCreateRequesStatusType = {
  __typename?: 'GoogleCalendarEventConferenceDataCreateRequesStatusType';
  statusCode?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarEventConferenceDataCreateRequestSolutionKeyType = {
  __typename?: 'GoogleCalendarEventConferenceDataCreateRequestSolutionKeyType';
  type?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarEventConferenceDataCreateRequestType = {
  __typename?: 'GoogleCalendarEventConferenceDataCreateRequestType';
  conferenceSolutionKey?: Maybe<GoogleCalendarEventConferenceDataCreateRequestSolutionKeyType>;
  requestId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<GoogleCalendarEventConferenceDataCreateRequesStatusType>;
};

export type GoogleCalendarEventConferenceDataEntryPointsType = {
  __typename?: 'GoogleCalendarEventConferenceDataEntryPointsType';
  accessCode?: Maybe<Scalars['String']['output']>;
  entryPointType?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  meetingCode?: Maybe<Scalars['String']['output']>;
  passcode?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarEventConferenceDataType = {
  __typename?: 'GoogleCalendarEventConferenceDataType';
  conferenceId?: Maybe<Scalars['String']['output']>;
  conferenceSolution?: Maybe<GoogleCalendarEventConferenceDataConferenceSolutionType>;
  createRequest?: Maybe<GoogleCalendarEventConferenceDataCreateRequestType>;
  entryPoints?: Maybe<Array<GoogleCalendarEventConferenceDataEntryPointsType>>;
  notes?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarEventCreatorType = {
  __typename?: 'GoogleCalendarEventCreatorType';
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  self?: Maybe<Scalars['Boolean']['output']>;
};

export type GoogleCalendarEventGadgetType = {
  __typename?: 'GoogleCalendarEventGadgetType';
  display?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  iconLink?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type GoogleCalendarEventReminderOverridesType = {
  __typename?: 'GoogleCalendarEventReminderOverridesType';
  method?: Maybe<Scalars['String']['output']>;
  minutes?: Maybe<Scalars['Float']['output']>;
};

export type GoogleCalendarEventReminderType = {
  __typename?: 'GoogleCalendarEventReminderType';
  overrides?: Maybe<GoogleCalendarEventReminderOverridesType>;
  useDefault?: Maybe<Scalars['Boolean']['output']>;
};

export type GoogleCalendarEventSourceType = {
  __typename?: 'GoogleCalendarEventSourceType';
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarEventStartEndType = {
  __typename?: 'GoogleCalendarEventStartEndType';
  date?: Maybe<Scalars['String']['output']>;
  dateTime?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarEventType = {
  __typename?: 'GoogleCalendarEventType';
  anyoneCanAddSelf?: Maybe<Scalars['Boolean']['output']>;
  attachments?: Maybe<Array<GoogleCalendarEventAttachmentType>>;
  attendees?: Maybe<Array<GoogleCalendarEventAttendeeType>>;
  attendeesOmitted?: Maybe<Scalars['Boolean']['output']>;
  colorId?: Maybe<Scalars['String']['output']>;
  conferenceData?: Maybe<GoogleCalendarEventConferenceDataType>;
  created?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<GoogleCalendarEventCreatorType>;
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<GoogleCalendarEventStartEndType>;
  endTimeUnspecified?: Maybe<Scalars['Boolean']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  gadget?: Maybe<GoogleCalendarEventGadgetType>;
  guestsCanInviteOthers?: Maybe<Scalars['Boolean']['output']>;
  guestsCanModify?: Maybe<Scalars['Boolean']['output']>;
  guestsCanSeeOtherGuests?: Maybe<Scalars['Boolean']['output']>;
  hangoutLink?: Maybe<Scalars['String']['output']>;
  htmlLink?: Maybe<Scalars['String']['output']>;
  iCalUID?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  organizer?: Maybe<GoogleCalendarEventCreatorType>;
  originalStartTime?: Maybe<GoogleCalendarEventStartEndType>;
  privateCopy?: Maybe<Scalars['Boolean']['output']>;
  recurrence?: Maybe<Array<Scalars['String']['output']>>;
  recurringEventId?: Maybe<Scalars['String']['output']>;
  reminders?: Maybe<GoogleCalendarEventReminderType>;
  sequence?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<GoogleCalendarEventSourceType>;
  start?: Maybe<GoogleCalendarEventStartEndType>;
  status?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  transparency?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarListResourceType = {
  __typename?: 'GoogleCalendarListResourceType';
  accessRole?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  colorId?: Maybe<Scalars['String']['output']>;
  conferenceProperties?: Maybe<GoogleCalendarConferencePropertiesType>;
  defaultReminders?: Maybe<Array<GoogleCalendarDefaultReminderType>>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  foregroundColor?: Maybe<Scalars['String']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  notificationSettings?: Maybe<GoogleCalendarNotificationSettingsType>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  selected?: Maybe<Scalars['Boolean']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  summaryOverride?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type GoogleCalendarNotificationSettingsNotificationType = {
  __typename?: 'GoogleCalendarNotificationSettingsNotificationType';
  method: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type GoogleCalendarNotificationSettingsType = {
  __typename?: 'GoogleCalendarNotificationSettingsType';
  notifications: Array<GoogleCalendarNotificationSettingsNotificationType>;
};

export type GoogleCalendarSettingsType = {
  __typename?: 'GoogleCalendarSettingsType';
  etag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GoogleColorType = {
  __typename?: 'GoogleColorType';
  backgroundColor: Scalars['String']['output'];
  textColor: Scalars['String']['output'];
};

export type GoogleDataType = {
  __typename?: 'GoogleDataType';
  email: Scalars['String']['output'];
  email_verified?: Maybe<Scalars['Boolean']['output']>;
  family_name?: Maybe<Scalars['String']['output']>;
  given_name?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  sub: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type GoogleDriveAboutChangesResourceType = {
  __typename?: 'GoogleDriveAboutChangesResourceType';
  changeType?: Maybe<Scalars['String']['output']>;
  drive?: Maybe<GoogleDriveTeamDriveResourceType>;
  driveId?: Maybe<Scalars['String']['output']>;
  file?: Maybe<GoogleDriveFileResourceType>;
  fileId?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  removed?: Maybe<Scalars['Boolean']['output']>;
  teamDrive?: Maybe<GoogleDriveTeamDriveResourceType>;
  teamDriveId?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GoogleDriveAboutStorageQuotaType = {
  __typename?: 'GoogleDriveAboutStorageQuotaType';
  limit?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['String']['output']>;
  usageInDrive?: Maybe<Scalars['String']['output']>;
  usageInDriveTrash?: Maybe<Scalars['String']['output']>;
};

export type GoogleDriveAboutTeamDriveThemesType = {
  __typename?: 'GoogleDriveAboutTeamDriveThemesType';
  backgroundImageLink?: Maybe<Scalars['String']['output']>;
  colorRgb?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type GoogleDriveAboutUserType = {
  __typename?: 'GoogleDriveAboutUserType';
  displayName?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  me?: Maybe<Scalars['Boolean']['output']>;
  permissionId?: Maybe<Scalars['String']['output']>;
  photoLink?: Maybe<Scalars['String']['output']>;
};

export type GoogleDriveBackgroundImageFileType = {
  __typename?: 'GoogleDriveBackgroundImageFileType';
  id?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  xCoordinate?: Maybe<Scalars['Float']['output']>;
  yCoordinate?: Maybe<Scalars['Float']['output']>;
};

export type GoogleDriveContentHintsType = {
  __typename?: 'GoogleDriveContentHintsType';
  indexableText?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<GoogleDriveThumbnailType>;
};

export type GoogleDriveContentRestrictionsType = {
  __typename?: 'GoogleDriveContentRestrictionsType';
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  restrictingUser?: Maybe<GoogleDriveAboutUserType>;
  restrictionTime?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GoogleDriveFileCapabilitiesType = {
  __typename?: 'GoogleDriveFileCapabilitiesType';
  canAddChildren?: Maybe<Scalars['Boolean']['output']>;
  canAddFolderFromAnotherDrive?: Maybe<Scalars['Boolean']['output']>;
  canAddMyDriveParent?: Maybe<Scalars['Boolean']['output']>;
  canChangeCopyRequiresWriterPermission?: Maybe<Scalars['Boolean']['output']>;
  canChangeSecurityUpdateEnabled?: Maybe<Scalars['Boolean']['output']>;
  canChangeViewersCanCopyContent?: Maybe<Scalars['Boolean']['output']>;
  canComment?: Maybe<Scalars['Boolean']['output']>;
  canCopy?: Maybe<Scalars['Boolean']['output']>;
  canDelete?: Maybe<Scalars['Boolean']['output']>;
  canDeleteChildren?: Maybe<Scalars['Boolean']['output']>;
  canDownload?: Maybe<Scalars['Boolean']['output']>;
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  canListChildren?: Maybe<Scalars['Boolean']['output']>;
  canModifyContent?: Maybe<Scalars['Boolean']['output']>;
  canModifyContentRestriction?: Maybe<Scalars['Boolean']['output']>;
  canMoveChildrenOutOfDrive?: Maybe<Scalars['Boolean']['output']>;
  canMoveChildrenOutOfTeamDrive?: Maybe<Scalars['Boolean']['output']>;
  canMoveChildrenWithinDrive?: Maybe<Scalars['Boolean']['output']>;
  canMoveChildrenWithinTeamDrive?: Maybe<Scalars['Boolean']['output']>;
  canMoveItemIntoTeamDrive?: Maybe<Scalars['Boolean']['output']>;
  canMoveItemOutOfDrive?: Maybe<Scalars['Boolean']['output']>;
  canMoveItemOutOfTeamDrive?: Maybe<Scalars['Boolean']['output']>;
  canMoveItemWithinDrive?: Maybe<Scalars['Boolean']['output']>;
  canMoveItemWithinTeamDrive?: Maybe<Scalars['Boolean']['output']>;
  canMoveTeamDriveItem?: Maybe<Scalars['Boolean']['output']>;
  canReadDrive?: Maybe<Scalars['Boolean']['output']>;
  canReadRevisions?: Maybe<Scalars['Boolean']['output']>;
  canReadTeamDrive?: Maybe<Scalars['Boolean']['output']>;
  canRemoveChildren?: Maybe<Scalars['Boolean']['output']>;
  canRemoveMyDriveParent?: Maybe<Scalars['Boolean']['output']>;
  canRename?: Maybe<Scalars['Boolean']['output']>;
  canShare?: Maybe<Scalars['Boolean']['output']>;
  canTrash?: Maybe<Scalars['Boolean']['output']>;
  canTrashChildren?: Maybe<Scalars['Boolean']['output']>;
  canUntrash?: Maybe<Scalars['Boolean']['output']>;
};

export type GoogleDriveFilePermissionsType = {
  __typename?: 'GoogleDriveFilePermissionsType';
  allowFileDiscovery?: Maybe<Scalars['Boolean']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  expirationTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  permissionDetails?: Maybe<Array<GoogleDriveTeamDrivePermissionDetailsType>>;
  photoLink?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  teamDrivePermissionDetails?: Maybe<Array<GoogleDriveTeamDrivePermissionDetailsType>>;
  type?: Maybe<Scalars['String']['output']>;
  view?: Maybe<Scalars['String']['output']>;
};

export type GoogleDriveFileResourceType = {
  __typename?: 'GoogleDriveFileResourceType';
  capabilities?: Maybe<GoogleDriveFileCapabilitiesType>;
  contentHints?: Maybe<GoogleDriveContentHintsType>;
  contentRestrictions?: Maybe<Array<GoogleDriveContentRestrictionsType>>;
  copyRequiresWriterPermission?: Maybe<Scalars['Boolean']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  driveId?: Maybe<Scalars['String']['output']>;
  explicitlyTrashed?: Maybe<Scalars['Boolean']['output']>;
  fileExtension?: Maybe<Scalars['String']['output']>;
  folderColorRgb?: Maybe<Scalars['String']['output']>;
  fullFileExtension?: Maybe<Scalars['String']['output']>;
  hasAugmentedPermissions?: Maybe<Scalars['Boolean']['output']>;
  hasThumbnail?: Maybe<Scalars['Boolean']['output']>;
  headRevisionId?: Maybe<Scalars['String']['output']>;
  iconLink?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageMediaMetadata?: Maybe<GoogleDriveImageMediaMetaDataType>;
  isAppAuthorized?: Maybe<Scalars['Boolean']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  lastModifyingUser?: Maybe<GoogleDriveAboutUserType>;
  linkShareMetadata?: Maybe<GoogleDriveLinkShareMetadataType>;
  md5Checksum?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  modifiedByMe?: Maybe<Scalars['Boolean']['output']>;
  modifiedByMeTime?: Maybe<Scalars['String']['output']>;
  modifiedTime?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  originalFilename?: Maybe<Scalars['String']['output']>;
  ownedByMe?: Maybe<Scalars['Boolean']['output']>;
  owners?: Maybe<Array<GoogleDriveAboutUserType>>;
  permissionIds?: Maybe<Array<Scalars['String']['output']>>;
  permissions?: Maybe<Array<GoogleDriveFilePermissionsType>>;
  resourceKey?: Maybe<Scalars['String']['output']>;
  shared?: Maybe<Scalars['Boolean']['output']>;
  sharedWithMeTime?: Maybe<Scalars['String']['output']>;
  sharingUser?: Maybe<GoogleDriveAboutUserType>;
  shortcutDetails?: Maybe<GoogleDriveShortcutDetailsType>;
  spaces?: Maybe<Array<Scalars['String']['output']>>;
  starred?: Maybe<Scalars['Boolean']['output']>;
  teamDriveId?: Maybe<Scalars['String']['output']>;
  thumbnailLink?: Maybe<Scalars['String']['output']>;
  trashed?: Maybe<Scalars['Boolean']['output']>;
  trashedTime?: Maybe<Scalars['String']['output']>;
  trashingUser?: Maybe<GoogleDriveAboutUserType>;
  viewedByMe?: Maybe<Scalars['Boolean']['output']>;
  viewedByMeTime?: Maybe<Scalars['String']['output']>;
  viewersCanCopyContent?: Maybe<Scalars['Boolean']['output']>;
  webContentLink?: Maybe<Scalars['String']['output']>;
  webViewLink?: Maybe<Scalars['String']['output']>;
  writersCanShare?: Maybe<Scalars['Boolean']['output']>;
};

export type GoogleDriveImageMediaMetaDataType = {
  __typename?: 'GoogleDriveImageMediaMetaDataType';
  aperture?: Maybe<Scalars['Float']['output']>;
  cameraMake?: Maybe<Scalars['String']['output']>;
  cameraModel?: Maybe<Scalars['String']['output']>;
  colorSpace?: Maybe<Scalars['String']['output']>;
  exposureBias?: Maybe<Scalars['Float']['output']>;
  exposureMode?: Maybe<Scalars['String']['output']>;
  exposureTime?: Maybe<Scalars['Float']['output']>;
  flashUsed?: Maybe<Scalars['Boolean']['output']>;
  focalLength?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  isoSpeed?: Maybe<Scalars['Int']['output']>;
  lens?: Maybe<Scalars['String']['output']>;
  location?: Maybe<GoogleDriveLocationType>;
  maxApertureValue?: Maybe<Scalars['Float']['output']>;
  meteringMode?: Maybe<Scalars['String']['output']>;
  rotation?: Maybe<Scalars['Int']['output']>;
  sensor?: Maybe<Scalars['String']['output']>;
  subjectDistance?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  whiteBalance?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type GoogleDriveLinkShareMetadataType = {
  __typename?: 'GoogleDriveLinkShareMetadataType';
  securityUpdateEligible?: Maybe<Scalars['Boolean']['output']>;
  securityUpdateEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type GoogleDriveLocationType = {
  __typename?: 'GoogleDriveLocationType';
  altitude?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type GoogleDriveRestrictionsType = {
  __typename?: 'GoogleDriveRestrictionsType';
  adminManagedRestrictions?: Maybe<Scalars['Boolean']['output']>;
  copyRequiresWriterPermission?: Maybe<Scalars['Boolean']['output']>;
  domainUsersOnly?: Maybe<Scalars['Boolean']['output']>;
  driveMembersOnly?: Maybe<Scalars['Boolean']['output']>;
};

export type GoogleDriveShortcutDetailsType = {
  __typename?: 'GoogleDriveShortcutDetailsType';
  targetId?: Maybe<Scalars['String']['output']>;
  targetMimeType?: Maybe<Scalars['String']['output']>;
  targetResourceKey?: Maybe<Scalars['String']['output']>;
};

export type GoogleDriveTeamDrivePermissionDetailsType = {
  __typename?: 'GoogleDriveTeamDrivePermissionDetailsType';
  inherited?: Maybe<Scalars['Boolean']['output']>;
  inheritedFrom?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  teamDrivePermissionType?: Maybe<Scalars['String']['output']>;
};

export type GoogleDriveTeamDriveResourceType = {
  __typename?: 'GoogleDriveTeamDriveResourceType';
  backgroundImageFile?: Maybe<GoogleDriveBackgroundImageFileType>;
  capabilities?: Maybe<GoogleDriveFileCapabilitiesType>;
  colorRgb?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  restrictions?: Maybe<GoogleDriveRestrictionsType>;
  themeId?: Maybe<Scalars['String']['output']>;
};

export type GoogleDriveThumbnailType = {
  __typename?: 'GoogleDriveThumbnailType';
  image?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
};

export type GoogleMapsAuditDataLocationType = {
  __typename?: 'GoogleMapsAuditDataLocationType';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type GoogleMapsAuditDataOrderType = {
  __typename?: 'GoogleMapsAuditDataOrderType';
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GoogleMapsAuditDataReviewsType = {
  __typename?: 'GoogleMapsAuditDataReviewsType';
  fiveStar?: Maybe<Scalars['Float']['output']>;
  fourStar?: Maybe<Scalars['Float']['output']>;
  oneStar?: Maybe<Scalars['Float']['output']>;
  threeStar?: Maybe<Scalars['Float']['output']>;
  twoStar?: Maybe<Scalars['Float']['output']>;
};

export type GoogleMapsAuditDataType = {
  __typename?: 'GoogleMapsAuditDataType';
  address?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  categoryName?: Maybe<Scalars['String']['output']>;
  cid?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  isAdvertisement?: Maybe<Scalars['Boolean']['output']>;
  locatedIn?: Maybe<Scalars['String']['output']>;
  location?: Maybe<GoogleMapsAuditDataLocationType>;
  menu?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  orderBy?: Maybe<GoogleMapsAuditDataOrderType>;
  permanentlyClosed?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  plusCode?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  reviews?: Maybe<Array<Scalars['String']['output']>>;
  reviewsCount?: Maybe<Scalars['Float']['output']>;
  reviewsDistribution?: Maybe<GoogleMapsAuditDataReviewsType>;
  scrapedAt?: Maybe<Scalars['DateTime']['output']>;
  searchPageUrl?: Maybe<Scalars['String']['output']>;
  searchString?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  temporarilyClosed?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalScore?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type GoogleSearchAuditDataCustomDataType = {
  __typename?: 'GoogleSearchAuditDataCustomDataType';
  pageTitle?: Maybe<Scalars['String']['output']>;
};

export type GoogleSearchAuditDataDebugType = {
  __typename?: 'GoogleSearchAuditDataDebugType';
  durationSecs?: Maybe<Scalars['Float']['output']>;
  errorMessages?: Maybe<Array<Scalars['String']['output']>>;
  method?: Maybe<Scalars['String']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
  retryCount?: Maybe<Scalars['Float']['output']>;
  statusCode?: Maybe<Scalars['Float']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GoogleSearchAuditDataRelatedQueriesType = {
  __typename?: 'GoogleSearchAuditDataRelatedQueriesType';
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GoogleSearchAuditDataResultsProductType = {
  __typename?: 'GoogleSearchAuditDataResultsProductType';
  numberOfReviews?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

export type GoogleSearchAuditDataResultsType = {
  __typename?: 'GoogleSearchAuditDataResultsType';
  description?: Maybe<Scalars['String']['output']>;
  displayedUrl?: Maybe<Scalars['String']['output']>;
  emphasizedKeywords?: Maybe<Array<Scalars['String']['output']>>;
  productInfo?: Maybe<GoogleSearchAuditDataResultsProductType>;
  siteLinks?: Maybe<Array<GoogleSearchAuditDataSiteLinksType>>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GoogleSearchAuditDataSearchQueryType = {
  __typename?: 'GoogleSearchAuditDataSearchQueryType';
  countryCode?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  locationUule?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['Float']['output']>;
  resultsPerPage?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GoogleSearchAuditDataSiteLinksType = {
  __typename?: 'GoogleSearchAuditDataSiteLinksType';
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type GoogleSearchAuditDataType = {
  __typename?: 'GoogleSearchAuditDataType';
  customData?: Maybe<GoogleSearchAuditDataCustomDataType>;
  debug?: Maybe<GoogleSearchAuditDataDebugType>;
  error?: Maybe<Scalars['Boolean']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  htmlSnapshotUrl?: Maybe<Scalars['String']['output']>;
  organicResults?: Maybe<Array<GoogleSearchAuditDataResultsType>>;
  paidProducts?: Maybe<Array<GoogleSearchAuditDataResultsType>>;
  paidResults?: Maybe<Array<GoogleSearchAuditDataResultsType>>;
  relatedQueries?: Maybe<Array<GoogleSearchAuditDataRelatedQueriesType>>;
  resultsTotal?: Maybe<Scalars['Float']['output']>;
  searchQuery?: Maybe<GoogleSearchAuditDataSearchQueryType>;
  serpProviderCode?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum GroupInviteStatusEnum {
  CANCELED = 'CANCELED',
  CONFIRMED = 'CONFIRMED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type GroupInviteType = {
  __typename?: 'GroupInviteType';
  createdAt: Scalars['DateTime']['output'];
  group?: Maybe<GroupType>;
  id: Scalars['ID']['output'];
  requestor?: Maybe<UserType>;
  status?: Maybe<GroupInviteStatusEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export type GroupLeaderboardBaseType = {
  __typename?: 'GroupLeaderboardBaseType';
  credit: Scalars['Decimal']['output'];
  effectiveDate: Scalars['DateTime']['output'];
  group: GroupType;
  rank: Scalars['Int']['output'];
  rankDifference: Scalars['Int']['output'];
  user: UserType;
};

export type GroupLeaderboardType = {
  __typename?: 'GroupLeaderboardType';
  createdAt: Scalars['DateTime']['output'];
  credit: Scalars['Decimal']['output'];
  effectiveDate: Scalars['DateTime']['output'];
  group: GroupType;
  id: Scalars['ID']['output'];
  rank: Scalars['Int']['output'];
  rankDifference: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export enum GroupPrivacyEnum {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export type GroupType = {
  __typename?: 'GroupType';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  members: Array<UserType>;
  moderators: Array<UserType>;
  name: Scalars['String']['output'];
  picture?: Maybe<NestedPicturesType>;
  privacy: GroupPrivacyEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export type GuestUserType = {
  __typename?: 'GuestUserType';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<IPhoneType>;
};

export type HeadToHeadType = {
  __typename?: 'HeadToHeadType';
  createdAt: Scalars['DateTime']['output'];
  fixture?: Maybe<FixtureSubType>;
  goals?: Maybe<FixtureGoalsType>;
  id: Scalars['ID']['output'];
  league?: Maybe<FixtureLeagueType>;
  score?: Maybe<FixtureScoreType>;
  teams?: Maybe<FixtureTeamsType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type IPhoneInput = {
  /** Phone country code */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  number?: InputMaybe<Scalars['String']['input']>;
};

export type IPhoneType = {
  __typename?: 'IPhoneType';
  countryCode?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type IQuestActivityActivitiesConditionConditionActionType = {
  __typename?: 'IQuestActivityActivitiesConditionConditionActionType';
  action?: Maybe<QuestActionActionType>;
  definition?: Maybe<QuestActivityIntType>;
};

export type IQuestActivityActivitiesConditionConditionScoreType = {
  __typename?: 'IQuestActivityActivitiesConditionConditionScoreType';
  operator?: Maybe<OperatorEnum>;
  value?: Maybe<OperatorEnum>;
};

export type IQuestActivityActivitiesConditionTransitionGotoType = {
  __typename?: 'IQuestActivityActivitiesConditionTransitionGotoType';
  action?: Maybe<QuestActivityIntType>;
};

export type IQuestActivityActivitiesInput = {
  action?: InputMaybe<Scalars['ID']['input']>;
  transition?: InputMaybe<IQuestActivityActivitiesTransitionInput>;
};

export type IQuestActivityActivitiesTransitionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IQuestActivityActivitiesTransitionType = {
  __typename?: 'IQuestActivityActivitiesTransitionType';
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type IQuestActivityActivitiesType = {
  __typename?: 'IQuestActivityActivitiesType';
  action?: Maybe<QuestActionDefinitionType>;
  transition?: Maybe<IQuestActivityActivitiesTransitionType>;
};

export type ImpressionsFieldType = {
  __typename?: 'ImpressionsFieldType';
  current: Scalars['Int']['output'];
  percentage?: Maybe<Scalars['Decimal']['output']>;
  previous: Scalars['Int']['output'];
  weeklyImpressions: Array<PeriodStatsType>;
};

export type InPlayOddsBookmakersType = {
  __typename?: 'InPlayOddsBookmakersType';
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<InPlayOddsBookmakersValueType>>;
};

export type InPlayOddsBookmakersValueType = {
  __typename?: 'InPlayOddsBookmakersValueType';
  handicap?: Maybe<Scalars['String']['output']>;
  main?: Maybe<Scalars['Boolean']['output']>;
  odd?: Maybe<Scalars['String']['output']>;
  suspended?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InPlayOddsFixtureStatusType = {
  __typename?: 'InPlayOddsFixtureStatusType';
  elapsed?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  seconds?: Maybe<Scalars['String']['output']>;
};

export type InPlayOddsFixtureType = {
  __typename?: 'InPlayOddsFixtureType';
  id?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<InPlayOddsFixtureStatusType>;
};

export type InPlayOddsLeagueType = {
  __typename?: 'InPlayOddsLeagueType';
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
};

export type InPlayOddsPaginateType = {
  __typename?: 'InPlayOddsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<InPlayOddsType>;
};

export type InPlayOddsStatusType = {
  __typename?: 'InPlayOddsStatusType';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  finished?: Maybe<Scalars['Boolean']['output']>;
  stopped?: Maybe<Scalars['Boolean']['output']>;
};

export type InPlayOddsTeamsHaType = {
  __typename?: 'InPlayOddsTeamsHAType';
  goals?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type InPlayOddsTeamsType = {
  __typename?: 'InPlayOddsTeamsType';
  away?: Maybe<InPlayOddsTeamsHaType>;
  home?: Maybe<InPlayOddsTeamsHaType>;
};

export type InPlayOddsType = {
  __typename?: 'InPlayOddsType';
  fixture?: Maybe<InPlayOddsFixtureType>;
  id: Scalars['ID']['output'];
  league?: Maybe<InPlayOddsLeagueType>;
  odds?: Maybe<Array<InPlayOddsBookmakersType>>;
  status?: Maybe<InPlayOddsStatusType>;
  teams?: Maybe<InPlayOddsTeamsType>;
  update?: Maybe<Scalars['DateTime']['output']>;
};

export type InactivityInput = {
  actions?: InputMaybe<Array<TransactionTypeEnum>>;
};

export type InactivityType = {
  __typename?: 'InactivityType';
  actions?: Maybe<Array<TransactionTypeEnum>>;
};

export type InjuriesFilterInput = {
  fixture?: InputMaybe<Array<Scalars['Int']['input']>>;
  league?: InputMaybe<Array<Scalars['Int']['input']>>;
  player?: InputMaybe<Array<Scalars['Int']['input']>>;
  season?: InputMaybe<Array<Scalars['Int']['input']>>;
  team?: InputMaybe<Array<Scalars['Int']['input']>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type InjuriesFixtureType = {
  __typename?: 'InjuriesFixtureType';
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  timestamp?: Maybe<Scalars['Float']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type InjuriesLeagueType = {
  __typename?: 'InjuriesLeagueType';
  country?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
};

export type InjuriesPaginateType = {
  __typename?: 'InjuriesPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<InjuriesType>;
};

export type InjuriesPlayerType = {
  __typename?: 'InjuriesPlayerType';
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type InjuriesTeamType = {
  __typename?: 'InjuriesTeamType';
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type InjuriesType = {
  __typename?: 'InjuriesType';
  createdAt: Scalars['DateTime']['output'];
  fixture?: Maybe<InjuriesFixtureType>;
  id: Scalars['ID']['output'];
  league?: Maybe<InjuriesLeagueType>;
  player?: Maybe<InjuriesPlayerType>;
  team?: Maybe<InjuriesTeamType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type InstagramProfileAuditDataIvgType = {
  __typename?: 'InstagramProfileAuditDataIVGType';
  caption?: Maybe<Scalars['String']['output']>;
  commentsCount?: Maybe<Scalars['Float']['output']>;
  commentsDisabled?: Maybe<Scalars['Boolean']['output']>;
  dimensionsHeight?: Maybe<Scalars['Float']['output']>;
  dimensionsWidth?: Maybe<Scalars['Float']['output']>;
  displayUrl?: Maybe<Scalars['String']['output']>;
  likesCount?: Maybe<Scalars['Float']['output']>;
  shortCode?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  videoDuration?: Maybe<Scalars['Float']['output']>;
  videoViewCount?: Maybe<Scalars['Float']['output']>;
};

export type InstagramProfileAuditDataLatestType = {
  __typename?: 'InstagramProfileAuditDataLatestType';
  alt?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  childPosts?: Maybe<Array<Scalars['String']['output']>>;
  commentsCount?: Maybe<Scalars['Float']['output']>;
  dimensionsHeight?: Maybe<Scalars['Float']['output']>;
  dimensionsWidth?: Maybe<Scalars['Float']['output']>;
  displayUrl?: Maybe<Scalars['String']['output']>;
  firstComment?: Maybe<Scalars['String']['output']>;
  hashtags?: Maybe<Array<Scalars['String']['output']>>;
  id?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Scalars['String']['output']>>;
  latestComments?: Maybe<Array<Scalars['String']['output']>>;
  likesCount?: Maybe<Scalars['Float']['output']>;
  mentions?: Maybe<Array<Scalars['String']['output']>>;
  ownerId?: Maybe<Scalars['String']['output']>;
  ownerUsername?: Maybe<Scalars['String']['output']>;
  shortCode?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type InstagramProfileAuditDataType = {
  __typename?: 'InstagramProfileAuditDataType';
  biography?: Maybe<Scalars['String']['output']>;
  businessCategoryName?: Maybe<Scalars['String']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  externalUrlShimmed?: Maybe<Scalars['String']['output']>;
  facebookPage?: Maybe<Scalars['String']['output']>;
  followersCount?: Maybe<Scalars['Float']['output']>;
  followsCount?: Maybe<Scalars['Float']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  hasChannel?: Maybe<Scalars['Boolean']['output']>;
  highlightReelCount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  igtvVideoCount?: Maybe<Scalars['Float']['output']>;
  isBusinessAccount?: Maybe<Scalars['Boolean']['output']>;
  joinedRecently?: Maybe<Scalars['Boolean']['output']>;
  latestIgtvVideos?: Maybe<Array<InstagramProfileAuditDataIvgType>>;
  latestPosts?: Maybe<Array<InstagramProfileAuditDataLatestType>>;
  postsCount?: Maybe<Scalars['Float']['output']>;
  private?: Maybe<Scalars['Boolean']['output']>;
  profilePicUrl?: Maybe<Scalars['String']['output']>;
  profilePicUrlHD?: Maybe<Scalars['String']['output']>;
  relatedProfiles?: Maybe<Array<Scalars['String']['output']>>;
  username?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type InstallmentType = {
  __typename?: 'InstallmentType';
  _id: Scalars['ID']['output'];
  amount: Scalars['Decimal']['output'];
  deadline?: Maybe<Scalars['DateTime']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paymentMethod: PaymentType;
  paymentStatus: PaymentStatusEnum;
  user?: Maybe<UserType>;
  wallet?: Maybe<WalletType>;
};

export type IntegrationIntegrationAccessType = {
  __typename?: 'IntegrationIntegrationAccessType';
  publicKey?: Maybe<Scalars['String']['output']>;
  secretKey?: Maybe<Scalars['String']['output']>;
};

export type IntegrationIntegrationEndpointsLoyaltyType = {
  __typename?: 'IntegrationIntegrationEndpointsLoyaltyType';
  onsiteconverter?: Maybe<Scalars['Boolean']['output']>;
};

export type IntegrationIntegrationEndpointsType = {
  __typename?: 'IntegrationIntegrationEndpointsType';
  loyalty?: Maybe<IntegrationIntegrationEndpointsLoyaltyType>;
  purchase?: Maybe<Scalars['Boolean']['output']>;
  sales?: Maybe<Scalars['Boolean']['output']>;
};

export type InternalProductAttributeInnerInput = {
  price?: InputMaybe<Scalars['Decimal']['input']>;
  productAttribute: Scalars['String']['input'];
  selectedValue: Scalars['String']['input'];
};

export type InternalProductAttributeInnerType = {
  __typename?: 'InternalProductAttributeInnerType';
  price?: Maybe<Scalars['Decimal']['output']>;
  productAttribute?: Maybe<ProductAttributeType>;
  selectedValue?: Maybe<Scalars['String']['output']>;
};

export type InternalProductAttributeInput = {
  attributes?: InputMaybe<Array<InternalProductAttributeInnerInput>>;
};

export type InternalProductAttributeType = {
  __typename?: 'InternalProductAttributeType';
  attributes?: Maybe<Array<InternalProductAttributeInnerType>>;
};

export type InternalProductAttributesValuesBaseType = {
  __typename?: 'InternalProductAttributesValuesBaseType';
  attributesValues?: Maybe<Array<AttributeValueBaseRawType>>;
};

export type InternalProductAttributesValuesFilterType = {
  __typename?: 'InternalProductAttributesValuesFilterType';
  attributesValues?: Maybe<Array<AttributeValueFilterType>>;
};

export type InternalProductAttributesValuesType = {
  __typename?: 'InternalProductAttributesValuesType';
  attributesValues?: Maybe<Array<AttributeValueType>>;
};

export type InternalProductByClassType = {
  __typename?: 'InternalProductByClassType';
  BEST_SELLERS?: Maybe<Array<InternalProductWithoutClassType>>;
  FEATURED_PRODUCTS?: Maybe<Array<InternalProductWithoutClassType>>;
  NEW_ARRIVALS?: Maybe<Array<InternalProductWithoutClassType>>;
  PROMO?: Maybe<Array<InternalProductWithoutClassType>>;
  TOP_PRODUCTS?: Maybe<Array<InternalProductWithoutClassType>>;
};

export type InternalProductByClassTypeWithFavoriteStatus = {
  __typename?: 'InternalProductByClassTypeWithFavoriteStatus';
  BEST_SELLERS?: Maybe<Array<InternalProductWithoutClassWithFavoriteStatusType>>;
  FEATURED_PRODUCTS?: Maybe<Array<InternalProductWithoutClassWithFavoriteStatusType>>;
  NEW_ARRIVALS?: Maybe<Array<InternalProductWithoutClassWithFavoriteStatusType>>;
  PROMO?: Maybe<Array<InternalProductWithoutClassWithFavoriteStatusType>>;
  TOP_PRODUCTS?: Maybe<Array<InternalProductWithoutClassWithFavoriteStatusType>>;
};

export type InternalProductFilterInput = {
  attributesValues?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** list of brands ids */
  brand?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** list of catalogueCategories ids */
  catalogueCategory?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** list of inventoryCategories ids */
  category?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** list of internalProduct classes */
  classification?: InputMaybe<Array<ProductClassEnum>>;
  condition?: InputMaybe<Array<ProductConditionEnum>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  fromPrice?: InputMaybe<Scalars['Decimal']['input']>;
  rent?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<ProductStatusEnum>>;
  structure?: InputMaybe<Array<ProductStructureEnum>>;
  target: TargetsInput;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  toPrice?: InputMaybe<Scalars['Decimal']['input']>;
  variety?: InputMaybe<Array<ProductVarietyEnum>>;
};

export type InternalProductFilterType = {
  __typename?: 'InternalProductFilterType';
  /** list of brands */
  brands?: Maybe<Array<FilterNameFieldType>>;
  /** list of catalogueCategories */
  catalogueCategories?: Maybe<Array<FilterNameFieldType>>;
  createdAtRange?: Maybe<DateRangeType>;
  priceRange?: Maybe<PriceRangeType>;
  /** list of AttributeValues */
  productAttributesValues?: Maybe<Array<AttributeWithValueFilterType>>;
  targets?: Maybe<TargetsType>;
  updatedAtRange?: Maybe<DateRangeType>;
};

export type InternalProductForPartnershipNetworkFilterInput = {
  fromPrice?: InputMaybe<Scalars['Decimal']['input']>;
  partners?: InputMaybe<TargetsInput>;
  toPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type InternalProductForPartnershipNetworkFilterType = {
  __typename?: 'InternalProductForPartnershipNetworkFilterType';
  priceRange?: Maybe<PriceRangeType>;
  targets?: Maybe<TargetsType>;
};

export type InternalProductForPartnershipNetworkWithTargetPictureAndRatingsPaginateWithFavoriteStatusWithFilterType = {
  __typename?: 'InternalProductForPartnershipNetworkWithTargetPictureAndRatingsPaginateWithFavoriteStatusWithFilterType';
  count?: Maybe<Scalars['Int']['output']>;
  filter?: Maybe<InternalProductForPartnershipNetworkFilterType>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<InternalProductWithRatingsTargetPictureWithFavoriteStatusType>;
};

export type InternalProductMaintenanceInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  expectedMeantime?: InputMaybe<Scalars['Int']['input']>;
  maintenanceDuration?: InputMaybe<Scalars['Int']['input']>;
  owner?: InputMaybe<Scalars['ID']['input']>;
  prevMaintenanceDuration?: InputMaybe<Scalars['Int']['input']>;
  technician?: InputMaybe<Scalars['ID']['input']>;
};

export type InternalProductMaintenanceType = {
  __typename?: 'InternalProductMaintenanceType';
  active?: Maybe<Scalars['Boolean']['output']>;
  expectedMeantime?: Maybe<Scalars['Int']['output']>;
  maintenanceDuration?: Maybe<Scalars['Int']['output']>;
  owner?: Maybe<UserType>;
  prevMaintenanceDuration?: Maybe<Scalars['Int']['output']>;
  technician?: Maybe<UserType>;
};

export type InternalProductPaginateType = {
  __typename?: 'InternalProductPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<InternalProductType>;
};

export type InternalProductPaginateWithFilterType = {
  __typename?: 'InternalProductPaginateWithFilterType';
  count?: Maybe<Scalars['Int']['output']>;
  filter?: Maybe<InternalProductFilterType>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<InternalProductType>;
};

export type InternalProductTranslationContentInput = {
  description: Scalars['String']['input'];
  descriptionList?: InputMaybe<Array<Scalars['String']['input']>>;
  longdesc?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  specs?: InputMaybe<Array<ProductSpecsInput>>;
};

export type InternalProductTranslationContentType = {
  __typename?: 'InternalProductTranslationContentType';
  description: Scalars['String']['output'];
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  longdesc?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  specs?: Maybe<Array<ProductSpecsType>>;
};

export type InternalProductTranslationInput = {
  content: InternalProductTranslationContentInput;
  language: Scalars['ID']['input'];
};

export type InternalProductTranslationType = {
  __typename?: 'InternalProductTranslationType';
  content: InternalProductTranslationContentType;
  language: LanguageType;
};

export type InternalProductType = {
  __typename?: 'InternalProductType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceType>>;
  brand?: Maybe<BrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  classification?: Maybe<Array<ProductClassEnum>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  globalCategory?: Maybe<GlobalCategoryProductType>;
  id?: Maybe<Scalars['ID']['output']>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type InternalProductWithBarcodesWithPublicPriceType = {
  __typename?: 'InternalProductWithBarcodesWithPublicPriceType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceType>>;
  brand?: Maybe<BrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  classification?: Maybe<Array<ProductClassEnum>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  globalCategory?: Maybe<GlobalCategoryProductType>;
  id?: Maybe<Scalars['ID']['output']>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type InternalProductWithFavoriteStatusPaginateType = {
  __typename?: 'InternalProductWithFavoriteStatusPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<InternalProductWithFavoriteStatusType>;
};

export type InternalProductWithFavoriteStatusType = {
  __typename?: 'InternalProductWithFavoriteStatusType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceType>>;
  brand?: Maybe<BrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  classification?: Maybe<Array<ProductClassEnum>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  globalCategory?: Maybe<GlobalCategoryProductType>;
  id?: Maybe<Scalars['ID']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type InternalProductWithRatingsPaginateWithFavoriteStatusType = {
  __typename?: 'InternalProductWithRatingsPaginateWithFavoriteStatusType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<InternalProductWithRatingsWithFavoriteStatusType>;
};

export type InternalProductWithRatingsPaginateWithFavoriteStatusWithFilterType = {
  __typename?: 'InternalProductWithRatingsPaginateWithFavoriteStatusWithFilterType';
  count?: Maybe<Scalars['Int']['output']>;
  filter?: Maybe<InternalProductFilterType>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<InternalProductWithRatingsWithFavoriteStatusType>;
};

export type InternalProductWithRatingsPaginateWithFilterType = {
  __typename?: 'InternalProductWithRatingsPaginateWithFilterType';
  count?: Maybe<Scalars['Int']['output']>;
  filter?: Maybe<InternalProductFilterType>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<InternalProductWithRatingsType>;
};

export type InternalProductWithRatingsTargetPictureWithFavoriteStatusType = {
  __typename?: 'InternalProductWithRatingsTargetPictureWithFavoriteStatusType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceType>>;
  brand?: Maybe<SimpleBrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  classification?: Maybe<Array<ProductClassEnum>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  id?: Maybe<Scalars['ID']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  ratings?: Maybe<Scalars['Decimal']['output']>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetWithPictureFilterType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type InternalProductWithRatingsType = {
  __typename?: 'InternalProductWithRatingsType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceType>>;
  brand?: Maybe<BrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  classification?: Maybe<Array<ProductClassEnum>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  id?: Maybe<Scalars['ID']['output']>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  ratings?: Maybe<Scalars['Decimal']['output']>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetFilterType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type InternalProductWithRatingsWithFavoriteStatusType = {
  __typename?: 'InternalProductWithRatingsWithFavoriteStatusType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceType>>;
  brand?: Maybe<BrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  classification?: Maybe<Array<ProductClassEnum>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  id?: Maybe<Scalars['ID']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  ratings?: Maybe<Scalars['Decimal']['output']>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetFilterType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type InternalProductWithStatsType = {
  __typename?: 'InternalProductWithStatsType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceType>>;
  brand?: Maybe<BrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  classification?: Maybe<Array<ProductClassEnum>>;
  clicks?: Maybe<Array<Array<Scalars['Float']['output']>>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  globalCategory?: Maybe<GlobalCategoryProductType>;
  id?: Maybe<Scalars['ID']['output']>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type InternalProductWithStockType = {
  __typename?: 'InternalProductWithStockType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceType>>;
  brand?: Maybe<BrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  classification?: Maybe<Array<ProductClassEnum>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  globalCategory?: Maybe<GlobalCategoryProductType>;
  id?: Maybe<Scalars['ID']['output']>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  stock?: Maybe<StockRawType>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type InternalProductWithoutClassType = {
  __typename?: 'InternalProductWithoutClassType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceType>>;
  brand?: Maybe<BrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  globalCategory?: Maybe<GlobalCategoryProductType>;
  id?: Maybe<Scalars['ID']['output']>;
  internalProductAttributes?: Maybe<InternalProductAttributeType>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  ratings?: Maybe<Scalars['Decimal']['output']>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type InternalProductWithoutClassWithFavoriteStatusType = {
  __typename?: 'InternalProductWithoutClassWithFavoriteStatusType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceType>>;
  brand?: Maybe<BrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  globalCategory?: Maybe<GlobalCategoryProductType>;
  id?: Maybe<Scalars['ID']['output']>;
  internalProductAttributes?: Maybe<InternalProductAttributeType>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  ratings?: Maybe<Scalars['Decimal']['output']>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type InternalProductsByCatalogueCategoryCountType = {
  __typename?: 'InternalProductsByCatalogueCategoryCountType';
  booking?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  delivery?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  hasChildren: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  layer: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  numberOfProducts: Scalars['Int']['output'];
  parent?: Maybe<CatalogueCategoryBaseType>;
  pickup?: Maybe<Scalars['Boolean']['output']>;
  pictures?: Maybe<Array<PictureType>>;
  portal?: Maybe<Scalars['Boolean']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  translation?: Maybe<Array<CatalogueCategoryTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  variety?: Maybe<ProductVarietyEnum>;
};

export type InternalProductsByInventoryCategoryCountType = {
  __typename?: 'InternalProductsByInventoryCategoryCountType';
  createdAt: Scalars['DateTime']['output'];
  hasChildren: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  layer: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  numberOfProducts: Scalars['Int']['output'];
  picture?: Maybe<PictureType>;
  rank: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InternalProductsByManufacturerCountType = {
  __typename?: 'InternalProductsByManufacturerCountType';
  address?: Maybe<FullAddressType>;
  contactEmails?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  currencies?: Maybe<Array<TargetCurrencyType>>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  numberOfManufacturerProducts: Scalars['Int']['output'];
  picture?: Maybe<PictureType>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type InternalProductsByPosCountType = {
  __typename?: 'InternalProductsByPOSCountType';
  aggregator?: Maybe<Scalars['Boolean']['output']>;
  averageCustomers?: Maybe<Scalars['Float']['output']>;
  brandColor?: Maybe<Scalars['String']['output']>;
  chatContact?: Maybe<Array<SocialValueType>>;
  contactEmails?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  currencies?: Maybe<Array<TargetCurrencyType>>;
  dashboard?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  insidePictures?: Maybe<Array<PictureType>>;
  isFollowed?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<LanguageType>>;
  locations?: Maybe<Array<FullAddressType>>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfPosProducts: Scalars['Int']['output'];
  openingHours?: Maybe<OpeningHoursType>;
  outsidePictures?: Maybe<Array<PictureType>>;
  phone?: Maybe<Array<Scalars['String']['output']>>;
  picture?: Maybe<PictureType>;
  published?: Maybe<Scalars['Boolean']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  socialMedia?: Maybe<Array<SocialValueType>>;
  specialOffers?: Maybe<Array<SpecialOfferType>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  turnover?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type InternalProductsByWholesalerCountType = {
  __typename?: 'InternalProductsByWholesalerCountType';
  address?: Maybe<FullAddressType>;
  contactEmails?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  currencies?: Maybe<Array<TargetCurrencyType>>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<IPhoneType>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  numberOfWholesalerProducts: Scalars['Int']['output'];
  phone?: Maybe<IPhoneType>;
  picture?: Maybe<PictureType>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type InventoryCategoryCountType = {
  __typename?: 'InventoryCategoryCountType';
  createdAt: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['String']['output']>;
  layer?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfProducts?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  rank?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type InventoryCategoryType = {
  __typename?: 'InventoryCategoryType';
  createdAt: Scalars['DateTime']['output'];
  hasChildren: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  layer: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  picture?: Maybe<PictureType>;
  rank: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InventoryIntegrationImportType = {
  __typename?: 'InventoryIntegrationImportType';
  articles?: Maybe<Scalars['String']['output']>;
  attributes?: Maybe<Scalars['String']['output']>;
  attributesvalues?: Maybe<Scalars['String']['output']>;
  brands?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Scalars['String']['output']>;
  enable?: Maybe<Scalars['Boolean']['output']>;
  products?: Maybe<Scalars['String']['output']>;
};

export type InvoicePdfType = {
  __typename?: 'InvoicePDFType';
  content?: Maybe<Scalars['String']['output']>;
};

export enum InvoiceStatus {
  CANCELED = 'CANCELED',
  DRAFT = 'DRAFT',
  ISSUED = 'ISSUED'
}

export type InvoiceType = {
  __typename?: 'InvoiceType';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  order: MarketPlaceOrderDtoType;
  sequence?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<InvoiceStatus>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};

export type InvoicingAddressType = {
  __typename?: 'InvoicingAddressType';
  billing?: Maybe<FullAddressType>;
  shipping?: Maybe<FullAddressType>;
};

export type InvoicingPriceType = {
  __typename?: 'InvoicingPriceType';
  gross?: Maybe<Scalars['Decimal']['output']>;
  net?: Maybe<Scalars['Decimal']['output']>;
};

export type InvoicingProductsBundleType = {
  __typename?: 'InvoicingProductsBundleType';
  kind: ProductKindEnum;
  product?: Maybe<InvoicingProductsType>;
  rank: Scalars['Decimal']['output'];
  text?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type InvoicingProductsType = {
  __typename?: 'InvoicingProductsType';
  article?: Maybe<BarcodeType>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<DiscountDtoType>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  rent?: Maybe<RentalRefType>;
  taxes?: Maybe<Array<ProductTaxesType>>;
  total?: Maybe<Scalars['Decimal']['output']>;
};

export type IosDataType = {
  __typename?: 'IosDataType';
  identifierForVendor?: Maybe<Scalars['String']['output']>;
  isPhysicalDevice?: Maybe<Scalars['String']['output']>;
  localizedModel?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  systemName?: Maybe<Scalars['String']['output']>;
  systemVersion?: Maybe<Scalars['String']['output']>;
  utsnameMachine?: Maybe<Scalars['String']['output']>;
  utsnameNodename?: Maybe<Scalars['String']['output']>;
  utsnameRelease?: Maybe<Scalars['String']['output']>;
  utsnameSysname?: Maybe<Scalars['String']['output']>;
  utsnameVersion?: Maybe<Scalars['String']['output']>;
};

export type IplocType = {
  __typename?: 'IplocType';
  country?: Maybe<CountryType>;
  createdAt: Scalars['DateTime']['output'];
  from: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  to?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type IsLinkedAccountType = {
  __typename?: 'IsLinkedAccountType';
  isLinked: Scalars['Boolean']['output'];
};

export type IsLoggedInType = {
  __typename?: 'IsLoggedInType';
  expired: Scalars['Boolean']['output'];
};

export type IsLoginExistInput = {
  /** Login email or username. */
  login?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<IPhoneInput>;
};

export type IsLoginForTargetExistInput = {
  /** Login email or username. */
  login?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  target: TargetAciInput;
};

export type IsUserNearPosDtoType = {
  __typename?: 'IsUserNearPOSDtoType';
  isUserNearPOS: Scalars['Boolean']['output'];
};

export type IsUserSubscribedToTargetType = {
  __typename?: 'IsUserSubscribedToTargetType';
  isSubscribed: Scalars['Boolean']['output'];
  status?: Maybe<SubscriptionStatus>;
};

export type JwtTokenType = {
  __typename?: 'JWTTokenType';
  token: Scalars['String']['output'];
};

export type JobApplicationBaseType = {
  __typename?: 'JobApplicationBaseType';
  cover?: Maybe<DocumentType>;
  createdAt: Scalars['DateTime']['output'];
  cv?: Maybe<DocumentType>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  jobDefinition: JobDefinitionBaseType;
  lastName: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: JobApplicationStatusEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export enum JobApplicationStatusEnum {
  HIRED = 'HIRED',
  NEW = 'NEW',
  NOT_CONSIDERED = 'NOT_CONSIDERED',
  SHORTLISTED = 'SHORTLISTED'
}

export type JobApplicationType = {
  __typename?: 'JobApplicationType';
  cover?: Maybe<DocumentType>;
  createdAt: Scalars['DateTime']['output'];
  cv?: Maybe<DocumentType>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  jobDefinition: JobDefinitionType;
  lastName: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: JobApplicationStatusEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export type JobDefinitionBaseType = {
  __typename?: 'JobDefinitionBaseType';
  createdAt: Scalars['DateTime']['output'];
  department: DepartmentBaseType;
  description?: Maybe<JobDescriptionType>;
  id: Scalars['ID']['output'];
  offer?: Maybe<JobDescriptionType>;
  responsibility?: Maybe<JobDescriptionType>;
  specs?: Maybe<Array<JobSpecsType>>;
  status: JobDefinitionStatusEnum;
  title: Scalars['String']['output'];
  translation?: Maybe<Array<JobDefinitionTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum JobDefinitionSpecEnum {
  HOLIDAYS = 'HOLIDAYS',
  HOMEOFFICE = 'HOMEOFFICE',
  LOCATION = 'LOCATION',
  PERKS = 'PERKS',
  SALARY = 'SALARY',
  SKILLS = 'SKILLS'
}

export enum JobDefinitionStatusEnum {
  CANCELED = 'CANCELED',
  DRAFT = 'DRAFT',
  HIRED = 'HIRED',
  ONGOING = 'ONGOING'
}

export type JobDefinitionTranslationContentType = {
  __typename?: 'JobDefinitionTranslationContentType';
  description?: Maybe<JobDescriptionType>;
  offer?: Maybe<JobDescriptionType>;
  responsibility?: Maybe<JobDescriptionType>;
  specs?: Maybe<Array<JobSpecsType>>;
  title: Scalars['String']['output'];
};

export type JobDefinitionTranslationType = {
  __typename?: 'JobDefinitionTranslationType';
  content: JobDefinitionTranslationContentType;
  language: LanguageType;
};

export type JobDefinitionType = {
  __typename?: 'JobDefinitionType';
  createdAt: Scalars['DateTime']['output'];
  department: DepartmentType;
  description?: Maybe<JobDescriptionType>;
  id: Scalars['ID']['output'];
  offer?: Maybe<JobDescriptionType>;
  responsibility?: Maybe<JobDescriptionType>;
  specs?: Maybe<Array<JobSpecsType>>;
  status: JobDefinitionStatusEnum;
  target: TargetType;
  title: Scalars['String']['output'];
  translation?: Maybe<Array<JobDefinitionTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type JobDescriptionType = {
  __typename?: 'JobDescriptionType';
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
};

export type JobSpecsType = {
  __typename?: 'JobSpecsType';
  key?: Maybe<JobDefinitionSpecEnum>;
  value?: Maybe<Scalars['String']['output']>;
};

export type KeyValueInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type KeyValueListType = {
  __typename?: 'KeyValueListType';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type KeyValueType = {
  __typename?: 'KeyValueType';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type LabelType = {
  __typename?: 'LabelType';
  category?: Maybe<LabelTypeEnum>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum LabelTypeEnum {
  NOTES = 'NOTES',
  SCRUM = 'SCRUM'
}

export enum LandingPageTypeEnum {
  ABOUT = 'ABOUT',
  BLOG = 'BLOG',
  CAREER = 'CAREER',
  CATALOG = 'CATALOG',
  CONTACT = 'CONTACT',
  COPYRIGHT = 'COPYRIGHT',
  FAQ = 'FAQ',
  POPUP = 'POPUP',
  PRIVACY = 'PRIVACY',
  PROJECT = 'PROJECT',
  PROJECTS = 'PROJECTS',
  RETURN_EXCHANGE = 'RETURN_EXCHANGE',
  SHIPPING = 'SHIPPING',
  TERMS = 'TERMS'
}

export type LandingPagesDataType = {
  __typename?: 'LandingPagesDataType';
  sectionContent?: Maybe<Scalars['String']['output']>;
  sectionPictures?: Maybe<Array<PictureType>>;
  sectionReference?: Maybe<Scalars['String']['output']>;
  sectionTitle?: Maybe<Scalars['String']['output']>;
};

export type LandingPagesTranslationContentType = {
  __typename?: 'LandingPagesTranslationContentType';
  pageDescription: Scalars['String']['output'];
  pageTitle: Scalars['String']['output'];
  sectionData: Array<LandingPagesDataType>;
};

export type LandingPagesTranslationType = {
  __typename?: 'LandingPagesTranslationType';
  content: LandingPagesTranslationContentType;
  language: LanguageType;
};

export type LandingPagesType = {
  __typename?: 'LandingPagesType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  pageDescription?: Maybe<Scalars['String']['output']>;
  pageReference: Scalars['String']['output'];
  pageTitle: Scalars['String']['output'];
  pageType: LandingPageTypeEnum;
  sectionData?: Maybe<Array<LandingPagesDataType>>;
  seo?: Maybe<SeoComponentType>;
  status: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  translation?: Maybe<Array<LandingPagesTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type LandingPagesWithoutTranslationType = {
  __typename?: 'LandingPagesWithoutTranslationType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  pageDescription?: Maybe<Scalars['String']['output']>;
  pageReference: Scalars['String']['output'];
  pageTitle: Scalars['String']['output'];
  pageType: LandingPageTypeEnum;
  sectionData?: Maybe<Array<LandingPagesDataType>>;
  seo?: Maybe<SeoComponentType>;
  status: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type LanguageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  flagSquare?: InputMaybe<PictureInput>;
  flagWide?: InputMaybe<PictureInput>;
  iconFlag?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type LanguagePaginatedType = {
  __typename?: 'LanguagePaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<LanguageType>;
};

export type LanguageType = {
  __typename?: 'LanguageType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  flagSquare?: Maybe<PictureType>;
  flagWide?: Maybe<PictureType>;
  iconFlag?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LastMessageType = {
  __typename?: 'LastMessageType';
  createdAt: Scalars['DateTime']['output'];
  custom?: Maybe<CustomMessageType>;
  gif?: Maybe<Scalars['String']['output']>;
  location?: Maybe<LonLatType>;
  media?: Maybe<MessageMediaType>;
  sticker?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  unread?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LatLngType = {
  __typename?: 'LatLngType';
  lat?: Maybe<Scalars['Decimal']['output']>;
  lng?: Maybe<Scalars['Decimal']['output']>;
};

export type LeaderboardBaseType = {
  __typename?: 'LeaderboardBaseType';
  compare: CompareRankType;
  credit: Scalars['Decimal']['output'];
  currentReputationLevel?: Maybe<ReputationWithoutTargetType>;
  entryDate: Scalars['DateTime']['output'];
  nextReputationLevel?: Maybe<ReputationWithoutTargetType>;
  rank: Scalars['Int']['output'];
  target?: Maybe<TargetType>;
  user?: Maybe<UserType>;
  userData?: Maybe<UserDataType>;
};

export type LeaderboardChallengePaginateType = {
  __typename?: 'LeaderboardChallengePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<LeaderboardChallengeType>;
};

export type LeaderboardChallengeType = {
  __typename?: 'LeaderboardChallengeType';
  credit?: Maybe<Scalars['Decimal']['output']>;
  rank: Scalars['Int']['output'];
  user: UserType;
};

export type LeaderboardChallengeWithCurrentUserPaginateType = {
  __typename?: 'LeaderboardChallengeWithCurrentUserPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  currentUser?: Maybe<LeaderboardChallengeType>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<LeaderboardChallengeType>;
};

export enum LeaderboardCompareEnum {
  DOWN = 'DOWN',
  NEW = 'NEW',
  SAME = 'SAME',
  UP = 'UP'
}

export enum LeaderboardCycleEnum {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  OVERALL = 'OVERALL',
  WEEKLY = 'WEEKLY'
}

export type LeaderboardPaginatedType = {
  __typename?: 'LeaderboardPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<LeaderboardType>;
};

export type LeaderboardType = {
  __typename?: 'LeaderboardType';
  compare: CompareRankType;
  createdAt: Scalars['DateTime']['output'];
  credit: Scalars['Decimal']['output'];
  currentReputationLevel?: Maybe<ReputationWithoutTargetType>;
  entryDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  nextReputationLevel?: Maybe<ReputationWithoutTargetType>;
  rank: Scalars['Int']['output'];
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
  userData?: Maybe<UserDataType>;
};

export type LeaderboardWithCycleNumbersAndClosingdateAndCurrentUserPaginatedType = {
  __typename?: 'LeaderboardWithCycleNumbersAndClosingdateAndCurrentUserPaginatedType';
  closingDate?: Maybe<Scalars['DateTime']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  currentUser?: Maybe<LeaderboardBaseType>;
  cycleNumber?: Maybe<Scalars['Int']['output']>;
  cycleNumbers?: Maybe<Array<Scalars['Int']['output']>>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<LeaderboardBaseType>;
};

export type LeaderboardWithCycleNumbersAndClosingdatePaginatedType = {
  __typename?: 'LeaderboardWithCycleNumbersAndClosingdatePaginatedType';
  closingDate?: Maybe<Scalars['DateTime']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  cycleNumber?: Maybe<Scalars['Int']['output']>;
  cycleNumbers?: Maybe<Array<Scalars['Int']['output']>>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<LeaderboardBaseType>;
};

export type LeaderboardWithRequiredCycleInput = {
  cycle: LeaderboardCycleEnum;
  game?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};

export type LeagueFilterInput = {
  code?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  current?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  season?: InputMaybe<Array<Scalars['Int']['input']>>;
  team?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Array<LeagueTypeEnum>>;
};

export type LeagueFixtureType = {
  __typename?: 'LeagueFixtureType';
  events?: Maybe<Scalars['Boolean']['output']>;
  lineups?: Maybe<Scalars['Boolean']['output']>;
  statistics_fixtures?: Maybe<Scalars['Boolean']['output']>;
  statistics_players?: Maybe<Scalars['Boolean']['output']>;
};

export type LeagueObjType = {
  __typename?: 'LeagueObjType';
  id: Scalars['Int']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  logo64?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<LeagueTypeEnum>;
};

export type LeaguePaginateType = {
  __typename?: 'LeaguePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<LeagueType>;
};

export type LeagueType = {
  __typename?: 'LeagueType';
  country?: Maybe<CountryProviderType>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  league?: Maybe<LeagueObjType>;
  seasons?: Maybe<Array<SeasonsType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum LeagueTypeEnum {
  CUP = 'Cup',
  LEAGUE = 'League'
}

export type LevelIntervalType = {
  __typename?: 'LevelIntervalType';
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

export type LineupCoachType = {
  __typename?: 'LineupCoachType';
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
};

export type LineupColorIntType = {
  __typename?: 'LineupColorIntType';
  border?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['String']['output']>;
};

export type LineupColorType = {
  __typename?: 'LineupColorType';
  goalkeeper?: Maybe<LineupColorIntType>;
  player?: Maybe<LineupColorIntType>;
};

export type LineupPlayerType = {
  __typename?: 'LineupPlayerType';
  grid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  pos?: Maybe<Scalars['String']['output']>;
};

export type LineupStartXiType = {
  __typename?: 'LineupStartXIType';
  player?: Maybe<LineupPlayerType>;
};

export type LineupTeamType = {
  __typename?: 'LineupTeamType';
  colors?: Maybe<LineupColorType>;
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LineupsPaginateType = {
  __typename?: 'LineupsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<LineupsType>;
};

export type LineupsType = {
  __typename?: 'LineupsType';
  coach?: Maybe<LineupCoachType>;
  createdAt: Scalars['DateTime']['output'];
  fixture?: Maybe<Scalars['Int']['output']>;
  formation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  startXI?: Maybe<Array<LineupStartXiType>>;
  substitutes?: Maybe<Array<LineupStartXiType>>;
  team?: Maybe<LineupTeamType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LinkAccountInput = {
  /** language of the email. */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Login email or username. */
  login?: InputMaybe<Scalars['String']['input']>;
  /** Message Text for sms or subject for email. */
  messageText: Scalars['String']['input'];
  phone?: InputMaybe<IPhoneInput>;
  target: TargetAciInput;
};

export enum LinkAccountStatusEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING'
}

export type LinkAccountType = {
  __typename?: 'LinkAccountType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  status: LinkAccountStatusEnum;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type LinkAccountWithLoginInput = {
  /** Login phone number/username or email. */
  login?: InputMaybe<Scalars['String']['input']>;
  /** password for login */
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  /** reference to subscribe to */
  reference: Scalars['ID']['input'];
  source?: InputMaybe<UserEventsSourceEnum>;
  target: TargetAciInput;
};

export type LinkItemType = {
  __typename?: 'LinkItemType';
  href?: Maybe<Scalars['String']['output']>;
  rel?: Maybe<Scalars['String']['output']>;
  sizes?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ListWithCardsType = {
  __typename?: 'ListWithCardsType';
  boardCards?: Maybe<Array<BoardCardForListType>>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  identifier?: Maybe<MaintenanceBoardListEnum>;
  name: Scalars['String']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  theme?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ListenForAmountPushedEventType = {
  __typename?: 'ListenForAmountPushedEventType';
  qualitativeAmount?: Maybe<Scalars['Decimal']['output']>;
  quantitativeAmount?: Maybe<Scalars['Decimal']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
};

export type LocationType = {
  __typename?: 'LocationType';
  address?: Maybe<FullAddressType>;
  company?: Maybe<CompanyType>;
  createdAt: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locationType?: Maybe<LocationTypeEnum>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum LocationTypeEnum {
  FACTORY = 'FACTORY',
  OFFICE = 'OFFICE',
  STORAGE = 'STORAGE',
  WAREHOUSE = 'WAREHOUSE'
}

export type LoginInput = {
  /** Login email or username. */
  login?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone?: InputMaybe<IPhoneInput>;
};

export enum LoginSourceEnum {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  USERNAME = 'USERNAME'
}

export type LoginType = {
  __typename?: 'LoginType';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Float']['output'];
  user: UserType;
};

export type LoginUserByTargetInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  phone?: InputMaybe<IPhoneInput>;
  reference?: InputMaybe<Scalars['String']['input']>;
  referral?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<UserEventsSourceEnum>;
  target?: InputMaybe<TargetAciInput>;
  theme: MobileThemesEnum;
  widget?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LogisticStatus {
  DELIVERED = 'DELIVERED',
  OUT_FOR_DELIVERY = 'OUT_FOR_DELIVERY',
  PACKED = 'PACKED',
  PLACED = 'PLACED'
}

export type LogisticTrackerType = {
  __typename?: 'LogisticTrackerType';
  date: Scalars['DateTime']['output'];
  status?: Maybe<LogisticStatus>;
};

export type LogisticType = {
  __typename?: 'LogisticType';
  company?: Maybe<CompanyType>;
  createdAt: Scalars['DateTime']['output'];
  driver?: Maybe<UserType>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  tracker?: Maybe<Array<LogisticTrackerType>>;
  updatedAt: Scalars['DateTime']['output'];
  warehouse?: Maybe<WarehouseType>;
};

export type LogoutUserByTargetInput = {
  identifier?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<UserEventsSourceEnum>;
  target: TargetAciInput;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type LonLatInput = {
  coordinates: Array<Scalars['Float']['input']>;
  type?: InputMaybe<ZoneTypesEnum>;
};

export type LonLatType = {
  __typename?: 'LonLatType';
  coordinates?: Maybe<Array<Scalars['Float']['output']>>;
  type?: Maybe<ZoneTypesEnum>;
};

export type LoyaltyProgramInput = {
  company: Scalars['String']['input'];
  picture?: InputMaybe<PictureInput>;
  programName: Scalars['String']['input'];
};

export type LoyaltyProgramPaginateType = {
  __typename?: 'LoyaltyProgramPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<LoyaltyProgramType>;
};

export type LoyaltyProgramType = {
  __typename?: 'LoyaltyProgramType';
  company?: Maybe<CompanyType>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  picture?: Maybe<PictureType>;
  programName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LoyaltySettingsAccelerateInput = {
  mobile?: InputMaybe<LoyaltySettingsAcceleratePlatformInput>;
  physical?: InputMaybe<LoyaltySettingsAcceleratePlatformInput>;
  web?: InputMaybe<LoyaltySettingsAcceleratePlatformInput>;
};

export type LoyaltySettingsAcceleratePaginateType = {
  __typename?: 'LoyaltySettingsAcceleratePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<LoyaltySettingsAccelerateType>;
};

export type LoyaltySettingsAcceleratePlatformInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  slots?: InputMaybe<Array<LoyaltySettingsAccelerateSlotsInput>>;
};

export type LoyaltySettingsAcceleratePlatformType = {
  __typename?: 'LoyaltySettingsAcceleratePlatformType';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  slots?: Maybe<Array<LoyaltySettingsAccelerateSlotType>>;
};

export type LoyaltySettingsAccelerateSlotType = {
  __typename?: 'LoyaltySettingsAccelerateSlotType';
  period?: Maybe<OpeningHoursDayType>;
  ratio?: Maybe<Scalars['Float']['output']>;
};

export type LoyaltySettingsAccelerateSlotsInput = {
  period?: InputMaybe<OpeningHoursDayInput>;
  ratio?: InputMaybe<Scalars['Float']['input']>;
};

export type LoyaltySettingsAccelerateType = {
  __typename?: 'LoyaltySettingsAccelerateType';
  mobile?: Maybe<LoyaltySettingsAcceleratePlatformType>;
  physical?: Maybe<LoyaltySettingsAcceleratePlatformType>;
  target?: Maybe<TargetType>;
  web?: Maybe<LoyaltySettingsAcceleratePlatformType>;
};

export type LoyaltySettingsAggregatorInput = {
  coin?: InputMaybe<Scalars['ID']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<TargetAciInput>;
};

export type LoyaltySettingsAggregatorType = {
  __typename?: 'LoyaltySettingsAggregatorType';
  coin?: Maybe<CoinType>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  target?: Maybe<TargetType>;
};

export type LoyaltySettingsCardLevelInput = {
  picture?: InputMaybe<PictureInput>;
  reputationLevel?: InputMaybe<Scalars['String']['input']>;
};

export type LoyaltySettingsCardLevelLeanType = {
  __typename?: 'LoyaltySettingsCardLevelLeanType';
  picture?: Maybe<PictureType>;
  reputationLevel?: Maybe<Scalars['ID']['output']>;
};

export type LoyaltySettingsCardLevelNumberInput = {
  format?: InputMaybe<CodeFormatEnum>;
  length?: InputMaybe<Scalars['Int']['input']>;
};

export type LoyaltySettingsCardLevelNumberType = {
  __typename?: 'LoyaltySettingsCardLevelNumberType';
  format?: Maybe<CodeFormatEnum>;
  length?: Maybe<Scalars['Int']['output']>;
};

export type LoyaltySettingsCardLevelRepresentationInput = {
  representation?: InputMaybe<CardRepresentationEnum>;
  style?: InputMaybe<BarcodeRepresentationTyeEnum>;
  visual?: InputMaybe<CodeRepresentationEnum>;
};

export type LoyaltySettingsCardLevelRepresentationType = {
  __typename?: 'LoyaltySettingsCardLevelRepresentationType';
  representation?: Maybe<CardRepresentationEnum>;
  style?: Maybe<BarcodeRepresentationTyeEnum>;
  visual?: Maybe<CodeRepresentationEnum>;
};

export type LoyaltySettingsCardLevelType = {
  __typename?: 'LoyaltySettingsCardLevelType';
  picture?: Maybe<PictureType>;
  reputationLevel?: Maybe<ReputationType>;
};

export type LoyaltySettingsDonationInput = {
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  qualitative?: InputMaybe<Scalars['Decimal']['input']>;
};

export type LoyaltySettingsDonationType = {
  __typename?: 'LoyaltySettingsDonationType';
  enable?: Maybe<Scalars['Boolean']['output']>;
  qualitative: Scalars['Decimal']['output'];
};

export type LoyaltySettingsLoginInput = {
  method?: InputMaybe<Array<LoginSourceEnum>>;
};

export type LoyaltySettingsLoginType = {
  __typename?: 'LoyaltySettingsLoginType';
  method?: Maybe<Array<LoginSourceEnum>>;
};

export type LoyaltySettingsOnsiteConverterInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  remunerations?: InputMaybe<Array<RemunerationWithReputationInput>>;
};

export type LoyaltySettingsOnsiteConverterLeanType = {
  __typename?: 'LoyaltySettingsOnsiteConverterLeanType';
  active: Scalars['Boolean']['output'];
  remunerations: Array<RemunerationWithReputationLeanDtoType>;
};

export type LoyaltySettingsOnsiteConverterPrelevelInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  qualitative?: InputMaybe<RemunerationWithReputationAmountInput>;
  quantitative?: InputMaybe<RemunerationWithReputationQuantitativeInput>;
};

export type LoyaltySettingsOnsiteConverterPrelevelRemunerationType = {
  __typename?: 'LoyaltySettingsOnsiteConverterPrelevelRemunerationType';
  qualitative?: Maybe<RemunerationWithReputationAmountType>;
  quantitative?: Maybe<RemunerationWithReputationQuantitativeType>;
};

export type LoyaltySettingsOnsiteConverterPrelevelType = {
  __typename?: 'LoyaltySettingsOnsiteConverterPrelevelType';
  active: Scalars['Boolean']['output'];
  qualitative?: Maybe<RemunerationWithReputationAmountType>;
  quantitative?: Maybe<RemunerationWithReputationQuantitativeType>;
};

export type LoyaltySettingsOnsiteConverterPrelevelWelcomeType = {
  __typename?: 'LoyaltySettingsOnsiteConverterPrelevelWelcomeType';
  active: Scalars['Boolean']['output'];
  remuneration?: Maybe<LoyaltySettingsOnsiteConverterPrelevelRemunerationType>;
};

export type LoyaltySettingsOnsiteConverterSetInput = {
  mobile?: InputMaybe<LoyaltySettingsOnsiteConverterInput>;
  physical?: InputMaybe<LoyaltySettingsOnsiteConverterInput>;
  web?: InputMaybe<LoyaltySettingsOnsiteConverterInput>;
};

export type LoyaltySettingsOnsiteConverterSetLeanType = {
  __typename?: 'LoyaltySettingsOnsiteConverterSetLeanType';
  mobile?: Maybe<LoyaltySettingsOnsiteConverterLeanType>;
  physical?: Maybe<LoyaltySettingsOnsiteConverterLeanType>;
  web?: Maybe<LoyaltySettingsOnsiteConverterLeanType>;
};

export type LoyaltySettingsOnsiteConverterSetPrelevelInput = {
  mobile?: InputMaybe<LoyaltySettingsOnsiteConverterPrelevelInput>;
  physical?: InputMaybe<LoyaltySettingsOnsiteConverterPrelevelInput>;
  web?: InputMaybe<LoyaltySettingsOnsiteConverterPrelevelInput>;
};

export type LoyaltySettingsOnsiteConverterSetPrelevelType = {
  __typename?: 'LoyaltySettingsOnsiteConverterSetPrelevelType';
  mobile?: Maybe<LoyaltySettingsOnsiteConverterPrelevelType>;
  physical?: Maybe<LoyaltySettingsOnsiteConverterPrelevelType>;
  web?: Maybe<LoyaltySettingsOnsiteConverterPrelevelType>;
};

export type LoyaltySettingsOnsiteConverterSetType = {
  __typename?: 'LoyaltySettingsOnsiteConverterSetType';
  mobile?: Maybe<LoyaltySettingsOnsiteConverterType>;
  physical?: Maybe<LoyaltySettingsOnsiteConverterType>;
  web?: Maybe<LoyaltySettingsOnsiteConverterType>;
};

export type LoyaltySettingsOnsiteConverterType = {
  __typename?: 'LoyaltySettingsOnsiteConverterType';
  active: Scalars['Boolean']['output'];
  remunerations: Array<RemunerationWithReputationDtoType>;
};

export type LoyaltySettingsOnsiteConverterWelcomeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  remuneration?: InputMaybe<LoyaltySettingsOnsiteConverterWelcomeRemunerationInput>;
};

export type LoyaltySettingsOnsiteConverterWelcomeRemunerationInput = {
  qualitative?: InputMaybe<RemunerationWithReputationAmountInput>;
  quantitative?: InputMaybe<RemunerationWithReputationQuantitativeInput>;
};

export type LoyaltySettingsPrelevelConverterInput = {
  qualitative?: InputMaybe<RemunerationWithReputationAmountInput>;
  quantitative?: InputMaybe<RemunerationWithReputationQuantitativeInput>;
};

export type LoyaltySettingsPrelevelConverterType = {
  __typename?: 'LoyaltySettingsPrelevelConverterType';
  qualitative?: Maybe<RemunerationWithReputationAmountType>;
  quantitative?: Maybe<RemunerationWithReputationQuantitativeType>;
};

export type LoyaltySettingsPrelevelInput = {
  cardPicture?: InputMaybe<PictureInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  frequencyGoalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  inactivityCycle?: InputMaybe<Scalars['Int']['input']>;
  lossAmount?: InputMaybe<Scalars['Int']['input']>;
  lossPoints?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onsiteConverter?: InputMaybe<LoyaltySettingsOnsiteConverterSetPrelevelInput>;
  period?: InputMaybe<Scalars['Int']['input']>;
  perks?: InputMaybe<LoyaltySettingsPrelevelPerksInput>;
  picture?: InputMaybe<PictureInput>;
  translation?: InputMaybe<Array<PrelevelTranslationInput>>;
  turnoverGoalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  turnoverPoints?: InputMaybe<Scalars['Int']['input']>;
};

export type LoyaltySettingsPrelevelPerksInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
};

export type LoyaltySettingsPrelevelPerksType = {
  __typename?: 'LoyaltySettingsPrelevelPerksType';
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Decimal']['output']>;
};

export type LoyaltySettingsPrelevelType = {
  __typename?: 'LoyaltySettingsPrelevelType';
  cardPicture?: Maybe<PictureType>;
  color?: Maybe<Scalars['String']['output']>;
  frequencyGoalEnabled?: Maybe<Scalars['Boolean']['output']>;
  inactivityCycle?: Maybe<Scalars['Int']['output']>;
  lossAmount?: Maybe<Scalars['Int']['output']>;
  lossPoints?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onsiteConverter?: Maybe<LoyaltySettingsOnsiteConverterSetPrelevelType>;
  period?: Maybe<Scalars['Int']['output']>;
  perks?: Maybe<LoyaltySettingsPrelevelPerksType>;
  picture?: Maybe<PictureType>;
  translation?: Maybe<Array<PrelevelTranslationType>>;
  turnoverGoalEnabled?: Maybe<Scalars['Boolean']['output']>;
  turnoverPoints?: Maybe<Scalars['Int']['output']>;
};

export type LoyaltySettingsProfileCompleteInput = {
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  levels?: InputMaybe<Array<LoyaltySettingsProfileCompleteLevelsInput>>;
};

export type LoyaltySettingsProfileCompleteLevelsInput = {
  elements?: InputMaybe<Array<ProfileCompleteElementsEnum>>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Decimal']['input']>;
  remuneration?: InputMaybe<LoyaltySettingsPrelevelConverterInput>;
};

export type LoyaltySettingsProfileCompleteLevelsType = {
  __typename?: 'LoyaltySettingsProfileCompleteLevelsType';
  elements?: Maybe<Array<ProfileCompleteElementsEnum>>;
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Decimal']['output']>;
  remuneration?: Maybe<LoyaltySettingsPrelevelConverterType>;
};

export type LoyaltySettingsProfileCompleteType = {
  __typename?: 'LoyaltySettingsProfileCompleteType';
  enable?: Maybe<Scalars['Boolean']['output']>;
  levels?: Maybe<Array<LoyaltySettingsProfileCompleteLevelsType>>;
};

export type LoyaltySettingsRedeemInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  editor?: InputMaybe<OutboundEditorEnum>;
  translation?: InputMaybe<Array<LoyaltySettingsRedeemTranslationInput>>;
};

export type LoyaltySettingsRedeemTranslationInput = {
  content: Scalars['String']['input'];
  language?: InputMaybe<Scalars['ID']['input']>;
};

export type LoyaltySettingsRedeemTranslationType = {
  __typename?: 'LoyaltySettingsRedeemTranslationType';
  _id?: Maybe<Scalars['ID']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  language?: Maybe<LanguageType>;
};

export type LoyaltySettingsRedeemType = {
  __typename?: 'LoyaltySettingsRedeemType';
  content?: Maybe<Scalars['String']['output']>;
  editor?: Maybe<OutboundEditorEnum>;
  translation?: Maybe<Array<LoyaltySettingsRedeemTranslationType>>;
};

export type LoyaltySettingsReferralInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<LoyaltySettingsReferralLimitInput>;
  remuneration?: InputMaybe<LoyaltySettingsReferralRemunerationInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LoyaltySettingsReferralLimitInput = {
  period?: InputMaybe<PeriodCycleEnum>;
  rate?: InputMaybe<Scalars['Int']['input']>;
};

export type LoyaltySettingsReferralLimitType = {
  __typename?: 'LoyaltySettingsReferralLimitType';
  period?: Maybe<PeriodCycleEnum>;
  rate?: Maybe<Scalars['Int']['output']>;
};

export type LoyaltySettingsReferralPaginateType = {
  __typename?: 'LoyaltySettingsReferralPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<LoyaltySettingsReferralType>;
};

export type LoyaltySettingsReferralRemunerationInput = {
  referred?: InputMaybe<RemunerationWithReferralInput>;
  referrer?: InputMaybe<RemunerationWithReferralInput>;
};

export type LoyaltySettingsReferralRemunerationType = {
  __typename?: 'LoyaltySettingsReferralRemunerationType';
  referred?: Maybe<LoyaltySettingsPrelevelConverterType>;
  referrer?: Maybe<LoyaltySettingsPrelevelConverterType>;
};

export type LoyaltySettingsReferralType = {
  __typename?: 'LoyaltySettingsReferralType';
  content?: Maybe<Scalars['String']['output']>;
  enable?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<LoyaltySettingsReferralLimitType>;
  remuneration?: Maybe<LoyaltySettingsReferralRemunerationType>;
  target?: Maybe<TargetType>;
  url?: Maybe<Scalars['String']['output']>;
};

export type LoyaltySettingsType = {
  __typename?: 'LoyaltySettingsType';
  accelerate?: Maybe<LoyaltySettingsAccelerateType>;
  aggregator?: Maybe<LoyaltySettingsAggregatorType>;
  createdAt: Scalars['DateTime']['output'];
  donation?: Maybe<LoyaltySettingsDonationType>;
  id: Scalars['ID']['output'];
  inactivity?: Maybe<InactivityType>;
  leaderboard?: Maybe<LoyaltySettingsWalletLeaderboardType>;
  login?: Maybe<LoyaltySettingsLoginType>;
  loyaltyCard?: Maybe<LoyaltySettingsWalletCardType>;
  onsiteConverter?: Maybe<LoyaltySettingsOnsiteConverterSetType>;
  prelevel?: Maybe<LoyaltySettingsPrelevelType>;
  profileComplete?: Maybe<LoyaltySettingsProfileCompleteType>;
  qualitative?: Maybe<LoyaltySettingsWalletQualitativeType>;
  quantitative?: Maybe<LoyaltySettingsWalletQuantitativeType>;
  redeem?: Maybe<LoyaltySettingsRedeemType>;
  referral?: Maybe<LoyaltySettingsReferralType>;
  subscribers?: Maybe<LoyaltySettingsWalletSubscribersType>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  welcome?: Maybe<LoyaltySettingsOnsiteConverterPrelevelWelcomeType>;
};

export type LoyaltySettingsUpdateInput = {
  accelerate?: InputMaybe<LoyaltySettingsAccelerateInput>;
  aggregator?: InputMaybe<LoyaltySettingsAggregatorInput>;
  donation?: InputMaybe<LoyaltySettingsDonationInput>;
  id: Scalars['ID']['input'];
  inactivity?: InputMaybe<InactivityInput>;
  leaderboard?: InputMaybe<LoyaltySettingsWalletLeaderboardInput>;
  login?: InputMaybe<LoyaltySettingsLoginInput>;
  loyaltyCard?: InputMaybe<LoyaltySettingsWalletCardInput>;
  onsiteConverter?: InputMaybe<LoyaltySettingsOnsiteConverterSetInput>;
  prelevel?: InputMaybe<LoyaltySettingsPrelevelInput>;
  profileComplete?: InputMaybe<LoyaltySettingsProfileCompleteInput>;
  qualitative?: InputMaybe<LoyaltySettingsWalletQualitativeInput>;
  quantitative?: InputMaybe<LoyaltySettingsWalletQuantitativeInput>;
  redeem?: InputMaybe<LoyaltySettingsRedeemInput>;
  referral?: InputMaybe<LoyaltySettingsReferralInput>;
  subscribers?: InputMaybe<LoyaltySettingsWalletSubscribersInput>;
  welcome?: InputMaybe<LoyaltySettingsOnsiteConverterWelcomeInput>;
};

export type LoyaltySettingsWalletCardInput = {
  digital?: InputMaybe<Scalars['Boolean']['input']>;
  levels?: InputMaybe<Array<LoyaltySettingsCardLevelInput>>;
  number?: InputMaybe<LoyaltySettingsCardLevelNumberInput>;
  physical?: InputMaybe<Scalars['Boolean']['input']>;
  representation?: InputMaybe<LoyaltySettingsCardLevelRepresentationInput>;
  validity?: InputMaybe<Scalars['Int']['input']>;
};

export type LoyaltySettingsWalletCardLeanType = {
  __typename?: 'LoyaltySettingsWalletCardLeanType';
  digital: Scalars['Boolean']['output'];
  levels: Array<LoyaltySettingsCardLevelLeanType>;
  number?: Maybe<LoyaltySettingsCardLevelNumberType>;
  physical: Scalars['Boolean']['output'];
  representation?: Maybe<LoyaltySettingsCardLevelRepresentationType>;
  validity: Scalars['Int']['output'];
};

export type LoyaltySettingsWalletCardType = {
  __typename?: 'LoyaltySettingsWalletCardType';
  digital: Scalars['Boolean']['output'];
  levels: Array<LoyaltySettingsCardLevelType>;
  number?: Maybe<LoyaltySettingsCardLevelNumberType>;
  physical: Scalars['Boolean']['output'];
  representation?: Maybe<LoyaltySettingsCardLevelRepresentationType>;
  validity: Scalars['Int']['output'];
};

export type LoyaltySettingsWalletLeaderboardInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  blur?: InputMaybe<Scalars['Boolean']['input']>;
  daily?: InputMaybe<Scalars['Boolean']['input']>;
  monthly?: InputMaybe<Scalars['Boolean']['input']>;
  overall?: InputMaybe<Scalars['Boolean']['input']>;
  weekly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LoyaltySettingsWalletLeaderboardType = {
  __typename?: 'LoyaltySettingsWalletLeaderboardType';
  active: Scalars['Boolean']['output'];
  blur: Scalars['Boolean']['output'];
  daily: Scalars['Boolean']['output'];
  monthly: Scalars['Boolean']['output'];
  overall: Scalars['Boolean']['output'];
  weekly: Scalars['Boolean']['output'];
};

export type LoyaltySettingsWalletQualitativeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  aggregator?: InputMaybe<Scalars['Boolean']['input']>;
  picture?: InputMaybe<PictureInput>;
};

export type LoyaltySettingsWalletQualitativeType = {
  __typename?: 'LoyaltySettingsWalletQualitativeType';
  active: Scalars['Boolean']['output'];
  aggregator: Scalars['Boolean']['output'];
  picture?: Maybe<PictureType>;
};

export type LoyaltySettingsWalletQuantitativeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  coin?: InputMaybe<Scalars['ID']['input']>;
};

export type LoyaltySettingsWalletQuantitativeType = {
  __typename?: 'LoyaltySettingsWalletQuantitativeType';
  active: Scalars['Boolean']['output'];
  coin?: Maybe<CoinType>;
};

export type LoyaltySettingsWalletSubscribersInput = {
  verification?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LoyaltySettingsWalletSubscribersType = {
  __typename?: 'LoyaltySettingsWalletSubscribersType';
  verification: Scalars['Boolean']['output'];
};

export type MachineDataType = {
  __typename?: 'MachineDataType';
  brand?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
};

export type MailAttachmentInput = {
  content: Scalars['String']['input'];
  encoding: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

export type MailResponseDto = {
  __typename?: 'MailResponseDto';
  accepted: Array<Scalars['String']['output']>;
  envelopeTime: Scalars['Float']['output'];
  messageId: Scalars['String']['output'];
  messageSize: Scalars['Float']['output'];
  messageTime: Scalars['Float']['output'];
  rejected: Array<Scalars['String']['output']>;
  response: Scalars['String']['output'];
};

export enum MaintenanceBoardListEnum {
  IN_PROGRESS = 'IN_PROGRESS',
  NEW_REQUEST = 'NEW_REQUEST',
  REPLACED = 'REPLACED',
  SCRAP = 'SCRAP'
}

export type ManufacturerCreateInput = {
  address?: InputMaybe<FullAddressInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  currencies?: InputMaybe<Array<TargetCurrencyInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type ManufacturerPaginateType = {
  __typename?: 'ManufacturerPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ManufacturerType>;
};

export type ManufacturerType = {
  __typename?: 'ManufacturerType';
  address?: Maybe<FullAddressType>;
  company?: Maybe<CompanyType>;
  contactEmails?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  currencies?: Maybe<Array<TargetCurrencyType>>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type ManufacturerUpdateInput = {
  address?: InputMaybe<FullAddressInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  currencies?: InputMaybe<Array<TargetCurrencyInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type MappingFixtureType = {
  __typename?: 'MappingFixtureType';
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  timestamp?: Maybe<Scalars['Float']['output']>;
};

export type MappingLeagueType = {
  __typename?: 'MappingLeagueType';
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
};

export type MappingType = {
  __typename?: 'MappingType';
  createdAt: Scalars['DateTime']['output'];
  fixture?: Maybe<MappingFixtureType>;
  id: Scalars['ID']['output'];
  league?: Maybe<MappingLeagueType>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum MaritalStatus {
  DIVORCED = 'DIVORCED',
  ENGAGED = 'ENGAGED',
  IN_RELATIONSHIP = 'IN_RELATIONSHIP',
  MARRIED = 'MARRIED',
  PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY',
  SEPERATED = 'SEPERATED',
  SINGLE = 'SINGLE',
  WIDOWED = 'WIDOWED'
}

export type MarketPlaceOrderControllerInput = {
  card?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['ID']['input']>;
  deliveryFees?: InputMaybe<Scalars['Decimal']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  orderTime?: InputMaybe<Scalars['DateTime']['input']>;
  orderType?: InputMaybe<OrderTypeEnum>;
  shoppingCart: MarketPlaceOrderShoppingCartControllerInput;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type MarketPlaceOrderDtoFeesType = {
  __typename?: 'MarketPlaceOrderDtoFeesType';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type MarketPlaceOrderDtoType = {
  __typename?: 'MarketPlaceOrderDtoType';
  affiliateId?: Maybe<Scalars['ID']['output']>;
  billingAddress?: Maybe<FullAddressType>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<CurrencyType>;
  deliveryAddress?: Maybe<FullAddressType>;
  deliveryFees?: Maybe<Scalars['Decimal']['output']>;
  extraFees?: Maybe<Array<MarketPlaceOrderDtoFeesType>>;
  guestUser?: Maybe<GuestUserType>;
  hasInvoice?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  installments?: Maybe<Array<InstallmentType>>;
  notes?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  orderTime?: Maybe<Scalars['DateTime']['output']>;
  orderType?: Maybe<OrderTypeEnum>;
  shoppingCart: MarketPlaceOrderShoppingCartType;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type MarketPlaceOrderPriceInput = {
  gross?: InputMaybe<ReduciblePriceInput>;
  net?: InputMaybe<ReduciblePriceInput>;
  toPay?: InputMaybe<ReduciblePriceInput>;
};

export type MarketPlaceOrderShoppingCartControllerInput = {
  discount?: InputMaybe<DiscountDtoInput>;
  price?: InputMaybe<MarketPlaceOrderPriceInput>;
  products: Array<MarketPlaceOrderShoppingCartProductControllerInput>;
  taxValue?: InputMaybe<ReduciblePriceInput>;
};

export type MarketPlaceOrderShoppingCartProductControllerInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<OrderProductPriceInput>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type MarketPlaceOrderShoppingCartType = {
  __typename?: 'MarketPlaceOrderShoppingCartType';
  discount?: Maybe<DiscountDtoType>;
  price?: Maybe<PriceFullType>;
  products?: Maybe<Array<OrderShoppingCartProductType>>;
  target?: Maybe<TargetType>;
  taxValue?: Maybe<ReduciblePriceType>;
};

export type MarketPlaceOrdersCountType = {
  __typename?: 'MarketPlaceOrdersCountType';
  orderTypes: MarketplaceOrdersTypesCountType;
  paymentMethods: MarketplacePaymentMethodsCountType;
  productsMarketplaceOrderByPaymentStatus: MarketplaceOrderByProductsMarketplaceOrderByPaymentStatusCountType;
  productsMarketplaceOrderByStatus: MarketplaceOrderByProductsMarketplaceOrderByStatusCountType;
  total: Scalars['Int']['output'];
  totalProducts: Scalars['Int']['output'];
};

export type MarketPlaceProductFilterType = {
  __typename?: 'MarketPlaceProductFilterType';
  /** list of brands */
  brands?: Maybe<Array<BrandType>>;
  /** list of inventoryCategories */
  categories?: Maybe<Array<InventoryCategoryType>>;
  createdAtRange?: Maybe<DateRangeType>;
  priceRange?: Maybe<PriceRangeType>;
  targets?: Maybe<TargetsType>;
  updatedAtRange?: Maybe<DateRangeType>;
};

export type MarketPlaceProductType = {
  __typename?: 'MarketPlaceProductType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  internalProducts: Array<InternalProductType>;
  product: ProductType;
  updatedAt: Scalars['DateTime']['output'];
};

export type MarketplaceOrderByProductsMarketplaceOrderByPaymentStatusCountType = {
  __typename?: 'MarketplaceOrderByProductsMarketplaceOrderByPaymentStatusCountType';
  CANCELED: Scalars['Int']['output'];
  OPEN: Scalars['Int']['output'];
  PAID: Scalars['Int']['output'];
};

export type MarketplaceOrderByProductsMarketplaceOrderByStatusCountType = {
  __typename?: 'MarketplaceOrderByProductsMarketplaceOrderByStatusCountType';
  CANCELED: Scalars['Int']['output'];
  CONFIRMED: Scalars['Int']['output'];
  DELIVERED: Scalars['Int']['output'];
  OPEN: Scalars['Int']['output'];
};

export type MarketplaceOrdersTypesCountType = {
  __typename?: 'MarketplaceOrdersTypesCountType';
  DELIVERY: Scalars['Int']['output'];
  IN_HOUSE: Scalars['Int']['output'];
  ORDER_AHEAD: Scalars['Int']['output'];
  PICKUP: Scalars['Int']['output'];
};

export type MarketplacePaymentMethodsCountType = {
  __typename?: 'MarketplacePaymentMethodsCountType';
  APP_COINS: Scalars['Int']['output'];
  CASH: Scalars['Int']['output'];
};

export type MediaInput = {
  deg360?: InputMaybe<Array<PictureInput>>;
  pictures?: InputMaybe<Array<PictureInput>>;
  videos?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MediaType = {
  __typename?: 'MediaType';
  deg360?: Maybe<Array<PictureType>>;
  pictures?: Maybe<Array<PictureType>>;
  videos?: Maybe<Array<Scalars['String']['output']>>;
};

export type MembersType = {
  __typename?: 'MembersType';
  users?: Maybe<Array<UserType>>;
};

export enum MemorySetupEnum {
  EIGHT = 'EIGHT',
  FOUR = 'FOUR',
  SIXTEEN = 'SIXTEEN',
  TWELVE = 'TWELVE'
}

export enum MessageGroupStatusEnum {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED'
}

export type MessageGroupType = {
  __typename?: 'MessageGroupType';
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  id: Scalars['ID']['output'];
  isDirectMessage?: Maybe<Scalars['Boolean']['output']>;
  lastMessage?: Maybe<LastMessageType>;
  members?: Maybe<MembersType>;
  mute?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<PictureType>;
  sound?: Maybe<MessageSoundEnum>;
  status?: Maybe<MessageGroupStatusEnum>;
  target?: Maybe<TargetType>;
  type?: Maybe<MessageGroupTypeEnum>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  wallpaper?: Maybe<MessageGroupWallpaperType>;
};

export enum MessageGroupTypeEnum {
  INTERNAL = 'INTERNAL',
  SUPPORT = 'SUPPORT'
}

export type MessageGroupWallpaperType = {
  __typename?: 'MessageGroupWallpaperType';
  assetImage?: Maybe<Scalars['String']['output']>;
  gradientColors?: Maybe<Array<Scalars['String']['output']>>;
  picture?: Maybe<PictureType>;
};

export type MessageMediaType = {
  __typename?: 'MessageMediaType';
  picture?: Maybe<Array<PictureType>>;
  video?: Maybe<Array<PictureType>>;
};

export enum MessageSoundEnum {
  AURORA = 'AURORA',
  DEFAULT = 'DEFAULT',
  NONE = 'NONE'
}

export type MessageType = {
  __typename?: 'MessageType';
  createdAt: Scalars['DateTime']['output'];
  custom?: Maybe<CustomMessageType>;
  gif?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<LonLatType>;
  media?: Maybe<MessageMediaType>;
  messageGroup: MessageGroupType;
  seenBy?: Maybe<Array<UserType>>;
  sender: UserType;
  sticker?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MetaItemType = {
  __typename?: 'MetaItemType';
  content?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  property?: Maybe<Scalars['String']['output']>;
};

export type MetaKeywordsInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MetaKeywordsType = {
  __typename?: 'MetaKeywordsType';
  content?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MilitaryTimeFromToType = {
  __typename?: 'MilitaryTimeFromToType';
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export enum MobileThemesEnum {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
  SYSTEM = 'SYSTEM'
}

export type ModulesDefinitionType = {
  __typename?: 'ModulesDefinitionType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  target?: Maybe<TargetTypeEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MonthDaysType = {
  __typename?: 'MonthDaysType';
  days?: Maybe<Array<Scalars['Int']['output']>>;
  month: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateOutbound: OutboundType;
  activateWidgetIntegrationAction: WidgetIntegrationType;
  addAccountPermission: AccountType;
  addBarcodeToInternalProductAndProduct: InternalProductType;
  addBudgetToQuest: QuestType;
  addReputationLevel: ReputationType;
  addTargetToAccount: AccountType;
  addUserForTarget: CorporateUserType;
  addUserToEventSubscription: EventSubscriptionType;
  approveLinkCorporateAccount: LinkAccountType;
  approveLoyaltySubscription: SubscribersFullType;
  approveSubscription: SubscribersFullType;
  assignDefaultAudienceToTarget: AudienceType;
  bulkUpdateBarcodeMedia: Array<BarcodeType>;
  bulkUpdateCompanyMedia: Array<CompanyType>;
  cancelSubscription: SubscribersFullType;
  convertWalletPoints: SuccessResponseDtoType;
  createAccount: AccountType;
  createActivityType: ActivityTypeType;
  createAdhocCorporateNotification: Array<CorporateNotificationFullType>;
  createAdhocNotification: NotificationFullType;
  createAudience: AudienceType;
  createAudienceCriteria: AudienceCriteriaType;
  createBank: BankType;
  createBankDetails: BankDetailsType;
  createBarcode: BarcodeType;
  createBarcodeForTarget: BarcodeType;
  createCatalogueCategory: CatalogueCategoryType;
  createChallenge: ChallengeType;
  createCoin: CoinType;
  createCompany: CompanyType;
  createCorporateEmailTemplate: CorporateEmailTemplateType;
  createCountry: CountryType;
  createCurrency: CurrencyType;
  createCustomInternalProduct: InternalProductType;
  createDefaultAudience: DefaultAudienceType;
  createEmailTemplate: EmailTemplateType;
  createFavoriteLeagueDefinition: FavoriteLeagueDefinitionType;
  createFavoriteLeagues: FavoriteLeagueType;
  createFavoriteTeamDefinition: FavoriteTeamDefinitionType;
  createFavoriteTeams: FavoriteTeamType;
  createForm: FormResponseType;
  createGame: GameType;
  createInternalProduct: InternalProductType;
  createInternalProductAndProduct: InternalProductType;
  createLanguage: LanguageType;
  createLoyaltyProgram: LoyaltyProgramType;
  createManufacturer: ManufacturerType;
  createOutboundCorporateNotification: CorporateNotificationFullType;
  createPOSCategory: PosCategoryType;
  createPOSServices: PosServicesType;
  createPartnershipNetwork: PartnershipNetworkType;
  createPayment: PaymentType;
  createPermission: PermissionType;
  createPermissionDefinition: PermissionDefinitionType;
  createPointOfSale: PointOfSaleType;
  createQuest: QuestType;
  createQuestActionDefinition: QuestActionDefinitionType;
  createQuestActivity: QuestActivityType;
  createQuestion: QuestionDtoType;
  createResponse: ResponseDtoType;
  createServiceProduct: BarcodeType;
  createSimpleProduct: InternalProductType;
  createSocial: SocialType;
  createState: StateType;
  createStaticTranslation: StaticTranslationType;
  createUser: UserType;
  createUserForApp: UserType;
  createWallet: WalletType;
  createWalletTopupSettings: WalletTopupSettingsType;
  createWholesaler: WholesalerType;
  createWidgetVisuals: WidgetVisualsType;
  deductCoinsFromUser: SuccessResponseDtoType;
  deleteAccount: DeleteResponseDtoType;
  deleteAccountPermission: DeleteResponseDtoType;
  deleteActivityType: DeleteResponseDtoType;
  deleteAudience: DeleteResponseDtoType;
  deleteAudienceCriteria: DeleteResponseDtoType;
  deleteBank: DeleteResponseDtoType;
  deleteBankDetails: DeleteResponseDtoType;
  deleteBarcode: DeleteResponseDtoType;
  deleteCatalogueCategory: DeleteResponseDtoType;
  deleteChallenge: DeleteResponseDtoType;
  deleteCoin: DeleteResponseDtoType;
  deleteCompany: DeleteResponseDtoType;
  deleteCorporateEmailTemplate: DeleteResponseDtoType;
  deleteCorporateNotification: DeleteResponseDtoType;
  deleteCountry: DeleteResponseDtoType;
  deleteCurrency: DeleteResponseDtoType;
  deleteEmailIntegration: DeleteResponseDtoType;
  deleteEmailTemplate: DeleteResponseDtoType;
  deleteFavoriteLeagueDefinition: DeleteResponseDtoType;
  deleteFavoriteLeagues: DeleteResponseDtoType;
  deleteFavoriteTeamDefinition: DeleteResponseDtoType;
  deleteFavoriteTeams: DeleteResponseDtoType;
  deleteForm: DeleteResponseDtoType;
  deleteFormAndQuestions: DeleteResponseDtoType;
  deleteGame: DeleteResponseDtoType;
  deleteGameIntegration: DeleteResponseDtoType;
  deleteInternalProduct: DeleteResponseDtoType;
  deleteLanguage: DeleteResponseDtoType;
  deleteLinkCorporateAccount: DeleteResponseDtoType;
  deleteLoyaltyProgram: LoyaltyProgramType;
  deleteManufacturer: ManufacturerType;
  deleteNotificationIntegration: DeleteResponseDtoType;
  deleteOutbound: DeleteResponseDtoType;
  deletePOSCategory: PosCategoryType;
  deletePOSServices: PosServicesType;
  deletePartnershipNetwork: DeleteResponseDtoType;
  deletePayment: DeleteResponseDtoType;
  deletePermission: DeleteResponseDtoType;
  deletePermissionDefinition: DeleteResponseDtoType;
  deletePointOfSale: PointOfSaleType;
  deleteQuest: DeleteResponseDtoType;
  deleteQuestActionDefinition: DeleteResponseDtoType;
  deleteQuestActivity: DeleteResponseDtoType;
  deleteQuestion: DeleteResponseDtoType;
  deleteResponse: DeleteResponseDtoType;
  deleteSmsIntegration: DeleteResponseDtoType;
  deleteSocial: DeleteResponseDtoType;
  deleteState: DeleteResponseDtoType;
  deleteStaticTranslation: DeleteResponseDtoType;
  deleteSubscriber: DeleteResponseDtoType;
  deleteTargetFromAccount: DeleteResponseDtoType;
  deleteTargetReputation: DeleteResponseDtoType;
  deleteUser: DeleteResponseDtoType;
  deleteUserWithData: DeleteResponseDtoType;
  deleteWalletTopupSettings: DeleteResponseDtoType;
  deleteWholesaler: WholesalerType;
  deleteWidgetIntegration: DeleteResponseDtoType;
  deleteWidgetVisuals: DeleteResponseDtoType;
  disableWidgetIntegrationAction: WidgetIntegrationType;
  expireCorporateUserCard: DeleteResponseDtoType;
  finishOutbound: OutboundType;
  generateTargetUserCards: SuccessResponseDtoType;
  generateTargetUserCardsBatch: SuccessResponseDtoType;
  importTargetUserCardsByExcel: SuccessResponseDtoType;
  initFavoriteLeagues: DeleteResponseDtoType;
  initReputations: Array<ReputationType>;
  initStaticTranslations: StaticTranslationPaginateType;
  initWidgetVisuals: WidgetVisualsPaginateType;
  insertOutbound: OutboundType;
  invitePartnerToNetwork: PartnershipNetworkType;
  linkUserAccount: SuccessResponseDtoType;
  loginUserByTarget: LoginType;
  loginWithPartner: LoginType;
  markAllAsSeenForPOS: NotificationResponse;
  markAllAsSeenForUser: NotificationResponse;
  markAllCorporateNotificationsAsSeenForUser: CorporateNotificationResponse;
  markAllCorporateNotificationsAsSeenForUserWithLinkedAccounts: CorporateNotificationResponse;
  mergeAccounts: UserType;
  onboardUserToTargetLoyalty: SuccessResponseDtoType;
  performDirectDonation: SuccessResponseWithAmountPushedDtoType;
  performDonationActivity: SuccessResponseDtoType;
  performNonPredefinedQuestByUser: SuccessResponseDtoType;
  performOnsiteActivity: QuestActionSuccessType;
  performPredefinedQuestByUser: SuccessResponseDtoType;
  placeBet: Array<BetOrderType>;
  processWelcomeMail: UserType;
  processWelcomeMailForTarget: CorporateUserType;
  redeemReferral: ReferralType;
  refreshStaticTranslations: StaticTranslationPaginateType;
  refreshWidgetVisuals: WidgetVisualsPaginateType;
  register: LoginType;
  registerAccountForApp: AccountType;
  registerApiForTarget: LoginType;
  registerForApp: LoginType;
  registerForTarget: LoginType;
  registerForTargetWithOnboard: CorporateLoginType;
  registerForTargetWithWholesaler: LoginType;
  rejectSubscription: SubscribersFullType;
  removeAudienceFromChallenge: ChallengeType;
  removeAudienceFromCorporateNotification: CorporateNotificationFullType;
  removeAudienceFromOutbound: OutboundType;
  removeAudienceFromQuest: QuestType;
  removeExecutionDateFromCorporateNotification: CorporateNotificationFullType;
  removeReputationLevel: DeleteResponseDtoType;
  removeUserFromEventSubscription: DeleteResponseDtoType;
  reorderCatalogueCategories: Array<CatalogueCategoryType>;
  reorderQuestActivity: QuestActivityType;
  reorderQuestion: QuestionDtoType;
  reorderQuestionOfForm: Array<QuestionDtoType>;
  requestLinkCorporateAccount: LinkAccountType;
  requestSubscription: SubscribersFullType;
  resendApproveCode: SuccessResponseDtoType;
  resetPassword: UserType;
  resetPasswordForTarget: CorporateUserType;
  resetPasswordWithMailForApp: UserType;
  resetPasswordWithSmsForApp: UserType;
  resetStaticTranslation: StaticTranslationType;
  resetWidgetVisual: WidgetVisualsType;
  saveCurrentCorporateUserStatus: UserType;
  saveCurrentUserStatus: UserType;
  sendBatchNotifications: DeleteResponseDtoType;
  sendForgotPasswordMail: MailResponseDto;
  sendForgotPasswordMailOrSmsToTarget: SuccessResponseDtoType;
  sendForgotPasswordMailToTarget: MailResponseDto;
  sendMergeAccountsEmail: MailResponseDto;
  sendRegistrationValidationSms: SmsIntegrationResponseType;
  sendSimpleNotification: DeleteResponseDtoType;
  sendTestQuestApi: ApiReturnType;
  sendValidMail: MailResponseDto;
  sendValidSms: SmsIntegrationResponseType;
  sendValidationCode: SuccessResponseDtoType;
  sendValidationEmail: SuccessResponseDtoType;
  sendValidationEmailForTarget: MailResponseDto;
  subscribeUserToTarget: SubscribersFullType;
  syncOneCategory: CatalogueCategoryType;
  topupWallet: QuestActionSuccessType;
  updateAccount: AccountType;
  updateAccountByAdmin: AccountType;
  updateActivityType: ActivityTypeType;
  updateAudience: AudienceType;
  updateAudienceCriteria: AudienceCriteriaType;
  updateBank: BankType;
  updateBankDetails: BankDetailsType;
  updateBarcode: BarcodeWithPublicPriceType;
  updateCatalogueCategory: CatalogueCategoryType;
  updateChallenge: ChallengeType;
  updateCoin: CoinType;
  updateCompany: CompanyType;
  updateCorporateEmailTemplate: CorporateEmailTemplateType;
  updateCorporateNotification: CorporateNotificationFullType;
  updateCorporateUserCard: CorporateUserCardType;
  updateCorporateUserProfile: UserType;
  updateCountry: CountryType;
  updateCurrency: CurrencyType;
  updateCurrentUser: UserType;
  updateCurrentUserApp: UserType;
  updateCurrentUserEmail: LoginType;
  updateCurrentUserLogins: LoginType;
  updateCurrentUserPassword: UserType;
  updateCurrentUserPasswordForApp: UserType;
  updateEmailIntegration: EmailIntegrationType;
  updateEmailTemplate: EmailTemplateType;
  updateFavoriteLeagues: FavoriteLeagueType;
  updateForm: FormResponseType;
  updateFormStatus: FormResponseType;
  updateGame: GameType;
  updateGameIntegration: GameIntegrationType;
  updateInternalProduct: InternalProductType;
  updateInternalProductAndProduct: InternalProductType;
  updateLanguage: LanguageType;
  updateLoyaltyProgram: LoyaltyProgramType;
  updateLoyaltySettings: LoyaltySettingsType;
  updateManufacturer: ManufacturerType;
  updateNotificationIntegration: NotificationIntegrationType;
  updateOutbound: OutboundType;
  updatePOSCategory: PosCategoryType;
  updatePOSServices: PosServicesType;
  updatePartnershipNetwork: PartnershipNetworkType;
  updatePayment: PaymentType;
  updatePermission: PermissionType;
  updatePermissionDefinition: PermissionDefinitionType;
  updatePointOfSale: PointOfSaleType;
  updatePreLevelGoalStatus: Array<LoyaltySettingsType>;
  updateQuest: QuestType;
  updateQuestActionDefinition: QuestActionDefinitionType;
  updateQuestActivity: QuestActivityType;
  updateQuestion: QuestionDtoType;
  updateReputationLevelGoalStatus: ReputationType;
  updateReputationLevelPoints: Array<ReputationType>;
  updateRewards: GameIntegrationOneRewardsType;
  updateSimpleProduct: InternalProductType;
  updateSmsIntegration: SmsIntegrationType;
  updateSocial: SocialType;
  updateState: StateType;
  updateStaticTranslation: StaticTranslationType;
  updateTargetReputation: ReputationType;
  updateUser: UserType;
  updateUserApp: UserType;
  updateUserPasswordForApp: UserType;
  updateVapidKey: VapidKeyType;
  updateWalletTopupSettings: WalletTopupSettingsType;
  updateWholesaler: WholesalerType;
  updateWidgetIntegration: WidgetIntegrationType;
  updateWidgetVisuals: WidgetVisualsType;
  validateEmailForTarget: CorporateUserType;
  validateLinkOrCodeForTarget: SuccessResponseDtoType;
  validateMail: UserType;
  validatePhoneNumber: UserType;
};


export type MutationActivateOutboundArgs = {
  id: Scalars['ID']['input'];
};


export type MutationActivateWidgetIntegrationActionArgs = {
  id: Scalars['ID']['input'];
  input: WidgetIntegrationActionsInput;
};


export type MutationAddAccountPermissionArgs = {
  permissionId: Scalars['ID']['input'];
  target: TargetAciInput;
  userId: Scalars['ID']['input'];
};


export type MutationAddBarcodeToInternalProductAndProductArgs = {
  barcodeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationAddBudgetToQuestArgs = {
  id: Scalars['ID']['input'];
  maxAnswers: Scalars['Int']['input'];
};


export type MutationAddReputationLevelArgs = {
  input: AddReputationInput;
};


export type MutationAddTargetToAccountArgs = {
  permission?: InputMaybe<Scalars['ID']['input']>;
  target: TargetAciInput;
  userId: Scalars['ID']['input'];
};


export type MutationAddUserForTargetArgs = {
  input: UserWithTargetInput;
};


export type MutationAddUserToEventSubscriptionArgs = {
  input: EventSubscriptionInput;
};


export type MutationApproveLinkCorporateAccountArgs = {
  code: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationApproveLoyaltySubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApproveSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAssignDefaultAudienceToTargetArgs = {
  id: Scalars['ID']['input'];
  target: TargetAciInput;
};


export type MutationBulkUpdateBarcodeMediaArgs = {
  input: Array<UpdateMediaInput>;
};


export type MutationBulkUpdateCompanyMediaArgs = {
  input: Array<UpdateMediaInput>;
};


export type MutationCancelSubscriptionArgs = {
  target: TargetAciInput;
  userId: Scalars['ID']['input'];
};


export type MutationConvertWalletPointsArgs = {
  input: WalletConversionInput;
};


export type MutationCreateAccountArgs = {
  input: AccountInput;
};


export type MutationCreateActivityTypeArgs = {
  input: ActivityTypeInput;
};


export type MutationCreateAdhocCorporateNotificationArgs = {
  input: CorporateNotificationInput;
};


export type MutationCreateAdhocNotificationArgs = {
  description: Scalars['String']['input'];
  executedAt?: InputMaybe<Scalars['DateTime']['input']>;
  picture: PictureInput;
  target: TargetAciInput;
  title: Scalars['String']['input'];
};


export type MutationCreateAudienceArgs = {
  input: AudienceInput;
};


export type MutationCreateAudienceCriteriaArgs = {
  input: AudienceCriteriaInput;
};


export type MutationCreateBankArgs = {
  input: BankInput;
};


export type MutationCreateBankDetailsArgs = {
  input: BankDetailsInput;
};


export type MutationCreateBarcodeArgs = {
  input: BarcodeInput;
  target?: InputMaybe<TargetAciInput>;
};


export type MutationCreateBarcodeForTargetArgs = {
  input: BarcodeInput;
  target?: InputMaybe<TargetAciInput>;
};


export type MutationCreateCatalogueCategoryArgs = {
  input: CatalogueCategoryInput;
};


export type MutationCreateChallengeArgs = {
  input: ChallengeInput;
};


export type MutationCreateCoinArgs = {
  input: CoinInput;
};


export type MutationCreateCompanyArgs = {
  input: CompanyInput;
};


export type MutationCreateCorporateEmailTemplateArgs = {
  input: CorporateEmailTemplateInput;
};


export type MutationCreateCountryArgs = {
  input: CountryInput;
};


export type MutationCreateCurrencyArgs = {
  input: CurrencyInput;
};


export type MutationCreateCustomInternalProductArgs = {
  input: CreateCustomInternalProductInput;
};


export type MutationCreateDefaultAudienceArgs = {
  input: DefaultAudienceInput;
};


export type MutationCreateEmailTemplateArgs = {
  input: EmailTemplateInput;
};


export type MutationCreateFavoriteLeagueDefinitionArgs = {
  league: Scalars['String']['input'];
};


export type MutationCreateFavoriteLeaguesArgs = {
  input: FavoriteLeagueInput;
};


export type MutationCreateFavoriteTeamDefinitionArgs = {
  team: Scalars['String']['input'];
};


export type MutationCreateFavoriteTeamsArgs = {
  input: FavoriteTeamInput;
};


export type MutationCreateFormArgs = {
  input: CreateFormInput;
};


export type MutationCreateGameArgs = {
  input: GameInput;
};


export type MutationCreateInternalProductArgs = {
  input: CreateInternalProductInput;
};


export type MutationCreateInternalProductAndProductArgs = {
  barcodes?: InputMaybe<Array<Scalars['ID']['input']>>;
  brand?: InputMaybe<Scalars['ID']['input']>;
  catalogueCategory: Array<Scalars['ID']['input']>;
  category?: InputMaybe<Array<Scalars['ID']['input']>>;
  classification?: InputMaybe<Array<ProductClassEnum>>;
  condition?: InputMaybe<ProductConditionEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionList?: InputMaybe<Array<Scalars['String']['input']>>;
  discount?: InputMaybe<DiscountDtoInput>;
  ean?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  factoryPrice?: InputMaybe<Scalars['Decimal']['input']>;
  flags?: InputMaybe<ProductFlagEnum>;
  globalCategory?: InputMaybe<GlobalCategoryInput>;
  internalProductAttributes?: InputMaybe<InternalProductAttributeInput>;
  longdesc?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  name: Scalars['String']['input'];
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  specs?: InputMaybe<Array<ProductSpecsInput>>;
  status?: InputMaybe<ProductStatusEnum>;
  structure?: InputMaybe<ProductStructureEnum>;
  suppliers?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  target: TargetAciInput;
  tax: Scalars['Decimal']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  wholesalerPrice?: InputMaybe<Scalars['Decimal']['input']>;
};


export type MutationCreateLanguageArgs = {
  input: LanguageInput;
};


export type MutationCreateLoyaltyProgramArgs = {
  input: LoyaltyProgramInput;
};


export type MutationCreateManufacturerArgs = {
  input: ManufacturerCreateInput;
};


export type MutationCreateOutboundCorporateNotificationArgs = {
  input: CorporateOutboundNotificationInput;
};


export type MutationCreatePosCategoryArgs = {
  input: PosCategoryInput;
};


export type MutationCreatePosServicesArgs = {
  input: PosServicesInput;
};


export type MutationCreatePartnershipNetworkArgs = {
  input: NewPartnershipNetworkInput;
};


export type MutationCreatePaymentArgs = {
  input: PaymentInput;
};


export type MutationCreatePermissionArgs = {
  input: PermissionInput;
};


export type MutationCreatePermissionDefinitionArgs = {
  input: PermissionDefinitionInput;
};


export type MutationCreatePointOfSaleArgs = {
  input: PointOfSaleInput;
};


export type MutationCreateQuestArgs = {
  input: QuestInput;
};


export type MutationCreateQuestActionDefinitionArgs = {
  input: QuestActionDefinitionInput;
};


export type MutationCreateQuestActivityArgs = {
  input: QuestActivityInput;
};


export type MutationCreateQuestionArgs = {
  input: QuestionInput;
};


export type MutationCreateResponseArgs = {
  input: ResponseInput;
};


export type MutationCreateServiceProductArgs = {
  input: BarcodeInput;
  target?: InputMaybe<TargetAciInput>;
};


export type MutationCreateSimpleProductArgs = {
  input: CreateSimpleProductInput;
};


export type MutationCreateSocialArgs = {
  input: SocialInput;
};


export type MutationCreateStateArgs = {
  input: StateInput;
};


export type MutationCreateStaticTranslationArgs = {
  input: StaticTranslationInput;
};


export type MutationCreateUserArgs = {
  input: UserInput;
  subject: Scalars['String']['input'];
  variables?: InputMaybe<EmailTempVariablesInput>;
};


export type MutationCreateUserForAppArgs = {
  input: UserInput;
  subject: Scalars['String']['input'];
  variables?: InputMaybe<EmailTempVariablesInput>;
};


export type MutationCreateWalletArgs = {
  input: WalletInput;
};


export type MutationCreateWalletTopupSettingsArgs = {
  input: WalletTopupSettingsInput;
};


export type MutationCreateWholesalerArgs = {
  input: WholesalerCreateInput;
};


export type MutationCreateWidgetVisualsArgs = {
  input: WidgetVisualsInput;
};


export type MutationDeductCoinsFromUserArgs = {
  amount: Scalars['String']['input'];
  coin?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<TransactionTypeEnum>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteAccountArgs = {
  accountId: Scalars['String']['input'];
};


export type MutationDeleteAccountPermissionArgs = {
  target: TargetAciInput;
  userId: Scalars['ID']['input'];
};


export type MutationDeleteActivityTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAudienceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAudienceCriteriaArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBankArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBankDetailsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBarcodeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCatalogueCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteChallengeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCoinArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCorporateEmailTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCorporateNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCountryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCurrencyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmailIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmailTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFavoriteLeagueDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFavoriteLeaguesArgs = {
  leagueId: Scalars['Int']['input'];
};


export type MutationDeleteFavoriteTeamDefinitionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteFavoriteTeamsArgs = {
  teamId: Scalars['Int']['input'];
};


export type MutationDeleteFormArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFormAndQuestionsArgs = {
  form: Scalars['ID']['input'];
};


export type MutationDeleteGameArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGameIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInternalProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLanguageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLinkCorporateAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLoyaltyProgramArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteManufacturerArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteNotificationIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOutboundArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePosCategoryArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePosServicesArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePartnershipNetworkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePermissionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePermissionDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePointOfSaleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQuestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQuestActionDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQuestActivityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteResponseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSmsIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSocialArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStaticTranslationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSubscriberArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTargetFromAccountArgs = {
  target: TargetAciInput;
  userId: Scalars['ID']['input'];
};


export type MutationDeleteTargetReputationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  password: Scalars['String']['input'];
  reason: DeleteUserReasonEnum;
};


export type MutationDeleteUserWithDataArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWalletTopupSettingsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWholesalerArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteWidgetIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWidgetVisualsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableWidgetIntegrationActionArgs = {
  id: Scalars['ID']['input'];
  input: WidgetIntegrationActionsBaseInput;
};


export type MutationExpireCorporateUserCardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFinishOutboundArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGenerateTargetUserCardsArgs = {
  target: TargetAciInput;
};


export type MutationGenerateTargetUserCardsBatchArgs = {
  target: TargetAciInput;
};


export type MutationImportTargetUserCardsByExcelArgs = {
  base64?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type MutationInitFavoriteLeaguesArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationInitReputationsArgs = {
  target: TargetAciInput;
};


export type MutationInitStaticTranslationsArgs = {
  app: TranslationAppEnum;
  language: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type MutationInitWidgetVisualsArgs = {
  app: TranslationAppEnum;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type MutationInsertOutboundArgs = {
  input: OutboundInput;
};


export type MutationInvitePartnerToNetworkArgs = {
  input: PartnershipNetworkInput;
};


export type MutationLinkUserAccountArgs = {
  input: LinkAccountWithLoginInput;
};


export type MutationLoginUserByTargetArgs = {
  input: LoginUserByTargetInput;
};


export type MutationLoginWithPartnerArgs = {
  input: LoginUserByTargetInput;
};


export type MutationMarkAllAsSeenForPosArgs = {
  posId: Scalars['String']['input'];
};


export type MutationMarkAllCorporateNotificationsAsSeenForUserArgs = {
  target: TargetAciInput;
};


export type MutationMarkAllCorporateNotificationsAsSeenForUserWithLinkedAccountsArgs = {
  target: TargetAciInput;
};


export type MutationMergeAccountsArgs = {
  token: Scalars['String']['input'];
};


export type MutationOnboardUserToTargetLoyaltyArgs = {
  id: Scalars['ID']['input'];
  target: TargetAciInput;
};


export type MutationPerformDirectDonationArgs = {
  amount: Scalars['Decimal']['input'];
  wallet: Scalars['ID']['input'];
};


export type MutationPerformDonationActivityArgs = {
  amount: Scalars['String']['input'];
  challengeId: Scalars['ID']['input'];
};


export type MutationPerformNonPredefinedQuestByUserArgs = {
  input: PerformNonPredefinedQuestByUserInput;
  userToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPerformOnsiteActivityArgs = {
  input: PushAmountInput;
};


export type MutationPerformPredefinedQuestByUserArgs = {
  quest: Scalars['ID']['input'];
};


export type MutationPlaceBetArgs = {
  input: BetOrderInput;
};


export type MutationProcessWelcomeMailArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationProcessWelcomeMailForTargetArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationRedeemReferralArgs = {
  card: Scalars['String']['input'];
  reference: Scalars['String']['input'];
};


export type MutationRefreshStaticTranslationsArgs = {
  app: TranslationAppEnum;
  language: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type MutationRefreshWidgetVisualsArgs = {
  app: TranslationAppEnum;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type MutationRegisterArgs = {
  brand: EmailTempVariablesBrandInput;
  input: UserInput;
  subject: Scalars['String']['input'];
};


export type MutationRegisterAccountForAppArgs = {
  brand: EmailTempVariablesBrandInput;
  input: UserAccountInput;
  subject: Scalars['String']['input'];
};


export type MutationRegisterApiForTargetArgs = {
  publicKey?: InputMaybe<Scalars['String']['input']>;
  secretKey?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type MutationRegisterForAppArgs = {
  brand: EmailTempVariablesBrandInput;
  input: UserInput;
  subject: Scalars['String']['input'];
};


export type MutationRegisterForTargetArgs = {
  input: UserWithTargetInput;
};


export type MutationRegisterForTargetWithOnboardArgs = {
  input: UserWithTargetInput;
  source?: InputMaybe<UserEventsSourceEnum>;
};


export type MutationRegisterForTargetWithWholesalerArgs = {
  input: UserWithTargetInput;
};


export type MutationRejectSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveAudienceFromChallengeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveAudienceFromCorporateNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveAudienceFromOutboundArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveAudienceFromQuestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveExecutionDateFromCorporateNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveReputationLevelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveUserFromEventSubscriptionArgs = {
  input: EventSubscriptionInput;
};


export type MutationReorderCatalogueCategoriesArgs = {
  catalogCategoryId: Scalars['ID']['input'];
  newRank: Scalars['Float']['input'];
  target: TargetAciInput;
};


export type MutationReorderQuestActivityArgs = {
  id: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
};


export type MutationReorderQuestionArgs = {
  id: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
};


export type MutationReorderQuestionOfFormArgs = {
  id: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
};


export type MutationRequestLinkCorporateAccountArgs = {
  input: LinkAccountInput;
};


export type MutationRequestSubscriptionArgs = {
  input: SubscribersInput;
};


export type MutationResendApproveCodeArgs = {
  input: LinkAccountInput;
};


export type MutationResetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationResetPasswordForTargetArgs = {
  password: Scalars['String']['input'];
  source?: InputMaybe<UserEventsSourceEnum>;
  target: TargetAciInput;
  token: Scalars['String']['input'];
};


export type MutationResetPasswordWithMailForAppArgs = {
  input: ResetPasswordForAppInput;
};


export type MutationResetPasswordWithSmsForAppArgs = {
  input: ResetPasswordForAppInput;
};


export type MutationResetStaticTranslationArgs = {
  app: TranslationAppEnum;
  language: Scalars['ID']['input'];
  reference: Scalars['String']['input'];
  target: TargetAciInput;
};


export type MutationResetWidgetVisualArgs = {
  app: TranslationAppEnum;
  reference: Scalars['String']['input'];
  target: TargetAciInput;
};


export type MutationSaveCurrentCorporateUserStatusArgs = {
  status: UserStatus;
  target: TargetAciInput;
};


export type MutationSaveCurrentUserStatusArgs = {
  status: UserStatus;
};


export type MutationSendBatchNotificationsArgs = {
  appName: Scalars['String']['input'];
  body: Scalars['String']['input'];
  settings: NotificationIntegrationFirebaseInput;
  title: Scalars['String']['input'];
  tokens: Array<Scalars['String']['input']>;
};


export type MutationSendForgotPasswordMailArgs = {
  brand?: InputMaybe<EmailTempVariablesBrandInput>;
  email: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};


export type MutationSendForgotPasswordMailOrSmsToTargetArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  source?: InputMaybe<UserEventsSourceEnum>;
  subject?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type MutationSendForgotPasswordMailToTargetArgs = {
  email: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type MutationSendMergeAccountsEmailArgs = {
  app: App;
  email: Scalars['String']['input'];
  ooredooId: Scalars['String']['input'];
};


export type MutationSendRegistrationValidationSmsArgs = {
  phone: IPhoneInput;
  target: TargetAciInput;
};


export type MutationSendSimpleNotificationArgs = {
  appName: Scalars['String']['input'];
  body: Scalars['String']['input'];
  settings: NotificationIntegrationFirebaseInput;
  title: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSendTestQuestApiArgs = {
  api: QuestActionDefinitionDefinitionApiInput;
  params?: InputMaybe<Array<KeyValueInput>>;
};


export type MutationSendValidMailArgs = {
  subject: Scalars['String']['input'];
  variables?: InputMaybe<EmailTempVariablesInput>;
};


export type MutationSendValidSmsArgs = {
  target: TargetAciInput;
};


export type MutationSendValidationCodeArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  source?: InputMaybe<UserEventsSourceEnum>;
  subject?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type MutationSendValidationEmailArgs = {
  email: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  target: TargetAciInput;
};


export type MutationSendValidationEmailForTargetArgs = {
  email: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  target: TargetAciInput;
};


export type MutationSubscribeUserToTargetArgs = {
  target: TargetAciInput;
  user: Scalars['String']['input'];
};


export type MutationSyncOneCategoryArgs = {
  input: CatalogueCategoryBulkInput;
};


export type MutationTopupWalletArgs = {
  input: TopupWalletInput;
};


export type MutationUpdateAccountArgs = {
  accountId: Scalars['String']['input'];
  expiresAt: Scalars['DateTime']['input'];
};


export type MutationUpdateAccountByAdminArgs = {
  accountId: Scalars['String']['input'];
  input: AccountUpdateInput;
};


export type MutationUpdateActivityTypeArgs = {
  id: Scalars['ID']['input'];
  input: ActivityTypeUpdateInput;
};


export type MutationUpdateAudienceArgs = {
  id: Scalars['ID']['input'];
  input: AudienceUpdateInput;
};


export type MutationUpdateAudienceCriteriaArgs = {
  id: Scalars['ID']['input'];
  input: AudienceCriteriaInput;
};


export type MutationUpdateBankArgs = {
  id: Scalars['ID']['input'];
  input: BankInput;
};


export type MutationUpdateBankDetailsArgs = {
  id: Scalars['ID']['input'];
  input: BankDetailsInput;
};


export type MutationUpdateBarcodeArgs = {
  input: BarcodeUpdateInput;
};


export type MutationUpdateCatalogueCategoryArgs = {
  input: CatalogueCategoryUpdateInput;
};


export type MutationUpdateChallengeArgs = {
  id: Scalars['ID']['input'];
  input: ChallengeInput;
};


export type MutationUpdateCoinArgs = {
  id: Scalars['ID']['input'];
  input: CoinInput;
};


export type MutationUpdateCompanyArgs = {
  id: Scalars['ID']['input'];
  input: CompanyUpdateInput;
};


export type MutationUpdateCorporateEmailTemplateArgs = {
  id: Scalars['ID']['input'];
  input: CorporateEmailTemplateInput;
};


export type MutationUpdateCorporateNotificationArgs = {
  id: Scalars['ID']['input'];
  input: CorporateNotificationInput;
};


export type MutationUpdateCorporateUserCardArgs = {
  id: Scalars['ID']['input'];
  validUntil: Scalars['DateTime']['input'];
};


export type MutationUpdateCorporateUserProfileArgs = {
  id: Scalars['ID']['input'];
  input: UserUpdateInput;
};


export type MutationUpdateCountryArgs = {
  id: Scalars['ID']['input'];
  input: CountryInput;
};


export type MutationUpdateCurrencyArgs = {
  id: Scalars['ID']['input'];
  input: CurrencyInput;
};


export type MutationUpdateCurrentUserArgs = {
  input: UserUpdateInput;
  source?: InputMaybe<UserEventsSourceEnum>;
};


export type MutationUpdateCurrentUserAppArgs = {
  app: App;
};


export type MutationUpdateCurrentUserEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationUpdateCurrentUserLoginsArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCurrentUserPasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationUpdateCurrentUserPasswordForAppArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationUpdateEmailIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: EmailIntegrationInput;
};


export type MutationUpdateEmailTemplateArgs = {
  id: Scalars['ID']['input'];
  input: EmailTemplateInput;
};


export type MutationUpdateFavoriteLeaguesArgs = {
  id: Scalars['ID']['input'];
  input: FavoriteLeagueInput;
};


export type MutationUpdateFormArgs = {
  input: UpdateFormInput;
};


export type MutationUpdateFormStatusArgs = {
  id: Scalars['String']['input'];
  status: FormStatus;
};


export type MutationUpdateGameArgs = {
  id: Scalars['ID']['input'];
  input: GameUpdateInput;
};


export type MutationUpdateGameIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: GameIntegrationInput;
};


export type MutationUpdateInternalProductArgs = {
  input: UpdateInternalProductInput;
};


export type MutationUpdateInternalProductAndProductArgs = {
  barcodes?: InputMaybe<Array<Scalars['ID']['input']>>;
  brand?: InputMaybe<Scalars['ID']['input']>;
  catalogueCategory?: InputMaybe<Array<Scalars['ID']['input']>>;
  category?: InputMaybe<Array<Scalars['ID']['input']>>;
  classification?: InputMaybe<Array<ProductClassEnum>>;
  condition?: InputMaybe<ProductConditionEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionList?: InputMaybe<Array<Scalars['String']['input']>>;
  discount?: InputMaybe<DiscountDtoInput>;
  ean?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  factoryPrice?: InputMaybe<Scalars['Decimal']['input']>;
  flags?: InputMaybe<ProductFlagEnum>;
  globalCategory?: InputMaybe<GlobalCategoryInput>;
  id: Scalars['ID']['input'];
  internalProductAttributes?: InputMaybe<InternalProductAttributeInput>;
  longdesc?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  specs?: InputMaybe<Array<ProductSpecsInput>>;
  status?: InputMaybe<ProductStatusEnum>;
  structure?: InputMaybe<ProductStructureEnum>;
  suppliers?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tax?: InputMaybe<Scalars['Decimal']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  wholesalerPrice?: InputMaybe<Scalars['Decimal']['input']>;
};


export type MutationUpdateLanguageArgs = {
  id: Scalars['ID']['input'];
  input: LanguageInput;
};


export type MutationUpdateLoyaltyProgramArgs = {
  id: Scalars['String']['input'];
  input: LoyaltyProgramInput;
};


export type MutationUpdateLoyaltySettingsArgs = {
  input: LoyaltySettingsUpdateInput;
};


export type MutationUpdateManufacturerArgs = {
  input: ManufacturerUpdateInput;
};


export type MutationUpdateNotificationIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: NotificationIntegrationInput;
};


export type MutationUpdateOutboundArgs = {
  id: Scalars['String']['input'];
  input: OutboundInput;
};


export type MutationUpdatePosCategoryArgs = {
  id: Scalars['String']['input'];
  input: PosCategoryInput;
};


export type MutationUpdatePosServicesArgs = {
  id: Scalars['String']['input'];
  input: PosServicesInput;
};


export type MutationUpdatePartnershipNetworkArgs = {
  id: Scalars['String']['input'];
  input: PartnershipNetworkInput;
};


export type MutationUpdatePaymentArgs = {
  id: Scalars['ID']['input'];
  input: PaymentInput;
};


export type MutationUpdatePermissionArgs = {
  id: Scalars['ID']['input'];
  input: PermissionInput;
};


export type MutationUpdatePermissionDefinitionArgs = {
  id: Scalars['ID']['input'];
  input: PermissionDefinitionInput;
};


export type MutationUpdatePointOfSaleArgs = {
  id: Scalars['ID']['input'];
  input: PointOfSaleInput;
};


export type MutationUpdatePreLevelGoalStatusArgs = {
  frequencyGoalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  turnoverGoalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateQuestArgs = {
  id: Scalars['ID']['input'];
  input: QuestUpdateInput;
};


export type MutationUpdateQuestActionDefinitionArgs = {
  id: Scalars['ID']['input'];
  input: QuestActionDefinitionInput;
};


export type MutationUpdateQuestActivityArgs = {
  id: Scalars['ID']['input'];
  input: QuestActivityInput;
};


export type MutationUpdateQuestionArgs = {
  id: Scalars['ID']['input'];
  input: QuestionInput;
};


export type MutationUpdateReputationLevelGoalStatusArgs = {
  frequencyGoalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  turnoverGoalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateReputationLevelPointsArgs = {
  id: Scalars['ID']['input'];
  points: Scalars['Float']['input'];
};


export type MutationUpdateRewardsArgs = {
  input: GetGameIntegrationAddRewardInput;
};


export type MutationUpdateSimpleProductArgs = {
  input: UpdateSimpleProductInput;
};


export type MutationUpdateSmsIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: SmsIntegrationInput;
};


export type MutationUpdateSocialArgs = {
  id: Scalars['ID']['input'];
  input: SocialInput;
};


export type MutationUpdateStateArgs = {
  id: Scalars['ID']['input'];
  input: StateInput;
};


export type MutationUpdateStaticTranslationArgs = {
  input: UpdateStaticTranslationInput;
};


export type MutationUpdateTargetReputationArgs = {
  input: UpdateReputationInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['ID']['input'];
  input: UserUpdateInput;
  source?: InputMaybe<UserEventsSourceEnum>;
};


export type MutationUpdateUserAppArgs = {
  app: App;
  id: Scalars['String']['input'];
};


export type MutationUpdateUserPasswordForAppArgs = {
  id: Scalars['ID']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationUpdateVapidKeyArgs = {
  input: VapidKeyInput;
};


export type MutationUpdateWalletTopupSettingsArgs = {
  id: Scalars['ID']['input'];
  input: WalletTopupSettingsUpdateInput;
};


export type MutationUpdateWholesalerArgs = {
  input: WholesalerUpdateInput;
};


export type MutationUpdateWidgetIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: WidgetIntegrationInput;
};


export type MutationUpdateWidgetVisualsArgs = {
  id: Scalars['ID']['input'];
  input: WidgetVisualsInput;
};


export type MutationValidateEmailForTargetArgs = {
  token: Scalars['String']['input'];
};


export type MutationValidateLinkOrCodeForTargetArgs = {
  code?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  source?: InputMaybe<UserEventsSourceEnum>;
  target: TargetAciInput;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationValidateMailArgs = {
  token: Scalars['String']['input'];
};


export type MutationValidatePhoneNumberArgs = {
  smsNumber: Scalars['Int']['input'];
};

export type NestedPicturesType = {
  __typename?: 'NestedPicturesType';
  cover?: Maybe<PictureType>;
  profile?: Maybe<PictureType>;
};

export type NewPartnershipNetworkInput = {
  app: App;
  partner: TargetCreateInput;
  partnership: Array<PartnershipTypeEnum>;
  subject: Scalars['String']['input'];
  target: TargetAciInput;
  variables: EmailTempVariablesInput;
};

export type NewsletterType = {
  __typename?: 'NewsletterType';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type NotesTaskType = {
  __typename?: 'NotesTaskType';
  done?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
};

export type NotificationFullType = {
  __typename?: 'NotificationFullType';
  action?: Maybe<ActionType>;
  createdAt: Scalars['DateTime']['output'];
  event?: Maybe<EventTypeEnum>;
  executed?: Maybe<Scalars['Boolean']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  seen?: Maybe<Scalars['Boolean']['output']>;
  subjects?: Maybe<SubjectsFullType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationIntegrationFirebaseInput = {
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientX509CertUrl?: InputMaybe<Scalars['String']['input']>;
  privateKey?: InputMaybe<Scalars['String']['input']>;
  privateKeyId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationIntegrationFirebaseType = {
  __typename?: 'NotificationIntegrationFirebaseType';
  clientEmail?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  clientX509CertUrl?: Maybe<Scalars['String']['output']>;
  privateKey?: Maybe<Scalars['String']['output']>;
  privateKeyId?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
};

export type NotificationIntegrationInput = {
  mobile?: InputMaybe<NotificationIntegrationPlatformInput>;
  target?: InputMaybe<TargetAciInput>;
  web?: InputMaybe<NotificationIntegrationPlatformInput>;
};

export type NotificationIntegrationPlatformApiInput = {
  headers?: InputMaybe<Array<KeyValueInput>>;
  link?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<ApiMethods>;
  params?: InputMaybe<Array<KeyValueInput>>;
  paramsConfig?: InputMaybe<NotificationIntegrationPlatformApiParamsInput>;
};

export type NotificationIntegrationPlatformApiType = {
  __typename?: 'NotificationIntegrationPlatformAPIType';
  headers?: Maybe<Array<KeyValueType>>;
  link?: Maybe<Scalars['String']['output']>;
  method?: Maybe<ApiMethods>;
  params?: Maybe<Array<KeyValueType>>;
  paramsConfig?: Maybe<NotificationIntegrationPlatformApiParamsType>;
};

export type NotificationIntegrationPlatformApiParamsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationIntegrationPlatformApiParamsType = {
  __typename?: 'NotificationIntegrationPlatformApiParamsType';
  description?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type NotificationIntegrationPlatformInput = {
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<ProvidersEnum>;
  settings?: InputMaybe<NotificationIntegrationSettingsInput>;
};

export type NotificationIntegrationSettingsInput = {
  api?: InputMaybe<NotificationIntegrationPlatformApiInput>;
  firebase?: InputMaybe<NotificationIntegrationFirebaseInput>;
};

export type NotificationIntegrationSettingsType = {
  __typename?: 'NotificationIntegrationSettingsType';
  api?: Maybe<NotificationIntegrationPlatformApiType>;
  firebase?: Maybe<NotificationIntegrationFirebaseType>;
};

export type NotificationIntegrationType = {
  __typename?: 'NotificationIntegrationType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mobile?: Maybe<NotificationIntegrationTypeType>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  web?: Maybe<NotificationIntegrationTypeType>;
};

export type NotificationIntegrationTypeType = {
  __typename?: 'NotificationIntegrationTypeType';
  enable?: Maybe<Scalars['Boolean']['output']>;
  provider?: Maybe<ProvidersEnum>;
  settings?: Maybe<NotificationIntegrationSettingsType>;
};

export type NotificationOnsiteConverterType = {
  __typename?: 'NotificationOnsiteConverterType';
  qualitativeAmountPushed?: Maybe<Scalars['Decimal']['output']>;
  quantitativeAmountPushed?: Maybe<Scalars['Decimal']['output']>;
};

export type NotificationResponse = {
  __typename?: 'NotificationResponse';
  success: Scalars['Boolean']['output'];
};

export type NotificationType = {
  __typename?: 'NotificationType';
  action?: Maybe<ActionType>;
  createdAt: Scalars['DateTime']['output'];
  event?: Maybe<EventTypeEnum>;
  executed?: Maybe<Scalars['Boolean']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  seen?: Maybe<Scalars['Boolean']['output']>;
  subjects?: Maybe<SubjectsType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type NumberOfInternalProductsType = {
  __typename?: 'NumberOfInternalProductsType';
  byCatalogueCategory: Array<InternalProductsByCatalogueCategoryCountType>;
  byInventoryCategory: Array<InternalProductsByInventoryCategoryCountType>;
  byManufacturers: Array<InternalProductsByManufacturerCountType>;
  byPos: Array<InternalProductsByPosCountType>;
  byWholesalers: Array<InternalProductsByWholesalerCountType>;
  total: Scalars['Int']['output'];
};

export type NumberOfInventoryCategoriesType = {
  __typename?: 'NumberOfInventoryCategoriesType';
  layer: Scalars['Int']['output'];
  numberOfInventoryCategories: Scalars['Int']['output'];
};

export type NumberOfPeopleCountType = {
  __typename?: 'NumberOfPeopleCountType';
  numberOfBookings: Scalars['Int']['output'];
  numberOfPeopleRange: Array<Scalars['Int']['output']>;
};

export type NumberOfPointOfSalesType = {
  __typename?: 'NumberOfPointOfSalesType';
  byPosCategory: Array<PosByPosCategoryCountType>;
  total: Scalars['Int']['output'];
};

export type NumberOfProductsInventoryDashboardType = {
  __typename?: 'NumberOfProductsInventoryDashboardType';
  byFactoryPriceRange: Array<PriceRangeCountType>;
  byInventoryCategory: Array<InventoryCategoryCountType>;
  byPriceRange: Array<PriceRangeCountType>;
  byWholesalerPriceRange: Array<PriceRangeCountType>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type NumberOfProductsType = {
  __typename?: 'NumberOfProductsType';
  byCatalogueCategory: Array<ProductsByCatalogueCategoryCountType>;
  byInventoryCategory: Array<InventoryCategoryCountType>;
  total: Scalars['Int']['output'];
};

export type OsLogoPngType = {
  __typename?: 'OSLogoPngType';
  default?: Maybe<PictureType>;
  size16?: Maybe<PictureType>;
  size24?: Maybe<PictureType>;
  size32?: Maybe<PictureType>;
  size48?: Maybe<PictureType>;
  size64?: Maybe<PictureType>;
  size128?: Maybe<PictureType>;
};

export type OsLogoType = {
  __typename?: 'OSLogoType';
  icon?: Maybe<Scalars['String']['output']>;
  png?: Maybe<OsLogoPngType>;
  svg?: Maybe<PictureType>;
};

export enum OddStatusEnum {
  LOST = 'LOST',
  WON = 'WON'
}

export type OddsBookmakersBetsType = {
  __typename?: 'OddsBookmakersBetsType';
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<OddsBookmakersBetsValuesType>>;
};

export type OddsBookmakersBetsValuesType = {
  __typename?: 'OddsBookmakersBetsValuesType';
  odd?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type OddsBookmakersType = {
  __typename?: 'OddsBookmakersType';
  bets?: Maybe<Array<OddsBookmakersBetsType>>;
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type OddsFilterInput = {
  bet?: InputMaybe<Array<Scalars['Int']['input']>>;
  bookmakers?: InputMaybe<Array<Scalars['Int']['input']>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  fixture?: InputMaybe<Scalars['Int']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  season?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type OddsFixtureType = {
  __typename?: 'OddsFixtureType';
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type OddsLeagueType = {
  __typename?: 'OddsLeagueType';
  country?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
};

export type OddsPaginateType = {
  __typename?: 'OddsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<OddsType>;
};

export type OddsType = {
  __typename?: 'OddsType';
  bookmakers?: Maybe<Array<OddsBookmakersType>>;
  createdAt: Scalars['DateTime']['output'];
  fixture?: Maybe<OddsFixtureType>;
  id: Scalars['ID']['output'];
  league?: Maybe<OddsLeagueType>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OddsWithBetsType = {
  __typename?: 'OddsWithBetsType';
  createdAt: Scalars['DateTime']['output'];
  fixture?: Maybe<OddsFixtureType>;
  id: Scalars['ID']['output'];
  league?: Maybe<OddsLeagueType>;
  odds?: Maybe<Array<OddsBookmakersBetsType>>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OnlineUsersByDeviceTypeType = {
  __typename?: 'OnlineUsersByDeviceTypeType';
  deviceType: DeviceTypeEnum;
  onlineUsers: Scalars['Int']['output'];
};

export enum OnsiteConverterTypeEnum {
  MOBILE = 'MOBILE',
  PHYSICAL = 'PHYSICAL',
  WEB = 'WEB'
}

export type OoredooDataType = {
  __typename?: 'OoredooDataType';
  id?: Maybe<Scalars['String']['output']>;
};

export type OpeningHoursDayInput = {
  day: DayEnum;
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type OpeningHoursDayType = {
  __typename?: 'OpeningHoursDayType';
  day?: Maybe<DayEnum>;
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type OpeningHoursInput = {
  hours: Array<OpeningHoursDayInput>;
  status: OpeningStatus;
};

export type OpeningHoursType = {
  __typename?: 'OpeningHoursType';
  hours?: Maybe<Array<OpeningHoursDayType>>;
  status?: Maybe<OpeningStatus>;
};

export enum OpeningStatus {
  ALWAYS_OPEN = 'ALWAYS_OPEN',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  PERMANENTLY_CLOSED = 'PERMANENTLY_CLOSED',
  SELECTED_HOURS = 'SELECTED_HOURS'
}

export type OperatingSystemDataType = {
  __typename?: 'OperatingSystemDataType';
  brand?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type OperatingSystemType = {
  __typename?: 'OperatingSystemType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  logo?: Maybe<OsLogoType>;
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum OperatorEnum {
  AT_LEAST_ONE = 'AT_LEAST_ONE',
  BETWEEN = 'BETWEEN',
  DIFFERENT = 'DIFFERENT',
  EQUAL = 'EQUAL',
  GREATER = 'GREATER',
  INCLUDED_IN = 'INCLUDED_IN',
  LESSER = 'LESSER',
  NOT_BETWEEN = 'NOT_BETWEEN',
  NOT_EQUAL = 'NOT_EQUAL',
  NOT_INCLUDED_IN = 'NOT_INCLUDED_IN',
  NOT_SPECIFIED = 'NOT_SPECIFIED'
}

export enum OrderEmailActionEnum {
  ORDER_CREATED = 'ORDER_CREATED',
  PRODUCT_CANCELED = 'PRODUCT_CANCELED',
  PRODUCT_CONFIRMED = 'PRODUCT_CONFIRMED',
  PRODUCT_DELIVERED = 'PRODUCT_DELIVERED',
  PRODUCT_PICKUP_READY = 'PRODUCT_PICKUP_READY'
}

export type OrderProductPriceInput = {
  gross?: InputMaybe<Scalars['Decimal']['input']>;
  net?: InputMaybe<Scalars['Decimal']['input']>;
  unitGross?: InputMaybe<Scalars['Decimal']['input']>;
  unitNet?: InputMaybe<Scalars['Decimal']['input']>;
};

export type OrderSettingsEmailsType = {
  __typename?: 'OrderSettingsEmailsType';
  definition?: Maybe<OrderEmailActionEnum>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type OrderSettingsExtraFeesType = {
  __typename?: 'OrderSettingsExtraFeesType';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type OrderSettingsImportType = {
  __typename?: 'OrderSettingsImportType';
  enable?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type OrderShoppingCartAttributeType = {
  __typename?: 'OrderShoppingCartAttributeType';
  externalId: Scalars['String']['output'];
  isMultipleChoice: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
};

export type OrderShoppingCartAttributesValuesType = {
  __typename?: 'OrderShoppingCartAttributesValuesType';
  attribute: OrderShoppingCartAttributeType;
  externalId: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type OrderShoppingCartProductType = {
  __typename?: 'OrderShoppingCartProductType';
  barcode: BarcodeWithPublicPriceType;
  deliveryMan?: Maybe<UserType>;
  name?: Maybe<Scalars['String']['output']>;
  orderProductStatus: OrderStatus;
  pickupTime?: Maybe<Scalars['DateTime']['output']>;
  price: ProductPriceType;
  productAttributesValues?: Maybe<Array<AttributeValueType>>;
  quantity: Scalars['Int']['output'];
  target?: Maybe<TargetType>;
  taxValue: TaxValueType;
};

export enum OrderStatus {
  ASSIGNED = 'ASSIGNED',
  CANCELED = 'CANCELED',
  CONFIRMED = 'CONFIRMED',
  DELIVERED = 'DELIVERED',
  OPEN = 'OPEN',
  READY_FOR_PICKUP = 'READY_FOR_PICKUP'
}

export enum OrderTypeEnum {
  DELIVERY = 'DELIVERY',
  IN_HOUSE = 'IN_HOUSE',
  ORDER_AHEAD = 'ORDER_AHEAD',
  PICKUP = 'PICKUP'
}

export type OutboundContentEmailInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  editor?: InputMaybe<OutboundEditorEnum>;
  preview?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type OutboundContentEmailType = {
  __typename?: 'OutboundContentEmailType';
  content?: Maybe<Scalars['String']['output']>;
  editor?: Maybe<OutboundEditorEnum>;
  preview?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type OutboundContentInput = {
  email?: InputMaybe<OutboundContentEmailInput>;
  push?: InputMaybe<OutboundContentPushInput>;
  sms?: InputMaybe<OutboundContentSmsInput>;
  widget?: InputMaybe<OutboundContentWidgetInput>;
};

export type OutboundContentPushInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type OutboundContentPushType = {
  __typename?: 'OutboundContentPushType';
  description?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type OutboundContentSmsInput = {
  content?: InputMaybe<Scalars['String']['input']>;
};

export type OutboundContentSmsType = {
  __typename?: 'OutboundContentSmsType';
  content?: Maybe<Scalars['String']['output']>;
};

export type OutboundContentType = {
  __typename?: 'OutboundContentType';
  email?: Maybe<OutboundContentEmailType>;
  push?: Maybe<OutboundContentPushType>;
  sms?: Maybe<OutboundContentSmsType>;
  widget?: Maybe<OutboundContentWidgetType>;
};

export type OutboundContentWidgetCallToActionActionInput = {
  leaderboard?: InputMaybe<LeaderboardCycleEnum>;
  paramId?: InputMaybe<Scalars['String']['input']>;
  widgetAction?: InputMaybe<OutboundWidgetActionsEnum>;
};

export type OutboundContentWidgetCallToActionActionType = {
  __typename?: 'OutboundContentWidgetCallToActionActionType';
  leaderboard?: Maybe<LeaderboardCycleEnum>;
  paramId?: Maybe<Scalars['String']['output']>;
  widgetAction?: Maybe<OutboundWidgetActionsEnum>;
};

export type OutboundContentWidgetCallToActionInput = {
  action?: InputMaybe<OutboundContentWidgetCallToActionActionInput>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type OutboundContentWidgetCallToActionType = {
  __typename?: 'OutboundContentWidgetCallToActionType';
  action?: Maybe<OutboundContentWidgetCallToActionActionType>;
  label?: Maybe<Scalars['String']['output']>;
};

export type OutboundContentWidgetContentInput = {
  description: Scalars['String']['input'];
  label: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type OutboundContentWidgetInput = {
  callToAction?: InputMaybe<OutboundContentWidgetCallToActionInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Array<OutboundContentWidgetTranslationInput>>;
};

export type OutboundContentWidgetTranslationContentType = {
  __typename?: 'OutboundContentWidgetTranslationContentType';
  description: Scalars['String']['output'];
  label: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type OutboundContentWidgetTranslationInput = {
  content: OutboundContentWidgetContentInput;
  language: Scalars['ID']['input'];
};

export type OutboundContentWidgetTranslationType = {
  __typename?: 'OutboundContentWidgetTranslationType';
  content: OutboundContentWidgetTranslationContentType;
  language: LanguageType;
};

export type OutboundContentWidgetType = {
  __typename?: 'OutboundContentWidgetType';
  callToAction?: Maybe<OutboundContentWidgetCallToActionType>;
  description?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  title?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Array<OutboundContentWidgetTranslationType>>;
};

export enum OutboundEditorEnum {
  HTML = 'HTML',
  TEXT = 'TEXT'
}

export enum OutboundEnum {
  DRAFT = 'DRAFT',
  FINISHED = 'FINISHED',
  LIVE = 'LIVE'
}

export type OutboundInput = {
  audience?: InputMaybe<Scalars['ID']['input']>;
  channel?: InputMaybe<ChannelEnum>;
  clicked?: InputMaybe<Scalars['Float']['input']>;
  content?: InputMaybe<OutboundContentInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  executedAt?: InputMaybe<Scalars['DateTime']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  sent?: InputMaybe<Scalars['Float']['input']>;
  smart?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OutboundEnum>;
  target?: InputMaybe<TargetAciInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<TriggerEnum>;
};

export type OutboundPaginateType = {
  __typename?: 'OutboundPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<OutboundType>;
};

export type OutboundType = {
  __typename?: 'OutboundType';
  audience?: Maybe<AudienceType>;
  channel?: Maybe<ChannelEnum>;
  clicked?: Maybe<Scalars['Float']['output']>;
  content?: Maybe<OutboundContentType>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  picture?: Maybe<PictureType>;
  sent?: Maybe<Scalars['Float']['output']>;
  smart?: Maybe<Scalars['String']['output']>;
  status?: Maybe<OutboundEnum>;
  target?: Maybe<TargetType>;
  title: Scalars['String']['output'];
  tracking?: Maybe<Scalars['String']['output']>;
  trigger?: Maybe<TriggerEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum OutboundWidgetActionsEnum {
  BADGES = 'BADGES',
  CHALLENGES = 'CHALLENGES',
  HOME = 'HOME',
  LEADERBOARD = 'LEADERBOARD',
  LEVELS = 'LEVELS',
  NOTIFICATION = 'NOTIFICATION',
  PROFILE = 'PROFILE',
  QUESTS = 'QUESTS',
  REDEEM = 'REDEEM',
  URL = 'URL',
  WIN = 'WIN'
}

export type PosByPosCategoryCountType = {
  __typename?: 'POSByPOSCategoryCountType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mapPicture?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfPos: Scalars['Int']['output'];
  picture?: Maybe<PictureType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PosCategoryInput = {
  mapPicture: Scalars['String']['input'];
  name: Scalars['String']['input'];
  picture?: InputMaybe<PictureInput>;
};

export type PosCategoryPaginateType = {
  __typename?: 'POSCategoryPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PosCategoryType>;
};

export type PosCategoryType = {
  __typename?: 'POSCategoryType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mapPicture?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PosContactRequestType = {
  __typename?: 'POSContactRequestType';
  companyName?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pos?: Maybe<PointOfSaleType>;
  subject: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PosLoyaltyInput = {
  from: Scalars['DateTime']['input'];
  loyaltyProgram?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};

export type PosLoyaltyType = {
  __typename?: 'POSLoyaltyType';
  from: Scalars['DateTime']['output'];
  loyaltyProgram?: Maybe<LoyaltyProgramType>;
  to: Scalars['DateTime']['output'];
};

export type PosServicesInput = {
  index: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type PosServicesPaginateType = {
  __typename?: 'POSServicesPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PosServicesType>;
};

export type PosServicesType = {
  __typename?: 'POSServicesType';
  createdAt: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PackageType = {
  __typename?: 'PackageType';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  delivrable: Scalars['Decimal']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  perks?: Maybe<Array<Scalars['String']['output']>>;
  price: Scalars['Decimal']['output'];
  subscriptionCycle: SubscriptionCycleEnum;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaginatedAccountsWithStatsType = {
  __typename?: 'PaginatedAccountsWithStatsType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<AccountsWithStatsType>;
};

export type PaginatedChallengesWithLinkedAccountsType = {
  __typename?: 'PaginatedChallengesWithLinkedAccountsType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ChallengeWithLinkedAccountsType>;
};

export type PaginatedEventSubscriptionType = {
  __typename?: 'PaginatedEventSubscriptionType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<EventSubscriptionType>;
};

export type PaginatedQuestWithQualitativePictureType = {
  __typename?: 'PaginatedQuestWithQualitativePictureType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<QuestWithQualitativePictureType>;
};

export type PaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type PartnerLoginType = {
  __typename?: 'PartnerLoginType';
  identifier?: Maybe<Scalars['String']['output']>;
};

export type PartnerReferralType = {
  __typename?: 'PartnerReferralType';
  address?: Maybe<FullAddressType>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  picture?: Maybe<PictureType>;
  posTitle?: Maybe<Scalars['String']['output']>;
  referralReference?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PartnershipNetworkInput = {
  partner: TargetAciInput;
  partnership: Array<PartnershipTypeEnum>;
  target: TargetAciInput;
};

export type PartnershipNetworkPaginateType = {
  __typename?: 'PartnershipNetworkPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PartnershipNetworkType>;
};

export type PartnershipNetworkType = {
  __typename?: 'PartnershipNetworkType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  partner?: Maybe<TargetType>;
  partnership?: Maybe<Array<PartnershipTypeEnum>>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PartnershipNetworkWithLinkedAccountStatusPaginateType = {
  __typename?: 'PartnershipNetworkWithLinkedAccountStatusPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PartnershipNetworkWithLinkedAccountStatusType>;
};

export type PartnershipNetworkWithLinkedAccountStatusType = {
  __typename?: 'PartnershipNetworkWithLinkedAccountStatusType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  linkedAccountStatus: LinkAccountStatusEnum;
  partner?: Maybe<TargetType>;
  partnership?: Maybe<Array<PartnershipTypeEnum>>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum PartnershipTypeEnum {
  ADVERTISER = 'ADVERTISER',
  CONVERSION = 'CONVERSION',
  DONATION = 'DONATION',
  MARKETPLACE = 'MARKETPLACE'
}

export type PaymentImagesInput = {
  png?: InputMaybe<PaymentImagesPngInput>;
  svg?: InputMaybe<PaymentImagesSvgInput>;
};

export type PaymentImagesPngInput = {
  alt?: InputMaybe<PictureInput>;
  alt2x?: InputMaybe<PictureInput>;
  alt_128?: InputMaybe<PictureInput>;
  alt_256?: InputMaybe<PictureInput>;
  alt_512?: InputMaybe<PictureInput>;
  card_flat?: InputMaybe<PictureInput>;
  card_flat2x?: InputMaybe<PictureInput>;
  card_flat_128?: InputMaybe<PictureInput>;
  card_flat_256?: InputMaybe<PictureInput>;
  card_flat_512?: InputMaybe<PictureInput>;
  dark?: InputMaybe<PictureInput>;
  dark2x?: InputMaybe<PictureInput>;
  dark_128?: InputMaybe<PictureInput>;
  dark_256?: InputMaybe<PictureInput>;
  dark_512?: InputMaybe<PictureInput>;
  default?: InputMaybe<PictureInput>;
  default2x?: InputMaybe<PictureInput>;
  default_128?: InputMaybe<PictureInput>;
  default_256?: InputMaybe<PictureInput>;
  default_512?: InputMaybe<PictureInput>;
  flat?: InputMaybe<PictureInput>;
  flat2x?: InputMaybe<PictureInput>;
  flat_128?: InputMaybe<PictureInput>;
  flat_256?: InputMaybe<PictureInput>;
  flat_512?: InputMaybe<PictureInput>;
  light?: InputMaybe<PictureInput>;
  light2x?: InputMaybe<PictureInput>;
  light_128?: InputMaybe<PictureInput>;
  light_256?: InputMaybe<PictureInput>;
  light_512?: InputMaybe<PictureInput>;
};

export type PaymentImagesPngType = {
  __typename?: 'PaymentImagesPngType';
  alt?: Maybe<PictureType>;
  alt2x?: Maybe<PictureType>;
  alt_128?: Maybe<PictureType>;
  alt_256?: Maybe<PictureType>;
  alt_512?: Maybe<PictureType>;
  card_flat?: Maybe<PictureType>;
  card_flat2x?: Maybe<PictureType>;
  card_flat_128?: Maybe<PictureType>;
  card_flat_256?: Maybe<PictureType>;
  card_flat_512?: Maybe<PictureType>;
  dark?: Maybe<PictureType>;
  dark2x?: Maybe<PictureType>;
  dark_128?: Maybe<PictureType>;
  dark_256?: Maybe<PictureType>;
  dark_512?: Maybe<PictureType>;
  default?: Maybe<PictureType>;
  default2x?: Maybe<PictureType>;
  default_128?: Maybe<PictureType>;
  default_256?: Maybe<PictureType>;
  default_512?: Maybe<PictureType>;
  flat?: Maybe<PictureType>;
  flat2x?: Maybe<PictureType>;
  flat_128?: Maybe<PictureType>;
  flat_256?: Maybe<PictureType>;
  flat_512?: Maybe<PictureType>;
  light?: Maybe<PictureType>;
  light2x?: Maybe<PictureType>;
  light_128?: Maybe<PictureType>;
  light_256?: Maybe<PictureType>;
  light_512?: Maybe<PictureType>;
};

export type PaymentImagesSvgInput = {
  alt?: InputMaybe<PictureInput>;
  card_flat?: InputMaybe<PictureInput>;
  dark?: InputMaybe<PictureInput>;
  default?: InputMaybe<PictureInput>;
  flat?: InputMaybe<PictureInput>;
  light?: InputMaybe<PictureInput>;
};

export type PaymentImagesSvgType = {
  __typename?: 'PaymentImagesSvgType';
  alt?: Maybe<PictureType>;
  card_flat?: Maybe<PictureType>;
  dark?: Maybe<PictureType>;
  default?: Maybe<PictureType>;
  flat?: Maybe<PictureType>;
  light?: Maybe<PictureType>;
};

export type PaymentImagesType = {
  __typename?: 'PaymentImagesType';
  png?: Maybe<PaymentImagesPngType>;
  svg?: Maybe<PaymentImagesSvgType>;
};

export type PaymentInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<PaymentImagesInput>;
  materialIcon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  paymentType?: InputMaybe<PaymentTypeEnum>;
};

export type PaymentMethodsFinanceDashboardDataType = {
  __typename?: 'PaymentMethodsFinanceDashboardDataType';
  APP_COINS?: Maybe<Scalars['Int']['output']>;
  AUTOMATIC_DEBIT?: Maybe<Scalars['Int']['output']>;
  BANK_TRANSFER?: Maybe<Scalars['Int']['output']>;
  BILL_OF_EXCHANGE?: Maybe<Scalars['Int']['output']>;
  CASH?: Maybe<Scalars['Int']['output']>;
  CHECK?: Maybe<Scalars['Int']['output']>;
  CREDIT_CARD?: Maybe<Scalars['Int']['output']>;
  MOBILE_PAYMENT?: Maybe<Scalars['Int']['output']>;
};

export type PaymentMethodsStatsType = {
  __typename?: 'PaymentMethodsStatsType';
  current: PaymentMethodsFinanceDashboardDataType;
  percentage: PaymentMethodsFinanceDashboardDataType;
  previous: PaymentMethodsFinanceDashboardDataType;
};

export type PaymentPaginatedType = {
  __typename?: 'PaymentPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PaymentType>;
};

export enum PaymentStatusEnum {
  CANCELED = 'CANCELED',
  OPEN = 'OPEN',
  PAID = 'PAID',
  REFUNDED = 'REFUNDED',
  REFUND_REQUESTED = 'REFUND_REQUESTED'
}

export type PaymentType = {
  __typename?: 'PaymentType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<PaymentImagesType>;
  materialIcon?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  paymentType?: Maybe<PaymentTypeEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum PaymentTypeEnum {
  COIN = 'COIN',
  CREDIT_CARD = 'CREDIT_CARD',
  METHODS = 'METHODS',
  PAYMENT = 'PAYMENT'
}

export type PerformNonPredefinedQuestByUserInput = {
  api?: InputMaybe<Array<QuestActionActivityApiInput>>;
  game?: InputMaybe<Array<QuestActionGameInput>>;
  quest: Scalars['ID']['input'];
  responses?: InputMaybe<Array<ResponseInput>>;
  watched?: InputMaybe<Array<QuestActionActivityWatchedInput>>;
};

export enum PeriodCycleEnum {
  DAY = 'DAY',
  HOUR = 'HOUR',
  MONTH = 'MONTH',
  WEEK = 'WEEK'
}

export type PeriodStatsType = {
  __typename?: 'PeriodStatsType';
  date: Scalars['String']['output'];
  total?: Maybe<Scalars['Decimal']['output']>;
};

export type PerksInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
};

export type PerksType = {
  __typename?: 'PerksType';
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Decimal']['output']>;
};

export type PermissionDefinitionInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PermissionDefinitionType = {
  __typename?: 'PermissionDefinitionType';
  category?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PermissionInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<PermissionPermissionsInput>>;
  target?: InputMaybe<TargetAciInput>;
};

export type PermissionPermissionsInput = {
  create?: InputMaybe<Scalars['Boolean']['input']>;
  permission: Scalars['ID']['input'];
  read?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PermissionPermissionsType = {
  __typename?: 'PermissionPermissionsType';
  create?: Maybe<Scalars['Boolean']['output']>;
  permission: PermissionDefinitionType;
  read?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<Scalars['Boolean']['output']>;
};

export type PermissionType = {
  __typename?: 'PermissionType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<PermissionPermissionsType>>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PhoneInput = {
  /** Phone country code */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  /** Phone number */
  number?: InputMaybe<Scalars['String']['input']>;
};

export type PhoneType = {
  __typename?: 'PhoneType';
  countryCode?: Maybe<Scalars['String']['output']>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  validationNumber?: Maybe<Scalars['Int']['output']>;
};

export type PictureInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  baseUrl: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  path: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
  x?: InputMaybe<Scalars['Int']['input']>;
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type PictureType = {
  __typename?: 'PictureType';
  alt?: Maybe<Scalars['String']['output']>;
  baseUrl?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
  x?: Maybe<Scalars['Int']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
};

export type PixelBarcodeInput = {
  include?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PixelBarcodeType = {
  __typename?: 'PixelBarcodeType';
  include?: Maybe<Scalars['Boolean']['output']>;
};

export enum PixelRecommendedEventsEnum {
  ADD_PAYMENT_INFO = 'ADD_PAYMENT_INFO',
  ADD_TO_CART = 'ADD_TO_CART',
  ADD_TO_WISHLIST = 'ADD_TO_WISHLIST',
  COMPLETE_REGISTRATION = 'COMPLETE_REGISTRATION',
  CONTACT = 'CONTACT',
  FIND_LOCATION = 'FIND_LOCATION',
  INITIATE_CHECKOUT = 'INITIATE_CHECKOUT',
  LEAD = 'LEAD',
  PURCHASE = 'PURCHASE',
  SCHEDULE = 'SCHEDULE',
  SEARCH = 'SEARCH',
  START_TRIAL = 'START_TRIAL',
  SUBSCRIBE = 'SUBSCRIBE',
  VIEW_CONTENT = 'VIEW_CONTENT'
}

export enum PlatformEnum {
  ANDROID = 'ANDROID',
  DESKTOP = 'DESKTOP',
  IOS = 'IOS',
  WEB = 'WEB'
}

export type PlayerSeasonType = {
  __typename?: 'PlayerSeasonType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  player: Scalars['Float']['output'];
  season: Array<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PlayerStatisticsCardsType = {
  __typename?: 'PlayerStatisticsCardsType';
  red?: Maybe<Scalars['Float']['output']>;
  yellow?: Maybe<Scalars['Float']['output']>;
};

export type PlayerStatisticsDribblesType = {
  __typename?: 'PlayerStatisticsDribblesType';
  attempts?: Maybe<Scalars['Float']['output']>;
  past?: Maybe<Scalars['Float']['output']>;
  success?: Maybe<Scalars['Float']['output']>;
};

export type PlayerStatisticsDuelsType = {
  __typename?: 'PlayerStatisticsDuelsType';
  total?: Maybe<Scalars['Float']['output']>;
  won?: Maybe<Scalars['Float']['output']>;
};

export type PlayerStatisticsFoulsType = {
  __typename?: 'PlayerStatisticsFoulsType';
  committed?: Maybe<Scalars['Float']['output']>;
  drawn?: Maybe<Scalars['Float']['output']>;
};

export type PlayerStatisticsGamesType = {
  __typename?: 'PlayerStatisticsGamesType';
  captain?: Maybe<Scalars['Boolean']['output']>;
  minutes?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  substitute?: Maybe<Scalars['Boolean']['output']>;
};

export type PlayerStatisticsGoalsType = {
  __typename?: 'PlayerStatisticsGoalsType';
  assists?: Maybe<Scalars['Float']['output']>;
  conceded?: Maybe<Scalars['Float']['output']>;
  saves?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PlayerStatisticsPaginateType = {
  __typename?: 'PlayerStatisticsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PlayerStatisticsType>;
};

export type PlayerStatisticsPassesType = {
  __typename?: 'PlayerStatisticsPassesType';
  accuracy?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PlayerStatisticsPenaltyType = {
  __typename?: 'PlayerStatisticsPenaltyType';
  commited?: Maybe<Scalars['Float']['output']>;
  missed?: Maybe<Scalars['Float']['output']>;
  saved?: Maybe<Scalars['Float']['output']>;
  scored?: Maybe<Scalars['Float']['output']>;
  won?: Maybe<Scalars['Float']['output']>;
};

export type PlayerStatisticsPlayerType = {
  __typename?: 'PlayerStatisticsPlayerType';
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
};

export type PlayerStatisticsPlayersType = {
  __typename?: 'PlayerStatisticsPlayersType';
  player?: Maybe<PlayerStatisticsPlayerType>;
  statistics?: Maybe<Array<PlayerStatisticsStatisticsType>>;
};

export type PlayerStatisticsShotsType = {
  __typename?: 'PlayerStatisticsShotsType';
  on?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PlayerStatisticsStatisticsType = {
  __typename?: 'PlayerStatisticsStatisticsType';
  cards?: Maybe<PlayerStatisticsCardsType>;
  dribbles?: Maybe<PlayerStatisticsDribblesType>;
  duels?: Maybe<PlayerStatisticsDuelsType>;
  fouls?: Maybe<PlayerStatisticsFoulsType>;
  games?: Maybe<PlayerStatisticsGamesType>;
  goals?: Maybe<PlayerStatisticsGoalsType>;
  offsides?: Maybe<Scalars['Float']['output']>;
  passes?: Maybe<PlayerStatisticsPassesType>;
  penalty?: Maybe<PlayerStatisticsPenaltyType>;
  shots?: Maybe<PlayerStatisticsShotsType>;
  tackles?: Maybe<PlayerStatisticsTacklesType>;
};

export type PlayerStatisticsTacklesType = {
  __typename?: 'PlayerStatisticsTacklesType';
  blocks?: Maybe<Scalars['Float']['output']>;
  interceptions?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PlayerStatisticsTeamType = {
  __typename?: 'PlayerStatisticsTeamType';
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  update?: Maybe<Scalars['DateTime']['output']>;
};

export type PlayerStatisticsType = {
  __typename?: 'PlayerStatisticsType';
  createdAt: Scalars['DateTime']['output'];
  fixture?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  players?: Maybe<Array<PlayerStatisticsPlayersType>>;
  team?: Maybe<PlayerStatisticsTeamType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PlayersPlayerBirthType = {
  __typename?: 'PlayersPlayerBirthType';
  country?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  place?: Maybe<Scalars['String']['output']>;
};

export type PlayersPlayerType = {
  __typename?: 'PlayersPlayerType';
  age?: Maybe<Scalars['Float']['output']>;
  birth?: Maybe<PlayersPlayerBirthType>;
  firstname?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  injured?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  photo64?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
};

export type PlayersStatisticsCardsType = {
  __typename?: 'PlayersStatisticsCardsType';
  red?: Maybe<Scalars['Float']['output']>;
  yellow?: Maybe<Scalars['Float']['output']>;
  yellowred?: Maybe<Scalars['Float']['output']>;
};

export type PlayersStatisticsDribblesType = {
  __typename?: 'PlayersStatisticsDribblesType';
  attempts?: Maybe<Scalars['Float']['output']>;
  past?: Maybe<Scalars['Float']['output']>;
  success?: Maybe<Scalars['Float']['output']>;
};

export type PlayersStatisticsDuelsType = {
  __typename?: 'PlayersStatisticsDuelsType';
  total?: Maybe<Scalars['Float']['output']>;
  won?: Maybe<Scalars['Float']['output']>;
};

export type PlayersStatisticsFoulsType = {
  __typename?: 'PlayersStatisticsFoulsType';
  committed?: Maybe<Scalars['Float']['output']>;
  drawn?: Maybe<Scalars['Float']['output']>;
};

export type PlayersStatisticsGamesType = {
  __typename?: 'PlayersStatisticsGamesType';
  appearences?: Maybe<Scalars['Float']['output']>;
  captain?: Maybe<Scalars['Boolean']['output']>;
  lineups?: Maybe<Scalars['Float']['output']>;
  minutes?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
};

export type PlayersStatisticsGoalsType = {
  __typename?: 'PlayersStatisticsGoalsType';
  assists?: Maybe<Scalars['Float']['output']>;
  conceded?: Maybe<Scalars['Float']['output']>;
  saves?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PlayersStatisticsLeagueType = {
  __typename?: 'PlayersStatisticsLeagueType';
  country?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['String']['output']>;
};

export type PlayersStatisticsPassesType = {
  __typename?: 'PlayersStatisticsPassesType';
  accuracy?: Maybe<Scalars['Float']['output']>;
  key?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PlayersStatisticsPenaltyType = {
  __typename?: 'PlayersStatisticsPenaltyType';
  commited?: Maybe<Scalars['Float']['output']>;
  missed?: Maybe<Scalars['Float']['output']>;
  saved?: Maybe<Scalars['Float']['output']>;
  scored?: Maybe<Scalars['Float']['output']>;
  won?: Maybe<Scalars['Float']['output']>;
};

export type PlayersStatisticsShotsType = {
  __typename?: 'PlayersStatisticsShotsType';
  on?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PlayersStatisticsSubstituesType = {
  __typename?: 'PlayersStatisticsSubstituesType';
  bench?: Maybe<Scalars['Float']['output']>;
  teamIn?: Maybe<Scalars['Float']['output']>;
  teamOut?: Maybe<Scalars['Float']['output']>;
};

export type PlayersStatisticsTacklesType = {
  __typename?: 'PlayersStatisticsTacklesType';
  blocks?: Maybe<Scalars['Float']['output']>;
  interceptions?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PlayersStatisticsTeamType = {
  __typename?: 'PlayersStatisticsTeamType';
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PlayersStatisticsType = {
  __typename?: 'PlayersStatisticsType';
  cards?: Maybe<PlayersStatisticsCardsType>;
  dribbles?: Maybe<PlayersStatisticsDribblesType>;
  duels?: Maybe<PlayersStatisticsDuelsType>;
  fouls?: Maybe<PlayersStatisticsFoulsType>;
  games?: Maybe<PlayersStatisticsGamesType>;
  goals?: Maybe<PlayersStatisticsGoalsType>;
  league?: Maybe<PlayersStatisticsLeagueType>;
  passes?: Maybe<PlayersStatisticsPassesType>;
  penalty?: Maybe<PlayersStatisticsPenaltyType>;
  shots?: Maybe<PlayersStatisticsShotsType>;
  substitutes?: Maybe<PlayersStatisticsSubstituesType>;
  tackles?: Maybe<PlayersStatisticsTacklesType>;
  team?: Maybe<PlayersStatisticsTeamType>;
};

export type PlayersStatsFilterInput = {
  leagues?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  seasons?: InputMaybe<Array<Scalars['Int']['input']>>;
  teams?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PlayersStatsPaginateType = {
  __typename?: 'PlayersStatsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PlayersStatsType>;
};

export type PlayersStatsType = {
  __typename?: 'PlayersStatsType';
  id: Scalars['ID']['output'];
  player?: Maybe<PlayersPlayerType>;
  statistics?: Maybe<Array<PlayersStatisticsType>>;
};

export type PluginPicturesType = {
  __typename?: 'PluginPicturesType';
  square?: Maybe<PictureType>;
  wide?: Maybe<PictureType>;
};

export type PluginType = {
  __typename?: 'PluginType';
  category?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  info?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pictures?: Maybe<PluginPicturesType>;
  recommended: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type PointOfSaleInput = {
  aggregator?: InputMaybe<Scalars['Boolean']['input']>;
  averageCustomers?: InputMaybe<Scalars['Float']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  chatContact?: InputMaybe<Array<SocialValueInput>>;
  company?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  currencies?: InputMaybe<Array<TargetCurrencyInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  insidePictures?: InputMaybe<Array<PictureInput>>;
  languages?: InputMaybe<Array<Scalars['ID']['input']>>;
  locations?: InputMaybe<Array<FullAddressInput>>;
  loyaltyPrograms?: InputMaybe<Array<PosLoyaltyInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingHours?: InputMaybe<OpeningHoursInput>;
  outsidePictures?: InputMaybe<Array<PictureInput>>;
  paymentMethods?: InputMaybe<Array<Scalars['ID']['input']>>;
  phone?: InputMaybe<Array<Scalars['String']['input']>>;
  picture?: InputMaybe<PictureInput>;
  posCategory?: InputMaybe<Array<Scalars['ID']['input']>>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Array<Scalars['ID']['input']>>;
  socialMedia?: InputMaybe<Array<SocialValueInput>>;
  specialOffers?: InputMaybe<Array<SpecilOfferInput>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  turnover?: InputMaybe<Scalars['Decimal']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type PointOfSalePaginateType = {
  __typename?: 'PointOfSalePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PointOfSaleType>;
};

export type PointOfSaleType = {
  __typename?: 'PointOfSaleType';
  aggregator?: Maybe<Scalars['Boolean']['output']>;
  averageCustomers?: Maybe<Scalars['Float']['output']>;
  brandColor?: Maybe<Scalars['String']['output']>;
  chatContact?: Maybe<Array<SocialValueType>>;
  company?: Maybe<CompanyType>;
  contactEmails?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  currencies?: Maybe<Array<TargetCurrencyType>>;
  dashboard?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  insidePictures?: Maybe<Array<PictureType>>;
  isFollowed?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<LanguageType>>;
  locations?: Maybe<Array<FullAddressType>>;
  loyaltyPrograms?: Maybe<Array<PosLoyaltyType>>;
  name?: Maybe<Scalars['String']['output']>;
  openingHours?: Maybe<OpeningHoursType>;
  outsidePictures?: Maybe<Array<PictureType>>;
  paymentMethods?: Maybe<Array<PaymentType>>;
  phone?: Maybe<Array<Scalars['String']['output']>>;
  picture?: Maybe<PictureType>;
  posCategory?: Maybe<Array<PosCategoryType>>;
  published?: Maybe<Scalars['Boolean']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<PosServicesType>>;
  socialMedia?: Maybe<Array<SocialValueType>>;
  specialOffers?: Maybe<Array<SpecialOfferType>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  turnover?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type PointOfSaleWithFollowShipStatusPaginateType = {
  __typename?: 'PointOfSaleWithFollowShipStatusPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PointOfSaleWithFollowShipStatusType>;
};

export type PointOfSaleWithFollowShipStatusType = {
  __typename?: 'PointOfSaleWithFollowShipStatusType';
  aggregator?: Maybe<Scalars['Boolean']['output']>;
  averageCustomers?: Maybe<Scalars['Float']['output']>;
  brandColor?: Maybe<Scalars['String']['output']>;
  chatContact?: Maybe<Array<SocialValueType>>;
  company?: Maybe<CompanyType>;
  contactEmails?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  currencies?: Maybe<Array<TargetCurrencyType>>;
  dashboard?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  insidePictures?: Maybe<Array<PictureType>>;
  isFollowed: Scalars['Boolean']['output'];
  languages?: Maybe<Array<LanguageType>>;
  locations?: Maybe<Array<FullAddressType>>;
  loyaltyPrograms?: Maybe<Array<PosLoyaltyType>>;
  name?: Maybe<Scalars['String']['output']>;
  openingHours?: Maybe<OpeningHoursType>;
  outsidePictures?: Maybe<Array<PictureType>>;
  paymentMethods?: Maybe<Array<PaymentType>>;
  phone?: Maybe<Array<Scalars['String']['output']>>;
  picture?: Maybe<PictureType>;
  posCategory?: Maybe<Array<PosCategoryType>>;
  published?: Maybe<Scalars['Boolean']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<PosServicesType>>;
  socialMedia?: Maybe<Array<SocialValueType>>;
  specialOffers?: Maybe<Array<SpecialOfferType>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  turnover?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export enum PositionEnum {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}

export type PredefinedActionInput = {
  action?: InputMaybe<Scalars['ID']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PredefinedActionType = {
  __typename?: 'PredefinedActionType';
  action?: Maybe<PredefinedType>;
  enable?: Maybe<Scalars['Boolean']['output']>;
};

export type PredefinedType = {
  __typename?: 'PredefinedType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<MediaType>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PredictionsComparisonType = {
  __typename?: 'PredictionsComparisonType';
  att?: Maybe<StatHaType>;
  def?: Maybe<StatHaType>;
  form?: Maybe<StatHaType>;
  goals?: Maybe<StatHaType>;
  h2h?: Maybe<StatHaType>;
  poisson_distribution?: Maybe<StatHaType>;
  total?: Maybe<StatHaType>;
};

export type PredictionsH2HFixturePeriodsType = {
  __typename?: 'PredictionsH2HFixturePeriodsType';
  first?: Maybe<Scalars['Float']['output']>;
  second?: Maybe<Scalars['Float']['output']>;
};

export type PredictionsH2HFixtureStatusType = {
  __typename?: 'PredictionsH2HFixtureStatusType';
  elapsed?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  short?: Maybe<Scalars['String']['output']>;
};

export type PredictionsH2HFixtureType = {
  __typename?: 'PredictionsH2HFixtureType';
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  periods?: Maybe<PredictionsH2HFixturePeriodsType>;
  referee?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PredictionsH2HFixtureStatusType>;
  timestamp?: Maybe<Scalars['Float']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  venue?: Maybe<PredictionsH2HFixtureVenueType>;
};

export type PredictionsH2HFixtureVenueType = {
  __typename?: 'PredictionsH2HFixtureVenueType';
  city?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PredictionsH2HLeagueType = {
  __typename?: 'PredictionsH2HLeagueType';
  country?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  round?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
};

export type PredictionsH2HScoreType = {
  __typename?: 'PredictionsH2HScoreType';
  extratime?: Maybe<StatHaType>;
  fulltime?: Maybe<StatHaType>;
  halftime?: Maybe<StatHaType>;
  penalty?: Maybe<StatHaType>;
};

export type PredictionsH2HTeamsHaType = {
  __typename?: 'PredictionsH2HTeamsHAType';
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  winner?: Maybe<Scalars['Boolean']['output']>;
};

export type PredictionsH2HTeamsType = {
  __typename?: 'PredictionsH2HTeamsType';
  away?: Maybe<PredictionsH2HTeamsHaType>;
  home?: Maybe<PredictionsH2HTeamsHaType>;
};

export type PredictionsH2HType = {
  __typename?: 'PredictionsH2HType';
  fixture?: Maybe<PredictionsH2HFixtureType>;
  goals?: Maybe<StatHaType>;
  league?: Maybe<PredictionsH2HLeagueType>;
  score?: Maybe<PredictionsH2HScoreType>;
  teams?: Maybe<PredictionsH2HTeamsType>;
};

export type PredictionsLeagueType = {
  __typename?: 'PredictionsLeagueType';
  country?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
};

export type PredictionsPaginateType = {
  __typename?: 'PredictionsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<PredictionsType>;
};

export type PredictionsPercentType = {
  __typename?: 'PredictionsPercentType';
  away?: Maybe<Scalars['String']['output']>;
  draw?: Maybe<Scalars['String']['output']>;
  home?: Maybe<Scalars['String']['output']>;
};

export type PredictionsPredictionsType = {
  __typename?: 'PredictionsPredictionsType';
  advice?: Maybe<Scalars['String']['output']>;
  goals?: Maybe<StatHaType>;
  percent?: Maybe<PredictionsPercentType>;
  under_over?: Maybe<Scalars['String']['output']>;
  win_or_draw?: Maybe<Scalars['Boolean']['output']>;
  winner?: Maybe<PredictionsWinnerType>;
};

export type PredictionsTamType = {
  __typename?: 'PredictionsTAMType';
  average?: Maybe<StatHatType>;
  minute?: Maybe<StatMinuteType>;
  total?: Maybe<StatHatType>;
};

export type PredictionsTeamsHomeLast5GoalsType = {
  __typename?: 'PredictionsTeamsHomeLast5GoalsType';
  against?: Maybe<StatTaType>;
  forstat?: Maybe<StatTaType>;
};

export type PredictionsTeamsHomeLast5Type = {
  __typename?: 'PredictionsTeamsHomeLast5Type';
  att?: Maybe<Scalars['String']['output']>;
  def?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Scalars['String']['output']>;
  goals?: Maybe<PredictionsTeamsHomeLast5GoalsType>;
};

export type PredictionsTeamsHomeLeagueBiggestGoalsType = {
  __typename?: 'PredictionsTeamsHomeLeagueBiggestGoalsType';
  against?: Maybe<StatHaType>;
  forstat?: Maybe<StatHaType>;
};

export type PredictionsTeamsHomeLeagueBiggestStreakType = {
  __typename?: 'PredictionsTeamsHomeLeagueBiggestStreakType';
  draws?: Maybe<Scalars['Float']['output']>;
  loses?: Maybe<Scalars['Float']['output']>;
  wins?: Maybe<Scalars['Float']['output']>;
};

export type PredictionsTeamsHomeLeagueBiggestType = {
  __typename?: 'PredictionsTeamsHomeLeagueBiggestType';
  goals?: Maybe<PredictionsTeamsHomeLeagueBiggestGoalsType>;
  loses?: Maybe<StatHaType>;
  streak?: Maybe<PredictionsTeamsHomeLeagueBiggestStreakType>;
  wins?: Maybe<StatHaType>;
};

export type PredictionsTeamsHomeLeagueCardsType = {
  __typename?: 'PredictionsTeamsHomeLeagueCardsType';
  red?: Maybe<StatMinuteType>;
  yellow?: Maybe<StatMinuteType>;
};

export type PredictionsTeamsHomeLeagueFixturesType = {
  __typename?: 'PredictionsTeamsHomeLeagueFixturesType';
  draws?: Maybe<StatHatType>;
  loses?: Maybe<StatHatType>;
  played?: Maybe<StatHatType>;
  wins?: Maybe<StatHatType>;
};

export type PredictionsTeamsHomeLeagueGoalsType = {
  __typename?: 'PredictionsTeamsHomeLeagueGoalsType';
  against?: Maybe<PredictionsTamType>;
  forstat?: Maybe<PredictionsTamType>;
};

export type PredictionsTeamsHomeLeaguePenaltyType = {
  __typename?: 'PredictionsTeamsHomeLeaguePenaltyType';
  missed?: Maybe<StatTpType>;
  scored?: Maybe<StatTpType>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PredictionsTeamsHomeLeagueType = {
  __typename?: 'PredictionsTeamsHomeLeagueType';
  biggest?: Maybe<PredictionsTeamsHomeLeagueBiggestType>;
  cards?: Maybe<PredictionsTeamsHomeLeagueCardsType>;
  clean_sheet?: Maybe<StatHatType>;
  failed_to_score?: Maybe<StatHatType>;
  fixtures?: Maybe<PredictionsTeamsHomeLeagueFixturesType>;
  form?: Maybe<Scalars['String']['output']>;
  goals?: Maybe<PredictionsTeamsHomeLeagueGoalsType>;
  penalty?: Maybe<PredictionsTeamsHomeLeaguePenaltyType>;
};

export type PredictionsTeamsHomeType = {
  __typename?: 'PredictionsTeamsHomeType';
  id?: Maybe<Scalars['Float']['output']>;
  last_5?: Maybe<PredictionsTeamsHomeLast5Type>;
  league?: Maybe<PredictionsTeamsHomeLeagueType>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PredictionsTeamsType = {
  __typename?: 'PredictionsTeamsType';
  away?: Maybe<PredictionsTeamsHomeType>;
  home?: Maybe<PredictionsTeamsHomeType>;
};

export type PredictionsType = {
  __typename?: 'PredictionsType';
  comparison?: Maybe<PredictionsComparisonType>;
  createdAt: Scalars['DateTime']['output'];
  fixture: Scalars['Int']['output'];
  h2h?: Maybe<Array<PredictionsH2HType>>;
  id: Scalars['ID']['output'];
  league?: Maybe<PredictionsLeagueType>;
  predictions?: Maybe<PredictionsPredictionsType>;
  teams?: Maybe<PredictionsTeamsType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PredictionsWinnerType = {
  __typename?: 'PredictionsWinnerType';
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PrelevelContentInput = {
  description: Scalars['String']['input'];
  reputationLevel: Scalars['String']['input'];
};

export type PrelevelTranslationContentType = {
  __typename?: 'PrelevelTranslationContentType';
  description: Scalars['String']['output'];
  reputationLevel: Scalars['String']['output'];
};

export type PrelevelTranslationInput = {
  content: PrelevelContentInput;
  language: Scalars['ID']['input'];
};

export type PrelevelTranslationType = {
  __typename?: 'PrelevelTranslationType';
  content: PrelevelTranslationContentType;
  language: LanguageType;
};

export type PriceCountType = {
  __typename?: 'PriceCountType';
  count?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
};

export type PriceCreditType = {
  __typename?: 'PriceCreditType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  periodCycle?: Maybe<RecurrenceType>;
  periodValue?: Maybe<Scalars['Int']['output']>;
};

export type PriceFullType = {
  __typename?: 'PriceFullType';
  gross?: Maybe<ReduciblePriceType>;
  net?: Maybe<ReduciblePriceType>;
  toPay?: Maybe<ReduciblePriceType>;
};

export type PriceRangeCountType = {
  __typename?: 'PriceRangeCountType';
  numberOfProducts: Scalars['Int']['output'];
  priceRange?: Maybe<Array<Scalars['Float']['output']>>;
};

export type PriceRangeType = {
  __typename?: 'PriceRangeType';
  max?: Maybe<Scalars['Decimal']['output']>;
  min?: Maybe<Scalars['Decimal']['output']>;
};

export type PriceType = {
  __typename?: 'PriceType';
  company?: Maybe<CompanyType>;
  createdAt: Scalars['DateTime']['output'];
  enable?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductAttributeType = {
  __typename?: 'ProductAttributeType';
  attribute: AttributeType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isMultipleChoice: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  possibleValues: Array<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ProductClassEnum {
  BEST_SELLERS = 'BEST_SELLERS',
  FEATURED_PRODUCTS = 'FEATURED_PRODUCTS',
  NEW_ARRIVALS = 'NEW_ARRIVALS',
  PROMO = 'PROMO',
  TOP_PRODUCTS = 'TOP_PRODUCTS'
}

export type ProductClicksType = {
  __typename?: 'ProductClicksType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  product: InternalProductType;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export enum ProductConditionEnum {
  NEW = 'NEW',
  REFURBISHED = 'REFURBISHED',
  USED = 'USED'
}

export type ProductFilterType = {
  __typename?: 'ProductFilterType';
  /** list of barcodes */
  barcodes?: Maybe<Array<BarcodeType>>;
  /** list of brands */
  brands?: Maybe<Array<BrandType>>;
  /** list of inventoryCategories */
  categories?: Maybe<Array<InventoryCategoryType>>;
  createdAtRange?: Maybe<DateRangeType>;
  priceRange?: Maybe<PriceRangeType>;
  /** list of productAttributes */
  productAttributes?: Maybe<Array<ProductAttributeType>>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  structure?: Maybe<Array<ProductStructureEnum>>;
  updatedAtRange?: Maybe<DateRangeType>;
  variety?: Maybe<Array<ProductVarietyEnum>>;
};

export enum ProductFlagEnum {
  AFFORDABLE = 'AFFORDABLE',
  AFFORDABLE_LUXURY = 'AFFORDABLE_LUXURY',
  ANNIVERSARY_SPECIAL = 'ANNIVERSARY_SPECIAL',
  AUTUMN_COLLECTION = 'AUTUMN_COLLECTION',
  AVAILABLE_NOW = 'AVAILABLE_NOW',
  AWARD_WINNING = 'AWARD_WINNING',
  BACK_IN_FASHION = 'BACK_IN_FASHION',
  BACK_IN_STOCK = 'BACK_IN_STOCK',
  BACK_TO_SCHOOL = 'BACK_TO_SCHOOL',
  BEST_SELLER = 'BEST_SELLER',
  BIRTHDAY_SPECIAL = 'BIRTHDAY_SPECIAL',
  BLACK_FRIDAY = 'BLACK_FRIDAY',
  BUDGET_FRIENDLY = 'BUDGET_FRIENDLY',
  BUY_ONE_GET_ONE = 'BUY_ONE_GET_ONE',
  CHRISTMAS_SPECIAL = 'CHRISTMAS_SPECIAL',
  CLEARANCE = 'CLEARANCE',
  CLEARANCE_PRICE = 'CLEARANCE_PRICE',
  COMING_SOON = 'COMING_SOON',
  CUSTOMER_FAVORITE = 'CUSTOMER_FAVORITE',
  CYBER_MONDAY = 'CYBER_MONDAY',
  DEAL_OF_THE_DAY = 'DEAL_OF_THE_DAY',
  DISCOUNTED = 'DISCOUNTED',
  EASTER_SPECIAL = 'EASTER_SPECIAL',
  ECO_FRIENDLY = 'ECO_FRIENDLY',
  EDITORS_PICK = 'EDITORS_PICK',
  EXCLUSIVE = 'EXCLUSIVE',
  EXCLUSIVE_ONLINE = 'EXCLUSIVE_ONLINE',
  FATHERS_DAY = 'FATHERS_DAY',
  FEATURED = 'FEATURED',
  FLASH_SALE = 'FLASH_SALE',
  FREE_SHIPPING = 'FREE_SHIPPING',
  GIFT_IDEAS = 'GIFT_IDEAS',
  GIFT_WITH_PURCHASE = 'GIFT_WITH_PURCHASE',
  GRADUATION_GIFT = 'GRADUATION_GIFT',
  HALLOWEEN_SPECIAL = 'HALLOWEEN_SPECIAL',
  HANDMADE = 'HANDMADE',
  HIGH_END = 'HIGH_END',
  HIGH_QUALITY = 'HIGH_QUALITY',
  HOLIDAY_SPECIAL = 'HOLIDAY_SPECIAL',
  HOT = 'HOT',
  HOT_DEAL = 'HOT_DEAL',
  INNOVATIVE = 'INNOVATIVE',
  IN_STOCK = 'IN_STOCK',
  JUST_ARRIVED = 'JUST_ARRIVED',
  LAST_CHANCE = 'LAST_CHANCE',
  LIMITED_EDITION = 'LIMITED_EDITION',
  LIMITED_RELEASE = 'LIMITED_RELEASE',
  LIMITED_STOCK = 'LIMITED_STOCK',
  LIMITED_TIME_OFFER = 'LIMITED_TIME_OFFER',
  LOW_STOCK = 'LOW_STOCK',
  LUXURY = 'LUXURY',
  MEMBER_EXCLUSIVE = 'MEMBER_EXCLUSIVE',
  MOST_WISHED_FOR = 'MOST_WISHED_FOR',
  MOTHERS_DAY = 'MOTHERS_DAY',
  MUST_HAVE = 'MUST_HAVE',
  NEW = 'NEW',
  NEW_ARRIVAL = 'NEW_ARRIVAL',
  NEW_SEASON = 'NEW_SEASON',
  NEW_YEAR_SALE = 'NEW_YEAR_SALE',
  ORGANIC = 'ORGANIC',
  OUT_OF_STOCK = 'OUT_OF_STOCK',
  POPULAR = 'POPULAR',
  PREMIUM = 'PREMIUM',
  PRE_ORDER = 'PRE_ORDER',
  PRE_SALE = 'PRE_SALE',
  PRICE_DROP = 'PRICE_DROP',
  REDUCED_PRICE = 'REDUCED_PRICE',
  SALE = 'SALE',
  SPECIAL_OFFER = 'SPECIAL_OFFER',
  SPRING_COLLECTION = 'SPRING_COLLECTION',
  SUMMER_COLLECTION = 'SUMMER_COLLECTION',
  SUSTAINABLE = 'SUSTAINABLE',
  TOP_RATED = 'TOP_RATED',
  TRENDING = 'TRENDING',
  UNDER_50 = 'UNDER_50',
  VALENTINES_DAY = 'VALENTINES_DAY',
  VALUE_PACK = 'VALUE_PACK',
  WEDDING_COLLECTION = 'WEDDING_COLLECTION',
  WEEKEND_SALE = 'WEEKEND_SALE',
  WINTER_COLLECTION = 'WINTER_COLLECTION'
}

export type ProductInput = {
  /** list of barcodes ids */
  barcodes?: InputMaybe<Array<Scalars['ID']['input']>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  category: Array<Scalars['String']['input']>;
  classification?: InputMaybe<Array<ProductClassEnum>>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionList?: InputMaybe<Array<Scalars['String']['input']>>;
  ean?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  factoryPrice?: InputMaybe<Scalars['Decimal']['input']>;
  media?: InputMaybe<MediaInput>;
  name: Scalars['String']['input'];
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  price: Scalars['Decimal']['input'];
  productAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  sku?: InputMaybe<Scalars['String']['input']>;
  specs?: InputMaybe<Array<ProductSpecsInput>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tax: Scalars['Decimal']['input'];
  taxes?: InputMaybe<Array<ProductTaxesInput>>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  wholesalerPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum ProductKindEnum {
  PRODUCT = 'PRODUCT',
  SECTION = 'SECTION',
  SEPARATOR = 'SEPARATOR',
  SUBTOTAL = 'SUBTOTAL',
  TEXT = 'TEXT'
}

export type ProductPriceListInput = {
  price: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ProductPriceListType = {
  __typename?: 'ProductPriceListType';
  price?: Maybe<PriceType>;
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type ProductPriceType = {
  __typename?: 'ProductPriceType';
  gross?: Maybe<Scalars['Decimal']['output']>;
  net?: Maybe<Scalars['Decimal']['output']>;
  unitGross?: Maybe<Scalars['Decimal']['output']>;
  unitNet?: Maybe<Scalars['Decimal']['output']>;
};

export type ProductRatingDefinitionType = {
  __typename?: 'ProductRatingDefinitionType';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  reviewType?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductRatingType = {
  __typename?: 'ProductRatingType';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mark: Scalars['Int']['output'];
  product: ProductType;
  reviewType: ProductRatingDefinitionType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type ProductSortInput = {
  /** 1 for sort by createdAt ascending and -1 for descending */
  createdAt?: InputMaybe<Scalars['Float']['input']>;
  /** 1 for sort by name ascending and -1 for descending */
  name?: InputMaybe<Scalars['Float']['input']>;
  /** 1 for sort by price ascending and -1 for descending */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** 1 for sort by updatedAt ascending and -1 for descending */
  updatedAt?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductSpecsInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSpecsType = {
  __typename?: 'ProductSpecsType';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum ProductStatusEnum {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED'
}

export enum ProductStructureEnum {
  CONSUMABLE = 'CONSUMABLE',
  SERVICE = 'SERVICE',
  STOCKABLE = 'STOCKABLE'
}

export type ProductTaxesInput = {
  rank: Scalars['Int']['input'];
  tax: Scalars['ID']['input'];
};

export type ProductTaxesType = {
  __typename?: 'ProductTaxesType';
  rank?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<TaxType>;
};

export type ProductType = {
  __typename?: 'ProductType';
  /** list of barcodes */
  barcodes?: Maybe<Array<BarcodeType>>;
  brand?: Maybe<BrandType>;
  category?: Maybe<Array<InventoryCategoryType>>;
  classification?: Maybe<Array<ProductClassEnum>>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  ean?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  factoryPrice?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  productAttributes?: Maybe<Array<ProductAttributeType>>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tax?: Maybe<Scalars['Decimal']['output']>;
  taxes?: Maybe<Array<ProductTaxesType>>;
  updatedAt: Scalars['DateTime']['output'];
  variety?: Maybe<ProductVarietyEnum>;
  weight?: Maybe<Scalars['Float']['output']>;
  wholesalerPrice?: Maybe<Scalars['Decimal']['output']>;
};

export type ProductValidationType = {
  __typename?: 'ProductValidationType';
  headersValid?: Maybe<Scalars['Boolean']['output']>;
  isBrandsComplete?: Maybe<Scalars['Boolean']['output']>;
  isCategoriesComplete?: Maybe<Scalars['Boolean']['output']>;
  isIdComplete?: Maybe<Scalars['Boolean']['output']>;
  isNameComplete?: Maybe<Scalars['Boolean']['output']>;
  isVATComplete?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  overallValidation?: Maybe<Scalars['Boolean']['output']>;
};

export enum ProductVarietyEnum {
  EQUIPMENT = 'EQUIPMENT',
  PRODUCT = 'PRODUCT',
  SERVICE = 'SERVICE',
  VEHICULE = 'VEHICULE'
}

export type ProductsByCatalogueCategoryCountType = {
  __typename?: 'ProductsByCatalogueCategoryCountType';
  booking?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  delivery?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  hasChildren: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  layer: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  numberOfProducts: Scalars['Int']['output'];
  parent?: Maybe<CatalogueCategoryBaseType>;
  pickup?: Maybe<Scalars['Boolean']['output']>;
  pictures?: Maybe<Array<PictureType>>;
  portal?: Maybe<Scalars['Boolean']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  translation?: Maybe<Array<CatalogueCategoryTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  variety?: Maybe<ProductVarietyEnum>;
};

export enum ProfileCompleteElementsEnum {
  ABOUT = 'ABOUT',
  BIRTHDATE = 'BIRTHDATE',
  EDUCATION = 'EDUCATION',
  EMAIL = 'EMAIL',
  GENDER = 'GENDER',
  GEOLOCATION = 'GEOLOCATION',
  HOBBIES = 'HOBBIES',
  INTERESTS = 'INTERESTS',
  JOBS = 'JOBS',
  MARITAL_STATUS = 'MARITAL_STATUS',
  PHONE = 'PHONE',
  PROFILE_PICTURE = 'PROFILE_PICTURE',
  RESIDENTIAL_ADDRESS = 'RESIDENTIAL_ADDRESS',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  VERIFY_EMAIL = 'VERIFY_EMAIL',
  VERIFY_PHONE = 'VERIFY_PHONE'
}

export type ProfileCompletnessProgressType = {
  __typename?: 'ProfileCompletnessProgressType';
  levels?: Maybe<Array<LoyaltySettingsProfileCompleteLevelsType>>;
  progress: Scalars['Decimal']['output'];
};

export type ProgramBookingType = {
  __typename?: 'ProgramBookingType';
  capacity?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<EventProgramStatusEnum>;
};

export type ProgramTranslationType = {
  __typename?: 'ProgramTranslationType';
  description?: Maybe<Scalars['String']['output']>;
  language?: Maybe<LanguageType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ProgramType = {
  __typename?: 'ProgramType';
  address?: Maybe<FullAddressType>;
  booking?: Maybe<ProgramBookingType>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  event?: Maybe<EventType>;
  from?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  picture?: Maybe<PictureType>;
  title?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
  translation?: Maybe<Array<ProgramTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProjectMemberType = {
  __typename?: 'ProjectMemberType';
  member?: Maybe<UserType>;
  role?: Maybe<ProjectRoleEnum>;
};

export enum ProjectPriorityEnum {
  CRITICAL = 'CRITICAL',
  HIGH = 'HIGH',
  LOW = 'LOW',
  NORMAL = 'NORMAL'
}

export enum ProjectPrivacyEnum {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export enum ProjectRoleEnum {
  LEAD = 'LEAD',
  MEMBER = 'MEMBER'
}

export enum ProjectStatusEnum {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
  CANCELLED = 'CANCELLED',
  DELIVERED = 'DELIVERED'
}

export type ProjectType = {
  __typename?: 'ProjectType';
  attachments?: Maybe<Array<DocumentType>>;
  boardCardsStats?: Maybe<BoardCardsStatsType>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deadline?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<MediaType>;
  members?: Maybe<Array<ProjectMemberType>>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  priority?: Maybe<ProjectPriorityEnum>;
  privacy?: Maybe<ProjectPrivacyEnum>;
  resources?: Maybe<Array<DocumentType>>;
  status?: Maybe<ProjectStatusEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PromotionProductsType = {
  __typename?: 'PromotionProductsType';
  barcode: BarcodeType;
  discount: DiscountDtoType;
};

export type PromotionProductsWithInternalProductType = {
  __typename?: 'PromotionProductsWithInternalProductType';
  barcode: BarcodeBaseRawType;
  discount: DiscountDtoType;
  internalProduct: InternalProductType;
};

export enum PromotionStatusEnum {
  DRAFT = 'DRAFT',
  EXPIRED = 'EXPIRED',
  ONGOING = 'ONGOING'
}

export type PromotionType = {
  __typename?: 'PromotionType';
  createdAt: Scalars['DateTime']['output'];
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  promotion: Array<PromotionProductsType>;
  startDate: Scalars['DateTime']['output'];
  status: PromotionStatusEnum;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PromotionWithInternalProductType = {
  __typename?: 'PromotionWithInternalProductType';
  createdAt: Scalars['DateTime']['output'];
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  promotion: Array<PromotionProductsWithInternalProductType>;
  startDate: Scalars['DateTime']['output'];
  status: PromotionStatusEnum;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ProvidersEnum {
  API = 'API',
  FIREBASE = 'FIREBASE'
}

export type PurchaseDeliveryNoteOriginType = {
  __typename?: 'PurchaseDeliveryNoteOriginType';
  order?: Maybe<PurchaseOrderType>;
};

export type PurchaseDeliveryNoteType = {
  __typename?: 'PurchaseDeliveryNoteType';
  address?: Maybe<InvoicingAddressType>;
  bank?: Maybe<BankDetailsType>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  currency: CurrencyType;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<KeyValueType>>;
  id: Scalars['ID']['output'];
  installments?: Maybe<Array<InstallmentType>>;
  logistic?: Maybe<LogisticType>;
  note?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  origin?: Maybe<PurchaseDeliveryNoteOriginType>;
  products?: Maybe<Array<InvoicingProductsBundleType>>;
  project?: Maybe<ProjectType>;
  status?: Maybe<GenericInvoicingStatusEnum>;
  supplier?: Maybe<PurchaseSupplierType>;
  target: TargetType;
  taxes?: Maybe<Array<TaxRankType>>;
  toPay?: Maybe<Scalars['Decimal']['output']>;
  totalPrice?: Maybe<InvoicingPriceType>;
  totalTax?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  warehouse?: Maybe<WarehouseType>;
};

export type PurchaseIntegrationDocumentPurchaseNoteType = {
  __typename?: 'PurchaseIntegrationDocumentPurchaseNoteType';
  note?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<DocumentReferenceModelEnum>;
};

export type PurchaseIntegrationDocumentType = {
  __typename?: 'PurchaseIntegrationDocumentType';
  deliveryNote?: Maybe<PurchaseIntegrationDocumentPurchaseNoteType>;
  inventory?: Maybe<PurchaseIntegrationDocumentPurchaseNoteType>;
  invoice?: Maybe<PurchaseIntegrationDocumentPurchaseNoteType>;
  order?: Maybe<PurchaseIntegrationDocumentPurchaseNoteType>;
};

export type PurchaseInvoiceOriginType = {
  __typename?: 'PurchaseInvoiceOriginType';
  order?: Maybe<PurchaseOrderType>;
};

export type PurchaseInvoiceType = {
  __typename?: 'PurchaseInvoiceType';
  address?: Maybe<InvoicingAddressType>;
  bank?: Maybe<BankDetailsType>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  currency: CurrencyType;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<KeyValueType>>;
  id: Scalars['ID']['output'];
  installments?: Maybe<Array<InstallmentType>>;
  logistic?: Maybe<LogisticType>;
  note?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  origin?: Maybe<PurchaseInvoiceOriginType>;
  products?: Maybe<Array<InvoicingProductsBundleType>>;
  project?: Maybe<ProjectType>;
  status?: Maybe<GenericInvoicingStatusEnum>;
  supplier?: Maybe<PurchaseSupplierType>;
  target: TargetType;
  taxes?: Maybe<Array<TaxRankType>>;
  toPay?: Maybe<Scalars['Decimal']['output']>;
  totalPrice?: Maybe<InvoicingPriceType>;
  totalTax?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PurchaseOrderConversionType = {
  __typename?: 'PurchaseOrderConversionType';
  deliveryNote?: Maybe<PurchaseDeliveryNoteType>;
  invoice?: Maybe<PurchaseInvoiceType>;
};

export type PurchaseOrderType = {
  __typename?: 'PurchaseOrderType';
  address?: Maybe<InvoicingAddressType>;
  bank?: Maybe<BankDetailsType>;
  conversion?: Maybe<PurchaseOrderConversionType>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  currency: CurrencyType;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<KeyValueType>>;
  id: Scalars['ID']['output'];
  installments?: Maybe<Array<InstallmentType>>;
  logistic?: Maybe<LogisticType>;
  note?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  products?: Maybe<Array<InvoicingProductsBundleType>>;
  project?: Maybe<ProjectType>;
  status?: Maybe<GenericInvoicingStatusEnum>;
  supplier?: Maybe<PurchaseSupplierType>;
  target: TargetType;
  taxes?: Maybe<Array<TaxRankType>>;
  toPay?: Maybe<Scalars['Decimal']['output']>;
  totalPrice?: Maybe<InvoicingPriceType>;
  totalTax?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum PurchaseStatusEnum {
  CANCELED = 'CANCELED',
  CONFIRMED = 'CONFIRMED',
  DELIVERED = 'DELIVERED',
  OPEN = 'OPEN'
}

export type PurchaseSupplierType = {
  __typename?: 'PurchaseSupplierType';
  details?: Maybe<Array<KeyValueType>>;
  supplier?: Maybe<CompanyType>;
};

export type PurchaseType = {
  __typename?: 'PurchaseType';
  attachments?: Maybe<Array<DocumentType>>;
  createdAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  installments: Array<InstallmentType>;
  notes?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  status: PurchaseStatusEnum;
  supplier: SupplierType;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type PurchasesStatusesFinanceDashboardDataType = {
  __typename?: 'PurchasesStatusesFinanceDashboardDataType';
  ASSIGNED?: Maybe<Scalars['Decimal']['output']>;
  CANCELED?: Maybe<Scalars['Decimal']['output']>;
  CONFIRMED?: Maybe<Scalars['Decimal']['output']>;
  DELIVERED?: Maybe<Scalars['Decimal']['output']>;
  OPEN?: Maybe<Scalars['Decimal']['output']>;
  READY_FOR_PICKUP?: Maybe<Scalars['Decimal']['output']>;
};

export type PushAmountInput = {
  amount: Scalars['Decimal']['input'];
  card?: InputMaybe<Scalars['String']['input']>;
  deductAmount?: InputMaybe<Scalars['Decimal']['input']>;
  order?: InputMaybe<MarketPlaceOrderControllerInput>;
  source: OnsiteConverterTypeEnum;
  target: TargetAciInput;
  transactionId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  account: AccountType;
  accountByUserId: Array<AccountType>;
  activityType: ActivityTypeType;
  audience: AudienceType;
  audienceCriteria: AudienceCriteriaType;
  barcode: BarcodeType;
  betOrder: BetOrderType;
  bets: BetsBookmakersType;
  bookmakers: BetsBookmakersType;
  calculateQuestBudget: QuestBudgetType;
  catalogueCategory: CatalogueCategoryType;
  catalogueCategoryCache: CatalogueCategoryType;
  challenge: ChallengeType;
  checkWalletAndReputation: CheckWalletAndReputationType;
  coachs: CoachsType;
  coin: CoinType;
  company: CompanyType;
  corporateUserCard: CorporateUserCardType;
  corporateUserCardByIdentifier: CorporateUserCardType;
  countUnseenCorporateNotificationsByTarget: UnseenCorporateNotificationCountType;
  countUnseenCorporateNotificationsByTargetWithLinkedAccounts: UnseenCorporateNotificationCountType;
  countUnseenCorporateNotificationsForUser: UnseenCorporateNotificationCountType;
  countUnseenNotificationsByPOS: UnseenNotificationCountType;
  countUnseenNotificationsByUser: UnseenNotificationCountType;
  countryProvider: CountryProviderType;
  currentAccount: Array<AccountType>;
  currentCorporateUser: CorporateUserType;
  currentUser: UserType;
  currentUserComplete: UserType;
  emailIntegration: EmailIntegrationType;
  emailTemplate: CorporateEmailTemplateType;
  eventLog: EventLogType;
  events: EventsType;
  exportResponsesByMail: MailResponseDto;
  favoriteLeague: FavoriteLeagueType;
  favoriteLeagueDefinition: FavoriteLeagueDefinitionType;
  favoriteTeam: FavoriteTeamType;
  favoriteTeamDefinition: FavoriteTeamDefinitionType;
  findAllCoinsWithoutCountry: CoinPaginateType;
  findBankById: BankType;
  findBankDetailsById: BankDetailsType;
  findBanksDetailsPagination: BankDetailsPaginatedType;
  findBanksPagination: BankPaginatedType;
  findCatalogueCategoryByExternalIdAndTarget: CatalogueCategoryType;
  findCorporateEmailTemplateByName: CorporateEmailTemplateType;
  findCounteryById: CountryType;
  findCountriesPagination: CountryPaginatedType;
  findCurrenciesPagination: CurrencyPaginatedType;
  findCurrencyById: CurrencyType;
  findCurrentCorporateUserCards: Array<CorporateUserCardType>;
  findCurrentCorporateUserCardsByTarget: Array<CorporateUserCardType>;
  findEmailTemplateByName: EmailTemplateType;
  findInternalProductByExternalIdAndTarget: InternalProductType;
  findLanguageById: LanguageType;
  findLoyaltySettingsByTarget: LoyaltySettingsType;
  findLoyaltySettingsByTargetCache: LoyaltySettingsType;
  findLoyaltySettingsRedeemByTarget: LoyaltySettingsRedeemType;
  findNonPredefinedQuestsByTarget: QuestPaginateType;
  findOneByCoachId: CoachsType;
  findOneByFixtureId: FixtureType;
  findOneByLeague: LeagueType;
  findOneByTeamId: TeamInformationType;
  findPOSNearbyPagination: PointOfSalePaginateType;
  findPOSNearbyWithFollowersPagination: PointOfSaleWithFollowShipStatusPaginateType;
  findPaymentById: PaymentType;
  findPayments: Array<PaymentType>;
  findPaymentsCache: Array<PaymentType>;
  findPaymentsPagination: PaymentPaginatedType;
  findPredefinedQuestsByTarget: QuestPaginateType;
  findPredefinedQuestsByTargetWithRepeatDate: Array<QuestWithRepeatDateType>;
  findQuestsByCategoryAndTarget: Array<QuestType>;
  findSocialByCode: SocialType;
  findSocialById: SocialType;
  findSocialsPagination: SocialPaginatedType;
  findStateById: StateType;
  findStatesByCountryPagination: StatePaginatedType;
  findStatesPagination: StatePaginatedType;
  findlanguagesPagination: LanguagePaginatedType;
  fixture: FixtureType;
  form: FormResponseType;
  game: GameType;
  generateCloudinarySignature: CloudinarySignatureType;
  generateJWTToken: JwtTokenType;
  getAccelerationSettingsByTargetWithLinkedAccount: LoyaltySettingsAcceleratePaginateType;
  getAccounts: AccountPaginateType;
  getAccountsByTargetAndRoles: AccountPaginateType;
  getAccountsByTargetWithStatsPaginate: PaginatedAccountsWithStatsType;
  getActivityTypes: Array<ActivityTypeType>;
  getActivityTypesPaginated: ActivityTypePaginateType;
  getAllByPlayerPlayersStatsFromProvider: Array<PlayersStatsType>;
  getAllInternalProducts: Array<InternalProductType>;
  getAllInternalProductsByTargetGroupedByClass: InternalProductByClassType;
  getAllInternalProductsByTargetGroupedByClassWithFavoriteStatus: InternalProductByClassTypeWithFavoriteStatus;
  getAppCorporateEmailsPaginated: CorporateEmailTemplatePaginateType;
  getApps: StringListType;
  getAudienceCriterias: Array<AudienceCriteriaType>;
  getAudienceCriteriasPaginated: AudienceCriteriaPaginateType;
  getAudienceReach: AudienceReachType;
  getAudienceUsersPaginated: CorporateUserPaginateType;
  getAudiences: Array<AudienceType>;
  getAudiencesByTargetPaginated: AudiencePaginateType;
  getAudiencesPaginated: AudiencePaginateType;
  getAuthEventLogsByTargetPaginated: EventLogPaginateType;
  getBanks: Array<BankType>;
  getBarcodeByBarcodeAndTarget: BarcodeType;
  getBarcodeByProductAndAttributes: BarcodeType;
  getBarcodeByProductAndAttributesCache: BarcodeType;
  getBarcodeWithProductAttributesAndStock: BarcodeWithStockType;
  getBarcodeWithStock: BarcodeWithStockType;
  getBarcodes: Array<BarcodeType>;
  getBarcodesByBarcodesAndTarget: Array<BarcodeType>;
  getBarcodesByTargetPaginated: BarcodePaginateType;
  getBarcodesByTargetWithInternalProductPaginated: BarcodePaginateType;
  getBarcodesPagination: BarcodePaginateType;
  getBarcodesWithFilter: BarcodePaginateType;
  getBarcodesWithVarietyAndStructureWithFilter: BarcodeWithPublicPricePaginateType;
  getBetsByExtId: BetsBookmakersType;
  getBetsPagination: BetsBookmakersPaginateType;
  getBookmakerByExtId: BetsBookmakersType;
  getBookmakersPagination: BetsBookmakersPaginateType;
  getBrandColors: Array<KeyValueListType>;
  getCatalogueCategories: Array<CatalogueCategoryType>;
  getCatalogueCategoriesByLayerAndParent: Array<CatalogueCategoryType>;
  getCatalogueCategoriesByLayerAndParentCache: Array<CatalogueCategoryType>;
  getCatalogueCategoriesByLayerAndParentForPortal: Array<CatalogueCategoryType>;
  getCatalogueCategoriesByTargetAndUrlKey: CatalogueCategoryType;
  getCatalogueCategoriesByTargetForPortal: Array<CatalogueCategoryType>;
  getCatalogueCategoriesByTargetPaginated: CatalogueCategoryPaginateType;
  getCatalogueCategoriesByTargetWithChildren: Array<CatalogueCategoryWithChildrenType>;
  getCatalogueCategoriesByTargetWithChildrenCache: Array<CatalogueCategoryWithChildrenType>;
  getCatalogueCategoryPath: Array<CatalogueCategoryType>;
  getChallengeLeaderboard: LeaderboardChallengePaginateType;
  getChallengeLeaderboardWithCurrentUser: LeaderboardChallengeWithCurrentUserPaginateType;
  getChallenges: Array<ChallengeType>;
  getChallengesByTargetAndCreatorPaginated: ChallengePaginateType;
  getChallengesByTargetPaginated: ChallengePaginateType;
  getChallengesByTargetWithDonationProgressPaginated: ChallengePaginateType;
  getChallengesPaginated: ChallengePaginateType;
  getChatContacts: StringListType;
  getCoachesFromProvider: Array<CoachsType>;
  getCoachsPagination: CoachsPaginateType;
  getCoinOneByOwner: CoinType;
  getCoinsByCategoryPaginated: CoinPaginateType;
  getCoinsByCountryAndCategoryPaginated: CoinPaginateType;
  getCoinsByCountryPaginated: CoinPaginateType;
  getCoinsPagination: CoinPaginateType;
  getComingSoonQuestsByTargetAndUserAudiencePaginated: QuestPaginateType;
  getComingSoonQuestsByTargetAndUserAudienceWithLinkedAccountsPaginated: PaginatedQuestWithQualitativePictureType;
  getCompanies: Array<CompanyType>;
  getCompaniesByTarget: CompanyPaginateType;
  getCompaniesPagination: CompanyPaginateType;
  getCorporateEmailTemplate: Array<CorporateEmailTemplateType>;
  getCorporateEmailsByTargetPaginated: CorporateEmailTemplatePaginateType;
  getCorporateNotificationsById: CorporateNotificationType;
  getCorporateNotificationsByTargetPaginated: CorporateNotificationPaginateType;
  getCorporateNotificationsByUser: CorporateNotificationPaginateType;
  getCorporateNotificationsForUserPaginated: CorporateNotificationPaginateType;
  getCorporateNotificationsForUserWithLinkedAccountsPaginated: CorporateNotificationPaginateType;
  getCorporateUserCardByUserAndTarget: Array<CorporateUserCardType>;
  getCorporateUserCards: Array<CorporateUserCardType>;
  getCorporateUserCardsByTarget: Array<CorporateUserCardType>;
  getCorporateUserCardsByTargetPaginated: CorporateUserCardFullPaginatedType;
  getCorporateUserCardsByTargetWithReputationsPaginated: CorporateUserCardFullWithReputationPaginatedType;
  getCorporateUserCardsByUser: Array<CorporateUserCardType>;
  getCorporateUsersByTarget: Array<CorporateUserType>;
  getCountries: Array<CountryType>;
  getCountriesProvider: Array<CountryProviderType>;
  getCountriesProviderPagination: CountryProviderPaginateType;
  getCountryProviderByFilter: Array<CountryProviderType>;
  getCurrencies: Array<CurrencyType>;
  getCurrentUserFinishedBetOrdersPagination: BetOrderPaginateType;
  getCurrentUserLinkedCorporateAccountByTarget: LinkAccountType;
  getCurrentUserPendingBetOrdersPagination: BetOrderPaginateType;
  getCurrentUserQualitativeWallet: WalletType;
  getCurrentUserQuantitativeWallets: WalletPaginateType;
  getCurrentUserReputationsLossDate: CurrentUserReputationsLossDateType;
  getCurrentUserReputationsTurnoverLossDate: CurrentUserReputationsTurnoverLossDateType;
  getCustomers: CompanyPaginateType;
  getDefaultAudiencesPaginated: DefaultAudiencePaginateType;
  getDeliveryManByPos: AccountPaginateType;
  getDiscountTypes: StringListType;
  getDonationActivityTypesByTargetPaginated: ActivityTypePaginateType;
  getEcommerceEventLogsByTargetPaginated: EventLogPaginateType;
  getEmailIntegration: Array<EmailIntegrationType>;
  getEmailIntegrationByTarget: EmailIntegrationType;
  getEmailTemplate: Array<EmailTemplateType>;
  getEventLogs: Array<EventLogType>;
  getEventLogsByTargetPaginated: EventLogPaginateType;
  getEventLogsPaginated: EventLogPaginateType;
  getEventSubscription: EventSubscriptionType;
  getEventSubscriptionPaginated: PaginatedEventSubscriptionType;
  getEventSubscriptions: Array<EventSubscriptionType>;
  getEventsFromProvider: Array<EventsType>;
  getEventsPagination: EventsPaginateType;
  getFavoriteLeagueDefinitionsPagination: FavoriteLeagueDefinitionPaginateType;
  getFavoriteLeaguesByUserPagination: LeaguePaginateType;
  getFavoriteLeaguesPagination: FavoriteLeaguePaginateType;
  getFavoriteTeamDefinitionsPagination: FavoriteTeamDefinitionPaginateType;
  getFavoriteTeamsByUserPagination: TeamInformationPaginateType;
  getFavoriteTeamsPagination: FavoriteTeamPaginateType;
  getFinishedBetOrdersByTargetPagination: BetOrderPaginateType;
  getFinishedBetOrdersPagination: BetOrderPaginateType;
  getFixtureSubscribers: UserType;
  getFixturesFromProvider: Array<FixtureType>;
  getFixturesFromProviderByFavorieLeagues: DeleteResponseDtoType;
  getFixturesFromProviderGuest: Array<FixtureType>;
  getFixturesPagination: FixturePaginateType;
  getFixturesWithFilter: FixturePaginateType;
  getFixturesWithFilterAndOdds: FixtureWithOddsPaginateType;
  getFixturesWithFilterWithSubs: FixturePaginateType;
  getFormResponses: QuestionSimplePaginateType;
  getFormSummary: Array<SummaryResponseDtoType>;
  getForms: Array<FormResponseType>;
  getFormsPagination: FormPaginateType;
  getFormsWithFilters: FormPaginateType;
  getGameByCode: GameType;
  getGameIntegrationByTarget: GameIntegrationType;
  getGameIntegrationWithFilter: GameIntegrationSettingsGameType;
  getGames: Array<GameType>;
  getGamesPaginated: GamePaginateType;
  getGenders: StringListType;
  getGuidanceTypes: StringListType;
  getHeadToHead: Array<FixtureType>;
  getImagesFromFolder: Array<CloudinaryResourceType>;
  getInPlayBetsByExtId: BetsBookmakersType;
  getInPlayBetsPagination: BetsBookmakersPaginateType;
  getInPlayOddsFromProvider: Array<InPlayOddsType>;
  getInPlayOddsPagination: InPlayOddsPaginateType;
  getInjuriesFromProvider: Array<InjuriesType>;
  getInjuriesPagination: InjuriesPaginateType;
  getInjuriesWithFilter: InjuriesPaginateType;
  getInjury: InjuriesType;
  getInternalProduct: InternalProductType;
  getInternalProductBarcodes: Array<BarcodeType>;
  getInternalProductBarcodesPaginated: BarcodePaginateType;
  getInternalProductWithFavoriteStatus: InternalProductWithFavoriteStatusType;
  getInternalProductWithFilter: InternalProductPaginateWithFilterType;
  getInternalProductWithStock: InternalProductWithStockType;
  getInternalProducts: InternalProductPaginateType;
  getInternalProductsByCatalogueCategory: InternalProductPaginateType;
  getInternalProductsByCatalogueCategoryForPortal: InternalProductPaginateType;
  getInternalProductsByCatalogueCategoryWithFavoriteStatus: InternalProductWithFavoriteStatusPaginateType;
  getInternalProductsByCategory: InternalProductPaginateType;
  getInternalProductsByClass: InternalProductPaginateType;
  getInternalProductsByProduct: InternalProductPaginateType;
  getInternalProductsByTargetAndCatalogueCategory: InternalProductPaginateType;
  getInternalProductsByTargetAndCatalogueCategoryUrlKey: InternalProductPaginateType;
  getInternalProductsByTargetAndCatalogueCategoryUrlKeyWithFavoriteStatus: InternalProductWithFavoriteStatusPaginateType;
  getInternalProductsWithRatingsWithFavoriteStatusWithFilter: InternalProductWithRatingsPaginateWithFavoriteStatusWithFilterType;
  getInternalProductsWithRatingsWithFilter: InternalProductWithRatingsPaginateWithFilterType;
  getLanguages: Array<LanguageType>;
  getLanguagesCache: Array<LanguageType>;
  getLastReferral: ReferralType;
  getLastWidgetOutboundsByTarget: OutboundType;
  getLeaderboard: LeaderboardType;
  getLeaderboardByCyclePaginated: LeaderboardPaginatedType;
  getLeaderboardByDatesAndCyclePaginated: LeaderboardPaginatedType;
  getLeaguePagination: LeaguePaginateType;
  getLeaguesByFilter: Array<LeagueType>;
  getLineupsFromProvider: Array<LineupsType>;
  getLineupsPagination: LineupsPaginateType;
  getLinkedAccountsCorporateUserCardsByTarget: Array<CorporateUserCardWithExtrasType>;
  getLiveFixtures: Array<FixtureType>;
  getLiveLeaderboardByCycleByExcel: InvoicePdfType;
  getLiveLeaderboardByCycleForCurrentUserPaginated: LeaderboardWithCycleNumbersAndClosingdateAndCurrentUserPaginatedType;
  getLiveLeaderboardByCyclePaginated: LeaderboardWithCycleNumbersAndClosingdatePaginatedType;
  getLiveStatisticsFromProvider: Array<StatisticsType>;
  getLoyaltyProgramsPagination: LoyaltyProgramPaginateType;
  getManufacturersPagination: ManufacturerPaginateType;
  getMaritalStatuses: StringListType;
  getNonPredefinedActivityTypesPaginated: ActivityTypePaginateType;
  getNotificationIntegration: Array<NotificationIntegrationType>;
  getNotificationIntegrationByTarget: NotificationIntegrationType;
  getOneInternalProductByBarcodeAndTarget: InternalProductType;
  getOngoingChallengesByTargetAndUserAudiencePaginated: ChallengePaginateType;
  getOngoingChallengesByTargetAndUserAudienceWithLinkedAccountsPaginated: PaginatedChallengesWithLinkedAccountsType;
  getOpeningStatuses: StringListType;
  getOrderStatuses: StringListType;
  getOutboundsByTargetPagination: OutboundPaginateType;
  getOutboundsPagination: OutboundPaginateType;
  getPOSCategories: Array<PosCategoryType>;
  getPOSCategoriesPagination: PosCategoryPaginateType;
  getPOSServicesPagination: PosServicesPaginateType;
  getPOSWithFollowersPagination: PointOfSaleWithFollowShipStatusPaginateType;
  getPOSservices: Array<PosServicesType>;
  getPartnershipNetworksById: PartnershipNetworkType;
  getPartnershipNetworksByPartnerAndPartnershipPagination: PartnershipNetworkPaginateType;
  getPartnershipNetworksByTargetAndPartnershipPagination: PartnershipNetworkWithLinkedAccountStatusPaginateType;
  getPartnershipNetworksByTargetPagination: PartnershipNetworkPaginateType;
  getPendingBetOrdersByTargetPagination: BetOrderPaginateType;
  getPendingBetOrdersPagination: BetOrderPaginateType;
  getPermission: Array<PermissionType>;
  getPermissionDefinition: Array<PermissionDefinitionType>;
  getPermissionsByTarget: Array<PermissionType>;
  getPlayOffsByRound: Array<FixtureType>;
  getPlayer: PlayersStatsType;
  getPlayerById: PlayersStatsType;
  getPlayerStatisticsFromProvider: Array<PlayerStatisticsType>;
  getPlayerStatisticsPagination: PlayerStatisticsPaginateType;
  getPlayersPagination: PlayersStatsPaginateType;
  getPlayersStatsFromProvider: Array<PlayersStatsType>;
  getPlayersStatsWithFilter: PlayersStatsPaginateType;
  getPointOfSalesAggregatorPagination: PointOfSalePaginateType;
  getPointOfSalesPagination: PointOfSalePaginateType;
  getPreMatchOddsFromProvider: Array<OddsWithBetsType>;
  getPreMatchOddsPagination: OddsPaginateType;
  getPreMatchOddsWithFilter: OddsPaginateType;
  getPredefinedActivityTypesByTargetPaginated: ActivityTypePaginateType;
  getPredefinedActivityTypesByTargetWithActiveStatusPaginated: ActivityTypeWithActiveStatusPaginateType;
  getPredefinedActivityTypesPaginated: ActivityTypePaginateType;
  getPredictions: PredictionsType;
  getPredictionsPagination: PredictionsPaginateType;
  getProductBarcodes: Array<BarcodeType>;
  getProductBarcodesCache: Array<BarcodeType>;
  getProfileCompletnessProgress: ProfileCompletnessProgressType;
  getQuestActionDefinitions: Array<QuestActionDefinitionType>;
  getQuestActionDefinitionsPaginated: QuestActionDefinitionPaginateType;
  getQuestActions: Array<QuestActionType>;
  getQuestActionsByQuestPaginated: QuestActionPaginateType;
  getQuestActionsPaginated: QuestActionPaginateType;
  getQuestActivities: Array<QuestActivityType>;
  getQuestActivitiesByQuest: Array<QuestActivityType>;
  getQuestActivitiesByQuestCache: Array<QuestActivityType>;
  getQuestActivitiesByQuestPaginated: QuestActivityPaginateType;
  getQuestActivitiesPaginated: QuestActivityPaginateType;
  getQuestByActivityType: QuestType;
  getQuestOverview: QuestOverviewType;
  getQuestReccurencyStatus: QuestRecurrencyStatusType;
  getQuestStatistics: QuestStatisticsType;
  getQuestionResponses: GetQuestionResponsesPaginateType;
  getQuestions: Array<QuestionDtoType>;
  getQuestionsByChallengeStep: QuestionPaginateType;
  getQuestionsByForm: QuestionPaginateType;
  getQuestionsPagination: QuestionPaginateType;
  getQuestionsbyFormWithResponsesStatsPaginated: QuestionWithResponsesStatsPaginateType;
  getQuests: Array<QuestType>;
  getQuestsByTarget: Array<QuestType>;
  getQuestsByTargetAndCreatorPaginated: QuestPaginateType;
  getQuestsByTargetAndUserAudiencePaginated: QuestWithPerformedPaginateType;
  getQuestsByTargetAndUserAudienceWithLinkedAccountsPaginated: PaginatedQuestWithQualitativePictureType;
  getQuestsByTargetPaginated: QuestPaginateType;
  getReferralSettingsByTargetWithLinkedAccount: LoyaltySettingsReferralPaginateType;
  getReferralsByTargetPagination: ReferralPaginateType;
  getReputations: Array<ReputationType>;
  getReputationsByTarget: Array<ReputationType>;
  getReputationsByTargetCache: Array<ReputationType>;
  getReputationsPagination: ReputationPaginateType;
  getResponses: Array<ResponseDtoType>;
  getResponsesPagination: ResponsePaginateType;
  getResponsesWithFilter: ResponsePaginateType;
  getRoles: StringListType;
  getRounds: Array<RoundType>;
  getRoundsPagination: RoundPaginateType;
  getSeasons: Array<SeasonType>;
  getSeasonsPagination: SeasonPaginateType;
  getServiceProduct: InternalProductType;
  getSidelined: SidelinedType;
  getSidelinedPagination: SidelinedPaginateType;
  getSimpleBarcodeByBarcodeAndTarget: BarcodeType;
  getSimpleBarcodesByBarcodesAndTarget: Array<BarcodeType>;
  getSimpleProductWithFavoriteStatus: InternalProductWithFavoriteStatusType;
  getSimpleProductWithFavoriteStatusByUrlKey: InternalProductWithFavoriteStatusType;
  getSimpleProductWithFilter: InternalProductPaginateWithFilterType;
  getSimpleProductWithProductAttributesAndFavoriteStatus: InternalProductWithFavoriteStatusType;
  getSimpleProductWithProductAttributesAndFavoriteStatusByUrlKey: InternalProductWithFavoriteStatusType;
  getSimpleProductsByCatalogueCategoryWithFavoriteStatus: InternalProductWithFavoriteStatusPaginateType;
  getSimpleProductsByTargetAndCatalogueCategoryUrlKeyWithFavoriteStatus: InternalProductWithFavoriteStatusPaginateType;
  getSimpleProductsByTargetAndCatalogueCategoryUrlKeyWithProductAttributesAndFavoriteStatus: InternalProductWithFavoriteStatusPaginateType;
  getSimpleProductsByTargetGroupedByClassWithFavoriteStatus: InternalProductByClassTypeWithFavoriteStatus;
  getSimpleProductsByTargetGroupedByClassWithProductAttributesAndFavoriteStatus: InternalProductByClassTypeWithFavoriteStatus;
  getSimpleProductsForPartnerhipNetworkWithRatingsWithFavoriteStatusWithFilter: InternalProductForPartnershipNetworkWithTargetPictureAndRatingsPaginateWithFavoriteStatusWithFilterType;
  getSimpleProductsWithRatingsWithFavoriteStatus: InternalProductWithRatingsPaginateWithFavoriteStatusType;
  getSimpleProductsWithRatingsWithFavoriteStatusWithFilter: InternalProductWithRatingsPaginateWithFavoriteStatusWithFilterType;
  getSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatus: InternalProductWithRatingsPaginateWithFavoriteStatusType;
  getSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusWithFilter: InternalProductWithRatingsPaginateWithFavoriteStatusWithFilterType;
  getSimpleServicesWithFilter: BarcodesPaginatedWithFilterType;
  getSmsIntegration: Array<SmsIntegrationType>;
  getSmsIntegrationByTarget: SmsIntegrationType;
  getSocialMedias: StringListType;
  getSpecialOffersTypes: StringListType;
  getSquadsFromProvider: Array<SquadsType>;
  getSquadsPagination: SquadsPaginateType;
  getStandings: Array<StandingsType>;
  getStandingsPagination: StandingPaginateType;
  getStates: Array<StateType>;
  getStaticTranslationsByTargetAndLanguage: Array<StaticTranslationSimpleType>;
  getStaticTranslationsByTargetAndLanguageCache: Array<StaticTranslationSimpleType>;
  getStaticTranslationsByTargetAndLanguagePaginated: StaticTranslationSimplePaginateType;
  getStaticTranslationsByTargetPaginated: StaticTranslationPaginateType;
  getStatisticsFromProvider: Array<StatisticsType>;
  getStatisticsPagination: StatisticsPaginateType;
  getTargetStats: StatsType;
  getTargetSubscribersByCsv: InvoicePdfType;
  getTargetSubscribersByExcel: InvoicePdfType;
  getTargetSubscribersPagination: SubscribersWithReputationsPaginateType;
  getTargetUserCardsByCsv: InvoicePdfType;
  getTargetUserCardsByExcel: InvoicePdfType;
  getTargetUsersWithWallets: SimpleUserWithWalletsPaginateType;
  getTargetWallets: Array<WalletType>;
  getTeamOrPlayerSquads: Array<SquadsType>;
  getTeamSeasons: TeamSeasonsType;
  getTeamSeasonsPagination: TeamSeasonsPaginateType;
  getTeamStatistics: TeamStatisticsType;
  getTeamStatisticsPagination: TeamStatisticsPaginateType;
  getTeamsByFilter: Array<TeamInformationType>;
  getTeamsInformationFromProvider: Array<TeamInformationType>;
  getTeamsInformationPagination: TeamInformationPaginateType;
  getTimezones: Array<TimezoneType>;
  getTimezonesPagination: TimezonePaginateType;
  getTopAssists: Array<TopAssistsType>;
  getTopAssistsPagination: TopAssistsPaginateType;
  getTopRedCards: Array<TopRedCardsType>;
  getTopRedCardsPagination: TopRedCardsPaginateType;
  getTopScorerPagination: TopScorerPaginateType;
  getTopScorers: TopScorersType;
  getTopYellowCards: TopYellowCardsType;
  getTopYellowCardsPagination: TopYellowCardsPaginateType;
  getTransfers: Array<TransfersType>;
  getTransfersFromProvider: Array<TransfersType>;
  getTransfersPagination: TransfersPaginateType;
  getTrophies: TrophiesType;
  getTrophiesPagination: TrophiesPaginateType;
  getUpcomingChallengesByTargetAndUserAudiencePaginated: ChallengePaginateType;
  getUpcomingChallengesByTargetAndUserAudienceWithLinkedAccountsPaginated: PaginatedChallengesWithLinkedAccountsType;
  getUserSubscribedTargets: Array<TargetType>;
  getUserWalletTransactionsStatsByAffected: TotalType;
  getUserWalletWithReputations: WalletWithReputationDtoType;
  getUsers: Array<UserType>;
  getUsersByPermissionPaginated: UserPaginateType;
  getUsersPaginated: UserPaginateType;
  getUsersPagination: UserPaginateType;
  getVapidKey: VapidKeyType;
  getVenuesFromProvider: Array<VenueTypeFull>;
  getVenuesPagination: VenuePaginateType;
  getWaitersByPoss: AccountPaginateType;
  getWalletByOwnerWithReputations: WalletWithCurrentAndNextReputationType;
  getWalletTopupsSettingsByTarget: WalletTopupSettingsType;
  getWalletTopupsSettingsByTargetPaginated: WalletTopupSettingsPaginateType;
  getWalletTopupsSettingsPagination: WalletTopupSettingsPaginateType;
  getWalletTransactionsByAffectedPaginated: WalletTransactionPaginateType;
  getWalletTransactionsByAffectedPaginatedByCsv: InvoicePdfType;
  getWalletTransactionsByAffectedPaginatedByExcel: InvoicePdfType;
  getWalletTransactionsPagination: WalletTransactionPaginateType;
  getWalletTransactionsStatsByAffected: WalletTransactionsStatsType;
  getWalletTransactionsStatsChartWithFilter: WalletDateValueChartType;
  getWalletsPagination: WalletPaginateType;
  getWholesalers: Array<WholesalerType>;
  getWholesalersPagination: WholesalerPaginateType;
  getWidgetForTarget: GetWidgetForTargetType;
  getWidgetGuestUserForTarget: GetWidgetGuestUserForTargetType;
  getWidgetIntegration: Array<WidgetIntegrationType>;
  getWidgetIntegrationByTarget: WidgetIntegrationType;
  getWidgetIntegrationByTargetCache: WidgetIntegrationType;
  getWidgetUserForTarget: GetWidgetUserForTargetType;
  getWidgetVisuals: Array<WidgetVisualsType>;
  getWidgetVisualsByTargetAndAppCache: Array<WidgetVisualsType>;
  getWidgetVisualsByTargetAndAppPaginated: WidgetVisualsPaginateType;
  getWidgetVisualsByTargetAndAppPaginatedCache: WidgetVisualsPaginateType;
  inPlayBets: BetsBookmakersType;
  inPlayOdds: InPlayOddsType;
  isCurrentUserLinkedToAggregator: IsLinkedAccountType;
  isEmailExist: UserExistType;
  isFixtureGotInPlayOdds: BooleanCheckType;
  isFixtureGotPreMatchOdds: BooleanCheckType;
  isLeagueFavorite: BooleanCheckType;
  isLoggedIn: IsLoggedInType;
  isLoginExist: UserExistType;
  isLoginForTargetExist: CorporateUserExistType;
  isTeamFavorite: BooleanCheckType;
  isUserNearPOS: IsUserNearPosDtoType;
  isUserSubscribedToTarget: IsUserSubscribedToTargetType;
  league: LeagueType;
  lineup: LineupsType;
  login: LoginType;
  loginForApp: LoginType;
  loginForTarget: LoginType;
  loginWithApple: LoginType;
  loginWithAppleForTarget: LoginType;
  loginWithFacebook: LoginType;
  loginWithFacebookForTarget: LoginType;
  loginWithGoogle: LoginType;
  loginWithGoogleForTarget: LoginType;
  logoutUserByTarget: SuccessResponseDtoType;
  logoutUserForTarget: SuccessResponseDtoType;
  loyaltyProgram: LoyaltyProgramType;
  manufacturer: ManufacturerType;
  notificationIntegration: NotificationIntegrationType;
  outbound: OutboundType;
  permission: PermissionType;
  permissionDefinition: PermissionDefinitionType;
  playerSeasons: PlayerSeasonType;
  playerStatistics: PlayerStatisticsType;
  pointOfSale: PointOfSaleType;
  pointOfSaleByOrigin: PointOfSaleType;
  pointOfSaleCache: PointOfSaleType;
  posCategory: PosCategoryType;
  posServices: PosServicesType;
  preMatchOdds: OddsType;
  predictions: PredictionsType;
  quantitativeWalletsByOwnerPagination: WalletPaginateType;
  quest: QuestType;
  questActionDefinition: QuestActionDefinitionType;
  questActivity: QuestActivityType;
  question: QuestionDtoType;
  referral: ReferralType;
  refreshAudienceViews: AudienceReachType;
  reputation: ReputationType;
  response: ResponseDtoType;
  round: RoundType;
  searchAccount: AccountPaginateType;
  searchBarcodesByTarget: BarcodePaginateType;
  searchBarcodesByTargetAndSupplier: BarcodePaginateType;
  searchBarcodesByTargetWithStock: BarcodeWithStockPaginatedType;
  searchCatalogueCategories: CatalogueCategoryPaginateType;
  searchCoaches: CoachsPaginateType;
  searchCompany: CompanyPaginateType;
  searchCorporateUsersByTarget: CorporateUserPaginateType;
  searchCustomersByTargetAndPhase: CompanyPaginateType;
  searchFavouritesLeagues: LeaguePaginateType;
  searchFavouritesTeams: TeamInformationPaginateType;
  searchForms: FormPaginateType;
  searchInternalProduct: InternalProductPaginateType;
  searchInternalProductByCatalogueCategory: InternalProductPaginateType;
  searchInternalProductByTarget: InternalProductPaginateType;
  searchLeagues: LeaguePaginateType;
  searchLiveFixtures: Array<FixtureType>;
  searchLogisticCompaniesByTarget: CompanyPaginateType;
  searchLoyaltyProgram: LoyaltyProgramPaginateType;
  searchManufacturer: ManufacturerPaginateType;
  searchPOSNearbyPagination: PointOfSalePaginateType;
  searchPlayers: PlayersStatsPaginateType;
  searchPos: PointOfSalePaginateType;
  searchPosCategory: PosCategoryPaginateType;
  searchPosServices: PosServicesPaginateType;
  searchResponse: ResponsePaginateType;
  searchSimpleBarcodesByTargetWithStock: BarcodeWithStockPaginatedType;
  searchSimpleEquipments: InternalProductPaginateWithFilterType;
  searchSimpleServices: BarcodePaginateType;
  searchSuppliersByTarget: CompanyPaginateType;
  searchTargetQualitativeWallets: WalletPaginateType;
  searchTargetSubscribers: SubscribersWithReputationsPaginateType;
  searchTeam: TeamInformationPaginateType;
  searchUser: UserPaginateType;
  searchUserTargetSubscriptions: TargetPaginateType;
  searchVenues: Array<VenueTypeFull>;
  searchWholesaler: WholesalerPaginateType;
  season: SeasonType;
  sendAdhocCorporateNotificationTest: AdhocCorporateNotificationTestType;
  sendAdhocNotificationTest: AdhocNotificationTestType;
  sendCorporateEmail: MailResponseDto;
  sendEmail: MailResponseDto;
  sendLiveLeaderboardByCycleBymail: MailResponseDto;
  sendQualitativeWalletsBymail: MailResponseDto;
  sendSms: SmsIntegrationResponseType;
  sendTargetSubscribersBymail: MailResponseDto;
  sendTargetUserCardsBymail: MailResponseDto;
  sendThemAndLanguageToWidget: SuccessResponseDtoType;
  sendUserAdhocNotification: AdhocNotificationTestType;
  sidelined: SidelinedType;
  smsIntegration: SmsIntegrationType;
  squads: SquadsType;
  standings: StandingsType;
  staticTranslation: StaticTranslationType;
  statistics: StatisticsType;
  targetHasStaticTranslationsReference: StaticTranslationReferenceCheckType;
  teamInformation: TeamInformationType;
  teamSeasons: TeamSeasonsType;
  teamStatistics: TeamStatisticsType;
  timezone: TimezoneType;
  topAssists: TopAssistsType;
  topRedCards: TopRedCardsType;
  topScorer: TopScorersType;
  topYellowCards: TopYellowCardsType;
  transfers: TransfersType;
  trophies: TrophiesType;
  uploadImage: PictureType;
  user: UserType;
  userByEmail: UserType;
  validateRegisterPhoneNumber: SmsLogType;
  validateSmsCode: SuccessResponseDtoType;
  verifyApiSettings: SuccessResponseDtoType;
  wallet: WalletType;
  walletOwnerHasEnoughBalance: WalletOwnerHasEnoughBalanceType;
  walletTopupSettings: WalletTopupSettingsType;
  walletTransaction: WalletTransactionType;
  walletsByOwner: Array<WalletType>;
  walletsByOwnerPagination: WalletPaginateType;
  wholesaler: WholesalerType;
  widgetIntegration: WidgetIntegrationType;
  widgetVisuals: WidgetVisualsType;
};


export type QueryAccountArgs = {
  id: Scalars['String']['input'];
};


export type QueryAccountByUserIdArgs = {
  userId: Scalars['String']['input'];
};


export type QueryActivityTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAudienceArgs = {
  id: Scalars['String']['input'];
};


export type QueryAudienceCriteriaArgs = {
  id: Scalars['String']['input'];
};


export type QueryBarcodeArgs = {
  id: Scalars['String']['input'];
};


export type QueryBetOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBetsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBookmakersArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCalculateQuestBudgetArgs = {
  maxAnswers: Scalars['Int']['input'];
  quest: Scalars['ID']['input'];
};


export type QueryCatalogueCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCatalogueCategoryCacheArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChallengeArgs = {
  id: Scalars['String']['input'];
};


export type QueryCheckWalletAndReputationArgs = {
  input: QuestActionCheckInput;
};


export type QueryCoachsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCoinArgs = {
  id: Scalars['String']['input'];
};


export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCorporateUserCardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCorporateUserCardByIdentifierArgs = {
  identifier: Scalars['String']['input'];
};


export type QueryCountUnseenCorporateNotificationsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryCountUnseenCorporateNotificationsByTargetWithLinkedAccountsArgs = {
  target: TargetAciInput;
};


export type QueryCountUnseenCorporateNotificationsForUserArgs = {
  target: TargetAciInput;
};


export type QueryCountUnseenNotificationsByPosArgs = {
  posId: Scalars['String']['input'];
};


export type QueryCountryProviderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmailIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmailTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExportResponsesByMailArgs = {
  email: Scalars['String']['input'];
  input: ResponseFilterInput;
  subject: Scalars['String']['input'];
};


export type QueryFavoriteLeagueArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFavoriteLeagueDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFavoriteTeamArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFavoriteTeamDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindAllCoinsWithoutCountryArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindBankByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindBankDetailsByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindBanksDetailsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindBanksPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindCatalogueCategoryByExternalIdAndTargetArgs = {
  externalId: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
};


export type QueryFindCorporateEmailTemplateByNameArgs = {
  name: EmailTemplateTypeEnum;
};


export type QueryFindCounteryByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindCountriesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindCurrenciesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindCurrencyByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindCurrentCorporateUserCardsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryFindEmailTemplateByNameArgs = {
  name: EmailTemplateTypeEnum;
};


export type QueryFindInternalProductByExternalIdAndTargetArgs = {
  externalId: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
};


export type QueryFindLanguageByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindLoyaltySettingsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryFindLoyaltySettingsByTargetCacheArgs = {
  target: TargetAciInput;
};


export type QueryFindLoyaltySettingsRedeemByTargetArgs = {
  target: TargetAciInput;
};


export type QueryFindNonPredefinedQuestsByTargetArgs = {
  advertiser?: InputMaybe<TargetAciInput>;
  filter?: InputMaybe<QuestsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryFindOneByCoachIdArgs = {
  coachId: Scalars['Int']['input'];
};


export type QueryFindOneByFixtureIdArgs = {
  fixtureId: Scalars['Int']['input'];
};


export type QueryFindOneByLeagueArgs = {
  leagueId: Scalars['Int']['input'];
};


export type QueryFindOneByTeamIdArgs = {
  teamId: Scalars['Int']['input'];
};


export type QueryFindPosNearbyPaginationArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
  pagination?: InputMaybe<PaginationInput>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  rad: Scalars['Float']['input'];
};


export type QueryFindPosNearbyWithFollowersPaginationArgs = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
  pagination?: InputMaybe<PaginationInput>;
  rad: Scalars['Float']['input'];
};


export type QueryFindPaymentByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindPaymentsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindPredefinedQuestsByTargetArgs = {
  filter?: InputMaybe<QuestsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryFindPredefinedQuestsByTargetWithRepeatDateArgs = {
  filter?: InputMaybe<QuestsFilterInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryFindQuestsByCategoryAndTargetArgs = {
  target: TargetAciInput;
};


export type QueryFindSocialByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryFindSocialByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindSocialsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindStateByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindStatesByCountryPaginationArgs = {
  country: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindStatesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFindlanguagesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFixtureArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFormArgs = {
  id: Scalars['String']['input'];
};


export type QueryGameArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGenerateCloudinarySignatureArgs = {
  folder: Scalars['String']['input'];
  public_id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGenerateJwtTokenArgs = {
  expiration: Scalars['String']['input'];
  payload: Array<KeyValueInput>;
};


export type QueryGetAccelerationSettingsByTargetWithLinkedAccountArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetAccountsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target?: InputMaybe<TargetAciInput>;
};


export type QueryGetAccountsByTargetAndRolesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  role: Array<UserRole>;
  target: TargetAciInput;
};


export type QueryGetAccountsByTargetWithStatsPaginateArgs = {
  pagination?: InputMaybe<PaginationInput>;
  targets?: InputMaybe<TargetsInput>;
};


export type QueryGetActivityTypesPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetAllByPlayerPlayersStatsFromProviderArgs = {
  player: Scalars['Int']['input'];
  season?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAllInternalProductsArgs = {
  target?: InputMaybe<TargetAciInput>;
};


export type QueryGetAllInternalProductsByTargetGroupedByClassArgs = {
  target: TargetAciInput;
};


export type QueryGetAllInternalProductsByTargetGroupedByClassWithFavoriteStatusArgs = {
  target: TargetAciInput;
};


export type QueryGetAppCorporateEmailsPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetAudienceCriteriasPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAudienceReachArgs = {
  segments: Array<AudienceSegmentInput>;
  target: TargetAciInput;
};


export type QueryGetAudienceUsersPaginatedArgs = {
  id: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetAudiencesByTargetPaginatedArgs = {
  advertiser?: InputMaybe<TargetAciInput>;
  pagination?: InputMaybe<PaginationInput>;
  questType?: InputMaybe<Scalars['ID']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetAudiencesPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetAuthEventLogsByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetBarcodeByBarcodeAndTargetArgs = {
  barcode: Scalars['String']['input'];
  target: TargetAciInput;
};


export type QueryGetBarcodeByProductAndAttributesArgs = {
  input: BarcodeFindInput;
};


export type QueryGetBarcodeByProductAndAttributesCacheArgs = {
  input: BarcodeFindInput;
};


export type QueryGetBarcodeWithProductAttributesAndStockArgs = {
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetBarcodeWithStockArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetBarcodesByBarcodesAndTargetArgs = {
  barcodes: Array<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetBarcodesByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetBarcodesByTargetWithInternalProductPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetBarcodesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetBarcodesWithFilterArgs = {
  filter: BarcodeFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetBarcodesWithVarietyAndStructureWithFilterArgs = {
  filter: BarcodeWithVarietyAndStructureFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetBetsByExtIdArgs = {
  extId: Scalars['Int']['input'];
};


export type QueryGetBetsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetBookmakerByExtIdArgs = {
  extId: Scalars['Int']['input'];
};


export type QueryGetBookmakersPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCatalogueCategoriesArgs = {
  target: TargetAciInput;
};


export type QueryGetCatalogueCategoriesByLayerAndParentArgs = {
  layer: Scalars['Int']['input'];
  parent?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  variety?: InputMaybe<ProductVarietyEnum>;
};


export type QueryGetCatalogueCategoriesByLayerAndParentCacheArgs = {
  layer: Scalars['Int']['input'];
  parent?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  variety?: InputMaybe<ProductVarietyEnum>;
};


export type QueryGetCatalogueCategoriesByLayerAndParentForPortalArgs = {
  layer: Scalars['Int']['input'];
  parent?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetCatalogueCategoriesByTargetAndUrlKeyArgs = {
  language?: InputMaybe<Scalars['ID']['input']>;
  target: TargetAciInput;
  urlKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCatalogueCategoriesByTargetForPortalArgs = {
  target: TargetAciInput;
};


export type QueryGetCatalogueCategoriesByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetCatalogueCategoriesByTargetWithChildrenArgs = {
  language?: InputMaybe<Scalars['ID']['input']>;
  target: TargetAciInput;
  variety?: InputMaybe<ProductVarietyEnum>;
};


export type QueryGetCatalogueCategoriesByTargetWithChildrenCacheArgs = {
  language?: InputMaybe<Scalars['ID']['input']>;
  target: TargetAciInput;
  variety?: InputMaybe<ProductVarietyEnum>;
};


export type QueryGetCatalogueCategoryPathArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetChallengeLeaderboardArgs = {
  id: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetChallengeLeaderboardWithCurrentUserArgs = {
  id: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetChallengesByTargetAndCreatorPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetChallengesByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetChallengesByTargetWithDonationProgressPaginatedArgs = {
  filter?: InputMaybe<ChallengeFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetChallengesPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCoachesFromProviderArgs = {
  team: Scalars['Int']['input'];
};


export type QueryGetCoachsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCoinOneByOwnerArgs = {
  target: TargetAciInput;
};


export type QueryGetCoinsByCategoryPaginatedArgs = {
  categories?: InputMaybe<Array<CoinCategoryEnum>>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCoinsByCountryAndCategoryPaginatedArgs = {
  categories?: InputMaybe<Array<CoinCategoryEnum>>;
  country: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCoinsByCountryPaginatedArgs = {
  country?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCoinsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetComingSoonQuestsByTargetAndUserAudiencePaginatedArgs = {
  input: QuestsByTargetAndUserAudienceInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetComingSoonQuestsByTargetAndUserAudienceWithLinkedAccountsPaginatedArgs = {
  input: QuestsByTargetAndUserAudienceInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCompaniesByTargetArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetCompaniesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCorporateEmailsByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetCorporateNotificationsByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetCorporateNotificationsByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetCorporateNotificationsByUserArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetCorporateNotificationsForUserPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetCorporateNotificationsForUserWithLinkedAccountsPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetCorporateUserCardByUserAndTargetArgs = {
  target: TargetAciInput;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetCorporateUserCardsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetCorporateUserCardsByTargetPaginatedArgs = {
  cardType?: InputMaybe<CardTypeEnum>;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetCorporateUserCardsByTargetWithReputationsPaginatedArgs = {
  filter?: InputMaybe<CorporateUserCardFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetCorporateUserCardsByUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetCorporateUsersByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetCountriesProviderPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCountryProviderByFilterArgs = {
  filter: CountryProviderInput;
};


export type QueryGetCurrentUserFinishedBetOrdersPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCurrentUserLinkedCorporateAccountByTargetArgs = {
  target: TargetWithoutUserInput;
};


export type QueryGetCurrentUserPendingBetOrdersPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCurrentUserQualitativeWalletArgs = {
  target: TargetAciInput;
};


export type QueryGetCurrentUserQuantitativeWalletsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCurrentUserReputationsLossDateArgs = {
  userToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCurrentUserReputationsTurnoverLossDateArgs = {
  userToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCustomersArgs = {
  pagination?: InputMaybe<PaginationInput>;
  phase: CustomerPhaseEnum;
  target: TargetAciInput;
};


export type QueryGetDefaultAudiencesPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDeliveryManByPosArgs = {
  pagination?: InputMaybe<PaginationInput>;
  posId: Scalars['String']['input'];
};


export type QueryGetDonationActivityTypesByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetEcommerceEventLogsByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetEmailIntegrationByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetEventLogsByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetEventLogsPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetEventSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetEventSubscriptionPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetEventsFromProviderArgs = {
  fixture: Scalars['Int']['input'];
};


export type QueryGetEventsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetFavoriteLeagueDefinitionsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetFavoriteLeaguesByUserPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFavoriteLeaguesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetFavoriteTeamDefinitionsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetFavoriteTeamsByUserPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFavoriteTeamsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetFinishedBetOrdersByTargetPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetFinishedBetOrdersPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userId: Scalars['String']['input'];
};


export type QueryGetFixtureSubscribersArgs = {
  fixtureId: Scalars['Int']['input'];
};


export type QueryGetFixturesFromProviderArgs = {
  filter: GetFixturesFromProviderInput;
};


export type QueryGetFixturesFromProviderGuestArgs = {
  filter: GetFixturesFromProviderInput;
};


export type QueryGetFixturesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetFixturesWithFilterArgs = {
  filter: FixtureFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetFixturesWithFilterAndOddsArgs = {
  filter: FixtureFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetFixturesWithFilterWithSubsArgs = {
  filter: FixtureFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetFormResponsesArgs = {
  form: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetFormSummaryArgs = {
  formId: Scalars['String']['input'];
};


export type QueryGetFormsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetFormsWithFiltersArgs = {
  input: FormFiltersInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetGameByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetGameIntegrationByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetGameIntegrationWithFilterArgs = {
  input: GetGameIntegrationWithFilterInput;
};


export type QueryGetGamesPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetHeadToHeadArgs = {
  firstTeam: Scalars['Int']['input'];
  league?: InputMaybe<Scalars['Int']['input']>;
  season?: InputMaybe<Scalars['Int']['input']>;
  secondTeam: Scalars['Int']['input'];
};


export type QueryGetImagesFromFolderArgs = {
  path: Scalars['String']['input'];
};


export type QueryGetInPlayBetsByExtIdArgs = {
  extId: Scalars['Int']['input'];
};


export type QueryGetInPlayBetsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetInPlayOddsFromProviderArgs = {
  fixtureId: Scalars['Int']['input'];
};


export type QueryGetInPlayOddsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetInjuriesFromProviderArgs = {
  fixture: Scalars['Int']['input'];
};


export type QueryGetInjuriesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetInjuriesWithFilterArgs = {
  filter: InjuriesFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetInjuryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetInternalProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetInternalProductBarcodesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetInternalProductBarcodesPaginatedArgs = {
  id: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetInternalProductWithFavoriteStatusArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetInternalProductWithFilterArgs = {
  filter?: InputMaybe<InternalProductFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ProductSortInput>>;
};


export type QueryGetInternalProductWithStockArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetInternalProductsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target?: InputMaybe<TargetAciInput>;
};


export type QueryGetInternalProductsByCatalogueCategoryArgs = {
  catalogueCategoryIds: Array<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetInternalProductsByCatalogueCategoryForPortalArgs = {
  catalogueCategoryIds: Array<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetInternalProductsByCatalogueCategoryWithFavoriteStatusArgs = {
  catalogueCategoryIds: Array<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetInternalProductsByCategoryArgs = {
  category: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetInternalProductsByClassArgs = {
  classification: Array<ProductClassEnum>;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetInternalProductsByProductArgs = {
  pagination?: InputMaybe<PaginationInput>;
  productId: Scalars['ID']['input'];
};


export type QueryGetInternalProductsByTargetAndCatalogueCategoryArgs = {
  category: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetInternalProductsByTargetAndCatalogueCategoryUrlKeyArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
  urlKey: Scalars['String']['input'];
};


export type QueryGetInternalProductsByTargetAndCatalogueCategoryUrlKeyWithFavoriteStatusArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
  urlKey: Scalars['String']['input'];
};


export type QueryGetInternalProductsWithRatingsWithFavoriteStatusWithFilterArgs = {
  filter?: InputMaybe<InternalProductFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ProductSortInput>>;
};


export type QueryGetInternalProductsWithRatingsWithFilterArgs = {
  filter?: InputMaybe<InternalProductFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ProductSortInput>>;
};


export type QueryGetLastReferralArgs = {
  userToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetLastWidgetOutboundsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetLeaderboardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetLeaderboardByCyclePaginatedArgs = {
  input?: InputMaybe<LeaderboardWithRequiredCycleInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetLeaderboardByDatesAndCyclePaginatedArgs = {
  input?: InputMaybe<GetLeaderboardByDatesAndCycleInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetLeaguePaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetLeaguesByFilterArgs = {
  filter: LeagueFilterInput;
};


export type QueryGetLineupsFromProviderArgs = {
  fixture: Scalars['Int']['input'];
};


export type QueryGetLineupsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetLinkedAccountsCorporateUserCardsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetLiveLeaderboardByCycleByExcelArgs = {
  input?: InputMaybe<LeaderboardWithRequiredCycleInput>;
  path?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetLiveLeaderboardByCycleForCurrentUserPaginatedArgs = {
  input?: InputMaybe<LeaderboardWithRequiredCycleInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetLiveLeaderboardByCyclePaginatedArgs = {
  input?: InputMaybe<LeaderboardWithRequiredCycleInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetLiveStatisticsFromProviderArgs = {
  fixture: Scalars['Int']['input'];
};


export type QueryGetLoyaltyProgramsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetManufacturersPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetNonPredefinedActivityTypesPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetNotificationIntegrationByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetOneInternalProductByBarcodeAndTargetArgs = {
  barcode: Scalars['ID']['input'];
  target: TargetAciInput;
};


export type QueryGetOngoingChallengesByTargetAndUserAudiencePaginatedArgs = {
  filter: ChallengeByAudienceFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetOngoingChallengesByTargetAndUserAudienceWithLinkedAccountsPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetOutboundsByTargetPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetOutboundsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPosCategoriesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPosServicesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPosWithFollowersPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetPartnershipNetworksByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPartnershipNetworksByPartnerAndPartnershipPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  partner: TargetAciInput;
  partnership: Array<PartnershipTypeEnum>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPartnershipNetworksByTargetAndPartnershipPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  partnership: Array<PartnershipTypeEnum>;
  target: TargetAciInput;
};


export type QueryGetPartnershipNetworksByTargetPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetPendingBetOrdersByTargetPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetPendingBetOrdersPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userId: Scalars['String']['input'];
};


export type QueryGetPermissionsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetPlayOffsByRoundArgs = {
  league: Scalars['Int']['input'];
  round: RoundsEnum;
  season: Scalars['Int']['input'];
};


export type QueryGetPlayerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPlayerByIdArgs = {
  id: Scalars['Int']['input'];
  season: Scalars['Int']['input'];
};


export type QueryGetPlayerStatisticsFromProviderArgs = {
  fixture: Scalars['Int']['input'];
};


export type QueryGetPlayerStatisticsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPlayersPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPlayersStatsFromProviderArgs = {
  league: Scalars['Int']['input'];
  season: Scalars['Int']['input'];
};


export type QueryGetPlayersStatsWithFilterArgs = {
  filter: PlayersStatsFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPointOfSalesAggregatorPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPointOfSalesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  posCategory?: InputMaybe<Scalars['ID']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetPreMatchOddsFromProviderArgs = {
  fixtureId: Scalars['Int']['input'];
};


export type QueryGetPreMatchOddsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPreMatchOddsWithFilterArgs = {
  filter: OddsFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPredefinedActivityTypesByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetPredefinedActivityTypesByTargetWithActiveStatusPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetPredefinedActivityTypesPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPredictionsArgs = {
  fixture: Scalars['Int']['input'];
};


export type QueryGetPredictionsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetProductBarcodesArgs = {
  productId: Scalars['String']['input'];
};


export type QueryGetProductBarcodesCacheArgs = {
  productId: Scalars['String']['input'];
};


export type QueryGetProfileCompletnessProgressArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  userToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetQuestActionDefinitionsPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetQuestActionsByQuestPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  quest: Scalars['ID']['input'];
};


export type QueryGetQuestActionsPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetQuestActivitiesByQuestArgs = {
  quest: Scalars['ID']['input'];
};


export type QueryGetQuestActivitiesByQuestCacheArgs = {
  quest: Scalars['ID']['input'];
};


export type QueryGetQuestActivitiesByQuestPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  quest: Scalars['ID']['input'];
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetQuestActivitiesPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetQuestByActivityTypeArgs = {
  activityType: Scalars['ID']['input'];
};


export type QueryGetQuestOverviewArgs = {
  quest: Scalars['ID']['input'];
};


export type QueryGetQuestReccurencyStatusArgs = {
  quest: Scalars['ID']['input'];
};


export type QueryGetQuestStatisticsArgs = {
  quest: Scalars['ID']['input'];
};


export type QueryGetQuestionResponsesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  questionId: Scalars['String']['input'];
};


export type QueryGetQuestionsByChallengeStepArgs = {
  id: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetQuestionsByFormArgs = {
  id: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetQuestionsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetQuestionsbyFormWithResponsesStatsPaginatedArgs = {
  id: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetQuestsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetQuestsByTargetAndCreatorPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetQuestsByTargetAndUserAudiencePaginatedArgs = {
  input: QuestsByTargetAndUserAudienceWithPerformedInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetQuestsByTargetAndUserAudienceWithLinkedAccountsPaginatedArgs = {
  input: QuestsByTargetAndUserAudienceWithPerformedInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetQuestsByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetReferralSettingsByTargetWithLinkedAccountArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetReferralsByTargetPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetReputationsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetReputationsByTargetCacheArgs = {
  target: TargetAciInput;
};


export type QueryGetReputationsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetResponsesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetResponsesWithFilterArgs = {
  input: ResponseFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetRoundsArgs = {
  league: Scalars['Int']['input'];
  season: Scalars['Int']['input'];
};


export type QueryGetRoundsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetSeasonsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetServiceProductArgs = {
  target: TargetAciInput;
};


export type QueryGetSidelinedArgs = {
  coach?: InputMaybe<Scalars['Int']['input']>;
  player?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetSidelinedPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetSimpleBarcodeByBarcodeAndTargetArgs = {
  barcode: Scalars['String']['input'];
  target: TargetAciInput;
};


export type QueryGetSimpleBarcodesByBarcodesAndTargetArgs = {
  barcodes: Array<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetSimpleProductWithFavoriteStatusArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSimpleProductWithFavoriteStatusByUrlKeyArgs = {
  language?: InputMaybe<Scalars['ID']['input']>;
  target: TargetAciInput;
  urlKey: Scalars['String']['input'];
};


export type QueryGetSimpleProductWithFilterArgs = {
  filter?: InputMaybe<InternalProductFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ProductSortInput>>;
};


export type QueryGetSimpleProductWithProductAttributesAndFavoriteStatusArgs = {
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSimpleProductWithProductAttributesAndFavoriteStatusByUrlKeyArgs = {
  language?: InputMaybe<Scalars['ID']['input']>;
  target: TargetAciInput;
  urlKey: Scalars['String']['input'];
};


export type QueryGetSimpleProductsByCatalogueCategoryWithFavoriteStatusArgs = {
  catalogueCategoryIds: Array<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<Array<ProductStatusEnum>>;
};


export type QueryGetSimpleProductsByTargetAndCatalogueCategoryUrlKeyWithFavoriteStatusArgs = {
  language?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
  urlKey: Scalars['String']['input'];
};


export type QueryGetSimpleProductsByTargetAndCatalogueCategoryUrlKeyWithProductAttributesAndFavoriteStatusArgs = {
  language?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
  urlKey: Scalars['String']['input'];
};


export type QueryGetSimpleProductsByTargetGroupedByClassWithFavoriteStatusArgs = {
  language?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Array<ProductStatusEnum>>;
  target: TargetAciInput;
};


export type QueryGetSimpleProductsByTargetGroupedByClassWithProductAttributesAndFavoriteStatusArgs = {
  status?: InputMaybe<Array<ProductStatusEnum>>;
  target: TargetAciInput;
};


export type QueryGetSimpleProductsForPartnerhipNetworkWithRatingsWithFavoriteStatusWithFilterArgs = {
  input: GetInternalProductForPartnershipNetworkWithFilterPaginatedInput;
};


export type QueryGetSimpleProductsWithRatingsWithFavoriteStatusArgs = {
  input: GetInternalProductWithFilterPaginatedInput;
};


export type QueryGetSimpleProductsWithRatingsWithFavoriteStatusWithFilterArgs = {
  input: GetInternalProductWithFilterPaginatedInput;
};


export type QueryGetSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusArgs = {
  input: GetInternalProductWithFilterPaginatedInput;
};


export type QueryGetSimpleProductsWithRatingsWithProductAttributesAndFavoriteStatusWithFilterArgs = {
  input: GetInternalProductWithFilterPaginatedInput;
};


export type QueryGetSimpleServicesWithFilterArgs = {
  filter?: InputMaybe<BarcodesFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ProductSortInput>>;
  target: TargetAciInput;
};


export type QueryGetSmsIntegrationByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetSquadsFromProviderArgs = {
  team?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetSquadsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetStandingsArgs = {
  input: GetStandingsInput;
};


export type QueryGetStandingsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetStaticTranslationsByTargetAndLanguageArgs = {
  app?: InputMaybe<TranslationAppEnum>;
  language?: InputMaybe<Scalars['ID']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetStaticTranslationsByTargetAndLanguageCacheArgs = {
  app?: InputMaybe<TranslationAppEnum>;
  language?: InputMaybe<Scalars['ID']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetStaticTranslationsByTargetAndLanguagePaginatedArgs = {
  app?: InputMaybe<TranslationAppEnum>;
  language?: InputMaybe<Scalars['ID']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetStaticTranslationsByTargetPaginatedArgs = {
  app?: InputMaybe<TranslationAppEnum>;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetStatisticsFromProviderArgs = {
  fixture: Scalars['Int']['input'];
};


export type QueryGetStatisticsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetTargetStatsArgs = {
  target: TargetAciInput;
};


export type QueryGetTargetSubscribersByCsvArgs = {
  input: GetTargetSubscribersByExcelInput;
};


export type QueryGetTargetSubscribersByExcelArgs = {
  input: GetTargetSubscribersByExcelInput;
};


export type QueryGetTargetSubscribersPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  status: Array<SubscriptionStatus>;
  target: TargetAciInput;
};


export type QueryGetTargetUserCardsByCsvArgs = {
  cardType?: InputMaybe<CardTypeEnum>;
  path?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetTargetUserCardsByExcelArgs = {
  cardType?: InputMaybe<CardTypeEnum>;
  path?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetTargetUsersWithWalletsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QueryGetTargetWalletsArgs = {
  target: TargetAciInput;
};


export type QueryGetTeamOrPlayerSquadsArgs = {
  player?: InputMaybe<Scalars['Int']['input']>;
  team?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetTeamSeasonsArgs = {
  team: Scalars['Int']['input'];
};


export type QueryGetTeamSeasonsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetTeamStatisticsArgs = {
  league: Scalars['Int']['input'];
  season: Scalars['Int']['input'];
  team: Scalars['Int']['input'];
};


export type QueryGetTeamStatisticsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetTeamsByFilterArgs = {
  filter: TeamInformationFilterInput;
};


export type QueryGetTeamsInformationPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetTimezonesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetTopAssistsArgs = {
  league: Scalars['Int']['input'];
  season: Scalars['Int']['input'];
};


export type QueryGetTopAssistsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetTopRedCardsArgs = {
  league: Scalars['Int']['input'];
  season: Scalars['Int']['input'];
};


export type QueryGetTopRedCardsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetTopScorerPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetTopScorersArgs = {
  league: Scalars['Int']['input'];
  season: Scalars['Int']['input'];
};


export type QueryGetTopYellowCardsArgs = {
  league: Scalars['Int']['input'];
  season: Scalars['Int']['input'];
};


export type QueryGetTopYellowCardsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetTransfersArgs = {
  player?: InputMaybe<Scalars['Int']['input']>;
  team?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetTransfersFromProviderArgs = {
  player?: InputMaybe<Scalars['Int']['input']>;
  team?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetTransfersPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetTrophiesArgs = {
  coach?: InputMaybe<Scalars['Int']['input']>;
  player?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetTrophiesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetUpcomingChallengesByTargetAndUserAudiencePaginatedArgs = {
  filter: ChallengeByAudienceFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetUpcomingChallengesByTargetAndUserAudienceWithLinkedAccountsPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetUserSubscribedTargetsArgs = {
  statuses?: InputMaybe<Array<SubscriptionStatus>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserWalletTransactionsStatsByAffectedArgs = {
  affected: TargetAciInput;
};


export type QueryGetUserWalletWithReputationsArgs = {
  userToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUsersByPermissionPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  permission: Scalars['ID']['input'];
};


export type QueryGetUsersPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<Array<UserStatus>>;
};


export type QueryGetUsersPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetVapidKeyArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetVenuesPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetWaitersByPossArgs = {
  pagination?: InputMaybe<PaginationInput>;
  posId: Scalars['String']['input'];
};


export type QueryGetWalletByOwnerWithReputationsArgs = {
  target: TargetAciInput;
  user: Scalars['ID']['input'];
};


export type QueryGetWalletTopupsSettingsByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetWalletTopupsSettingsByTargetPaginatedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetWalletTopupsSettingsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetWalletTransactionsByAffectedPaginatedArgs = {
  filter: WalletTransactionsByAffectedFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetWalletTransactionsByAffectedPaginatedByCsvArgs = {
  filter?: InputMaybe<WalletTransactionsByAffectedFilterInput>;
  path?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetWalletTransactionsByAffectedPaginatedByExcelArgs = {
  filter?: InputMaybe<WalletTransactionsByAffectedFilterInput>;
  path?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetWalletTransactionsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetWalletTransactionsStatsByAffectedArgs = {
  affected: TargetAciInput;
};


export type QueryGetWalletTransactionsStatsChartWithFilterArgs = {
  filter: WalletTransactionsStatsChartFilterInput;
};


export type QueryGetWalletsPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetWholesalersPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetWidgetForTargetArgs = {
  app: TranslationAppEnum;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetWidgetGuestUserForTargetArgs = {
  target: TargetTransferInput;
};


export type QueryGetWidgetIntegrationByTargetArgs = {
  target: TargetAciInput;
};


export type QueryGetWidgetIntegrationByTargetCacheArgs = {
  target: TargetAciInput;
};


export type QueryGetWidgetUserForTargetArgs = {
  target: TargetTransferInput;
  userToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetWidgetVisualsByTargetAndAppCacheArgs = {
  app: TranslationAppEnum;
  target: TargetAciInput;
};


export type QueryGetWidgetVisualsByTargetAndAppPaginatedArgs = {
  app: TranslationAppEnum;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryGetWidgetVisualsByTargetAndAppPaginatedCacheArgs = {
  app: TranslationAppEnum;
  pagination?: InputMaybe<PaginationInput>;
  target: TargetAciInput;
};


export type QueryInPlayBetsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInPlayOddsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIsEmailExistArgs = {
  email: Scalars['String']['input'];
};


export type QueryIsFixtureGotInPlayOddsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIsFixtureGotPreMatchOddsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryIsLeagueFavoriteArgs = {
  leagueId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};


export type QueryIsLoginExistArgs = {
  input: IsLoginExistInput;
};


export type QueryIsLoginForTargetExistArgs = {
  input: IsLoginForTargetExistInput;
};


export type QueryIsTeamFavoriteArgs = {
  teamId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};


export type QueryIsUserNearPosArgs = {
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
  posId: Scalars['ID']['input'];
};


export type QueryIsUserSubscribedToTargetArgs = {
  target: TargetAciInput;
};


export type QueryLeagueArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLineupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLoginArgs = {
  input: LoginInput;
};


export type QueryLoginForAppArgs = {
  input: LoginInput;
};


export type QueryLoginForTargetArgs = {
  login?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone?: InputMaybe<IPhoneInput>;
  source?: InputMaybe<UserEventsSourceEnum>;
  target: TargetAciInput;
};


export type QueryLoginWithAppleArgs = {
  authorizationData: AuthorizationDataInput;
};


export type QueryLoginWithAppleForTargetArgs = {
  authorizationData: AuthorizationDataInput;
  target: TargetAciInput;
};


export type QueryLoginWithFacebookArgs = {
  token: Scalars['String']['input'];
};


export type QueryLoginWithFacebookForTargetArgs = {
  target: TargetAciInput;
  token: Scalars['String']['input'];
};


export type QueryLoginWithGoogleArgs = {
  token: Scalars['String']['input'];
};


export type QueryLoginWithGoogleForTargetArgs = {
  target: TargetAciInput;
  token: Scalars['String']['input'];
};


export type QueryLogoutUserByTargetArgs = {
  input: LogoutUserByTargetInput;
};


export type QueryLogoutUserForTargetArgs = {
  source?: InputMaybe<UserEventsSourceEnum>;
};


export type QueryLoyaltyProgramArgs = {
  id: Scalars['String']['input'];
};


export type QueryManufacturerArgs = {
  id: Scalars['String']['input'];
};


export type QueryNotificationIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOutboundArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPermissionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPermissionDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlayerSeasonsArgs = {
  player: Scalars['Int']['input'];
};


export type QueryPlayerStatisticsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPointOfSaleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPointOfSaleByOriginArgs = {
  website?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPointOfSaleCacheArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPosCategoryArgs = {
  id: Scalars['String']['input'];
};


export type QueryPosServicesArgs = {
  id: Scalars['String']['input'];
};


export type QueryPreMatchOddsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPredictionsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuantitativeWalletsByOwnerPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<TargetTransferInput>;
};


export type QueryQuestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuestActionDefinitionArgs = {
  id: Scalars['String']['input'];
};


export type QueryQuestActivityArgs = {
  id: Scalars['String']['input'];
};


export type QueryQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReferralArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRefreshAudienceViewsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReputationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryResponseArgs = {
  id: Scalars['String']['input'];
};


export type QueryRoundArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySearchAccountArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QuerySearchBarcodesByTargetArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QuerySearchBarcodesByTargetAndSupplierArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  supplier: Scalars['ID']['input'];
  target: TargetAciInput;
};


export type QuerySearchBarcodesByTargetWithStockArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QuerySearchCatalogueCategoriesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchCoachesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchCompanyArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchCorporateUsersByTargetArgs = {
  input: SearchCorporateUsersByTargetInput;
};


export type QuerySearchCustomersByTargetAndPhaseArgs = {
  pagination?: InputMaybe<PaginationInput>;
  phase: CustomerPhaseEnum;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QuerySearchFavouritesLeaguesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchFavouritesTeamsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchFormsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchInternalProductArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchInternalProductByCatalogueCategoryArgs = {
  catalogueCategoryId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchInternalProductByTargetArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QuerySearchLeaguesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchLiveFixturesArgs = {
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchLogisticCompaniesByTargetArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QuerySearchLoyaltyProgramArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchManufacturerArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchPosNearbyPaginationArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
  pagination?: InputMaybe<PaginationInput>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  rad: Scalars['Float']['input'];
  searchString: Scalars['String']['input'];
};


export type QuerySearchPlayersArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchPosArgs = {
  pagination?: InputMaybe<PaginationInput>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchPosCategoryArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchPosServicesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchResponseArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchSimpleBarcodesByTargetWithStockArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QuerySearchSimpleEquipmentsArgs = {
  searchInput: SearchSimpleProductInput;
};


export type QuerySearchSimpleServicesArgs = {
  searchInput: SearchSimpleProductInput;
};


export type QuerySearchSuppliersByTargetArgs = {
  kinds?: InputMaybe<Array<SupplierTypeEnum>>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};


export type QuerySearchTargetQualitativeWalletsArgs = {
  input: SearchTargetQualitativeWalletsPaginatedInput;
};


export type QuerySearchTargetSubscribersArgs = {
  input: SearchTargetSubscribersPaginatedInput;
};


export type QuerySearchTeamArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchUserArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchUserTargetSubscriptionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<SubscriptionStatus>>;
  target: TargetAciInput;
};


export type QuerySearchVenuesArgs = {
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchWholesalerArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySeasonArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySendAdhocCorporateNotificationTestArgs = {
  input: CorporateNotificationInput;
};


export type QuerySendAdhocNotificationTestArgs = {
  description: Scalars['String']['input'];
  picture: PictureInput;
  title: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QuerySendCorporateEmailArgs = {
  input: CorporateEmailTempInput;
};


export type QuerySendEmailArgs = {
  input: EmailTempInput;
};


export type QuerySendLiveLeaderboardByCycleBymailArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  input?: InputMaybe<LeaderboardWithRequiredCycleInput>;
  subject: Scalars['String']['input'];
};


export type QuerySendQualitativeWalletsBymailArgs = {
  input: SendTargetQualitativeWalletsByEmailInput;
};


export type QuerySendSmsArgs = {
  content: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  target: TargetAciInput;
};


export type QuerySendTargetSubscribersBymailArgs = {
  input: SendTargetSubscribersBymailnput;
};


export type QuerySendTargetUserCardsBymailArgs = {
  cardType?: InputMaybe<CardTypeEnum>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  subject: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
};


export type QuerySendThemAndLanguageToWidgetArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
  target: TargetAciInput;
  theme?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySendUserAdhocNotificationArgs = {
  description: Scalars['String']['input'];
  executedAt?: InputMaybe<Scalars['DateTime']['input']>;
  picture: PictureInput;
  title: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QuerySidelinedArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySmsIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySquadsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStandingsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStaticTranslationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStatisticsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTargetHasStaticTranslationsReferenceArgs = {
  app: TranslationAppEnum;
  reference: Scalars['String']['input'];
  target: TargetAciInput;
};


export type QueryTeamInformationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTeamSeasonsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTeamStatisticsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTimezoneArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTopAssistsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTopRedCardsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTopScorerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTopYellowCardsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTransfersArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTrophiesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUploadImageArgs = {
  localPath: Scalars['String']['input'];
  remotePath: Scalars['String']['input'];
};


export type QueryUserArgs = {
  id: Scalars['String']['input'];
};


export type QueryUserByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryValidateRegisterPhoneNumberArgs = {
  phone: IPhoneInput;
  smsNumber: Scalars['Int']['input'];
};


export type QueryValidateSmsCodeArgs = {
  input: ValidateSmsCodeInput;
};


export type QueryVerifyApiSettingsArgs = {
  input?: InputMaybe<VerifyApiSettingsInput>;
};


export type QueryWalletArgs = {
  id: Scalars['String']['input'];
};


export type QueryWalletOwnerHasEnoughBalanceArgs = {
  input: WalletOwnerHasEnoughBalanceInput;
};


export type QueryWalletTopupSettingsArgs = {
  id: Scalars['String']['input'];
};


export type QueryWalletTransactionArgs = {
  id: Scalars['String']['input'];
};


export type QueryWalletsByOwnerArgs = {
  target?: InputMaybe<TargetTransferInput>;
};


export type QueryWalletsByOwnerPaginationArgs = {
  pagination?: InputMaybe<PaginationInput>;
  target?: InputMaybe<TargetTransferInput>;
};


export type QueryWholesalerArgs = {
  id: Scalars['String']['input'];
};


export type QueryWidgetIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWidgetVisualsArgs = {
  id: Scalars['ID']['input'];
};

export type QuestActionActionGameInput = {
  jigsaw?: InputMaybe<QuestActionActionPerformedInput>;
  memory?: InputMaybe<QuestActionActionPerformedInput>;
  quizz?: InputMaybe<QuestActionActionPerformedInput>;
  sliding?: InputMaybe<QuestActionActionPerformedInput>;
};

export type QuestActionActionGamePerformedType = {
  __typename?: 'QuestActionActionGamePerformedType';
  jigsaw?: Maybe<QuestActionActionPerformedType>;
  memory?: Maybe<QuestActionActionPerformedType>;
  quizz?: Maybe<QuestActionActionPerformedType>;
  sliding?: Maybe<QuestActionActionPerformedType>;
};

export type QuestActionActionPerformedInput = {
  performed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestActionActionPerformedType = {
  __typename?: 'QuestActionActionPerformedType';
  performed?: Maybe<Scalars['Boolean']['output']>;
};

export type QuestActionActionType = {
  __typename?: 'QuestActionActionType';
  api?: Maybe<QuestActionActionPerformedType>;
  appDownload?: Maybe<QuestActionActionPerformedType>;
  form?: Maybe<QuestActionFormType>;
  game?: Maybe<QuestActionActionGamePerformedType>;
  lead?: Maybe<QuestActionActionPerformedType>;
  socialMedia?: Maybe<QuestActionActionPerformedType>;
  video?: Maybe<QuestActionActionPerformedType>;
};

export type QuestActionActivityApiInput = {
  activity?: InputMaybe<Scalars['ID']['input']>;
  params?: InputMaybe<Array<KeyValueInput>>;
};

export type QuestActionActivityWatchedInput = {
  activity?: InputMaybe<Scalars['ID']['input']>;
  watched?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestActionCheckInput = {
  card?: InputMaybe<Scalars['String']['input']>;
  coin?: InputMaybe<Scalars['ID']['input']>;
  referral?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type QuestActionDefinitionDefinitionApiInput = {
  headers?: InputMaybe<Array<KeyValueInput>>;
  link?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<ApiMethods>;
  params?: InputMaybe<Array<QuestActionDefinitionDefinitionApiParamsInput>>;
};

export type QuestActionDefinitionDefinitionApiParamsInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<QuestActionDefinitionDefinitionApiParamsUserInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type QuestActionDefinitionDefinitionApiParamsType = {
  __typename?: 'QuestActionDefinitionDefinitionApiParamsType';
  key?: Maybe<Scalars['String']['output']>;
  user?: Maybe<QuestActionDefinitionDefinitionApiParamsUserType>;
  value?: Maybe<Scalars['String']['output']>;
};

export type QuestActionDefinitionDefinitionApiParamsUserInput = {
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type QuestActionDefinitionDefinitionApiParamsUserType = {
  __typename?: 'QuestActionDefinitionDefinitionApiParamsUserType';
  enable?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type QuestActionDefinitionDefinitionApiType = {
  __typename?: 'QuestActionDefinitionDefinitionApiType';
  headers?: Maybe<Array<KeyValueType>>;
  link?: Maybe<Scalars['String']['output']>;
  method?: Maybe<ApiMethods>;
  params?: Maybe<Array<QuestActionDefinitionDefinitionApiParamsType>>;
};

export type QuestActionDefinitionDefinitionAppDownloadInput = {
  appgallery?: InputMaybe<Scalars['String']['input']>;
  appstore?: InputMaybe<Scalars['String']['input']>;
  playstore?: InputMaybe<Scalars['String']['input']>;
};

export type QuestActionDefinitionDefinitionAppDownloadType = {
  __typename?: 'QuestActionDefinitionDefinitionAppDownloadType';
  appgallery?: Maybe<Scalars['String']['output']>;
  appstore?: Maybe<Scalars['String']['output']>;
  playstore?: Maybe<Scalars['String']['output']>;
};

export type QuestActionDefinitionDefinitionGameInput = {
  gameType?: InputMaybe<GameTypeEnum>;
  jigsaw?: InputMaybe<QuestActionDefinitionDefinitionGameJigsawInput>;
  memory?: InputMaybe<QuestActionDefinitionDefinitionGameMemoryInput>;
  quizz?: InputMaybe<QuestActionDefinitionDefinitionGameQuizzInput>;
  sliding?: InputMaybe<QuestActionDefinitionDefinitionGamePuzzleInput>;
};

export type QuestActionDefinitionDefinitionGameJigsawInput = {
  picture?: InputMaybe<PictureInput>;
  pieces?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestActionDefinitionDefinitionGameJigsawType = {
  __typename?: 'QuestActionDefinitionDefinitionGameJigsawType';
  picture?: Maybe<PictureType>;
  pieces?: Maybe<Scalars['Int']['output']>;
};

export type QuestActionDefinitionDefinitionGameMemoryInput = {
  pictures?: InputMaybe<Array<PictureInput>>;
  setup?: InputMaybe<MemorySetupEnum>;
  timer?: InputMaybe<GameTimerEnum>;
};

export type QuestActionDefinitionDefinitionGameMemoryType = {
  __typename?: 'QuestActionDefinitionDefinitionGameMemoryType';
  pictures?: Maybe<Array<PictureType>>;
  setup?: Maybe<MemorySetupEnum>;
  timer?: Maybe<GameTimerEnum>;
};

export type QuestActionDefinitionDefinitionGamePuzzleInput = {
  picture?: InputMaybe<PictureInput>;
  threshold?: InputMaybe<Array<QuestActionDefinitionDefinitionGamePuzzleThresholdInput>>;
};

export type QuestActionDefinitionDefinitionGamePuzzleThresholdInput = {
  bonus?: InputMaybe<Array<RemunerationInput>>;
  timer?: InputMaybe<GameTimerEnum>;
};

export type QuestActionDefinitionDefinitionGamePuzzleThresholdType = {
  __typename?: 'QuestActionDefinitionDefinitionGamePuzzleThresholdType';
  bonus?: Maybe<Array<RemunerationDtoType>>;
  timer?: Maybe<GameTimerEnum>;
};

export type QuestActionDefinitionDefinitionGamePuzzleType = {
  __typename?: 'QuestActionDefinitionDefinitionGamePuzzleType';
  picture?: Maybe<PictureType>;
  threshold?: Maybe<Array<QuestActionDefinitionDefinitionGamePuzzleThresholdType>>;
};

export type QuestActionDefinitionDefinitionGameQuizzChoicesInput = {
  correct?: InputMaybe<Scalars['Boolean']['input']>;
  item?: InputMaybe<Scalars['String']['input']>;
};

export type QuestActionDefinitionDefinitionGameQuizzChoicesType = {
  __typename?: 'QuestActionDefinitionDefinitionGameQuizzChoicesType';
  correct?: Maybe<Scalars['Boolean']['output']>;
  item?: Maybe<Scalars['String']['output']>;
};

export type QuestActionDefinitionDefinitionGameQuizzInput = {
  choices?: InputMaybe<Array<QuestActionDefinitionDefinitionGameQuizzChoicesInput>>;
  picture?: InputMaybe<PictureInput>;
  quizzType?: InputMaybe<QuestionTypeEnum>;
};

export type QuestActionDefinitionDefinitionGameQuizzType = {
  __typename?: 'QuestActionDefinitionDefinitionGameQuizzType';
  choices?: Maybe<Array<QuestActionDefinitionDefinitionGameQuizzChoicesType>>;
  picture?: Maybe<PictureType>;
  quizzType?: Maybe<QuestionTypeEnum>;
};

export type QuestActionDefinitionDefinitionGameType = {
  __typename?: 'QuestActionDefinitionDefinitionGameType';
  gameType?: Maybe<GameTypeEnum>;
  jigsaw?: Maybe<QuestActionDefinitionDefinitionGameJigsawType>;
  memory?: Maybe<QuestActionDefinitionDefinitionGameMemoryType>;
  quizz?: Maybe<QuestActionDefinitionDefinitionGameQuizzType>;
  sliding?: Maybe<QuestActionDefinitionDefinitionGamePuzzleType>;
};

export type QuestActionDefinitionDefinitionInput = {
  api?: InputMaybe<QuestActionDefinitionDefinitionApiInput>;
  appDownload?: InputMaybe<QuestActionDefinitionDefinitionAppDownloadInput>;
  form?: InputMaybe<QuestActionDefinitionDefinitionQuestionInput>;
  game?: InputMaybe<QuestActionDefinitionDefinitionGameInput>;
  lead?: InputMaybe<QuestActionDefinitionDefinitionLeadInput>;
  socialMedia?: InputMaybe<QuestActionDefinitionDefinitionSocialMediaInput>;
  video?: InputMaybe<QuestActionDefinitionDefinitionVideoInput>;
};

export type QuestActionDefinitionDefinitionLeadInput = {
  image?: InputMaybe<Scalars['String']['input']>;
  minSeconds?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type QuestActionDefinitionDefinitionLeadType = {
  __typename?: 'QuestActionDefinitionDefinitionLeadType';
  image?: Maybe<Scalars['String']['output']>;
  minSeconds?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type QuestActionDefinitionDefinitionQuestionInput = {
  form?: InputMaybe<Scalars['ID']['input']>;
  random?: InputMaybe<Scalars['Boolean']['input']>;
  scoring?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestActionDefinitionDefinitionQuestionType = {
  __typename?: 'QuestActionDefinitionDefinitionQuestionType';
  form?: Maybe<FormDtoType>;
  random?: Maybe<Scalars['Boolean']['output']>;
  scoring?: Maybe<Scalars['Boolean']['output']>;
};

export type QuestActionDefinitionDefinitionSocialMediaInput = {
  action?: InputMaybe<SocialActionEnum>;
  hashtag?: InputMaybe<Scalars['String']['input']>;
  socialContent?: InputMaybe<SocialContentTypeEnum>;
  socialMedia?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type QuestActionDefinitionDefinitionSocialMediaType = {
  __typename?: 'QuestActionDefinitionDefinitionSocialMediaType';
  action?: Maybe<SocialActionEnum>;
  hashtag?: Maybe<Scalars['String']['output']>;
  socialContent?: Maybe<SocialContentTypeEnum>;
  socialMedia?: Maybe<SocialType>;
  url?: Maybe<Scalars['String']['output']>;
};

export type QuestActionDefinitionDefinitionType = {
  __typename?: 'QuestActionDefinitionDefinitionType';
  api?: Maybe<QuestActionDefinitionDefinitionApiType>;
  appDownload?: Maybe<QuestActionDefinitionDefinitionAppDownloadType>;
  form?: Maybe<QuestActionDefinitionDefinitionQuestionType>;
  game?: Maybe<QuestActionDefinitionDefinitionGameType>;
  lead?: Maybe<QuestActionDefinitionDefinitionLeadType>;
  socialMedia?: Maybe<QuestActionDefinitionDefinitionSocialMediaType>;
  video?: Maybe<QuestActionDefinitionDefinitionVideoType>;
};

export type QuestActionDefinitionDefinitionVideoInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  minSeconds?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<QuestActionDefinitionVideo>;
};

export type QuestActionDefinitionDefinitionVideoType = {
  __typename?: 'QuestActionDefinitionDefinitionVideoType';
  action?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  minSeconds?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<QuestActionDefinitionVideo>;
};

export type QuestActionDefinitionInput = {
  activityType?: InputMaybe<Scalars['String']['input']>;
  definition?: InputMaybe<QuestActionDefinitionDefinitionInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestActionDefinitionPaginateType = {
  __typename?: 'QuestActionDefinitionPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<QuestActionDefinitionType>;
};

export type QuestActionDefinitionType = {
  __typename?: 'QuestActionDefinitionType';
  activityType?: Maybe<ActivityTypeType>;
  createdAt: Scalars['DateTime']['output'];
  definition?: Maybe<QuestActionDefinitionDefinitionType>;
  id: Scalars['ID']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum QuestActionDefinitionVideo {
  FACEBOOK_REEL = 'FACEBOOK_REEL',
  FACEBOOK_VIDEO = 'FACEBOOK_VIDEO',
  FILE = 'FILE',
  PICTURE = 'PICTURE',
  TIKTOK_REEL = 'TIKTOK_REEL',
  YOUTUBE = 'YOUTUBE',
  YOUTUBE_SHORT = 'YOUTUBE_SHORT'
}

export type QuestActionFormType = {
  __typename?: 'QuestActionFormType';
  form?: Maybe<FormDtoType>;
  performed?: Maybe<Scalars['Boolean']['output']>;
};

export type QuestActionGameInput = {
  activity: Scalars['ID']['input'];
  duration: Scalars['Int']['input'];
  movesCount: Scalars['Int']['input'];
  timer?: InputMaybe<GameTimerEnum>;
};

export type QuestActionPaginateType = {
  __typename?: 'QuestActionPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<QuestActionType>;
};

export type QuestActionSuccessType = {
  __typename?: 'QuestActionSuccessType';
  message: Scalars['String']['output'];
  qualitativeAmount?: Maybe<Scalars['Decimal']['output']>;
  quantitativeAmount?: Maybe<Scalars['Decimal']['output']>;
  success: Scalars['Boolean']['output'];
};

export type QuestActionType = {
  __typename?: 'QuestActionType';
  action: QuestActionActionType;
  activity: QuestActivityType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type QuestActionsRecurrenceInput = {
  cycle?: InputMaybe<Scalars['Int']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestActionsRecurrenceType = {
  __typename?: 'QuestActionsRecurrenceType';
  cycle?: Maybe<Scalars['Int']['output']>;
  enable?: Maybe<Scalars['Boolean']['output']>;
};

export type QuestActivityInput = {
  activity?: InputMaybe<IQuestActivityActivitiesInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  quest: Scalars['ID']['input'];
  rank?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type QuestActivityIntType = {
  __typename?: 'QuestActivityIntType';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<MediaType>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type QuestActivityPaginateType = {
  __typename?: 'QuestActivityPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<QuestActivityType>;
};

export type QuestActivityType = {
  __typename?: 'QuestActivityType';
  activity?: Maybe<IQuestActivityActivitiesType>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<MediaType>;
  quest?: Maybe<QuestType>;
  rank?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestAudienceSegmentFilterValuesAnswersInput = {
  date?: InputMaybe<TimeFromToInput>;
  multipleChoices?: InputMaybe<Array<Scalars['String']['input']>>;
  number?: InputMaybe<QuestAudienceSegmentFilterValuesAnswersNumberInput>;
  paragraph?: InputMaybe<Array<Scalars['String']['input']>>;
  rating?: InputMaybe<Array<Scalars['Int']['input']>>;
  shortAnswer?: InputMaybe<Array<Scalars['String']['input']>>;
  singleChoice?: InputMaybe<Array<Scalars['String']['input']>>;
  smiley?: InputMaybe<Array<ResponseAnswerSmileyObjInput>>;
};

export type QuestAudienceSegmentFilterValuesAnswersNumberInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type QuestAudienceSegmentFilterValuesAnswersNumberType = {
  __typename?: 'QuestAudienceSegmentFilterValuesAnswersNumberType';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type QuestAudienceSegmentFrequencyInput = {
  frequency?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<PeriodCycleEnum>;
};

export type QuestAudienceSegmentFrequencyType = {
  __typename?: 'QuestAudienceSegmentFrequencyType';
  frequency?: Maybe<Scalars['Int']['output']>;
  period?: Maybe<PeriodCycleEnum>;
};

export type QuestBudgetType = {
  __typename?: 'QuestBudgetType';
  budget?: Maybe<Scalars['Decimal']['output']>;
  maxAnswers?: Maybe<Scalars['Int']['output']>;
  pricePerUser?: Maybe<Scalars['Decimal']['output']>;
  remainingBudget?: Maybe<Scalars['Decimal']['output']>;
  remainingCoins?: Maybe<Scalars['Decimal']['output']>;
};

export enum QuestCategoryEnum {
  FAMILY = 'FAMILY',
  FITNESS = 'FITNESS',
  GASTRONOMY = 'GASTRONOMY',
  INDUSTRY = 'INDUSTRY'
}

export type QuestInput = {
  activityType?: InputMaybe<Scalars['ID']['input']>;
  advertiser?: InputMaybe<TargetAciInput>;
  audience?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<QuestCategoryEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  leaderboard?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<MediaInput>;
  questType?: InputMaybe<Scalars['ID']['input']>;
  recurrence?: InputMaybe<QuestActionsRecurrenceInput>;
  remuneration?: InputMaybe<Array<QuestRemunerationInput>>;
  rewards?: InputMaybe<Scalars['String']['input']>;
  sponsored?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<QuestStatusEnum>;
  target: TargetAciInput;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type QuestOverviewType = {
  __typename?: 'QuestOverviewType';
  consumedBudget?: Maybe<AmountPercentageDecimalType>;
  totalActions?: Maybe<AmountPercentageDecimalType>;
  totalAudience?: Maybe<AmountPercentageDecimalType>;
  totalBudget?: Maybe<AmountPercentageDecimalType>;
  totalReplies?: Maybe<AmountPercentageDecimalType>;
  totalSteps?: Maybe<AmountPercentageDecimalType>;
};

export type QuestPaginateType = {
  __typename?: 'QuestPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<QuestType>;
};

export type QuestPerformedType = {
  __typename?: 'QuestPerformedType';
  activityType?: Maybe<ActivityTypeType>;
  advertiser?: Maybe<TargetType>;
  audience?: Maybe<AudienceType>;
  budget?: Maybe<QuestBudgetType>;
  category?: Maybe<QuestCategoryEnum>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  leaderboard?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<MediaType>;
  performed?: Maybe<Scalars['Boolean']['output']>;
  progress?: Maybe<Scalars['Decimal']['output']>;
  questType?: Maybe<QuestTypeType>;
  recurrence?: Maybe<QuestActionsRecurrenceType>;
  remuneration?: Maybe<Array<RemunerationDtoType>>;
  rewards?: Maybe<Scalars['String']['output']>;
  sponsored?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<QuestStatusEnum>;
  target: TargetType;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestRecurrencyStatusType = {
  __typename?: 'QuestRecurrencyStatusType';
  isReccurent: Scalars['Boolean']['output'];
  repeatDate?: Maybe<Scalars['DateTime']['output']>;
};

export type QuestRemunerationInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  wallet?: InputMaybe<Scalars['ID']['input']>;
  walletType: WalletTypeEnum;
};

export type QuestStatisticsChartType = {
  __typename?: 'QuestStatisticsChartType';
  actions: Array<Array<Scalars['Float']['output']>>;
  budget: Array<Array<Scalars['Float']['output']>>;
  replies: Array<Array<Scalars['Float']['output']>>;
};

export type QuestStatisticsType = {
  __typename?: 'QuestStatisticsType';
  chart?: Maybe<QuestStatisticsChartType>;
  lastDayActions?: Maybe<Scalars['Decimal']['output']>;
  lastDayBudget?: Maybe<Scalars['Decimal']['output']>;
  lastDayReplies?: Maybe<Scalars['Decimal']['output']>;
  totalReplies?: Maybe<Scalars['Decimal']['output']>;
};

export type QuestStatsType = {
  __typename?: 'QuestStatsType';
  quest?: Maybe<QuestWithoutTargetType>;
  questActionsCount?: Maybe<Scalars['Float']['output']>;
};

export enum QuestStatusEnum {
  DRAFT = 'DRAFT',
  FINISHED = 'FINISHED',
  IN_REVIEW = 'IN_REVIEW',
  ONGOING = 'ONGOING',
  ON_HOLD = 'ON_HOLD'
}

export type QuestType = {
  __typename?: 'QuestType';
  activityType?: Maybe<ActivityTypeType>;
  advertiser?: Maybe<TargetType>;
  audience?: Maybe<AudienceType>;
  budget?: Maybe<QuestBudgetType>;
  category?: Maybe<QuestCategoryEnum>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  leaderboard?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<MediaType>;
  progress?: Maybe<Scalars['Decimal']['output']>;
  questType?: Maybe<QuestTypeType>;
  recurrence?: Maybe<QuestActionsRecurrenceType>;
  remuneration?: Maybe<Array<RemunerationDtoType>>;
  rewards?: Maybe<Scalars['String']['output']>;
  sponsored?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<QuestStatusEnum>;
  target: TargetType;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestTypeAudienceType = {
  __typename?: 'QuestTypeAudienceType';
  criteria?: Maybe<AudienceCriteriaType>;
  fields?: Maybe<Array<AudienceCriteriaFieldType>>;
};

export type QuestTypeRemunerationType = {
  __typename?: 'QuestTypeRemunerationType';
  max?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
};

export type QuestTypeType = {
  __typename?: 'QuestTypeType';
  activityTypes?: Maybe<Array<ActivityTypeType>>;
  admin?: Maybe<Scalars['Boolean']['output']>;
  advertiser?: Maybe<TargetType>;
  audience?: Maybe<Array<QuestTypeAudienceType>>;
  condition?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enable?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maxActivities?: Maybe<Scalars['Int']['output']>;
  maxQuestions?: Maybe<Scalars['Int']['output']>;
  media?: Maybe<MediaType>;
  profile?: Maybe<Scalars['Boolean']['output']>;
  qualitative?: Maybe<QuestTypeRemunerationType>;
  quantitative?: Maybe<QuestTypeRemunerationType>;
  questionTypes?: Maybe<Array<QuestionTypeEnum>>;
  rewardPoints?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Boolean']['output']>;
  social?: Maybe<Array<SocialType>>;
  target?: Maybe<TargetType>;
  title?: Maybe<Scalars['String']['output']>;
  transition?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  wallet?: Maybe<WalletType>;
};

export type QuestUpdateInput = {
  activityType?: InputMaybe<Scalars['ID']['input']>;
  audience?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<QuestCategoryEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  leaderboard?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<MediaInput>;
  questType?: InputMaybe<Scalars['ID']['input']>;
  recurrence?: InputMaybe<QuestActionsRecurrenceInput>;
  remuneration?: InputMaybe<Array<QuestRemunerationInput>>;
  rewards?: InputMaybe<Scalars['String']['input']>;
  sponsored?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<QuestStatusEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type QuestWithActionsType = {
  __typename?: 'QuestWithActionsType';
  actions?: Maybe<Scalars['Int']['output']>;
  activityType?: Maybe<ActivityTypeType>;
  advertiser?: Maybe<TargetType>;
  audience?: Maybe<AudienceType>;
  budget?: Maybe<QuestBudgetType>;
  category?: Maybe<QuestCategoryEnum>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  leaderboard?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<MediaType>;
  progress?: Maybe<Scalars['Decimal']['output']>;
  questType?: Maybe<QuestTypeType>;
  recurrence?: Maybe<QuestActionsRecurrenceType>;
  remuneration?: Maybe<Array<RemunerationDtoType>>;
  rewards?: Maybe<Scalars['String']['output']>;
  sponsored?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<QuestStatusEnum>;
  target: TargetType;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestWithPerformedPaginateType = {
  __typename?: 'QuestWithPerformedPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<QuestPerformedType>;
};

export type QuestWithQualitativePictureType = {
  __typename?: 'QuestWithQualitativePictureType';
  activityType?: Maybe<ActivityTypeType>;
  advertiser?: Maybe<TargetType>;
  audience?: Maybe<AudienceType>;
  budget?: Maybe<QuestBudgetType>;
  category?: Maybe<QuestCategoryEnum>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isAccountLinked?: Maybe<Scalars['Boolean']['output']>;
  leaderboard?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<MediaType>;
  performed?: Maybe<Scalars['Boolean']['output']>;
  progress?: Maybe<Scalars['Decimal']['output']>;
  qualitativePicture?: Maybe<PictureType>;
  questType?: Maybe<QuestTypeType>;
  recurrence?: Maybe<QuestActionsRecurrenceType>;
  remuneration?: Maybe<Array<RemunerationDtoType>>;
  rewards?: Maybe<Scalars['String']['output']>;
  sponsored?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<QuestStatusEnum>;
  target: TargetType;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestWithRepeatDateType = {
  __typename?: 'QuestWithRepeatDateType';
  activityType?: Maybe<ActivityTypeType>;
  advertiser?: Maybe<TargetType>;
  audience?: Maybe<AudienceType>;
  budget?: Maybe<QuestBudgetType>;
  category?: Maybe<QuestCategoryEnum>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  leaderboard?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<MediaType>;
  progress?: Maybe<Scalars['Decimal']['output']>;
  questType?: Maybe<QuestTypeType>;
  recurrence?: Maybe<QuestActionsRecurrenceType>;
  remuneration?: Maybe<Array<RemunerationDtoType>>;
  repeatDate?: Maybe<Scalars['DateTime']['output']>;
  rewards?: Maybe<Scalars['String']['output']>;
  sponsored?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<QuestStatusEnum>;
  target: TargetType;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestWithoutTargetType = {
  __typename?: 'QuestWithoutTargetType';
  activityType?: Maybe<ActivityTypeType>;
  audience?: Maybe<AudienceType>;
  budget?: Maybe<QuestBudgetType>;
  category?: Maybe<QuestCategoryEnum>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  leaderboard?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<MediaType>;
  progress?: Maybe<Scalars['Decimal']['output']>;
  questType?: Maybe<QuestTypeType>;
  recurrence?: Maybe<QuestActionsRecurrenceType>;
  remuneration?: Maybe<Array<RemunerationDtoType>>;
  rewards?: Maybe<Scalars['String']['output']>;
  sponsored?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<QuestStatusEnum>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestionChoiceDtoType = {
  __typename?: 'QuestionChoiceDtoType';
  enable?: Maybe<Scalars['Boolean']['output']>;
  item: Scalars['String']['output'];
};

export type QuestionChoiceInput = {
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  item: Scalars['String']['input'];
};

export type QuestionDtoType = {
  __typename?: 'QuestionDtoType';
  choices?: Maybe<Array<QuestionChoiceDtoType>>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  form?: Maybe<FormDtoType>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  settings?: Maybe<QuestionSettingsType>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<QuestionTypeEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestionInput = {
  challengeStep?: InputMaybe<Scalars['ID']['input']>;
  choices?: InputMaybe<Array<QuestionChoiceInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  form?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  settings?: InputMaybe<QuestionSettingsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<QuestionTypeEnum>;
};

export type QuestionPaginateType = {
  __typename?: 'QuestionPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<QuestionDtoType>;
};

export type QuestionResponsesStatsType = {
  __typename?: 'QuestionResponsesStatsType';
  answer?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Decimal']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<ResponseUserType>>;
};

export type QuestionSettingsDateInput = {
  interval: Scalars['Boolean']['input'];
  outdated: Scalars['Boolean']['input'];
};

export type QuestionSettingsDateType = {
  __typename?: 'QuestionSettingsDateType';
  interval?: Maybe<Scalars['Boolean']['output']>;
  outdated?: Maybe<Scalars['Boolean']['output']>;
};

export type QuestionSettingsInput = {
  date?: InputMaybe<QuestionSettingsDateInput>;
  multipleChoice?: InputMaybe<QuestionSettingsPollInput>;
  number?: InputMaybe<QuestionSettingsNumberInput>;
  paragraph?: InputMaybe<QuestionSettingsTextInput>;
  rating?: InputMaybe<QuestionSettingsRatingInput>;
  shortAnswer?: InputMaybe<QuestionSettingsTextInput>;
  singleChoice?: InputMaybe<QuestionSettingsToggleInput>;
  smiley?: InputMaybe<QuestionSettingsSmileyInput>;
};

export type QuestionSettingsNumberInput = {
  maxValue?: InputMaybe<Scalars['Int']['input']>;
  minValue?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionSettingsNumberType = {
  __typename?: 'QuestionSettingsNumberType';
  maxValue?: Maybe<Scalars['Int']['output']>;
  minValue?: Maybe<Scalars['Int']['output']>;
};

export type QuestionSettingsPollInput = {
  poll: Scalars['Boolean']['input'];
};

export type QuestionSettingsPollType = {
  __typename?: 'QuestionSettingsPollType';
  poll: Scalars['Boolean']['output'];
};

export type QuestionSettingsRatingInput = {
  levels: Array<Scalars['Int']['input']>;
};

export type QuestionSettingsRatingType = {
  __typename?: 'QuestionSettingsRatingType';
  levels: Array<Scalars['Int']['output']>;
};

export type QuestionSettingsSmileyInput = {
  levels: Array<QuestionSettingsSmileyObjInput>;
};

export type QuestionSettingsSmileyObjInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  rank: Scalars['Float']['input'];
};

export type QuestionSettingsSmileyObjType = {
  __typename?: 'QuestionSettingsSmileyObjType';
  icon?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  rank: Scalars['Float']['output'];
};

export type QuestionSettingsSmileyType = {
  __typename?: 'QuestionSettingsSmileyType';
  levels?: Maybe<Array<QuestionSettingsSmileyObjType>>;
};

export type QuestionSettingsTextInput = {
  max: Scalars['Float']['input'];
  min: Scalars['Float']['input'];
};

export type QuestionSettingsTextType = {
  __typename?: 'QuestionSettingsTextType';
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
};

export type QuestionSettingsToggleInput = {
  poll: Scalars['Boolean']['input'];
  toggle: Scalars['Boolean']['input'];
};

export type QuestionSettingsToggleType = {
  __typename?: 'QuestionSettingsToggleType';
  poll: Scalars['Boolean']['output'];
  toggle: Scalars['Boolean']['output'];
};

export type QuestionSettingsType = {
  __typename?: 'QuestionSettingsType';
  date?: Maybe<QuestionSettingsDateType>;
  multipleChoice?: Maybe<QuestionSettingsPollType>;
  number?: Maybe<QuestionSettingsNumberType>;
  paragraph?: Maybe<QuestionSettingsTextType>;
  rating?: Maybe<QuestionSettingsRatingType>;
  shortAnswer?: Maybe<QuestionSettingsTextType>;
  singleChoice?: Maybe<QuestionSettingsToggleType>;
  smiley?: Maybe<QuestionSettingsSmileyType>;
};

export type QuestionSimplePaginateType = {
  __typename?: 'QuestionSimplePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<QuestionSimpleType>;
};

export type QuestionSimpleType = {
  __typename?: 'QuestionSimpleType';
  choices?: Maybe<Array<QuestionChoiceDtoType>>;
  description?: Maybe<Scalars['String']['output']>;
  response: ResponseAnswerType;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<QuestionTypeEnum>;
  user: SimpleUserType;
};

export enum QuestionTypeEnum {
  DATETIME = 'DATETIME',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  NUMBER = 'NUMBER',
  PARAGRAPH = 'PARAGRAPH',
  RATING = 'RATING',
  SHORT_ANSWER = 'SHORT_ANSWER',
  SINGLE_CHOICE = 'SINGLE_CHOICE',
  SMILEY = 'SMILEY'
}

export type QuestionWithResponsesStatsPaginateType = {
  __typename?: 'QuestionWithResponsesStatsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<QuestionWithResponsesStatsType>;
};

export type QuestionWithResponsesStatsType = {
  __typename?: 'QuestionWithResponsesStatsType';
  choices?: Maybe<Array<QuestionChoiceDtoType>>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  form?: Maybe<FormDtoType>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  responses?: Maybe<Array<QuestionResponsesStatsType>>;
  settings?: Maybe<QuestionSettingsType>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<QuestionTypeEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestsByTargetAndUserAudienceInput = {
  reversed?: InputMaybe<Scalars['Boolean']['input']>;
  target: TargetAciInput;
};

export type QuestsByTargetAndUserAudienceWithPerformedInput = {
  performed?: InputMaybe<Scalars['Boolean']['input']>;
  reversed?: InputMaybe<Scalars['Boolean']['input']>;
  target: TargetAciInput;
};

export type QuestsFilterInput = {
  createdAt?: InputMaybe<TimeFromToInput>;
  dueDate?: InputMaybe<TimeFromToInput>;
  reversed?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<TimeFromToInput>;
  status?: InputMaybe<Array<QuestStatusEnum>>;
  users?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QuotationConversionType = {
  __typename?: 'QuotationConversionType';
  deliveryNote?: Maybe<SaleDeliveryNoteType>;
  invoice?: Maybe<SaleInvoiceType>;
  order?: Maybe<SaleOrderType>;
};

export type QuotationType = {
  __typename?: 'QuotationType';
  address?: Maybe<InvoicingAddressType>;
  bank?: Maybe<BankDetailsType>;
  conversion?: Maybe<QuotationConversionType>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  currency: CurrencyType;
  customer?: Maybe<SaleCustomerType>;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<KeyValueType>>;
  id: Scalars['ID']['output'];
  installments?: Maybe<Array<InstallmentType>>;
  logistic?: Maybe<LogisticType>;
  note?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  products?: Maybe<Array<InvoicingProductsBundleType>>;
  project?: Maybe<ProjectType>;
  status?: Maybe<GenericInvoicingStatusEnum>;
  target: TargetType;
  taxes?: Maybe<Array<TaxRankType>>;
  toPay?: Maybe<Scalars['Decimal']['output']>;
  totalPrice?: Maybe<InvoicingPriceType>;
  totalTax?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RatingsCountType = {
  __typename?: 'RatingsCountType';
  fiveStarsDaily: Array<PeriodStatsType>;
  fourStarsDaily: Array<PeriodStatsType>;
  inPeriod: Scalars['Int']['output'];
  oneStarDaily: Array<PeriodStatsType>;
  threeStarsDaily: Array<PeriodStatsType>;
  total: Scalars['Int']['output'];
  twoStarsDaily: Array<PeriodStatsType>;
};

export type RecentlyViewedInternalProductWithFavoriteStatusType = {
  __typename?: 'RecentlyViewedInternalProductWithFavoriteStatusType';
  barcodes?: Maybe<Array<BarcodeWithPublicPriceType>>;
  brand?: Maybe<BrandType>;
  catalogueCategory?: Maybe<Array<CatalogueCategoryType>>;
  classification?: Maybe<Array<ProductClassEnum>>;
  condition?: Maybe<ProductConditionEnum>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionList?: Maybe<Array<Scalars['String']['output']>>;
  discount?: Maybe<DiscountDtoType>;
  externalId?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<ProductFlagEnum>>;
  globalCategory?: Maybe<GlobalCategoryProductType>;
  id?: Maybe<Scalars['ID']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  longdesc?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceBeforeReduction?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductType>;
  rent?: Maybe<Scalars['Boolean']['output']>;
  seo?: Maybe<CatalogueCategorySeoType>;
  sku?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Array<ProductSpecsType>>;
  status?: Maybe<ProductStatusEnum>;
  structure?: Maybe<ProductStructureEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  tax?: Maybe<Scalars['Decimal']['output']>;
  translation?: Maybe<Array<InternalProductTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variety?: Maybe<ProductVarietyEnum>;
};

export type RecentlyViewedType = {
  __typename?: 'RecentlyViewedType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  product: InternalProductType;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export enum RecurrenceType {
  DAILY = 'DAILY',
  HOURLY = 'HOURLY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  YEARLY = 'YEARLY'
}

export type ReduciblePriceInput = {
  afterReduction?: InputMaybe<Scalars['Decimal']['input']>;
  beforeReduction?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ReduciblePriceType = {
  __typename?: 'ReduciblePriceType';
  afterReduction?: Maybe<Scalars['Decimal']['output']>;
  beforeReduction?: Maybe<Scalars['Decimal']['output']>;
};

export type ReferralPaginateType = {
  __typename?: 'ReferralPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ReferralType>;
};

export type ReferralRemunerationObjectType = {
  __typename?: 'ReferralRemunerationObjectType';
  qualitative?: Maybe<RemunerationWithReputationAmountType>;
  quantitative?: Maybe<RemunerationWithReputationQuantitativeType>;
};

export type ReferralRemunerationType = {
  __typename?: 'ReferralRemunerationType';
  referred?: Maybe<ReferralRemunerationObjectType>;
  referrer?: Maybe<ReferralRemunerationObjectType>;
};

export type ReferralType = {
  __typename?: 'ReferralType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  reference: Scalars['String']['output'];
  referred?: Maybe<UserType>;
  referrer: UserType;
  remuneration?: Maybe<ReferralRemunerationType>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type RemunerationDtoType = {
  __typename?: 'RemunerationDtoType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  wallet?: Maybe<WalletType>;
  walletType?: Maybe<WalletTypeEnum>;
};

export type RemunerationInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  walletType: WalletTypeEnum;
};

export type RemunerationWithReferralInput = {
  qualitative?: InputMaybe<RemunerationWithReputationQuantitativeInput>;
  quantitative?: InputMaybe<RemunerationWithReputationQuantitativeInput>;
};

export type RemunerationWithReputationAmountInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
};

export type RemunerationWithReputationAmountType = {
  __typename?: 'RemunerationWithReputationAmountType';
  amount: Scalars['Decimal']['output'];
};

export type RemunerationWithReputationDtoType = {
  __typename?: 'RemunerationWithReputationDtoType';
  qualitative: RemunerationWithReputationAmountType;
  quantitative: RemunerationWithReputationQuantitativeType;
  reputationLevel?: Maybe<ReputationType>;
};

export type RemunerationWithReputationInput = {
  qualitative?: InputMaybe<RemunerationWithReputationQuantitativeInput>;
  quantitative?: InputMaybe<RemunerationWithReputationQuantitativeInput>;
  reputationLevel?: InputMaybe<Scalars['ID']['input']>;
};

export type RemunerationWithReputationLeanDtoType = {
  __typename?: 'RemunerationWithReputationLeanDtoType';
  qualitative: RemunerationWithReputationAmountType;
  quantitative: RemunerationWithReputationQuantitativeType;
  reputationLevel?: Maybe<Scalars['ID']['output']>;
};

export type RemunerationWithReputationQuantitativeInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  wallet?: InputMaybe<Scalars['ID']['input']>;
};

export type RemunerationWithReputationQuantitativeType = {
  __typename?: 'RemunerationWithReputationQuantitativeType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  wallet?: Maybe<WalletType>;
};

export type RentalInvoicingProductsType = {
  __typename?: 'RentalInvoicingProductsType';
  article?: Maybe<BarcodeType>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<DiscountDtoType>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Decimal']['output']>;
};

export type RentalInvoicingType = {
  __typename?: 'RentalInvoicingType';
  address?: Maybe<InvoicingAddressType>;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logistic?: Maybe<LogisticType>;
  number: Scalars['String']['output'];
  project?: Maybe<ProjectType>;
  status?: Maybe<GenericInvoicingStatusEnum>;
  toPay?: Maybe<Scalars['Decimal']['output']>;
  totalPrice?: Maybe<InvoicingPriceType>;
  totalTax?: Maybe<Scalars['Decimal']['output']>;
};

export type RentalNoteType = {
  __typename?: 'RentalNoteType';
  delivery?: Maybe<Scalars['String']['output']>;
  returning?: Maybe<Scalars['String']['output']>;
};

export type RentalRefType = {
  __typename?: 'RentalRefType';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  end: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  note?: Maybe<RentalNoteType>;
  start: Scalars['DateTime']['output'];
  status?: Maybe<RentalStatusEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum RentalStatusEnum {
  DELIVERED = 'DELIVERED',
  DELIVERING = 'DELIVERING',
  READY_FOR_PICKUP = 'READY_FOR_PICKUP',
  RETURNED = 'RETURNED',
  RETURNING = 'RETURNING'
}

export type RentalType = {
  __typename?: 'RentalType';
  createdAt: Scalars['DateTime']['output'];
  deliveryNote?: Maybe<RentalInvoicingType>;
  description?: Maybe<Scalars['String']['output']>;
  end: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invoice?: Maybe<RentalInvoicingType>;
  location?: Maybe<Scalars['String']['output']>;
  note?: Maybe<RentalNoteType>;
  order?: Maybe<RentalInvoicingType>;
  product?: Maybe<RentalInvoicingProductsType>;
  start: Scalars['DateTime']['output'];
  status?: Maybe<RentalStatusEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ReputationContentInput = {
  description: Scalars['String']['input'];
  reputationLevel: Scalars['String']['input'];
};

export type ReputationPaginateType = {
  __typename?: 'ReputationPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ReputationType>;
};

export type ReputationSimpleType = {
  __typename?: 'ReputationSimpleType';
  color?: Maybe<Scalars['String']['output']>;
  perks?: Maybe<PerksType>;
  reputationLevel?: Maybe<Scalars['String']['output']>;
};

export type ReputationTranslationContentType = {
  __typename?: 'ReputationTranslationContentType';
  description: Scalars['String']['output'];
  reputationLevel: Scalars['String']['output'];
};

export type ReputationTranslationInput = {
  content: ReputationContentInput;
  language: Scalars['ID']['input'];
};

export type ReputationTranslationType = {
  __typename?: 'ReputationTranslationType';
  content: ReputationTranslationContentType;
  language: LanguageType;
};

export type ReputationType = {
  __typename?: 'ReputationType';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  frequencyGoalEnabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  inactivityCycle?: Maybe<Scalars['Int']['output']>;
  levelInterval?: Maybe<LevelIntervalType>;
  lossAmount?: Maybe<Scalars['Int']['output']>;
  lossPoints?: Maybe<Scalars['Int']['output']>;
  nextLevelMax?: Maybe<Scalars['Int']['output']>;
  period?: Maybe<Scalars['Int']['output']>;
  perks?: Maybe<PerksType>;
  picture?: Maybe<PictureType>;
  rank?: Maybe<Scalars['Int']['output']>;
  reputationLevel?: Maybe<Scalars['String']['output']>;
  target: TargetType;
  translation?: Maybe<Array<ReputationTranslationType>>;
  turnoverGoalEnabled?: Maybe<Scalars['Boolean']['output']>;
  turnoverPoints?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ReputationWithoutTargetType = {
  __typename?: 'ReputationWithoutTargetType';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  frequencyGoalEnabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  inactivityCycle?: Maybe<Scalars['Int']['output']>;
  levelInterval?: Maybe<LevelIntervalType>;
  lossAmount?: Maybe<Scalars['Int']['output']>;
  lossPoints?: Maybe<Scalars['Int']['output']>;
  nextLevelMax?: Maybe<Scalars['Int']['output']>;
  period?: Maybe<Scalars['Int']['output']>;
  perks?: Maybe<PerksType>;
  picture?: Maybe<PictureType>;
  rank?: Maybe<Scalars['Int']['output']>;
  reputationLevel?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Array<ReputationTranslationType>>;
  turnoverGoalEnabled?: Maybe<Scalars['Boolean']['output']>;
  turnoverPoints?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RequestCompanyType = {
  __typename?: 'RequestCompanyType';
  address?: Maybe<FullAddressType>;
  email?: Maybe<Scalars['String']['output']>;
  licenceNo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<IPhoneType>;
  registerNo?: Maybe<Scalars['String']['output']>;
  vatId?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type RequestKeyValueType = {
  __typename?: 'RequestKeyValueType';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type RequestRequestType = {
  __typename?: 'RequestRequestType';
  content?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type RequestRequestorType = {
  __typename?: 'RequestRequestorType';
  address?: Maybe<FullAddressType>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<IPhoneType>;
};

export enum RequestStatusEnum {
  CLOSED = 'CLOSED',
  REQUESTED = 'REQUESTED',
  TREATED = 'TREATED'
}

export type RequestType = {
  __typename?: 'RequestType';
  company?: Maybe<RequestCompanyType>;
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Array<RequestKeyValueType>>;
  id: Scalars['ID']['output'];
  request?: Maybe<RequestRequestType>;
  requestor?: Maybe<RequestRequestorType>;
  status?: Maybe<RequestStatusEnum>;
  target?: Maybe<TargetType>;
  type?: Maybe<RequestTypeEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum RequestTypeEnum {
  CONTACT = 'CONTACT',
  DEMO = 'DEMO',
  PARTNER = 'PARTNER'
}

export type ResetPasswordForAppInput = {
  password: Scalars['String']['input'];
  phone?: InputMaybe<IPhoneInput>;
  smsValidationCode?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type ResponseAnswerInput = {
  date?: InputMaybe<TimeFromToInput>;
  multipleChoices?: InputMaybe<Array<Scalars['String']['input']>>;
  number?: InputMaybe<Scalars['Int']['input']>;
  paragraph?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  shortAnswer?: InputMaybe<Scalars['String']['input']>;
  singleChoice?: InputMaybe<Scalars['String']['input']>;
  smiley?: InputMaybe<ResponseAnswerSmileyObjInput>;
};

export type ResponseAnswerSmileyObjInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
};

export type ResponseAnswerSmileyObjType = {
  __typename?: 'ResponseAnswerSmileyObjType';
  icon?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
};

export type ResponseAnswerType = {
  __typename?: 'ResponseAnswerType';
  date?: Maybe<TimeFromToType>;
  multipleChoices?: Maybe<Array<Scalars['String']['output']>>;
  number?: Maybe<Scalars['Int']['output']>;
  paragraph?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  shortAnswer?: Maybe<Scalars['String']['output']>;
  singleChoice?: Maybe<Scalars['String']['output']>;
  smiley?: Maybe<ResponseAnswerSmileyObjType>;
};

export type ResponseDtoType = {
  __typename?: 'ResponseDtoType';
  answers: ResponseAnswerType;
  createdAt: Scalars['DateTime']['output'];
  executor: UserType;
  id: Scalars['ID']['output'];
  question: QuestionDtoType;
  target: TargetDtoType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ResponseFilterInput = {
  executors?: InputMaybe<Array<Scalars['String']['input']>>;
  forms?: InputMaybe<Array<Scalars['String']['input']>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  pos?: InputMaybe<Array<Scalars['String']['input']>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  users?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ResponseInput = {
  answers: ResponseAnswerInput;
  question: Scalars['ID']['input'];
  target?: InputMaybe<TargetInput>;
};

export type ResponsePaginateType = {
  __typename?: 'ResponsePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<ResponseDtoType>;
};

export type ResponseUserType = {
  __typename?: 'ResponseUserType';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
};

export type RolesCountType = {
  __typename?: 'RolesCountType';
  countByRoles: Array<AccountsByRoleCountType>;
  numberOfManufacturersRoles: Scalars['Int']['output'];
  numberOfPosRoles: Scalars['Int']['output'];
  numberOfWholesalersRoles: Scalars['Int']['output'];
};

export type RoundPaginateType = {
  __typename?: 'RoundPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<RoundType>;
};

export type RoundType = {
  __typename?: 'RoundType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  league: Scalars['Int']['output'];
  rounds: Array<Scalars['String']['output']>;
  season: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum RoundsEnum {
  FINAL = 'FINAL',
  QUARTER_FINAL = 'QUARTER_FINAL',
  ROUND_16 = 'ROUND_16',
  SEMI_FINAL = 'SEMI_FINAL',
  THIRD_PLACE = 'THIRD_PLACE'
}

export type SeoAuditDataType = {
  __typename?: 'SEOAuditDataType';
  brokenImages?: Maybe<Array<Scalars['String']['output']>>;
  brokenImagesCount?: Maybe<Scalars['Int']['output']>;
  brokenLinks?: Maybe<Array<Scalars['String']['output']>>;
  brokenLinksCount?: Maybe<Scalars['Int']['output']>;
  externalBrokenLinks?: Maybe<Array<Scalars['String']['output']>>;
  externalBrokenLinksCount?: Maybe<Scalars['Int']['output']>;
  faviconExists?: Maybe<Scalars['Boolean']['output']>;
  h1?: Maybe<Scalars['String']['output']>;
  internalNoFollowLinks?: Maybe<Array<Scalars['String']['output']>>;
  internalNoFollowLinksCount?: Maybe<Scalars['Int']['output']>;
  isAmp?: Maybe<Scalars['Boolean']['output']>;
  isCharacterEncode?: Maybe<Scalars['Boolean']['output']>;
  isContentEnoughLong?: Maybe<Scalars['Boolean']['output']>;
  isDoctype?: Maybe<Scalars['Boolean']['output']>;
  isGoogleAnalyticsFunc?: Maybe<Scalars['Boolean']['output']>;
  isGoogleAnalyticsObject?: Maybe<Scalars['Boolean']['output']>;
  isH1?: Maybe<Scalars['Boolean']['output']>;
  isH1OnlyOne?: Maybe<Scalars['Boolean']['output']>;
  isH2?: Maybe<Scalars['Boolean']['output']>;
  isLoaded?: Maybe<Scalars['Boolean']['output']>;
  isMetaDescription?: Maybe<Scalars['Boolean']['output']>;
  isMetaDescriptionEnoughLong?: Maybe<Scalars['Boolean']['output']>;
  isNotIframe?: Maybe<Scalars['Boolean']['output']>;
  isTitle?: Maybe<Scalars['Boolean']['output']>;
  isTitleEnoughLong?: Maybe<Scalars['Boolean']['output']>;
  isTooEnoughLinks?: Maybe<Scalars['Boolean']['output']>;
  isViewport?: Maybe<Scalars['Boolean']['output']>;
  linksCount?: Maybe<Scalars['Int']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  notOptimizedImages?: Maybe<Array<Scalars['String']['output']>>;
  notOptimizedImagesCount?: Maybe<Scalars['Int']['output']>;
  pageIsBlocked?: Maybe<Scalars['Boolean']['output']>;
  robotsFileExists?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  wordsCount?: Maybe<Scalars['Int']['output']>;
};

export type SeoType = {
  __typename?: 'SEOType';
  createdAt: Scalars['DateTime']['output'];
  googleAnalyticsId?: Maybe<Scalars['String']['output']>;
  headerTags?: Maybe<Array<TagType>>;
  id: Scalars['ID']['output'];
  metaDescriptionTag?: Maybe<Scalars['String']['output']>;
  target: TargetType;
  titleTag?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SaleCustomerType = {
  __typename?: 'SaleCustomerType';
  customer?: Maybe<CompanyType>;
  details?: Maybe<Array<KeyValueType>>;
};

export type SaleDeliveryNoteOriginType = {
  __typename?: 'SaleDeliveryNoteOriginType';
  order?: Maybe<SaleOrderType>;
  quotation?: Maybe<QuotationType>;
};

export type SaleDeliveryNoteType = {
  __typename?: 'SaleDeliveryNoteType';
  address?: Maybe<InvoicingAddressType>;
  bank?: Maybe<BankDetailsType>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  currency: CurrencyType;
  customer?: Maybe<SaleCustomerType>;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<KeyValueType>>;
  id: Scalars['ID']['output'];
  installments?: Maybe<Array<InstallmentType>>;
  logistic?: Maybe<LogisticType>;
  note?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  origin?: Maybe<SaleDeliveryNoteOriginType>;
  products?: Maybe<Array<InvoicingProductsBundleType>>;
  project?: Maybe<ProjectType>;
  status?: Maybe<GenericInvoicingStatusEnum>;
  target: TargetType;
  taxes?: Maybe<Array<TaxRankType>>;
  toPay?: Maybe<Scalars['Decimal']['output']>;
  totalPrice?: Maybe<InvoicingPriceType>;
  totalTax?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  warehouse?: Maybe<WarehouseType>;
};

export type SaleInvoiceOriginType = {
  __typename?: 'SaleInvoiceOriginType';
  order?: Maybe<SaleOrderType>;
  quotation?: Maybe<QuotationType>;
};

export type SaleInvoiceType = {
  __typename?: 'SaleInvoiceType';
  address?: Maybe<InvoicingAddressType>;
  bank?: Maybe<BankDetailsType>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  currency: CurrencyType;
  customer?: Maybe<SaleCustomerType>;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<KeyValueType>>;
  id: Scalars['ID']['output'];
  installments?: Maybe<Array<InstallmentType>>;
  logistic?: Maybe<LogisticType>;
  note?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  origin?: Maybe<SaleInvoiceOriginType>;
  products?: Maybe<Array<InvoicingProductsBundleType>>;
  project?: Maybe<ProjectType>;
  status?: Maybe<GenericInvoicingStatusEnum>;
  target: TargetType;
  taxes?: Maybe<Array<TaxRankType>>;
  toPay?: Maybe<Scalars['Decimal']['output']>;
  totalPrice?: Maybe<InvoicingPriceType>;
  totalTax?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SaleIssueNoteType = {
  __typename?: 'SaleIssueNoteType';
  address?: Maybe<InvoicingAddressType>;
  bank?: Maybe<BankDetailsType>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  currency: CurrencyType;
  customer?: Maybe<SaleCustomerType>;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<KeyValueType>>;
  id: Scalars['ID']['output'];
  installments?: Maybe<Array<InstallmentType>>;
  logistic?: Maybe<LogisticType>;
  note?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  products?: Maybe<Array<InvoicingProductsBundleType>>;
  project?: Maybe<ProjectType>;
  status?: Maybe<GenericInvoicingStatusEnum>;
  target: TargetType;
  taxes?: Maybe<Array<TaxRankType>>;
  toPay?: Maybe<Scalars['Decimal']['output']>;
  totalPrice?: Maybe<InvoicingPriceType>;
  totalTax?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SaleOrderConversionType = {
  __typename?: 'SaleOrderConversionType';
  deliveryNote?: Maybe<SaleDeliveryNoteType>;
  invoice?: Maybe<SaleInvoiceType>;
};

export type SaleOrderOriginType = {
  __typename?: 'SaleOrderOriginType';
  quotation?: Maybe<QuotationType>;
};

export type SaleOrderType = {
  __typename?: 'SaleOrderType';
  address?: Maybe<InvoicingAddressType>;
  bank?: Maybe<BankDetailsType>;
  conversion?: Maybe<SaleOrderConversionType>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  currency: CurrencyType;
  customer?: Maybe<SaleCustomerType>;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<KeyValueType>>;
  id: Scalars['ID']['output'];
  installments?: Maybe<Array<InstallmentType>>;
  logistic?: Maybe<LogisticType>;
  note?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  origin?: Maybe<SaleOrderOriginType>;
  products?: Maybe<Array<InvoicingProductsBundleType>>;
  project?: Maybe<ProjectType>;
  status?: Maybe<GenericInvoicingStatusEnum>;
  target: TargetType;
  taxes?: Maybe<Array<TaxRankType>>;
  toPay?: Maybe<Scalars['Decimal']['output']>;
  totalPrice?: Maybe<InvoicingPriceType>;
  totalTax?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SalesAnalyticsRevenueStatsChartType = {
  __typename?: 'SalesAnalyticsRevenueStatsChartType';
  orders: Array<Scalars['Decimal']['output']>;
  paid: Array<Scalars['Decimal']['output']>;
  partiallyPaid: Array<Scalars['Decimal']['output']>;
  unpaid: Array<Scalars['Decimal']['output']>;
};

export type SalesAnalyticsSalesByCountrySegmentsType = {
  __typename?: 'SalesAnalyticsSalesByCountrySegmentsType';
  country?: Maybe<CountryType>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type SalesIntegrationDocumentQuotationType = {
  __typename?: 'SalesIntegrationDocumentQuotationType';
  color?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<DocumentReferenceModelEnum>;
  validity?: Maybe<SalesIntegrationDocumentQuotationValidityType>;
};

export type SalesIntegrationDocumentQuotationValidityType = {
  __typename?: 'SalesIntegrationDocumentQuotationValidityType';
  cycle?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['String']['output']>;
};

export type SalesIntegrationDocumentType = {
  __typename?: 'SalesIntegrationDocumentType';
  deliveryNote?: Maybe<SalesIntegrationDocumentQuotationType>;
  invoice?: Maybe<SalesIntegrationDocumentQuotationType>;
  issueNote?: Maybe<SalesIntegrationDocumentQuotationType>;
  order?: Maybe<SalesIntegrationDocumentQuotationType>;
  quotation?: Maybe<SalesIntegrationDocumentQuotationType>;
};

export type ScriptItemType = {
  __typename?: 'ScriptItemType';
  content?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SearchCorporateUsersByTargetInput = {
  createdAt?: InputMaybe<FromToInput>;
  dateOfBirthRange?: InputMaybe<FromToInput>;
  gender?: InputMaybe<Array<Gender>>;
  maritalStatus?: InputMaybe<Array<MaritalStatus>>;
  pagination?: InputMaybe<PaginationInput>;
  roles?: InputMaybe<Array<UserRole>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  sortingField?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<UserStatus>>;
  target: TargetAciInput;
};

export type SearchSimpleProductInput = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ProductStatusEnum>>;
  target: TargetAciInput;
};

export type SearchTargetQualitativeWalletsPaginatedInput = {
  isPrelevel?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  reputationsLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};

export type SearchTargetSubscribersPaginatedInput = {
  isPrelevel?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  reputationsLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<SubscriptionStatus>>;
  target: TargetAciInput;
};

export type SeasonPaginateType = {
  __typename?: 'SeasonPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<SeasonType>;
};

export type SeasonType = {
  __typename?: 'SeasonType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  season: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SeasonsType = {
  __typename?: 'SeasonsType';
  coverage?: Maybe<CoverageType>;
  current?: Maybe<Scalars['Boolean']['output']>;
  end?: Maybe<Scalars['DateTime']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type SegmentsDefinitionsInput = {
  criteria?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AudienceSegmentFilterInput>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<AudienceSegmentFilterValueInput>;
};

export type SegmentsDefinitionsType = {
  __typename?: 'SegmentsDefinitionsType';
  criteria?: Maybe<AudienceCriteriaType>;
  filter?: Maybe<AudienceSegmentFilterType>;
  rank?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<AudienceSegmentFilterValuesType>;
};

export type SendTargetQualitativeWalletsByEmailInput = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  isPrelevel?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  reputationsLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
};

export type SendTargetSubscribersBymailnput = {
  emails: Array<Scalars['String']['input']>;
  isPrelevel?: InputMaybe<Scalars['Boolean']['input']>;
  reputationsLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<SubscriptionStatus>>;
  subject: Scalars['String']['input'];
  target: TargetAciInput;
};

export type SeoComponentType = {
  __typename?: 'SeoComponentType';
  metaDesription?: Maybe<Scalars['String']['output']>;
  metaKeywords?: Maybe<Array<TagType>>;
  metaTitle?: Maybe<Scalars['String']['output']>;
};

export enum SequenceCategoryEnum {
  PURCHASE_DELIVERY_NOTE = 'PURCHASE_DELIVERY_NOTE',
  PURCHASE_INVOICE = 'PURCHASE_INVOICE',
  PURCHASE_ORDER = 'PURCHASE_ORDER',
  QUOTATION = 'QUOTATION',
  SALE_DELIVERY_NOTE = 'SALE_DELIVERY_NOTE',
  SALE_INVOICE = 'SALE_INVOICE',
  SALE_ISSUE_NOTE = 'SALE_ISSUE_NOTE',
  SALE_ORDER = 'SALE_ORDER'
}

export type SettingsAttributeType = {
  __typename?: 'SettingsAttributeType';
  attribute: BookingAttributeType;
  value: Scalars['String']['output'];
};

export type ShoppingCartsForTargetType = {
  __typename?: 'ShoppingCartsForTargetType';
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<DiscountDtoType>;
  id: Scalars['ID']['output'];
  price?: Maybe<PriceFullType>;
  products?: Maybe<Array<CartProductForTargetType>>;
  target?: Maybe<TargetType>;
  taxValue?: Maybe<ReduciblePriceType>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type ShoppingCartsType = {
  __typename?: 'ShoppingCartsType';
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<DiscountDtoType>;
  id: Scalars['ID']['output'];
  price?: Maybe<PriceFullType>;
  products?: Maybe<Array<CartProductForTargetType>>;
  target?: Maybe<TargetType>;
  taxValue?: Maybe<ReduciblePriceType>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type ShortcutType = {
  __typename?: 'ShortcutType';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  link: Scalars['String']['output'];
  picture?: Maybe<PictureType>;
  router: Scalars['Boolean']['output'];
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type SidelinedInnerType = {
  __typename?: 'SidelinedInnerType';
  end?: Maybe<Scalars['DateTime']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SidelinedPaginateType = {
  __typename?: 'SidelinedPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<SidelinedType>;
};

export type SidelinedType = {
  __typename?: 'SidelinedType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  sideLined: Array<SidelinedInnerType>;
  target: ApiTargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type SimpleBrandType = {
  __typename?: 'SimpleBrandType';
  createdAt: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SimpleTargetWithUserType = {
  __typename?: 'SimpleTargetWithUserType';
  /** manufacturer id. */
  manufacturer?: Maybe<Scalars['ID']['output']>;
  /** PointOfSale id. */
  pos?: Maybe<Scalars['ID']['output']>;
  /** user */
  user?: Maybe<UserType>;
  /** wholesaler id. */
  wholesaler?: Maybe<Scalars['ID']['output']>;
};

export type SimpleUserType = {
  __typename?: 'SimpleUserType';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
};

export type SimpleUserWithWalletsPaginateType = {
  __typename?: 'SimpleUserWithWalletsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<SimpleUserWithWalletsType>;
};

export type SimpleUserWithWalletsType = {
  __typename?: 'SimpleUserWithWalletsType';
  about?: Maybe<Scalars['String']['output']>;
  apps?: Maybe<Array<App>>;
  billingAddress?: Maybe<Array<FullAddressType>>;
  chatContact?: Maybe<Array<SocialValueType>>;
  covers?: Maybe<Array<PictureType>>;
  createdAt: Scalars['DateTime']['output'];
  custom?: Maybe<Array<UserCustomType>>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  education?: Maybe<Array<UserEducationType>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  hasAutoGeneratedEmail?: Maybe<Scalars['Boolean']['output']>;
  hobbies?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  interests?: Maybe<Array<Scalars['String']['output']>>;
  isMailValid?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<LanguageType>>;
  lastName?: Maybe<Scalars['String']['output']>;
  lived?: Maybe<Array<StateType>>;
  locale?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<MaritalStatus>;
  mobileTheme?: Maybe<MobileThemesEnum>;
  nationality?: Maybe<CountryType>;
  newsletterSubs?: Maybe<Scalars['Boolean']['output']>;
  permission?: Maybe<PermissionType>;
  phone?: Maybe<PhoneType>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  placeOfBirth?: Maybe<Scalars['String']['output']>;
  plugged?: Maybe<Scalars['Boolean']['output']>;
  residentialAddress?: Maybe<Array<FullAddressType>>;
  roles?: Maybe<Array<UserRole>>;
  shippingAddress?: Maybe<Array<FullAddressType>>;
  socialLoginData?: Maybe<SocialLoginDataType>;
  socialMedia?: Maybe<Array<SocialValueType>>;
  source?: Maybe<SourcesEnum>;
  status?: Maybe<UserStatus>;
  target?: Maybe<TargetIdsType>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
  wallets?: Maybe<Array<SimpleWalletType>>;
  widget?: Maybe<Scalars['Boolean']['output']>;
  work?: Maybe<Array<UserWorkType>>;
};

export type SimpleWalletType = {
  __typename?: 'SimpleWalletType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  coin?: Maybe<CoinSimpleType>;
  fee?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  walletType?: Maybe<WalletTypeEnum>;
};

export type SingleAnswerDtoType = {
  __typename?: 'SingleAnswerDtoType';
  answer: ResponseAnswerType;
  count: Scalars['Int']['output'];
  percentage: Scalars['Decimal']['output'];
};

export type SingleMediaInput = {
  deg360?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<PictureInput>;
  videos?: InputMaybe<Scalars['String']['input']>;
};

export enum SlideVisualTypeEnum {
  ICON = 'ICON',
  PICTURE = 'PICTURE'
}

export type SlidesContentCallToActionType = {
  __typename?: 'SlidesContentCallToActionType';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type SlidesContentType = {
  __typename?: 'SlidesContentType';
  calltoaction?: Maybe<SlidesContentCallToActionType>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  image?: Maybe<PictureType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SlidesTranslationType = {
  __typename?: 'SlidesTranslationType';
  content: Array<SlidesContentType>;
  language: LanguageType;
};

export type SlidesType = {
  __typename?: 'SlidesType';
  content?: Maybe<Array<SlidesContentType>>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  target: TargetType;
  translation?: Maybe<Array<SlidesTranslationType>>;
  updatedAt: Scalars['DateTime']['output'];
  visualType?: Maybe<SlideVisualTypeEnum>;
};

export enum SmsActionEnum {
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  ORDER_CREATED = 'ORDER_CREATED',
  PRODUCT_CANCELED = 'PRODUCT_CANCELED',
  PRODUCT_CONFIRMED = 'PRODUCT_CONFIRMED',
  PRODUCT_DELIVERED = 'PRODUCT_DELIVERED',
  PRODUCT_PICKUP_READY = 'PRODUCT_PICKUP_READY',
  REGISTRATION_CONFIRMATION = 'REGISTRATION_CONFIRMATION',
  REGISTRATION_REQUEST = 'REGISTRATION_REQUEST',
  VALIDATE_PHONE = 'VALIDATE_PHONE'
}

export enum SmsGatewayEnum {
  TUNISIE_SMS = 'TUNISIE_SMS'
}

export type SmsIntegrationAccessInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
};

export type SmsIntegrationAccessType = {
  __typename?: 'SmsIntegrationAccessType';
  key?: Maybe<Scalars['String']['output']>;
  sender?: Maybe<Scalars['String']['output']>;
};

export type SmsIntegrationActionInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  definition?: InputMaybe<SmsActionEnum>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  translation?: InputMaybe<Array<SmsIntegrationActionTranslationInput>>;
};

export type SmsIntegrationActionTranslationInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['ID']['input']>;
};

export type SmsIntegrationActionTranslationType = {
  __typename?: 'SmsIntegrationActionTranslationType';
  content?: Maybe<Scalars['String']['output']>;
  language?: Maybe<LanguageType>;
};

export type SmsIntegrationActionType = {
  __typename?: 'SmsIntegrationActionType';
  content?: Maybe<Scalars['String']['output']>;
  definition?: Maybe<SmsActionEnum>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  translation?: Maybe<Array<SmsIntegrationActionTranslationType>>;
};

export type SmsIntegrationInput = {
  access?: InputMaybe<SmsIntegrationAccessInput>;
  actions?: InputMaybe<Array<SmsIntegrationActionInput>>;
  gateway?: InputMaybe<SmsGatewayEnum>;
  target?: InputMaybe<TargetAciInput>;
};

export type SmsIntegrationResponseType = {
  __typename?: 'SmsIntegrationResponseType';
  messageId: Scalars['String']['output'];
  statusCode: Scalars['String']['output'];
  statusMobile: Scalars['String']['output'];
  statusMsg: Scalars['String']['output'];
};

export type SmsIntegrationType = {
  __typename?: 'SmsIntegrationType';
  access?: Maybe<SmsIntegrationAccessType>;
  actions?: Maybe<Array<SmsIntegrationActionType>>;
  createdAt: Scalars['DateTime']['output'];
  gateway?: Maybe<SmsGatewayEnum>;
  id: Scalars['ID']['output'];
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type SmsLogType = {
  __typename?: 'SmsLogType';
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  expirationDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  phone?: Maybe<IPhoneType>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  validationNumber?: Maybe<Scalars['Int']['output']>;
};

export enum SocialActionEnum {
  LIKE = 'LIKE',
  SHARE = 'SHARE'
}

export enum SocialContentTypeEnum {
  PAGE = 'PAGE',
  POST = 'POST',
  PROFILE = 'PROFILE',
  REEL = 'REEL',
  STORY = 'STORY',
  VIDEO = 'VIDEO'
}

export enum SocialImageStyleEnum {
  BUBBLE = 'BUBBLE',
  COLOR = 'COLOR',
  COLOR_HAND_DROWN = 'COLOR_HAND_DROWN',
  STICKER = 'STICKER'
}

export type SocialImagesImagesInput = {
  png?: InputMaybe<SocialImagesImagesSetInput>;
  svg?: InputMaybe<SocialImagesImagesSetInput>;
};

export type SocialImagesImagesSetInput = {
  size48?: InputMaybe<PictureInput>;
  size96?: InputMaybe<PictureInput>;
  size144?: InputMaybe<PictureInput>;
  size240?: InputMaybe<PictureInput>;
  size480?: InputMaybe<PictureInput>;
};

export type SocialImagesImagesSetType = {
  __typename?: 'SocialImagesImagesSetType';
  size48?: Maybe<PictureType>;
  size96?: Maybe<PictureType>;
  size144?: Maybe<PictureType>;
  size240?: Maybe<PictureType>;
  size480?: Maybe<PictureType>;
};

export type SocialImagesImagesType = {
  __typename?: 'SocialImagesImagesType';
  png?: Maybe<SocialImagesImagesSetType>;
  svg?: Maybe<SocialImagesImagesSetType>;
};

export type SocialImagesInput = {
  images?: InputMaybe<Array<SocialImagesImagesInput>>;
  style: SocialImageStyleEnum;
};

export type SocialImagesType = {
  __typename?: 'SocialImagesType';
  images?: Maybe<Array<SocialImagesImagesType>>;
  style: SocialImageStyleEnum;
};

export type SocialInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  fontIcon?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<SocialImagesInput>>;
  name: Scalars['String']['input'];
};

export type SocialLoginDataType = {
  __typename?: 'SocialLoginDataType';
  apple?: Maybe<AppleDataType>;
  facebook?: Maybe<FacebookDataType>;
  google?: Maybe<GoogleDataType>;
  ooredoo?: Maybe<OoredooDataType>;
  partner?: Maybe<PartnerLoginType>;
};

export type SocialPaginatedType = {
  __typename?: 'SocialPaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<SocialType>;
};

export type SocialType = {
  __typename?: 'SocialType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fontIcon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<SocialImagesType>>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SocialValueInput = {
  name: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export type SocialValueType = {
  __typename?: 'SocialValueType';
  name?: Maybe<SocialType>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum SourcesEnum {
  FIGAMY = 'FIGAMY',
  OOREDOO = 'OOREDOO'
}

export type SpecialOfferType = {
  __typename?: 'SpecialOfferType';
  hours?: Maybe<Array<OpeningHoursDayType>>;
  offerType?: Maybe<SpecialOffersType>;
};

export enum SpecialOffersType {
  BAR = 'BAR',
  BREAKFAST = 'BREAKFAST',
  BRUNCH = 'BRUNCH',
  DINNER = 'DINNER',
  HAPPY_HOUR = 'HAPPY_HOUR',
  LUNCH = 'LUNCH'
}

export type SpecilOfferInput = {
  hours?: InputMaybe<Array<OpeningHoursDayInput>>;
  offerType?: InputMaybe<SpecialOffersType>;
};

export type SquadsPaginateType = {
  __typename?: 'SquadsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<SquadsType>;
};

export type SquadsPlayersType = {
  __typename?: 'SquadsPlayersType';
  age?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
};

export type SquadsTeamType = {
  __typename?: 'SquadsTeamType';
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SquadsType = {
  __typename?: 'SquadsType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  players?: Maybe<Array<SquadsPlayersType>>;
  team?: Maybe<SquadsTeamType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StandingLeagueType = {
  __typename?: 'StandingLeagueType';
  country?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  standings?: Maybe<Array<Array<StandingType>>>;
};

export type StandingPaginateType = {
  __typename?: 'StandingPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<StandingsType>;
};

export type StandingStatGoalsType = {
  __typename?: 'StandingStatGoalsType';
  against?: Maybe<Scalars['Float']['output']>;
  forstat?: Maybe<Scalars['Float']['output']>;
};

export type StandingStatType = {
  __typename?: 'StandingStatType';
  goals?: Maybe<StandingStatGoalsType>;
  lose?: Maybe<Scalars['Float']['output']>;
  played?: Maybe<Scalars['Float']['output']>;
  win?: Maybe<Scalars['Float']['output']>;
};

export type StandingTeamType = {
  __typename?: 'StandingTeamType';
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type StandingType = {
  __typename?: 'StandingType';
  all?: Maybe<StandingStatType>;
  away?: Maybe<StandingStatType>;
  description?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Scalars['String']['output']>;
  goalsDiff?: Maybe<Scalars['Float']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  home?: Maybe<StandingStatType>;
  points?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  team?: Maybe<StandingTeamType>;
  update?: Maybe<Scalars['DateTime']['output']>;
};

export type StandingsType = {
  __typename?: 'StandingsType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  league?: Maybe<StandingLeagueType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StatBiggestType = {
  __typename?: 'StatBiggestType';
  goals?: Maybe<StatFaType>;
  loses?: Maybe<StatHaType>;
  streak?: Maybe<StatWdlType>;
  wins?: Maybe<StatHaType>;
};

export type StatCardsType = {
  __typename?: 'StatCardsType';
  red?: Maybe<StatMinuteType>;
  yellow?: Maybe<StatMinuteType>;
};

export type StatFaType = {
  __typename?: 'StatFAType';
  against?: Maybe<StatHaType>;
  forstat?: Maybe<StatHaType>;
};

export type StatFixturesType = {
  __typename?: 'StatFixturesType';
  draws?: Maybe<StatHatType>;
  loses?: Maybe<StatHatType>;
  played?: Maybe<StatHatType>;
  wins?: Maybe<StatHatType>;
};

export type StatFpType = {
  __typename?: 'StatFpType';
  formation?: Maybe<Scalars['String']['output']>;
  played?: Maybe<Scalars['Float']['output']>;
};

export type StatGoalsType = {
  __typename?: 'StatGoalsType';
  against?: Maybe<StatTamType>;
  forstat?: Maybe<StatTamType>;
};

export type StatHatType = {
  __typename?: 'StatHATType';
  away?: Maybe<Scalars['Float']['output']>;
  home?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type StatHaType = {
  __typename?: 'StatHAType';
  away?: Maybe<Scalars['String']['output']>;
  home?: Maybe<Scalars['String']['output']>;
};

export type StatLeagueType = {
  __typename?: 'StatLeagueType';
  country?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
};

export type StatMinuteType = {
  __typename?: 'StatMinuteType';
  fixtyoneToSeventyfive?: Maybe<StatTpType>;
  fourtysixToSixty?: Maybe<StatTpType>;
  hundredsixToHundredtwenty?: Maybe<StatTpType>;
  ninetyoneToHundredfive?: Maybe<StatTpType>;
  seventysixToNinety?: Maybe<StatTpType>;
  sixteenToThirty?: Maybe<StatTpType>;
  thirtyoneToFourtyfive?: Maybe<StatTpType>;
  zeroToFifteen?: Maybe<StatTpType>;
};

export type StatPenaltyType = {
  __typename?: 'StatPenaltyType';
  missed?: Maybe<StatTpType>;
  scored?: Maybe<StatTpType>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type StatTamType = {
  __typename?: 'StatTAMType';
  average?: Maybe<StatHatType>;
  minute?: Maybe<StatMinuteType>;
  total?: Maybe<StatHatType>;
};

export type StatTaType = {
  __typename?: 'StatTAType';
  average?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type StatTpType = {
  __typename?: 'StatTPType';
  percentage?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type StatTeamType = {
  __typename?: 'StatTeamType';
  id?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type StatWdlType = {
  __typename?: 'StatWDLType';
  draws?: Maybe<Scalars['Float']['output']>;
  loses?: Maybe<Scalars['Float']['output']>;
  wins?: Maybe<Scalars['Float']['output']>;
};

export enum StateCapitalEnum {
  ADMIN = 'ADMIN',
  MINOR = 'MINOR',
  PRIMARY = 'PRIMARY'
}

export type StateInput = {
  adminName: Scalars['String']['input'];
  ascii: Scalars['String']['input'];
  capital: StateCapitalEnum;
  country?: InputMaybe<Scalars['ID']['input']>;
  flagSquare?: InputMaybe<PictureInput>;
  flagWide?: InputMaybe<PictureInput>;
  lat: Scalars['Decimal']['input'];
  lng: Scalars['Decimal']['input'];
  name: Scalars['String']['input'];
  population?: InputMaybe<Scalars['Decimal']['input']>;
};

export type StatePaginatedType = {
  __typename?: 'StatePaginatedType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<StateType>;
};

export type StateType = {
  __typename?: 'StateType';
  adminName?: Maybe<Scalars['String']['output']>;
  ascii?: Maybe<Scalars['String']['output']>;
  capital?: Maybe<StateCapitalEnum>;
  country?: Maybe<CountryType>;
  createdAt: Scalars['DateTime']['output'];
  flagSquare?: Maybe<PictureType>;
  flagWide?: Maybe<PictureType>;
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['Decimal']['output']>;
  lng?: Maybe<Scalars['Decimal']['output']>;
  name: Scalars['String']['output'];
  population?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StaticTranslationInput = {
  app?: InputMaybe<TranslationAppEnum>;
  reference: Scalars['String']['input'];
  target?: InputMaybe<TargetAciInput>;
  translation: Array<StaticTranslationTranslationInput>;
};

export type StaticTranslationPaginateType = {
  __typename?: 'StaticTranslationPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<StaticTranslationType>;
};

export type StaticTranslationReferenceCheckType = {
  __typename?: 'StaticTranslationReferenceCheckType';
  hasReference: Scalars['Boolean']['output'];
};

export type StaticTranslationSimplePaginateType = {
  __typename?: 'StaticTranslationSimplePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<StaticTranslationSimpleType>;
};

export type StaticTranslationSimpleType = {
  __typename?: 'StaticTranslationSimpleType';
  app: TranslationAppEnum;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  reference: Scalars['String']['output'];
  target?: Maybe<TargetSimpleType>;
  translation: Array<StaticTranslationTranslationSimpleType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StaticTranslationTranslationInput = {
  content: Scalars['String']['input'];
  language?: InputMaybe<Scalars['ID']['input']>;
};

export type StaticTranslationTranslationSimpleType = {
  __typename?: 'StaticTranslationTranslationSimpleType';
  _id: Scalars['ID']['output'];
  content: Scalars['String']['output'];
  language?: Maybe<Scalars['ID']['output']>;
};

export type StaticTranslationTranslationType = {
  __typename?: 'StaticTranslationTranslationType';
  _id: Scalars['ID']['output'];
  content: Scalars['String']['output'];
  language?: Maybe<LanguageType>;
};

export type StaticTranslationType = {
  __typename?: 'StaticTranslationType';
  app: TranslationAppEnum;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  reference: Scalars['String']['output'];
  target?: Maybe<TargetType>;
  translation: Array<StaticTranslationTranslationType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StatisticsIntType = {
  __typename?: 'StatisticsIntType';
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type StatisticsPaginateType = {
  __typename?: 'StatisticsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<StatisticsType>;
};

export type StatisticsTeamsType = {
  __typename?: 'StatisticsTeamsType';
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type StatisticsType = {
  __typename?: 'StatisticsType';
  createdAt: Scalars['DateTime']['output'];
  fixture?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  statistics?: Maybe<Array<StatisticsIntType>>;
  team?: Maybe<StatisticsTeamsType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StatsType = {
  __typename?: 'StatsType';
  numberOfFollowers: Scalars['Int']['output'];
  numberOfProducts: Scalars['Int']['output'];
  numberOfSubscribers: Scalars['Int']['output'];
};

export type StockPixelType = {
  __typename?: 'StockPixelType';
  quantityToSellOnFacebook?: Maybe<Scalars['Int']['output']>;
};

export type StockRawType = {
  __typename?: 'StockRawType';
  createdAt: Scalars['DateTime']['output'];
  currentStock: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  minimumStockQuantity: Scalars['Int']['output'];
  outOfStock: Scalars['Boolean']['output'];
  pixel?: Maybe<StockPixelType>;
  stockCapacity: Scalars['Int']['output'];
  stockPercentage: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type StockStatsType = {
  __typename?: 'StockStatsType';
  daily: Array<PeriodStatsType>;
  total: Scalars['Int']['output'];
};

export type StockType = {
  __typename?: 'StockType';
  barcode: BarcodeType;
  createdAt: Scalars['DateTime']['output'];
  currentStock: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  minimumStockQuantity: Scalars['Int']['output'];
  outOfStock: Scalars['Boolean']['output'];
  pixel?: Maybe<StockPixelType>;
  stockCapacity: Scalars['Int']['output'];
  stockPercentage: Scalars['Decimal']['output'];
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  warehouse?: Maybe<WarehouseType>;
};

export type StockValidationType = {
  __typename?: 'StockValidationType';
  headersValid?: Maybe<Scalars['Boolean']['output']>;
  isBarcodeComplete?: Maybe<Scalars['Boolean']['output']>;
  isCapacityComplete?: Maybe<Scalars['Boolean']['output']>;
  isMinimumComplete?: Maybe<Scalars['Boolean']['output']>;
  isStockComplete?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  overallValidation?: Maybe<Scalars['Boolean']['output']>;
};

export type StocksCountType = {
  __typename?: 'StocksCountType';
  inPeriod: Scalars['Int']['output'];
  inStock: StockStatsType;
  outOfStock: StockStatsType;
  total: Scalars['Int']['output'];
};

export enum StoriesContentTypeEnum {
  EMOJI = 'EMOJI',
  GIF = 'GIF',
  STICKER = 'STICKER',
  TEXT = 'TEXT'
}

export type StoriesType = {
  __typename?: 'StoriesType';
  content?: Maybe<Array<StoryContentContentType>>;
  createdAt: Scalars['DateTime']['output'];
  /** group */
  group?: Maybe<GroupType>;
  id: Scalars['ID']['output'];
  manufacturer?: Maybe<ManufacturerType>;
  media?: Maybe<StoryMediaType>;
  pos?: Maybe<PointOfSaleType>;
  seen?: Maybe<Scalars['Boolean']['output']>;
  seenBy?: Maybe<Array<UserType>>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
  wholesaler?: Maybe<WholesalerType>;
};

export type StoryContentContentType = {
  __typename?: 'StoryContentContentType';
  color?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<StoriesContentTypeEnum>;
  dimension?: Maybe<StoryContentDimensionType>;
  position?: Maybe<StoryContentPositionType>;
};

export type StoryContentDimensionType = {
  __typename?: 'StoryContentDimensionType';
  fontSize?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type StoryContentPositionType = {
  __typename?: 'StoryContentPositionType';
  bottom?: Maybe<Scalars['Float']['output']>;
  left?: Maybe<Scalars['Float']['output']>;
  right?: Maybe<Scalars['Float']['output']>;
  top?: Maybe<Scalars['Float']['output']>;
};

export type StoryMediaType = {
  __typename?: 'StoryMediaType';
  picture?: Maybe<PictureType>;
  video?: Maybe<PictureType>;
};

export type StringListType = {
  __typename?: 'StringListType';
  list?: Maybe<Array<Scalars['String']['output']>>;
};

export type SubjectsFullType = {
  __typename?: 'SubjectsFullType';
  consumer?: Maybe<UserType>;
  deliveryMan?: Maybe<UserType>;
  pos?: Maybe<PointOfSaleType>;
  user?: Maybe<UserType>;
};

export type SubjectsType = {
  __typename?: 'SubjectsType';
  consumer?: Maybe<Scalars['String']['output']>;
  deliveryMan?: Maybe<Scalars['String']['output']>;
  pos?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type SubscribersFullType = {
  __typename?: 'SubscribersFullType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  status?: Maybe<SubscriptionStatus>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type SubscribersFullWithReputationType = {
  __typename?: 'SubscribersFullWithReputationType';
  createdAt: Scalars['DateTime']['output'];
  currentReputationLevel?: Maybe<ReputationWithoutTargetType>;
  id: Scalars['ID']['output'];
  nextReputationLevel?: Maybe<ReputationWithoutTargetType>;
  status?: Maybe<SubscriptionStatus>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
  wallet?: Maybe<WalletType>;
};

export type SubscribersInput = {
  target: TargetAciInput;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type SubscribersWithReputationsPaginateType = {
  __typename?: 'SubscribersWithReputationsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<SubscribersFullWithReputationType>;
};

export type Subscription = {
  __typename?: 'Subscription';
  listenForAmountPushedEvent: ListenForAmountPushedEventType;
  listenForAudienceCriteriaStarted: AudienceCriteriaType;
  listenForAudienceStarted: AudienceType;
  listenForChallengeStarted: ChallengeType;
  listenForChallengeWon: ChallengeType;
  listenForCompanyCreated: CompanyType;
  listenForCorporateUserStatusChanged: UserStatsType;
  listenForFormCreated: FormDtoType;
  listenForLinkAccountApproved: LinkAccountType;
  listenForLoyaltyProgramCreated: LoyaltyProgramType;
  listenForManufacturerCreated: ManufacturerType;
  listenForNewAdhocCorporateNotification: CorporateNotificationFullType;
  listenForNewAdhocNotification: NotificationFullType;
  listenForPOSCategoryCreated: PosCategoryType;
  listenForQuestActionDefinitionStarted: QuestActionDefinitionType;
  listenForQuestActivityStarted: QuestActivityType;
  listenForQuestionCreated: QuestionDtoType;
  listenForResponseCreated: ResponseDtoType;
  listenForSendAdhocCorporateNotificationTest: AdhocCorporateNotificationTestType;
  listenForSendAdhocNotificationTest: AdhocNotificationTestType;
  listenForSendThemAndLanguageToWidget: ThemAndLanguageToWidgetType;
  listenForSubscriptionReply: SubscribersFullType;
  listenForSubscriptionRequest: SubscribersFullType;
  listenForUserAuthentication: UserAuthenticationType;
  listenForUserCreated: UserType;
  listenForUserEvents: EventLogBaseType;
  listenForUserLoggedInByTarget: LoginType;
  listenForUserLoggedInForTarget: CorporateLoginWithActionTypeType;
  listenForUserLoggedOutByTarget: DeleteResponseDtoType;
  listenForUserStatusChanged: UserType;
  listenForWalletTransactionCreated: WalletTransactionForSubscriptionType;
  listenForWholesalerCreated: WholesalerType;
  pointOfSaleCreated: PointOfSaleType;
};


export type SubscriptionListenForAmountPushedEventArgs = {
  reference: Scalars['String']['input'];
};


export type SubscriptionListenForAudienceCriteriaStartedArgs = {
  targets: TargetsInput;
};


export type SubscriptionListenForAudienceStartedArgs = {
  targets: TargetsInput;
};


export type SubscriptionListenForChallengeStartedArgs = {
  target: TargetAciInput;
};


export type SubscriptionListenForChallengeWonArgs = {
  user: Scalars['ID']['input'];
};


export type SubscriptionListenForCorporateUserStatusChangedArgs = {
  target: TargetAciInput;
};


export type SubscriptionListenForLinkAccountApprovedArgs = {
  requestId: Scalars['ID']['input'];
};


export type SubscriptionListenForNewAdhocCorporateNotificationArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionListenForQuestActionDefinitionStartedArgs = {
  targets: TargetsInput;
};


export type SubscriptionListenForQuestActivityStartedArgs = {
  targets: TargetsInput;
};


export type SubscriptionListenForSendAdhocCorporateNotificationTestArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionListenForSendAdhocNotificationTestArgs = {
  userId: Scalars['String']['input'];
};


export type SubscriptionListenForSendThemAndLanguageToWidgetArgs = {
  reference: Scalars['String']['input'];
  target: TargetAciInput;
};


export type SubscriptionListenForSubscriptionReplyArgs = {
  userId: Scalars['String']['input'];
};


export type SubscriptionListenForSubscriptionRequestArgs = {
  target: TargetAciInput;
};


export type SubscriptionListenForUserEventsArgs = {
  target: TargetAciInput;
};


export type SubscriptionListenForUserLoggedInByTargetArgs = {
  reference: Scalars['String']['input'];
};


export type SubscriptionListenForUserLoggedInForTargetArgs = {
  reference: Scalars['String']['input'];
  target: TargetAciInput;
};


export type SubscriptionListenForUserLoggedOutByTargetArgs = {
  reference: Scalars['String']['input'];
};


export type SubscriptionListenForWalletTransactionCreatedArgs = {
  posId: Scalars['ID']['input'];
};

export enum SubscriptionCycleEnum {
  ADHOC = 'ADHOC',
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  YEARLY = 'YEARLY'
}

export enum SubscriptionStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type SuccessResponseDtoType = {
  __typename?: 'SuccessResponseDtoType';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SuccessResponseWithAmountPushedDtoType = {
  __typename?: 'SuccessResponseWithAmountPushedDtoType';
  amountPushed: Scalars['Decimal']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SummaryResponseDtoType = {
  __typename?: 'SummaryResponseDtoType';
  choices?: Maybe<Array<QuestionChoiceDtoType>>;
  description?: Maybe<Scalars['String']['output']>;
  responses: Array<SingleAnswerDtoType>;
  title?: Maybe<Scalars['String']['output']>;
  totalResponsesCount: Scalars['Int']['output'];
  type?: Maybe<QuestionTypeEnum>;
};

export type SupplierType = {
  __typename?: 'SupplierType';
  createdAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reference: Scalars['String']['output'];
  supplier: TargetType;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum SupplierTypeEnum {
  FRANCHISE = 'FRANCHISE',
  MANUFACTURER = 'MANUFACTURER',
  WHOLESALER = 'WHOLESALER'
}

export type SupplliersChartDashboardType = {
  __typename?: 'SupplliersChartDashboardType';
  earnings: Array<Scalars['Decimal']['output']>;
  orders: Array<Scalars['Decimal']['output']>;
  refunds: Array<Scalars['Decimal']['output']>;
};

export type TagType = {
  __typename?: 'TagType';
  content?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TargetAciInput = {
  /** manufacturer id */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** pos id */
  pos?: InputMaybe<Scalars['String']['input']>;
  /** Commercial id */
  user?: InputMaybe<Scalars['String']['input']>;
  /** wholesaler id */
  wholesaler?: InputMaybe<Scalars['String']['input']>;
};

export type TargetCreateInput = {
  /** manufacturer input */
  manufacturer?: InputMaybe<ManufacturerCreateInput>;
  /** pos input */
  pos?: InputMaybe<PointOfSaleInput>;
  /** User input */
  user: UserInput;
  /** wholesaler input */
  wholesaler?: InputMaybe<WholesalerCreateInput>;
};

export type TargetCurrencyInput = {
  currency?: InputMaybe<Scalars['ID']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TargetCurrencyType = {
  __typename?: 'TargetCurrencyType';
  currency?: Maybe<CurrencyType>;
  default?: Maybe<Scalars['Boolean']['output']>;
};

export type TargetDtoType = {
  __typename?: 'TargetDtoType';
  pos?: Maybe<PointOfSaleType>;
  user?: Maybe<UserType>;
};

export type TargetFilterType = {
  __typename?: 'TargetFilterType';
  /** manufacturer */
  manufacturer?: Maybe<FilterNameFieldType>;
  /** PointOfSale */
  pos?: Maybe<FilterNameFieldType>;
  /** wholesaler */
  wholesaler?: Maybe<FilterNameFieldType>;
};

export type TargetIdsType = {
  __typename?: 'TargetIdsType';
  /** manufacturer id */
  manufacturer?: Maybe<Scalars['ID']['output']>;
  /** pos id */
  pos?: Maybe<Scalars['ID']['output']>;
  /** wholesaler id */
  wholesaler?: Maybe<Scalars['ID']['output']>;
};

export type TargetInput = {
  pos?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type TargetPaginateType = {
  __typename?: 'TargetPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<TargetType>;
};

export type TargetSimpleType = {
  __typename?: 'TargetSimpleType';
  /** manufacturer id. */
  manufacturer?: Maybe<Scalars['ID']['output']>;
  /** PointOfSale id. */
  pos?: Maybe<Scalars['ID']['output']>;
  /** wholesaler id. */
  wholesaler?: Maybe<Scalars['ID']['output']>;
};

export type TargetTransferInput = {
  /** manufacturer id */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** pos id */
  pos?: InputMaybe<Scalars['String']['input']>;
  /** user id */
  user?: InputMaybe<Scalars['String']['input']>;
  /** wholesaler id */
  wholesaler?: InputMaybe<Scalars['String']['input']>;
};

export type TargetType = {
  __typename?: 'TargetType';
  /** manufacturer */
  manufacturer?: Maybe<ManufacturerType>;
  /** PointOfSale */
  pos?: Maybe<PointOfSaleType>;
  /** wholesaler */
  wholesaler?: Maybe<WholesalerType>;
};

export enum TargetTypeEnum {
  MANUFACTURER = 'MANUFACTURER',
  POS = 'POS',
  USER = 'USER'
}

export type TargetWithGroupAndStoriesType = {
  __typename?: 'TargetWithGroupAndStoriesType';
  /** group */
  group?: Maybe<GroupType>;
  /** is all Stories are seen */
  isAllStoriesSeen: Scalars['Boolean']['output'];
  /** manufacturer */
  manufacturer?: Maybe<ManufacturerType>;
  /** PointOfSale */
  pos?: Maybe<PointOfSaleType>;
  /** Stories list */
  stories?: Maybe<Array<StoriesType>>;
  /** user */
  user?: Maybe<UserType>;
  /** wholesaler */
  wholesaler?: Maybe<WholesalerType>;
};

export type TargetWithGroupType = {
  __typename?: 'TargetWithGroupType';
  /** group */
  group?: Maybe<GroupType>;
  /** manufacturer */
  manufacturer?: Maybe<ManufacturerType>;
  /** PointOfSale */
  pos?: Maybe<PointOfSaleType>;
  /** user */
  user?: Maybe<UserType>;
  /** wholesaler */
  wholesaler?: Maybe<WholesalerType>;
};

export type TargetWithPictureFilterType = {
  __typename?: 'TargetWithPictureFilterType';
  /** manufacturer */
  manufacturer?: Maybe<FilterNamePictureFieldType>;
  /** PointOfSale */
  pos?: Maybe<FilterNamePictureFieldType>;
  /** wholesaler */
  wholesaler?: Maybe<FilterNamePictureFieldType>;
};

export type TargetWithUserType = {
  __typename?: 'TargetWithUserType';
  /** manufacturer */
  manufacturer?: Maybe<ManufacturerType>;
  /** PointOfSale */
  pos?: Maybe<PointOfSaleType>;
  /** user */
  user?: Maybe<UserType>;
  /** wholesaler */
  wholesaler?: Maybe<WholesalerType>;
};

export type TargetWithoutUserInput = {
  /** manufacturer id */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** pos id */
  pos?: InputMaybe<Scalars['String']['input']>;
  /** wholesaler id */
  wholesaler?: InputMaybe<Scalars['String']['input']>;
};

export type TargetsInput = {
  /** list of manufacturers ids */
  manufacturer?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** list of pointOfSales ids */
  pos?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** list of wholesalers ids */
  wholesaler?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TargetsType = {
  __typename?: 'TargetsType';
  /** list of manufacturers */
  manufacturer?: Maybe<Array<ManufacturerType>>;
  /** list of pointOfSales */
  pos?: Maybe<Array<PointOfSaleType>>;
  /** list of wholesalers */
  wholesaler?: Maybe<Array<WholesalerType>>;
};

export enum TaskPriorityEnum {
  HIGH = 'HIGH',
  LOW = 'LOW',
  NORMAL = 'NORMAL'
}

export type TaskSectionType = {
  __typename?: 'TaskSectionType';
  archived: Scalars['Boolean']['output'];
  completed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  priority: TaskPriorityEnum;
  rank: Scalars['Int']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target: TargetType;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TasksStatsType = {
  __typename?: 'TasksStatsType';
  done: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum TaxSignEnum {
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE'
}

export type TaxType = {
  __typename?: 'TaxType';
  company?: Maybe<CompanyType>;
  createdAt: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  use?: Maybe<Array<TaxUseEnum>>;
  value?: Maybe<TaxVaType>;
};

export enum TaxUseEnum {
  PURCHASE = 'PURCHASE',
  SALE = 'SALE'
}

export type TaxVaType = {
  __typename?: 'TaxVaType';
  sign: TaxSignEnum;
  type: DiscountType;
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type TaxValueType = {
  __typename?: 'TaxValueType';
  total?: Maybe<Scalars['Decimal']['output']>;
  unit?: Maybe<Scalars['Decimal']['output']>;
};

export type TeamInformationFilterInput = {
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TeamInformationPaginateType = {
  __typename?: 'TeamInformationPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<TeamInformationType>;
};

export type TeamInformationType = {
  __typename?: 'TeamInformationType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  team?: Maybe<TeamType>;
  updatedAt: Scalars['DateTime']['output'];
  venue?: Maybe<VenueType>;
};

export type TeamSeasonsPaginateType = {
  __typename?: 'TeamSeasonsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<TeamSeasonsType>;
};

export type TeamSeasonsType = {
  __typename?: 'TeamSeasonsType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  seasons?: Maybe<Array<Scalars['Float']['output']>>;
  team?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TeamStatisticsPaginateType = {
  __typename?: 'TeamStatisticsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<TeamStatisticsType>;
};

export type TeamStatisticsType = {
  __typename?: 'TeamStatisticsType';
  biggest?: Maybe<StatBiggestType>;
  cards?: Maybe<StatCardsType>;
  clean_sheet?: Maybe<StatHatType>;
  createdAt: Scalars['DateTime']['output'];
  failed_to_score?: Maybe<StatHatType>;
  fixtures?: Maybe<StatFixturesType>;
  form?: Maybe<Scalars['String']['output']>;
  goals?: Maybe<StatGoalsType>;
  id?: Maybe<Scalars['ID']['output']>;
  league?: Maybe<StatLeagueType>;
  lineups?: Maybe<Array<StatFpType>>;
  penalty?: Maybe<StatPenaltyType>;
  team?: Maybe<StatTeamType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TeamType = {
  __typename?: 'TeamType';
  country?: Maybe<Scalars['String']['output']>;
  founded?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logo64?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  national?: Maybe<Scalars['String']['output']>;
};

export type TechDeviceBrandType = {
  __typename?: 'TechDeviceBrandType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  logo?: Maybe<DeviceBrandLogoType>;
  name: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TechDeviceSpecsType = {
  __typename?: 'TechDeviceSpecsType';
  alarm?: Maybe<Scalars['String']['output']>;
  alertTypes?: Maybe<Scalars['String']['output']>;
  announced?: Maybe<Scalars['String']['output']>;
  band2g?: Maybe<Scalars['String']['output']>;
  bluetooth?: Maybe<Scalars['String']['output']>;
  browser?: Maybe<Scalars['String']['output']>;
  callRecords?: Maybe<Scalars['String']['output']>;
  cardSlot?: Maybe<Scalars['String']['output']>;
  clock?: Maybe<Scalars['String']['output']>;
  colors?: Maybe<Scalars['String']['output']>;
  dimensions?: Maybe<Scalars['String']['output']>;
  edge?: Maybe<Scalars['String']['output']>;
  games?: Maybe<Scalars['String']['output']>;
  gprs?: Maybe<Scalars['String']['output']>;
  gps?: Maybe<Scalars['String']['output']>;
  jack35mm?: Maybe<Scalars['String']['output']>;
  java?: Maybe<Scalars['String']['output']>;
  languages?: Maybe<Scalars['String']['output']>;
  loudspeaker?: Maybe<Scalars['String']['output']>;
  messaging?: Maybe<Scalars['String']['output']>;
  phonebook?: Maybe<Scalars['String']['output']>;
  radio?: Maybe<Scalars['String']['output']>;
  resolution?: Maybe<Scalars['String']['output']>;
  sensors?: Maybe<Scalars['String']['output']>;
  sim?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  technology?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  usb?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
  wlan?: Maybe<Scalars['String']['output']>;
};

export type TechDeviceType = {
  __typename?: 'TechDeviceType';
  batterySize?: Maybe<Scalars['String']['output']>;
  batteryType?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<TechDeviceBrandType>;
  cameraPixels?: Maybe<Scalars['String']['output']>;
  chipset?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  displayResolution?: Maybe<Scalars['String']['output']>;
  displaySize?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  ram?: Maybe<Scalars['String']['output']>;
  releasedat?: Maybe<Scalars['String']['output']>;
  specifications?: Maybe<TechDeviceSpecsType>;
  storage?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
  videoPixels?: Maybe<Scalars['String']['output']>;
};

export type TechDeviceTypeType = {
  __typename?: 'TechDeviceTypeType';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nodeName?: Maybe<Scalars['String']['output']>;
  pictureSquare?: Maybe<PictureType>;
  pictureWide?: Maybe<PictureType>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ThemAndLanguageToWidgetType = {
  __typename?: 'ThemAndLanguageToWidgetType';
  language?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  theme?: Maybe<Scalars['String']['output']>;
};

export enum TicketPriorityEnum {
  CRITICAL = 'CRITICAL',
  HIGH = 'HIGH',
  LOW = 'LOW',
  NORMAL = 'NORMAL'
}

export enum TicketStatusEnum {
  BLOCKED = 'BLOCKED',
  IN_PROGRESS = 'IN_PROGRESS',
  ON_HOLD = 'ON_HOLD',
  OPEN = 'OPEN',
  RESOLVED = 'RESOLVED'
}

export type TicketType = {
  __typename?: 'TicketType';
  assignedTo?: Maybe<Array<UserType>>;
  attachments?: Maybe<Array<DocumentType>>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<CompanyType>;
  deadline?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<TicketPriorityEnum>;
  project?: Maybe<ProjectType>;
  status?: Maybe<TicketStatusEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TimeEntryType = {
  __typename?: 'TimeEntryType';
  card: BoardCardType;
  createdAt: Scalars['DateTime']['output'];
  end: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  member: UserType;
  start: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TimeFromToInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimeFromToType = {
  __typename?: 'TimeFromToType';
  from?: Maybe<Scalars['DateTime']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
};

export type TimeTrackOnType = {
  __typename?: 'TimeTrackOnType';
  card?: Maybe<BoardCardType>;
  project?: Maybe<ProjectType>;
  ticket?: Maybe<TicketType>;
};

export type TimeTrackType = {
  __typename?: 'TimeTrackType';
  createdAt: Scalars['DateTime']['output'];
  end?: Maybe<Scalars['DateTime']['output']>;
  holder?: Maybe<TimeTrackOnType>;
  id: Scalars['ID']['output'];
  idle?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type TimezonePaginateType = {
  __typename?: 'TimezonePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<TimezoneType>;
};

export type TimezoneType = {
  __typename?: 'TimezoneType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TopAssistsPaginateType = {
  __typename?: 'TopAssistsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<TopAssistsType>;
};

export type TopAssistsType = {
  __typename?: 'TopAssistsType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  league?: Maybe<Scalars['Int']['output']>;
  season?: Maybe<Scalars['Int']['output']>;
  topAssists?: Maybe<Array<PlayersStatsType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TopChartCategoryItemType = {
  __typename?: 'TopChartCategoryItemType';
  cron: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TopChartGenreType = {
  __typename?: 'TopChartGenreType';
  category: TopChartCategoryItemType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  platform: ChartPlatformEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export type TopChartLeaderboardType = {
  __typename?: 'TopChartLeaderboardType';
  artist_name?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  ext_id?: Maybe<Scalars['String']['output']>;
  feed_type?: Maybe<Scalars['String']['output']>;
  genre_id?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  pos?: Maybe<Scalars['Float']['output']>;
  pos_curr?: Maybe<Scalars['Float']['output']>;
  pos_diff?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  rating_avg?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type TopRedCardsPaginateType = {
  __typename?: 'TopRedCardsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<TopRedCardsType>;
};

export type TopRedCardsType = {
  __typename?: 'TopRedCardsType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  league?: Maybe<Scalars['Int']['output']>;
  season?: Maybe<Scalars['Int']['output']>;
  topRedCards?: Maybe<Array<PlayersStatsType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TopScorerPaginateType = {
  __typename?: 'TopScorerPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<TopScorersType>;
};

export type TopScorersType = {
  __typename?: 'TopScorersType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  league?: Maybe<Scalars['Int']['output']>;
  season?: Maybe<Scalars['Int']['output']>;
  topScorers?: Maybe<Array<PlayersStatsType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TopYellowCardsPaginateType = {
  __typename?: 'TopYellowCardsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<TopYellowCardsType>;
};

export type TopYellowCardsType = {
  __typename?: 'TopYellowCardsType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  league?: Maybe<Scalars['Int']['output']>;
  season?: Maybe<Scalars['Int']['output']>;
  topYellowCards?: Maybe<Array<PlayersStatsType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TopupWalletInput = {
  amount: Scalars['Decimal']['input'];
  card?: InputMaybe<Scalars['String']['input']>;
  source: OnsiteConverterTypeEnum;
  target: TargetAciInput;
  transactionId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type TotalAndInPeriodCountsType = {
  __typename?: 'TotalAndInPeriodCountsType';
  inPeriod: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TotalPriceType = {
  __typename?: 'TotalPriceType';
  gross?: Maybe<Scalars['Decimal']['output']>;
  net?: Maybe<Scalars['Decimal']['output']>;
};

export type TotalType = {
  __typename?: 'TotalType';
  total: Scalars['Decimal']['output'];
};

export enum TransactionChallengeTypeEnum {
  MOBILE_ONSITE_ACTIVITY = 'MOBILE_ONSITE_ACTIVITY',
  PHYSICAL_ONSITE_ACTIVITY = 'PHYSICAL_ONSITE_ACTIVITY',
  QUEST_FULFILLED = 'QUEST_FULFILLED',
  WEB_ONSITE_ACTIVITY = 'WEB_ONSITE_ACTIVITY'
}

export enum TransactionPartnerEnum {
  BITAKA = 'BITAKA'
}

export enum TransactionTypeEnum {
  CONVERSION = 'CONVERSION',
  DEAL_ORDER_ADDED = 'DEAL_ORDER_ADDED',
  DONATION = 'DONATION',
  GAME_FEES = 'GAME_FEES',
  MOBILE_ONSITE_ACTIVITY = 'MOBILE_ONSITE_ACTIVITY',
  MOBILE_REDEEM = 'MOBILE_REDEEM',
  ORDER_ADDED = 'ORDER_ADDED',
  ORDER_PAYMENT = 'ORDER_PAYMENT',
  PHONE_RECHARGE = 'PHONE_RECHARGE',
  PHYSICAL_ONSITE_ACTIVITY = 'PHYSICAL_ONSITE_ACTIVITY',
  PROFILE_LEVEL_COMPLETED = 'PROFILE_LEVEL_COMPLETED',
  QUEST_FULFILLED = 'QUEST_FULFILLED',
  REDEEM = 'REDEEM',
  REFERRAL = 'REFERRAL',
  REPUTATION_LOST = 'REPUTATION_LOST',
  TURNOVER_LOST = 'TURNOVER_LOST',
  WALLET_TOPUP = 'WALLET_TOPUP',
  WALLET_WITHDRAW = 'WALLET_WITHDRAW',
  WEB_ONSITE_ACTIVITY = 'WEB_ONSITE_ACTIVITY',
  WEB_REDEEM = 'WEB_REDEEM',
  WELCOME_BONUS = 'WELCOME_BONUS'
}

export type TransfersPaginateType = {
  __typename?: 'TransfersPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<TransfersType>;
};

export type TransfersPlayerType = {
  __typename?: 'TransfersPlayerType';
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TransfersTransfersTeamsInOutType = {
  __typename?: 'TransfersTransfersTeamsInOutType';
  id?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TransfersTransfersTeamsType = {
  __typename?: 'TransfersTransfersTeamsType';
  teamIn?: Maybe<TransfersTransfersTeamsInOutType>;
  teamOut?: Maybe<TransfersTransfersTeamsInOutType>;
};

export type TransfersTransfersType = {
  __typename?: 'TransfersTransfersType';
  date?: Maybe<Scalars['DateTime']['output']>;
  teams?: Maybe<TransfersTransfersTeamsType>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TransfersType = {
  __typename?: 'TransfersType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  player?: Maybe<TransfersPlayerType>;
  transfers?: Maybe<Array<TransfersTransfersType>>;
  updateAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum TranslationAppEnum {
  WEBSITE = 'WEBSITE',
  WIDGET_MOBILE = 'WIDGET_MOBILE',
  WIDGET_WEB = 'WIDGET_WEB'
}

export enum TriggerEnum {
  INSTANT = 'INSTANT',
  SCHEDULED = 'SCHEDULED'
}

export type TrophiesInnerType = {
  __typename?: 'TrophiesInnerType';
  country?: Maybe<Scalars['String']['output']>;
  league?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['String']['output']>;
};

export type TrophiesPaginateType = {
  __typename?: 'TrophiesPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<TrophiesType>;
};

export type TrophiesType = {
  __typename?: 'TrophiesType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  target: ApiTargetType;
  trophies: Array<TrophiesInnerType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type UnseenCorporateNotificationCountType = {
  __typename?: 'UnseenCorporateNotificationCountType';
  count: Scalars['Int']['output'];
};

export type UnseenNotificationCountType = {
  __typename?: 'UnseenNotificationCountType';
  count: Scalars['Int']['output'];
};

export type UpdateFormInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  owner?: InputMaybe<FormOwnerInput>;
  status?: InputMaybe<FormStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FormType>;
};

export type UpdateInternalProductInput = {
  /** list of barcodes ids */
  barcodes?: InputMaybe<Array<Scalars['ID']['input']>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  catalogueCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  classification?: InputMaybe<Array<ProductClassEnum>>;
  condition?: InputMaybe<ProductConditionEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionList?: InputMaybe<Array<Scalars['String']['input']>>;
  discount?: InputMaybe<DiscountDtoInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Array<ProductFlagEnum>>;
  globalCategory?: InputMaybe<GlobalCategoryInput>;
  id: Scalars['ID']['input'];
  internalProductAttributes?: InputMaybe<InternalProductAttributeInput>;
  longdesc?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  rent?: InputMaybe<Scalars['Boolean']['input']>;
  seo?: InputMaybe<CatalogueCategorySeoInput>;
  sku?: InputMaybe<Scalars['String']['input']>;
  specs?: InputMaybe<Array<ProductSpecsInput>>;
  status?: InputMaybe<ProductStatusEnum>;
  structure?: InputMaybe<ProductStructureEnum>;
  /** list of suppliers ids */
  suppliers?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translation?: InputMaybe<Array<InternalProductTranslationInput>>;
  url?: InputMaybe<Scalars['String']['input']>;
  variety?: InputMaybe<ProductVarietyEnum>;
};

export type UpdateMediaInput = {
  id: Scalars['ID']['input'];
  media: SingleMediaInput;
};

export type UpdatePictureInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
  x?: InputMaybe<Scalars['Int']['input']>;
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateReputationInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  inactivityCycle?: InputMaybe<Scalars['Int']['input']>;
  lossAmount?: InputMaybe<Scalars['Int']['input']>;
  lossPoints?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<Scalars['Int']['input']>;
  perks?: InputMaybe<PerksInput>;
  picture?: InputMaybe<UpdatePictureInput>;
  reputationLevel?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Array<ReputationTranslationInput>>;
  turnoverPoints?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSimpleProductInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  catalogueCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  classification?: InputMaybe<Array<ProductClassEnum>>;
  condition?: InputMaybe<ProductConditionEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionList?: InputMaybe<Array<Scalars['String']['input']>>;
  discount?: InputMaybe<DiscountDtoInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Array<ProductFlagEnum>>;
  globalCategory?: InputMaybe<GlobalCategoryInput>;
  id: Scalars['ID']['input'];
  longdesc?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  rent?: InputMaybe<Scalars['Boolean']['input']>;
  seo?: InputMaybe<CatalogueCategorySeoInput>;
  sku?: InputMaybe<Scalars['String']['input']>;
  specs?: InputMaybe<Array<ProductSpecsInput>>;
  status?: InputMaybe<ProductStatusEnum>;
  structure?: InputMaybe<ProductStructureEnum>;
  /** list of suppliers ids */
  suppliers?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translation?: InputMaybe<Array<InternalProductTranslationInput>>;
  url?: InputMaybe<Scalars['String']['input']>;
  variety?: InputMaybe<ProductVarietyEnum>;
};

export type UpdateStaticTranslationInput = {
  app?: InputMaybe<TranslationAppEnum>;
  /** required when contentId is sent. */
  content?: InputMaybe<Scalars['String']['input']>;
  /** required when editing content. */
  contentId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  /** can't exists if only editing reference. */
  language?: InputMaybe<Scalars['ID']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type UserAccountInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  apps?: InputMaybe<Array<App>>;
  billingAddress?: InputMaybe<Array<FullAddressInput>>;
  chatContact?: InputMaybe<Array<SocialValueInput>>;
  covers?: InputMaybe<Array<PictureInput>>;
  custom?: InputMaybe<Array<UserCustomInput>>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  education?: InputMaybe<Array<UserEducationInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  hobbies?: InputMaybe<Array<Scalars['String']['input']>>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isMailValid?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lived?: InputMaybe<Array<Scalars['ID']['input']>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<MaritalStatus>;
  mobileTheme?: InputMaybe<MobileThemesEnum>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  newsletterSubs?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  permission?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<PhoneInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  plugged?: InputMaybe<Scalars['Boolean']['input']>;
  residentialAddress?: InputMaybe<Array<FullAddressInput>>;
  roles: Array<UserRole>;
  shippingAddress?: InputMaybe<Array<FullAddressInput>>;
  socialMedia?: InputMaybe<Array<SocialValueInput>>;
  source?: InputMaybe<SourcesEnum>;
  status?: InputMaybe<UserStatus>;
  target: TargetAciInput;
  title?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  widget?: InputMaybe<Scalars['Boolean']['input']>;
  work?: InputMaybe<Array<UserWorkInput>>;
};

export type UserAuthenticationType = {
  __typename?: 'UserAuthenticationType';
  actionType: ActionTypeEnum;
  user: UserType;
};

export type UserByStatesType = {
  __typename?: 'UserByStatesType';
  count: Scalars['Int']['output'];
  country?: Maybe<CountryType>;
  percentage: Scalars['Decimal']['output'];
  state?: Maybe<StateType>;
};

export type UserCustomInput = {
  customKey?: InputMaybe<Scalars['String']['input']>;
  customValue?: InputMaybe<Scalars['String']['input']>;
};

export type UserCustomType = {
  __typename?: 'UserCustomType';
  customKey?: Maybe<Scalars['String']['output']>;
  customValue?: Maybe<Scalars['String']['output']>;
};

export type UserDataType = {
  __typename?: 'UserDataType';
  firstName: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  picture: PictureType;
};

export type UserEducationInput = {
  city?: InputMaybe<Scalars['ID']['input']>;
  country?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  graduated?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<AcademicLevel>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserEducationType = {
  __typename?: 'UserEducationType';
  city?: Maybe<StateType>;
  country?: Maybe<CountryType>;
  description?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['DateTime']['output']>;
  graduated?: Maybe<Scalars['Boolean']['output']>;
  level?: Maybe<AcademicLevel>;
  name?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  to?: Maybe<Scalars['DateTime']['output']>;
};

export enum UserEventsSourceEnum {
  MOBILE = 'MOBILE',
  STORE = 'STORE',
  WEB = 'WEB',
  WIDGET_MOBILE = 'WIDGET_MOBILE',
  WIDGET_WEB = 'WIDGET_WEB'
}

export type UserExistType = {
  __typename?: 'UserExistType';
  exist: Scalars['Boolean']['output'];
  user?: Maybe<UserType>;
};

export type UserInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  apps?: InputMaybe<Array<App>>;
  billingAddress?: InputMaybe<Array<FullAddressInput>>;
  chatContact?: InputMaybe<Array<SocialValueInput>>;
  covers?: InputMaybe<Array<PictureInput>>;
  custom?: InputMaybe<Array<UserCustomInput>>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  education?: InputMaybe<Array<UserEducationInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  hobbies?: InputMaybe<Array<Scalars['String']['input']>>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isMailValid?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lived?: InputMaybe<Array<Scalars['ID']['input']>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<MaritalStatus>;
  mobileTheme?: InputMaybe<MobileThemesEnum>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  newsletterSubs?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  permission?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<PhoneInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  plugged?: InputMaybe<Scalars['Boolean']['input']>;
  residentialAddress?: InputMaybe<Array<FullAddressInput>>;
  roles: Array<UserRole>;
  shippingAddress?: InputMaybe<Array<FullAddressInput>>;
  socialMedia?: InputMaybe<Array<SocialValueInput>>;
  source?: InputMaybe<SourcesEnum>;
  status?: InputMaybe<UserStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  widget?: InputMaybe<Scalars['Boolean']['input']>;
  work?: InputMaybe<Array<UserWorkInput>>;
};

export type UserPaginateType = {
  __typename?: 'UserPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<UserType>;
};

export enum UserRole {
  ADMIN = 'ADMIN',
  API = 'API',
  CATALOG = 'CATALOG',
  COMMERCIAL = 'COMMERCIAL',
  COMMUNITY = 'COMMUNITY',
  CONSUMER = 'CONSUMER',
  CONTENT = 'CONTENT',
  CUSTOMERS = 'CUSTOMERS',
  DASHBOARDS_ANALYTICS = 'DASHBOARDS_ANALYTICS',
  DASHBOARDS_FINANCE = 'DASHBOARDS_FINANCE',
  DASHBOARDS_MERCHANDISING = 'DASHBOARDS_MERCHANDISING',
  DASHBOARDS_SALES = 'DASHBOARDS_SALES',
  DASHBOARDS_WAREHOUSE = 'DASHBOARDS_WAREHOUSE',
  DELIVERY_MAN = 'DELIVERY_MAN',
  EDITOR = 'EDITOR',
  FINANCIAL = 'FINANCIAL',
  GROUP_MODERATOR = 'GROUP_MODERATOR',
  INVENTORY = 'INVENTORY',
  LOYALTY = 'LOYALTY',
  MANAGER = 'MANAGER',
  MANUFACTURER_ASSISTANT = 'MANUFACTURER_ASSISTANT',
  MANUFACTURER_MANAGER = 'MANUFACTURER_MANAGER',
  MANUFACTURER_OWNER = 'MANUFACTURER_OWNER',
  MERCHANDISER = 'MERCHANDISER',
  MERCHANDISING = 'MERCHANDISING',
  NETWORK = 'NETWORK',
  NOT_SPECIFIED = 'NOT_SPECIFIED',
  ORGANIZATION = 'ORGANIZATION',
  POS_ASSISTANT = 'POS_ASSISTANT',
  POS_MANAGER = 'POS_MANAGER',
  POS_OWNER = 'POS_OWNER',
  POS_WAITER = 'POS_WAITER',
  SALES = 'SALES',
  SYSTEM = 'SYSTEM',
  WAREHOUSE = 'WAREHOUSE',
  WHOLESALER_ASSISTANT = 'WHOLESALER_ASSISTANT',
  WHOLESALER_MANAGER = 'WHOLESALER_MANAGER',
  WHOLESALER_OWNER = 'WHOLESALER_OWNER'
}

export type UserStatsType = {
  __typename?: 'UserStatsType';
  allUsers: Scalars['Int']['output'];
  onlineUsers: Scalars['Int']['output'];
  user: UserType;
};

export enum UserStatus {
  AWAY = 'AWAY',
  BUSY = 'BUSY',
  OFFLINE = 'OFFLINE',
  ONLINE = 'ONLINE'
}

export type UserType = {
  __typename?: 'UserType';
  about?: Maybe<Scalars['String']['output']>;
  apps?: Maybe<Array<App>>;
  billingAddress?: Maybe<Array<FullAddressType>>;
  chatContact?: Maybe<Array<SocialValueType>>;
  covers?: Maybe<Array<PictureType>>;
  createdAt: Scalars['DateTime']['output'];
  custom?: Maybe<Array<UserCustomType>>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  education?: Maybe<Array<UserEducationType>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  hasAutoGeneratedEmail?: Maybe<Scalars['Boolean']['output']>;
  hobbies?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  interests?: Maybe<Array<Scalars['String']['output']>>;
  isMailValid?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<LanguageType>>;
  lastName?: Maybe<Scalars['String']['output']>;
  lived?: Maybe<Array<StateType>>;
  locale?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<MaritalStatus>;
  mobileTheme?: Maybe<MobileThemesEnum>;
  nationality?: Maybe<CountryType>;
  newsletterSubs?: Maybe<Scalars['Boolean']['output']>;
  permission?: Maybe<PermissionType>;
  phone?: Maybe<PhoneType>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<PictureType>;
  pictures?: Maybe<Array<PictureType>>;
  placeOfBirth?: Maybe<Scalars['String']['output']>;
  plugged?: Maybe<Scalars['Boolean']['output']>;
  residentialAddress?: Maybe<Array<FullAddressType>>;
  roles?: Maybe<Array<UserRole>>;
  shippingAddress?: Maybe<Array<FullAddressType>>;
  socialLoginData?: Maybe<SocialLoginDataType>;
  socialMedia?: Maybe<Array<SocialValueType>>;
  source?: Maybe<SourcesEnum>;
  status?: Maybe<UserStatus>;
  target?: Maybe<TargetIdsType>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
  widget?: Maybe<Scalars['Boolean']['output']>;
  work?: Maybe<Array<UserWorkType>>;
};

export type UserUpdateInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  apps?: InputMaybe<Array<App>>;
  billingAddress?: InputMaybe<Array<FullAddressInput>>;
  chatContact?: InputMaybe<Array<SocialValueInput>>;
  covers?: InputMaybe<Array<PictureInput>>;
  custom?: InputMaybe<Array<UserCustomInput>>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  education?: InputMaybe<Array<UserEducationInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  hobbies?: InputMaybe<Array<Scalars['String']['input']>>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isMailValid?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lived?: InputMaybe<Array<Scalars['ID']['input']>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<MaritalStatus>;
  mobileTheme?: InputMaybe<MobileThemesEnum>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  newsletterSubs?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  plugged?: InputMaybe<Scalars['Boolean']['input']>;
  residentialAddress?: InputMaybe<Array<FullAddressInput>>;
  roles?: InputMaybe<Array<UserRole>>;
  shippingAddress?: InputMaybe<Array<FullAddressInput>>;
  socialMedia?: InputMaybe<Array<SocialValueInput>>;
  source?: InputMaybe<SourcesEnum>;
  status?: InputMaybe<UserStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  vapidKey?: InputMaybe<Scalars['String']['input']>;
  widget?: InputMaybe<Scalars['Boolean']['input']>;
  work?: InputMaybe<Array<UserWorkInput>>;
};

export type UserWithTargetInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  apps?: InputMaybe<Array<App>>;
  billingAddress?: InputMaybe<Array<FullAddressInput>>;
  chatContact?: InputMaybe<Array<SocialValueInput>>;
  covers?: InputMaybe<Array<PictureInput>>;
  custom?: InputMaybe<Array<UserCustomInput>>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  education?: InputMaybe<Array<UserEducationInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  hobbies?: InputMaybe<Array<Scalars['String']['input']>>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  isMailValid?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lived?: InputMaybe<Array<Scalars['ID']['input']>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<MaritalStatus>;
  mobileTheme?: InputMaybe<MobileThemesEnum>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  newsletterSubs?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  permission?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<PhoneInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<PictureInput>;
  pictures?: InputMaybe<Array<PictureInput>>;
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  plugged?: InputMaybe<Scalars['Boolean']['input']>;
  residentialAddress?: InputMaybe<Array<FullAddressInput>>;
  roles: Array<UserRole>;
  shippingAddress?: InputMaybe<Array<FullAddressInput>>;
  socialMedia?: InputMaybe<Array<SocialValueInput>>;
  source?: InputMaybe<SourcesEnum>;
  status?: InputMaybe<UserStatus>;
  subject?: InputMaybe<Scalars['String']['input']>;
  target: TargetAciInput;
  title?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  widget?: InputMaybe<Scalars['Boolean']['input']>;
  work?: InputMaybe<Array<UserWorkInput>>;
};

export type UserWorkInput = {
  city?: InputMaybe<Scalars['ID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['ID']['input']>;
  current?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserWorkType = {
  __typename?: 'UserWorkType';
  city?: Maybe<StateType>;
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryType>;
  current?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['DateTime']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  to?: Maybe<Scalars['DateTime']['output']>;
};

export type ValidateSmsCodeInput = {
  code: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  target: TargetAciInput;
};

export type VapidKeyInput = {
  userId: Scalars['String']['input'];
  vapidKey: Scalars['String']['input'];
};

export type VapidKeyType = {
  __typename?: 'VapidKeyType';
  vapidKey: Scalars['String']['output'];
};

export type VenuePaginateType = {
  __typename?: 'VenuePaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<VenueTypeFull>;
};

export type VenueType = {
  __typename?: 'VenueType';
  address?: Maybe<Scalars['String']['output']>;
  capacity?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  surface?: Maybe<Scalars['String']['output']>;
};

export type VenueTypeFull = {
  __typename?: 'VenueTypeFull';
  address?: Maybe<Scalars['String']['output']>;
  capacity?: Maybe<Scalars['Float']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  surface?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  venueId?: Maybe<Scalars['Float']['output']>;
};

export type VerifyApiSettingsInput = {
  /** Login phone number/username or email. */
  login?: InputMaybe<Scalars['String']['input']>;
  /** password for login */
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  target: TargetAciInput;
};

export type VersionContentType = {
  __typename?: 'VersionContentType';
  content: Scalars['String']['output'];
  contentType: VersionContentTypeEnum;
};

export enum VersionContentTypeEnum {
  ADDED = 'ADDED',
  CHANGED = 'CHANGED',
  FIXED = 'FIXED'
}

export type VersionType = {
  __typename?: 'VersionType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  platform: PlatformEnum;
  requireUpdate: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
  versionContent: Array<VersionContentType>;
};

export type VisitsFieldType = {
  __typename?: 'VisitsFieldType';
  current: Scalars['Int']['output'];
  percentage?: Maybe<Scalars['Decimal']['output']>;
  previous: Scalars['Int']['output'];
  weeklyVisits: Array<PeriodStatsType>;
};

export type VisualsFaviconType = {
  __typename?: 'VisualsFaviconType';
  size16?: Maybe<PictureType>;
  size32?: Maybe<PictureType>;
  size57?: Maybe<PictureType>;
  size60?: Maybe<PictureType>;
  size72?: Maybe<PictureType>;
  size76?: Maybe<PictureType>;
  size96?: Maybe<PictureType>;
  size114?: Maybe<PictureType>;
  size120?: Maybe<PictureType>;
  size144?: Maybe<PictureType>;
  size152?: Maybe<PictureType>;
  size180?: Maybe<PictureType>;
  size192?: Maybe<PictureType>;
};

export type VisualsType = {
  __typename?: 'VisualsType';
  createdAt: Scalars['DateTime']['output'];
  favicon?: Maybe<VisualsFaviconType>;
  id: Scalars['ID']['output'];
  logo?: Maybe<PictureType>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  square?: Maybe<PictureType>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  wide?: Maybe<PictureType>;
};

export type WalletBaseType = {
  __typename?: 'WalletBaseType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  coin?: Maybe<CoinType>;
  createdAt: Scalars['DateTime']['output'];
  currentReputationLevel?: Maybe<ReputationWithoutTargetType>;
  fee?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  nextReputationLevel?: Maybe<ReputationWithoutTargetType>;
  updatedAt: Scalars['DateTime']['output'];
  walletType?: Maybe<WalletTypeEnum>;
};

export type WalletCheckType = {
  __typename?: 'WalletCheckType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  coin?: Maybe<CoinSimpleType>;
  walletType?: Maybe<WalletTypeEnum>;
};

export type WalletConversionEntryInput = {
  amount: Scalars['Decimal']['input'];
  wallet: Scalars['ID']['input'];
};

export type WalletConversionInput = {
  debitor: WalletConversionEntryInput;
  receiver: WalletConversionEntryInput;
};

export type WalletDateValueChartType = {
  __typename?: 'WalletDateValueChartType';
  chart: Array<Array<Scalars['Float']['output']>>;
  wallet: WalletType;
};

export type WalletInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  coin?: InputMaybe<Scalars['ID']['input']>;
  fee?: InputMaybe<Scalars['Int']['input']>;
  owner?: InputMaybe<TargetTransferInput>;
  target?: InputMaybe<TargetAciInput>;
  walletType?: InputMaybe<WalletTypeEnum>;
};

export type WalletOwnerHasEnoughBalanceInput = {
  amount: Scalars['Decimal']['input'];
  coin: Scalars['ID']['input'];
  owner: TargetTransferInput;
};

export type WalletOwnerHasEnoughBalanceType = {
  __typename?: 'WalletOwnerHasEnoughBalanceType';
  hasEnoughBalance: Scalars['Boolean']['output'];
};

export type WalletPaginateType = {
  __typename?: 'WalletPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<WalletType>;
};

export type WalletTopupCurrencyType = {
  __typename?: 'WalletTopupCurrencyType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  currency?: Maybe<CurrencyType>;
};

export type WalletTopupPlatformInput = {
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  prelevel?: InputMaybe<WalletTopupPrelevelInput>;
  remunerations?: InputMaybe<Array<WalletTopupRemunerationInput>>;
};

export type WalletTopupPlatformType = {
  __typename?: 'WalletTopupPlatformType';
  enable: Scalars['Boolean']['output'];
  prelevel?: Maybe<WalletTopupPrelevelType>;
  remunerations?: Maybe<Array<WalletTopupRemunerationType>>;
};

export type WalletTopupPrelevelInput = {
  qualitative?: InputMaybe<WalletTopupPrelevelQualitativeInput>;
  quantitative?: InputMaybe<WalletTopupPrelevelQuantitativeInput>;
};

export type WalletTopupPrelevelQualitativeInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
};

export type WalletTopupPrelevelQualitativeType = {
  __typename?: 'WalletTopupPrelevelQualitativeType';
  amount?: Maybe<Scalars['Decimal']['output']>;
};

export type WalletTopupPrelevelQuantitativeInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  wallet?: InputMaybe<Scalars['ID']['input']>;
};

export type WalletTopupPrelevelQuantitativeType = {
  __typename?: 'WalletTopupPrelevelQuantitativeType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  wallet: WalletType;
};

export type WalletTopupPrelevelType = {
  __typename?: 'WalletTopupPrelevelType';
  qualitative: WalletTopupPrelevelQualitativeType;
  quantitative: WalletTopupPrelevelQuantitativeType;
};

export type WalletTopupSettingsInput = {
  mobile?: InputMaybe<WalletTopupPlatformInput>;
  physical?: InputMaybe<WalletTopupPlatformInput>;
  target: TargetAciInput;
  web?: InputMaybe<WalletTopupPlatformInput>;
};

export type WalletTopupSettingsPaginateType = {
  __typename?: 'WalletTopupSettingsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<WalletTopupSettingsType>;
};

export type WalletTopupSettingsType = {
  __typename?: 'WalletTopupSettingsType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mobile?: Maybe<WalletTopupPlatformType>;
  physical?: Maybe<WalletTopupPlatformType>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
  web?: Maybe<WalletTopupPlatformType>;
};

export type WalletTopupSettingsUpdateInput = {
  mobile?: InputMaybe<WalletTopupPlatformInput>;
  physical?: InputMaybe<WalletTopupPlatformInput>;
  web?: InputMaybe<WalletTopupPlatformInput>;
};

export enum WalletTopupStatusEnum {
  CONFIRMED = 'CONFIRMED',
  DELIVERED = 'DELIVERED',
  OPEN = 'OPEN'
}

export type WalletTopupType = {
  __typename?: 'WalletTopupType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['DateTime']['output'];
  executor?: Maybe<UserType>;
  id?: Maybe<Scalars['ID']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  status?: Maybe<WalletTopupStatusEnum>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<WalletTopupCurrencyType>;
  wallet?: Maybe<WalletType>;
};

export type WalletTransactionAmountType = {
  __typename?: 'WalletTransactionAmountType';
  qualitative?: Maybe<Scalars['Decimal']['output']>;
  quantitative?: Maybe<Scalars['Decimal']['output']>;
};

export type WalletTransactionBalanceType = {
  __typename?: 'WalletTransactionBalanceType';
  debitor?: Maybe<WalletTransactionAmountType>;
  receiver?: Maybe<WalletTransactionAmountType>;
};

export type WalletTransactionForSubscriptionType = {
  __typename?: 'WalletTransactionForSubscriptionType';
  amount: WalletTransactionAmountType;
  challenge?: Maybe<ChallengeType>;
  createdAt: Scalars['DateTime']['output'];
  debitor?: Maybe<DebitorWalletWithStringCoinType>;
  externalId?: Maybe<ExternalIdType>;
  newBalance: WalletTransactionBalanceType;
  questActions?: Maybe<Array<QuestActionType>>;
  reason: TransactionTypeEnum;
  receiver?: Maybe<WalletWithStringCoinType>;
  reputationLevel?: Maybe<ReputationType>;
  target: TargetType;
};

export type WalletTransactionPaginateType = {
  __typename?: 'WalletTransactionPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<WalletTransactionType>;
};

export type WalletTransactionType = {
  __typename?: 'WalletTransactionType';
  amount: WalletTransactionAmountType;
  challenge?: Maybe<ChallengeType>;
  createdAt: Scalars['DateTime']['output'];
  debitor?: Maybe<WalletType>;
  externalId?: Maybe<ExternalIdType>;
  id: Scalars['ID']['output'];
  newBalance: WalletTransactionBalanceType;
  questActions?: Maybe<Array<QuestActionType>>;
  reason: TransactionTypeEnum;
  receiver?: Maybe<WalletType>;
  reference?: Maybe<WalletTransactionsReferenceType>;
  reputationLevel?: Maybe<ReputationType>;
  target: TargetType;
  updatedAt: Scalars['DateTime']['output'];
};

export type WalletTransactionsByAffectedFilterInput = {
  affected?: InputMaybe<Array<TargetTransferInput>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  includeAllCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Array<TransactionTypeEnum>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  transactionId?: InputMaybe<Array<Scalars['String']['input']>>;
  walletId?: InputMaybe<Scalars['ID']['input']>;
  walletType?: InputMaybe<Array<WalletTypeEnum>>;
};

export type WalletTransactionsReferenceType = {
  __typename?: 'WalletTransactionsReferenceType';
  partner?: Maybe<TransactionPartnerEnum>;
  reference?: Maybe<Scalars['String']['output']>;
};

export type WalletTransactionsStatsChartFilterInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  wallet: Scalars['ID']['input'];
};

export type WalletTransactionsStatsType = {
  __typename?: 'WalletTransactionsStatsType';
  myWallet: CurrentPreviousPercentageType;
  overallReturns: CurrentPreviousPercentageType;
  overallVolume: CurrentPreviousPercentageType;
  todayReturns: CurrentPreviousPercentageType;
  todayVolume: CurrentPreviousPercentageType;
};

export type WalletType = {
  __typename?: 'WalletType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  coin?: Maybe<CoinType>;
  createdAt: Scalars['DateTime']['output'];
  currentReputationLevel?: Maybe<ReputationWithoutTargetType>;
  fee?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  nextReputationLevel?: Maybe<ReputationWithoutTargetType>;
  owner?: Maybe<TargetWithUserType>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  walletType?: Maybe<WalletTypeEnum>;
};

export enum WalletTypeEnum {
  QUALITATIVE = 'QUALITATIVE',
  QUANTITATIVE = 'QUANTITATIVE'
}

export type WalletWithCurrentAndNextReputationType = {
  __typename?: 'WalletWithCurrentAndNextReputationType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  coin?: Maybe<CoinType>;
  createdAt: Scalars['DateTime']['output'];
  currentReputationLevel?: Maybe<ReputationWithoutTargetType>;
  fee?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  nextReputationLevel?: Maybe<ReputationWithoutTargetType>;
  owner?: Maybe<TargetWithUserType>;
  prelevel?: Maybe<LoyaltySettingsPrelevelType>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  walletType?: Maybe<WalletTypeEnum>;
};

export type WalletWithReputationDtoType = {
  __typename?: 'WalletWithReputationDtoType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  coin?: Maybe<CoinType>;
  createdAt: Scalars['DateTime']['output'];
  currentReputationLevel?: Maybe<ReputationWithoutTargetType>;
  fee?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  nextReputationLevel?: Maybe<ReputationWithoutTargetType>;
  owner?: Maybe<TargetWithUserType>;
  prelevel?: Maybe<LoyaltySettingsPrelevelType>;
  reputationLevels?: Maybe<Array<ReputationWithoutTargetType>>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  walletType?: Maybe<WalletTypeEnum>;
};

export type WalletWithStringCoinType = {
  __typename?: 'WalletWithStringCoinType';
  amount?: Maybe<Scalars['Decimal']['output']>;
  coin?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentReputationLevel?: Maybe<ReputationWithoutTargetType>;
  fee?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  nextReputationLevel?: Maybe<ReputationWithoutTargetType>;
  owner?: Maybe<TargetWithUserType>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
  walletType?: Maybe<WalletTypeEnum>;
};

export type WarehouseType = {
  __typename?: 'WarehouseType';
  createdAt: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<LocationType>;
  media?: Maybe<MediaType>;
  name?: Maybe<Scalars['String']['output']>;
  nonStorageSurface?: Maybe<Scalars['Float']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  totalSurface?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type WebsiteIntegrationMulticurrencyCurrencyType = {
  __typename?: 'WebsiteIntegrationMulticurrencyCurrencyType';
  currency?: Maybe<CurrencyType>;
  default?: Maybe<Scalars['Boolean']['output']>;
};

export type WebsiteIntegrationMulticurrencyType = {
  __typename?: 'WebsiteIntegrationMulticurrencyType';
  active?: Maybe<Scalars['Boolean']['output']>;
  currencies?: Maybe<Array<WebsiteIntegrationMulticurrencyCurrencyType>>;
};

export type WebsiteIntegrationMultilanguageLanguageType = {
  __typename?: 'WebsiteIntegrationMultilanguageLanguageType';
  default?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<LanguageType>;
};

export type WebsiteIntegrationMultilanguageType = {
  __typename?: 'WebsiteIntegrationMultilanguageType';
  active?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<WebsiteIntegrationMultilanguageLanguageType>>;
};

export type WholesalerCreateInput = {
  address?: InputMaybe<FullAddressInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  currencies?: InputMaybe<Array<TargetCurrencyInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<IPhoneInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  picture?: InputMaybe<PictureInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type WholesalerPaginateType = {
  __typename?: 'WholesalerPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<WholesalerType>;
};

export type WholesalerType = {
  __typename?: 'WholesalerType';
  address?: Maybe<FullAddressType>;
  company?: Maybe<CompanyType>;
  contactEmails?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  currencies?: Maybe<Array<TargetCurrencyType>>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<IPhoneType>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<IPhoneType>;
  picture?: Maybe<PictureType>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type WholesalerUpdateInput = {
  address?: InputMaybe<FullAddressInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  currencies?: InputMaybe<Array<TargetCurrencyInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<IPhoneInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  picture?: InputMaybe<PictureInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type WidgetIntegrationActionsBaseInput = {
  activity: Scalars['ID']['input'];
  target: TargetAciInput;
};

export type WidgetIntegrationActionsInput = {
  activity: Scalars['ID']['input'];
  recurrence?: InputMaybe<QuestActionsRecurrenceInput>;
  remuneration?: InputMaybe<Array<QuestRemunerationInput>>;
  target: TargetAciInput;
};

export type WidgetIntegrationActionsType = {
  __typename?: 'WidgetIntegrationActionsType';
  definition?: Maybe<ActivityTypeType>;
  recurrence?: Maybe<QuestActionsRecurrenceType>;
  remuneration?: Maybe<Array<RemunerationDtoType>>;
};

export type WidgetIntegrationContentInput = {
  affiliate?: InputMaybe<Scalars['Boolean']['input']>;
  badges?: InputMaybe<Scalars['Boolean']['input']>;
  buttons?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Scalars['Boolean']['input']>;
  challenge?: InputMaybe<Scalars['Boolean']['input']>;
  chat?: InputMaybe<Scalars['Boolean']['input']>;
  leaderboard?: InputMaybe<Scalars['Boolean']['input']>;
  marketplace?: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceCoin?: InputMaybe<Scalars['ID']['input']>;
  notification?: InputMaybe<Scalars['Boolean']['input']>;
  profile?: InputMaybe<Scalars['Boolean']['input']>;
  theme?: InputMaybe<Scalars['Boolean']['input']>;
  wallet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WidgetIntegrationContentType = {
  __typename?: 'WidgetIntegrationContentType';
  affiliate?: Maybe<Scalars['Boolean']['output']>;
  badges?: Maybe<Scalars['Boolean']['output']>;
  buttons?: Maybe<Scalars['Boolean']['output']>;
  campaigns?: Maybe<Scalars['Boolean']['output']>;
  challenge?: Maybe<Scalars['Boolean']['output']>;
  chat?: Maybe<Scalars['Boolean']['output']>;
  leaderboard?: Maybe<Scalars['Boolean']['output']>;
  marketplace?: Maybe<Scalars['Boolean']['output']>;
  marketplaceCoin?: Maybe<CoinType>;
  notification?: Maybe<Scalars['Boolean']['output']>;
  profile?: Maybe<Scalars['Boolean']['output']>;
  theme?: Maybe<Scalars['Boolean']['output']>;
  wallet?: Maybe<Scalars['Boolean']['output']>;
};

export type WidgetIntegrationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<WidgetIntegrationContentInput>;
  font?: InputMaybe<Scalars['ID']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  login?: InputMaybe<WidgetIntegrationLoginInput>;
  multilanguage?: InputMaybe<WidgetIntegrationMultilanguageInput>;
  picture?: InputMaybe<PictureInput>;
  position?: InputMaybe<WidgetIntegrationPositionInput>;
  target?: InputMaybe<TargetAciInput>;
  test?: InputMaybe<WidgetIntegrationTestInput>;
  theme?: InputMaybe<Scalars['String']['input']>;
};

export type WidgetIntegrationLoginInput = {
  app?: InputMaybe<EnableableFieldInput>;
  apple?: InputMaybe<EnableableFieldInput>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  facebook?: InputMaybe<EnableableFieldInput>;
  google?: InputMaybe<EnableableFieldInput>;
  privacy?: InputMaybe<EnableableFieldInput>;
  qr?: InputMaybe<EnableableFieldInput>;
  terms?: InputMaybe<EnableableFieldInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type WidgetIntegrationLoginType = {
  __typename?: 'WidgetIntegrationLoginType';
  app?: Maybe<EnableableFieldType>;
  apple?: Maybe<EnableableFieldType>;
  enable?: Maybe<Scalars['Boolean']['output']>;
  facebook?: Maybe<EnableableFieldType>;
  google?: Maybe<EnableableFieldType>;
  privacy?: Maybe<EnableableFieldType>;
  qr?: Maybe<EnableableFieldType>;
  terms?: Maybe<EnableableFieldType>;
  url?: Maybe<Scalars['String']['output']>;
};

export type WidgetIntegrationMultilanguageInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<WidgetIntegrationMultilanguageLanguageInput>>;
};

export type WidgetIntegrationMultilanguageLanguageInput = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['ID']['input']>;
};

export type WidgetIntegrationMultilanguageLanguageType = {
  __typename?: 'WidgetIntegrationMultilanguageLanguageType';
  default?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<LanguageType>;
};

export type WidgetIntegrationMultilanguageType = {
  __typename?: 'WidgetIntegrationMultilanguageType';
  active?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<WidgetIntegrationMultilanguageLanguageType>>;
};

export type WidgetIntegrationPositionInput = {
  alignment?: InputMaybe<PositionEnum>;
  positioning?: InputMaybe<Scalars['Float']['input']>;
};

export type WidgetIntegrationPositionType = {
  __typename?: 'WidgetIntegrationPositionType';
  alignment?: Maybe<PositionEnum>;
  positioning?: Maybe<Scalars['Float']['output']>;
};

export type WidgetIntegrationTestInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  ips?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WidgetIntegrationTestType = {
  __typename?: 'WidgetIntegrationTestType';
  active?: Maybe<Scalars['Boolean']['output']>;
  ips?: Maybe<Array<Scalars['String']['output']>>;
};

export type WidgetIntegrationType = {
  __typename?: 'WidgetIntegrationType';
  actions?: Maybe<Array<WidgetIntegrationActionsType>>;
  active?: Maybe<Scalars['Boolean']['output']>;
  content?: Maybe<WidgetIntegrationContentType>;
  createdAt: Scalars['DateTime']['output'];
  font?: Maybe<FontType>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  login?: Maybe<WidgetIntegrationLoginType>;
  multilanguage?: Maybe<WidgetIntegrationMultilanguageType>;
  picture?: Maybe<PictureType>;
  position?: Maybe<WidgetIntegrationPositionType>;
  target: TargetType;
  test?: Maybe<WidgetIntegrationTestType>;
  theme?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type WidgetVisualsInput = {
  app?: InputMaybe<TranslationAppEnum>;
  picture?: InputMaybe<PictureInput>;
  reference?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<TargetAciInput>;
};

export type WidgetVisualsPaginateType = {
  __typename?: 'WidgetVisualsPaginateType';
  count?: Maybe<Scalars['Int']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  objects: Array<WidgetVisualsType>;
};

export type WidgetVisualsType = {
  __typename?: 'WidgetVisualsType';
  app?: Maybe<TranslationAppEnum>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  picture?: Maybe<PictureType>;
  reference?: Maybe<Scalars['String']['output']>;
  target?: Maybe<TargetType>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ZoneTypesEnum {
  POINT = 'POINT',
  POLYGON = 'POLYGON'
}

export type TaxRankType = {
  __typename?: 'taxRankType';
  rank?: Maybe<Scalars['String']['output']>;
  tax?: Maybe<TaxType>;
};

export type WalletTopupRemunerationInput = {
  qualitative?: InputMaybe<WalletTopupPrelevelQualitativeInput>;
  quantitative?: InputMaybe<WalletTopupPrelevelQuantitativeInput>;
  reputationLevel?: InputMaybe<Scalars['ID']['input']>;
};

export type WalletTopupRemunerationType = {
  __typename?: 'walletTopupRemunerationType';
  qualitative: WalletTopupPrelevelQualitativeType;
  quantitative: WalletTopupPrelevelQuantitativeType;
  reputationLevel: ReputationType;
};

export type GetFinishedBetOrdersByTargetPaginationQueryVariables = Exact<{
  target: TargetAciInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetFinishedBetOrdersByTargetPaginationQuery = { __typename?: 'Query', getFinishedBetOrdersByTargetPagination: { __typename?: 'BetOrderPaginateType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'BetOrderType', id: string, maxWin: number, finalWin?: any | null, fixture: { __typename?: 'FixtureType', id: string, fixture?: { __typename?: 'FixtureSubType', date?: any | null, status?: { __typename?: 'FixtureStatusType', short?: string | null, long?: string | null, elapsed?: number | null } | null } | null, league?: { __typename?: 'FixtureLeagueType', name?: string | null } | null, teams?: { __typename?: 'FixtureTeamsType', home?: { __typename?: 'FixtureHAType', name?: string | null, logo?: string | null, winner?: boolean | null } | null, away?: { __typename?: 'FixtureHAType', name?: string | null, logo?: string | null, winner?: boolean | null } | null } | null }, odds: Array<{ __typename?: 'BetOrderOddsOddsType', id: number, value: string, name: string, odd: any, gains?: any | null, status?: OddStatusEnum | null, bet: number }>, user: { __typename?: 'UserType', email?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null } | null } }> } };

export type GetPendingBetOrdersByTargetPaginationQueryVariables = Exact<{
  target: TargetAciInput;
  pagination: PaginationInput;
}>;


export type GetPendingBetOrdersByTargetPaginationQuery = { __typename?: 'Query', getPendingBetOrdersByTargetPagination: { __typename?: 'BetOrderPaginateType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'BetOrderType', id: string, maxWin: number, finalWin?: any | null, fixture: { __typename?: 'FixtureType', id: string, fixture?: { __typename?: 'FixtureSubType', date?: any | null, status?: { __typename?: 'FixtureStatusType', short?: string | null, long?: string | null, elapsed?: number | null } | null } | null, league?: { __typename?: 'FixtureLeagueType', name?: string | null } | null, teams?: { __typename?: 'FixtureTeamsType', home?: { __typename?: 'FixtureHAType', name?: string | null, logo?: string | null, winner?: boolean | null } | null, away?: { __typename?: 'FixtureHAType', name?: string | null, logo?: string | null, winner?: boolean | null } | null } | null }, odds: Array<{ __typename?: 'BetOrderOddsOddsType', id: number, value: string, name: string, odd: any, gains?: any | null, status?: OddStatusEnum | null, bet: number }>, user: { __typename?: 'UserType', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null } | null } }> } };

export type GetCurrentUserPendingBetOrdersPaginationQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetCurrentUserPendingBetOrdersPaginationQuery = { __typename?: 'Query', getCurrentUserPendingBetOrdersPagination: { __typename?: 'BetOrderPaginateType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'BetOrderType', id: string, maxWin: number, finalWin?: any | null, fixture: { __typename?: 'FixtureType', id: string, fixture?: { __typename?: 'FixtureSubType', date?: any | null, id?: number | null, status?: { __typename?: 'FixtureStatusType', short?: string | null, long?: string | null, elapsed?: number | null } | null } | null, league?: { __typename?: 'FixtureLeagueType', name?: string | null } | null, teams?: { __typename?: 'FixtureTeamsType', home?: { __typename?: 'FixtureHAType', name?: string | null, logo?: string | null, winner?: boolean | null } | null, away?: { __typename?: 'FixtureHAType', name?: string | null, logo?: string | null, winner?: boolean | null } | null } | null }, odds: Array<{ __typename?: 'BetOrderOddsOddsType', id: number, value: string, name: string, odd: any, gains?: any | null, status?: OddStatusEnum | null, bet: number }>, user: { __typename?: 'UserType', email?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null } | null } }> } };

export type GetCurrentUserFinishedBetOrdersPaginationQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type GetCurrentUserFinishedBetOrdersPaginationQuery = { __typename?: 'Query', getCurrentUserFinishedBetOrdersPagination: { __typename?: 'BetOrderPaginateType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'BetOrderType', id: string, maxWin: number, finalWin?: any | null, fixture: { __typename?: 'FixtureType', id: string, fixture?: { __typename?: 'FixtureSubType', date?: any | null, id?: number | null, status?: { __typename?: 'FixtureStatusType', short?: string | null, long?: string | null, elapsed?: number | null } | null } | null, league?: { __typename?: 'FixtureLeagueType', name?: string | null } | null, teams?: { __typename?: 'FixtureTeamsType', home?: { __typename?: 'FixtureHAType', name?: string | null, logo?: string | null, winner?: boolean | null } | null, away?: { __typename?: 'FixtureHAType', name?: string | null, logo?: string | null, winner?: boolean | null } | null } | null }, odds: Array<{ __typename?: 'BetOrderOddsOddsType', id: number, value: string, name: string, odd: any, gains?: any | null, status?: OddStatusEnum | null, bet: number }>, user: { __typename?: 'UserType', email?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null } | null } }> } };

export type PlaceBetMutationVariables = Exact<{
  input: BetOrderInput;
}>;


export type PlaceBetMutation = { __typename?: 'Mutation', placeBet: Array<{ __typename?: 'BetOrderType', id: string, maxWin: number, finalWin?: any | null, user: { __typename?: 'UserType', id: string, username?: string | null }, fixture: { __typename?: 'FixtureType', id: string, fixture?: { __typename?: 'FixtureSubType', id?: number | null, date?: any | null } | null, league?: { __typename?: 'FixtureLeagueType', id?: number | null, name?: string | null } | null } }> };

export type GetFixturesWithFilterQueryVariables = Exact<{
  filter: FixtureFilterInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetFixturesWithFilterQuery = { __typename?: 'Query', getFixturesWithFilter: { __typename?: 'FixturePaginateType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'FixtureType', id: string, isUserSubscribedToFixtureEvents?: boolean | null, createdAt?: any | null, updatedAt?: any | null, fixture?: { __typename?: 'FixtureSubType', id?: number | null, date?: any | null, referee?: string | null, timezone?: string | null, timestamp?: number | null, venue?: { __typename?: 'FixtureVenueType', id?: number | null, name?: string | null, city?: string | null } | null, status?: { __typename?: 'FixtureStatusType', long?: string | null, short?: string | null, elapsed?: number | null } | null, periods?: { __typename?: 'FixturePeriodType', first?: number | null, second?: string | null } | null } | null, score?: { __typename?: 'FixtureScoreType', penalty?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, halftime?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, fulltime?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, extratime?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null } | null, teams?: { __typename?: 'FixtureTeamsType', home?: { __typename?: 'FixtureHAType', id?: number | null, name?: string | null, logo?: string | null, winner?: boolean | null } | null, away?: { __typename?: 'FixtureHAType', id?: number | null, name?: string | null, logo?: string | null, winner?: boolean | null } | null } | null, goals?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, league?: { __typename?: 'FixtureLeagueType', id?: number | null, name?: string | null, logo?: string | null, flag?: string | null, round?: string | null, season?: number | null, country?: string | null } | null }> } };

export type GetFixturesWithFilterWithSubsQueryVariables = Exact<{
  filter: FixtureFilterInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetFixturesWithFilterWithSubsQuery = { __typename?: 'Query', getFixturesWithFilterWithSubs: { __typename?: 'FixturePaginateType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'FixtureType', id: string, isUserSubscribedToFixtureEvents?: boolean | null, createdAt?: any | null, updatedAt?: any | null, fixture?: { __typename?: 'FixtureSubType', id?: number | null, date?: any | null, referee?: string | null, timezone?: string | null, timestamp?: number | null, venue?: { __typename?: 'FixtureVenueType', id?: number | null, name?: string | null, city?: string | null } | null, status?: { __typename?: 'FixtureStatusType', long?: string | null, short?: string | null, elapsed?: number | null } | null, periods?: { __typename?: 'FixturePeriodType', first?: number | null, second?: string | null } | null } | null, score?: { __typename?: 'FixtureScoreType', penalty?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, halftime?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, fulltime?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, extratime?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null } | null, teams?: { __typename?: 'FixtureTeamsType', home?: { __typename?: 'FixtureHAType', id?: number | null, name?: string | null, logo?: string | null, winner?: boolean | null } | null, away?: { __typename?: 'FixtureHAType', id?: number | null, name?: string | null, logo?: string | null, winner?: boolean | null } | null } | null, goals?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, league?: { __typename?: 'FixtureLeagueType', id?: number | null, name?: string | null, logo?: string | null, flag?: string | null, round?: string | null, season?: number | null, country?: string | null } | null }> } };

export type GetFixturesWithFilterAndOddsQueryVariables = Exact<{
  filter: FixtureFilterInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetFixturesWithFilterAndOddsQuery = { __typename?: 'Query', getFixturesWithFilterAndOdds: { __typename?: 'FixtureWithOddsPaginateType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'FixtureWithOddsType', id: string, fixture?: { __typename?: 'FixtureSubType', id?: number | null, date?: any | null, referee?: string | null, timezone?: string | null, timestamp?: number | null, venue?: { __typename?: 'FixtureVenueType', id?: number | null, name?: string | null, city?: string | null } | null, status?: { __typename?: 'FixtureStatusType', long?: string | null, short?: string | null, elapsed?: number | null } | null, periods?: { __typename?: 'FixturePeriodType', first?: number | null, second?: string | null } | null } | null, score?: { __typename?: 'FixtureScoreType', penalty?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, halftime?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, fulltime?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, extratime?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null } | null, teams?: { __typename?: 'FixtureTeamsType', home?: { __typename?: 'FixtureHAType', id?: number | null, name?: string | null, logo?: string | null, winner?: boolean | null } | null, away?: { __typename?: 'FixtureHAType', id?: number | null, name?: string | null, logo?: string | null, winner?: boolean | null } | null } | null, goals?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, league?: { __typename?: 'FixtureLeagueType', id?: number | null, name?: string | null, logo?: string | null, flag?: string | null, round?: string | null, season?: number | null, country?: string | null } | null, odds?: { __typename?: 'OddsBookmakersBetsType', id?: number | null, name?: string | null, values?: Array<{ __typename?: 'OddsBookmakersBetsValuesType', value?: string | null, odd?: string | null }> | null } | null }> } };

export type FindOneByFixtureIdQueryVariables = Exact<{
  fixtureId: Scalars['Int']['input'];
}>;


export type FindOneByFixtureIdQuery = { __typename?: 'Query', findOneByFixtureId: { __typename?: 'FixtureType', id: string, createdAt?: any | null, updatedAt?: any | null, fixture?: { __typename?: 'FixtureSubType', id?: number | null, date?: any | null, referee?: string | null, timezone?: string | null, timestamp?: number | null, venue?: { __typename?: 'FixtureVenueType', id?: number | null, name?: string | null, city?: string | null } | null, status?: { __typename?: 'FixtureStatusType', long?: string | null, short?: string | null, elapsed?: number | null } | null, periods?: { __typename?: 'FixturePeriodType', first?: number | null, second?: string | null } | null } | null, score?: { __typename?: 'FixtureScoreType', penalty?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, halftime?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, fulltime?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, extratime?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null } | null, teams?: { __typename?: 'FixtureTeamsType', home?: { __typename?: 'FixtureHAType', id?: number | null, name?: string | null, logo?: string | null, winner?: boolean | null } | null, away?: { __typename?: 'FixtureHAType', id?: number | null, name?: string | null, logo?: string | null, winner?: boolean | null } | null } | null, goals?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, league?: { __typename?: 'FixtureLeagueType', id?: number | null, name?: string | null, logo?: string | null, flag?: string | null, round?: string | null, season?: number | null, country?: string | null } | null } };

export type GetFavoriteLeagueDefinitionsPaginationQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetFavoriteLeagueDefinitionsPaginationQuery = { __typename?: 'Query', getFavoriteLeagueDefinitionsPagination: { __typename?: 'FavoriteLeagueDefinitionPaginateType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'FavoriteLeagueDefinitionType', id?: string | null, league?: { __typename?: 'LeagueType', league?: { __typename?: 'LeagueObjType', id: number, name?: string | null, logo?: string | null } | null } | null }> } };

export type GetEventsFromProviderQueryVariables = Exact<{
  fixture: Scalars['Int']['input'];
}>;


export type GetEventsFromProviderQuery = { __typename?: 'Query', getEventsFromProvider: Array<{ __typename?: 'EventsType', id: string, fixture?: number | null, type?: string | null, detail?: string | null, comments?: string | null, createdAt: any, updatedAt: any, time?: { __typename?: 'EventsTimeType', elapsed?: number | null, extra?: number | null } | null, team?: { __typename?: 'EventsTeamType', id?: number | null, name?: string | null, logo?: string | null } | null, player?: { __typename?: 'EventsPlayerType', id?: number | null, name?: string | null } | null, assist?: { __typename?: 'EventsPlayerType', id?: number | null, name?: string | null } | null }> };

export type GetPredictionsQueryVariables = Exact<{
  fixture: Scalars['Int']['input'];
}>;


export type GetPredictionsQuery = { __typename?: 'Query', getPredictions: { __typename?: 'PredictionsType', id: string, fixture: number, createdAt: any, updatedAt: any, predictions?: { __typename?: 'PredictionsPredictionsType', win_or_draw?: boolean | null, under_over?: string | null, advice?: string | null, winner?: { __typename?: 'PredictionsWinnerType', id?: number | null, name?: string | null, comment?: string | null } | null, goals?: { __typename?: 'StatHAType', home?: string | null, away?: string | null } | null, percent?: { __typename?: 'PredictionsPercentType', home?: string | null, draw?: string | null, away?: string | null } | null } | null, league?: { __typename?: 'PredictionsLeagueType', id?: number | null, name?: string | null, country?: string | null, logo?: string | null, flag?: string | null, season?: number | null } | null, teams?: { __typename?: 'PredictionsTeamsType', home?: { __typename?: 'PredictionsTeamsHomeType', id?: number | null, name?: string | null, logo?: string | null, last_5?: { __typename?: 'PredictionsTeamsHomeLast5Type', form?: string | null, att?: string | null, def?: string | null, goals?: { __typename?: 'PredictionsTeamsHomeLast5GoalsType', forstat?: { __typename?: 'StatTAType', total?: number | null, average?: string | null } | null, against?: { __typename?: 'StatTAType', total?: number | null, average?: string | null } | null } | null } | null, league?: { __typename?: 'PredictionsTeamsHomeLeagueType', form?: string | null, fixtures?: { __typename?: 'PredictionsTeamsHomeLeagueFixturesType', played?: { __typename?: 'StatHATType', home?: number | null, away?: number | null, total?: number | null } | null, wins?: { __typename?: 'StatHATType', home?: number | null, away?: number | null, total?: number | null } | null, draws?: { __typename?: 'StatHATType', home?: number | null, away?: number | null, total?: number | null } | null, loses?: { __typename?: 'StatHATType', home?: number | null, away?: number | null, total?: number | null } | null } | null, goals?: { __typename?: 'PredictionsTeamsHomeLeagueGoalsType', forstat?: { __typename?: 'PredictionsTAMType', total?: { __typename?: 'StatHATType', home?: number | null, away?: number | null, total?: number | null } | null, average?: { __typename?: 'StatHATType', home?: number | null, away?: number | null, total?: number | null } | null, minute?: { __typename?: 'StatMinuteType', zeroToFifteen?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, sixteenToThirty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, thirtyoneToFourtyfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, fourtysixToSixty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, fixtyoneToSeventyfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, seventysixToNinety?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, ninetyoneToHundredfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, hundredsixToHundredtwenty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null } | null } | null, against?: { __typename?: 'PredictionsTAMType', total?: { __typename?: 'StatHATType', home?: number | null, away?: number | null, total?: number | null } | null, average?: { __typename?: 'StatHATType', home?: number | null, away?: number | null, total?: number | null } | null, minute?: { __typename?: 'StatMinuteType', zeroToFifteen?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, sixteenToThirty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, thirtyoneToFourtyfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, fourtysixToSixty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, fixtyoneToSeventyfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, seventysixToNinety?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, ninetyoneToHundredfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, hundredsixToHundredtwenty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null } | null } | null } | null, biggest?: { __typename?: 'PredictionsTeamsHomeLeagueBiggestType', streak?: { __typename?: 'PredictionsTeamsHomeLeagueBiggestStreakType', wins?: number | null, draws?: number | null, loses?: number | null } | null, wins?: { __typename?: 'StatHAType', home?: string | null, away?: string | null } | null, loses?: { __typename?: 'StatHAType', home?: string | null, away?: string | null } | null, goals?: { __typename?: 'PredictionsTeamsHomeLeagueBiggestGoalsType', forstat?: { __typename?: 'StatHAType', home?: string | null, away?: string | null } | null, against?: { __typename?: 'StatHAType', home?: string | null, away?: string | null } | null } | null } | null, clean_sheet?: { __typename?: 'StatHATType', home?: number | null, away?: number | null, total?: number | null } | null, failed_to_score?: { __typename?: 'StatHATType', home?: number | null, away?: number | null, total?: number | null } | null, penalty?: { __typename?: 'PredictionsTeamsHomeLeaguePenaltyType', total?: number | null, scored?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, missed?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null } | null, cards?: { __typename?: 'PredictionsTeamsHomeLeagueCardsType', yellow?: { __typename?: 'StatMinuteType', zeroToFifteen?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, sixteenToThirty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, thirtyoneToFourtyfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, fourtysixToSixty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, fixtyoneToSeventyfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, seventysixToNinety?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, ninetyoneToHundredfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, hundredsixToHundredtwenty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null } | null, red?: { __typename?: 'StatMinuteType', zeroToFifteen?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, sixteenToThirty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, thirtyoneToFourtyfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, fourtysixToSixty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, fixtyoneToSeventyfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, seventysixToNinety?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, ninetyoneToHundredfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, hundredsixToHundredtwenty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null } | null } | null } | null } | null, away?: { __typename?: 'PredictionsTeamsHomeType', id?: number | null, name?: string | null, logo?: string | null, last_5?: { __typename?: 'PredictionsTeamsHomeLast5Type', form?: string | null, att?: string | null, def?: string | null, goals?: { __typename?: 'PredictionsTeamsHomeLast5GoalsType', forstat?: { __typename?: 'StatTAType', total?: number | null, average?: string | null } | null, against?: { __typename?: 'StatTAType', total?: number | null, average?: string | null } | null } | null } | null, league?: { __typename?: 'PredictionsTeamsHomeLeagueType', form?: string | null, fixtures?: { __typename?: 'PredictionsTeamsHomeLeagueFixturesType', played?: { __typename?: 'StatHATType', home?: number | null, away?: number | null, total?: number | null } | null, wins?: { __typename?: 'StatHATType', home?: number | null, away?: number | null, total?: number | null } | null, draws?: { __typename?: 'StatHATType', home?: number | null, away?: number | null, total?: number | null } | null, loses?: { __typename?: 'StatHATType', home?: number | null, away?: number | null, total?: number | null } | null } | null, goals?: { __typename?: 'PredictionsTeamsHomeLeagueGoalsType', forstat?: { __typename?: 'PredictionsTAMType', total?: { __typename?: 'StatHATType', home?: number | null, away?: number | null, total?: number | null } | null, average?: { __typename?: 'StatHATType', home?: number | null, away?: number | null, total?: number | null } | null, minute?: { __typename?: 'StatMinuteType', zeroToFifteen?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, sixteenToThirty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, thirtyoneToFourtyfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, fourtysixToSixty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, fixtyoneToSeventyfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, seventysixToNinety?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, ninetyoneToHundredfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, hundredsixToHundredtwenty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null } | null } | null, against?: { __typename?: 'PredictionsTAMType', total?: { __typename?: 'StatHATType', home?: number | null, away?: number | null, total?: number | null } | null, average?: { __typename?: 'StatHATType', home?: number | null, away?: number | null, total?: number | null } | null, minute?: { __typename?: 'StatMinuteType', zeroToFifteen?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, sixteenToThirty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, thirtyoneToFourtyfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, fourtysixToSixty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, fixtyoneToSeventyfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, seventysixToNinety?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, ninetyoneToHundredfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, hundredsixToHundredtwenty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null } | null } | null } | null, biggest?: { __typename?: 'PredictionsTeamsHomeLeagueBiggestType', streak?: { __typename?: 'PredictionsTeamsHomeLeagueBiggestStreakType', wins?: number | null, draws?: number | null, loses?: number | null } | null, wins?: { __typename?: 'StatHAType', home?: string | null, away?: string | null } | null, loses?: { __typename?: 'StatHAType', home?: string | null, away?: string | null } | null, goals?: { __typename?: 'PredictionsTeamsHomeLeagueBiggestGoalsType', forstat?: { __typename?: 'StatHAType', home?: string | null, away?: string | null } | null, against?: { __typename?: 'StatHAType', home?: string | null, away?: string | null } | null } | null } | null, clean_sheet?: { __typename?: 'StatHATType', home?: number | null, away?: number | null, total?: number | null } | null, failed_to_score?: { __typename?: 'StatHATType', home?: number | null, away?: number | null, total?: number | null } | null, penalty?: { __typename?: 'PredictionsTeamsHomeLeaguePenaltyType', total?: number | null, scored?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, missed?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null } | null, cards?: { __typename?: 'PredictionsTeamsHomeLeagueCardsType', yellow?: { __typename?: 'StatMinuteType', zeroToFifteen?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, sixteenToThirty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, thirtyoneToFourtyfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, fourtysixToSixty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, fixtyoneToSeventyfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, seventysixToNinety?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, ninetyoneToHundredfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, hundredsixToHundredtwenty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null } | null, red?: { __typename?: 'StatMinuteType', zeroToFifteen?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, sixteenToThirty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, thirtyoneToFourtyfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, fourtysixToSixty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, fixtyoneToSeventyfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, seventysixToNinety?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, ninetyoneToHundredfive?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null, hundredsixToHundredtwenty?: { __typename?: 'StatTPType', total?: number | null, percentage?: string | null } | null } | null } | null } | null } | null } | null, comparison?: { __typename?: 'PredictionsComparisonType', form?: { __typename?: 'StatHAType', home?: string | null, away?: string | null } | null, att?: { __typename?: 'StatHAType', home?: string | null, away?: string | null } | null, def?: { __typename?: 'StatHAType', home?: string | null, away?: string | null } | null, poisson_distribution?: { __typename?: 'StatHAType', home?: string | null, away?: string | null } | null, h2h?: { __typename?: 'StatHAType', home?: string | null, away?: string | null } | null, goals?: { __typename?: 'StatHAType', home?: string | null, away?: string | null } | null, total?: { __typename?: 'StatHAType', home?: string | null, away?: string | null } | null } | null, h2h?: Array<{ __typename?: 'PredictionsH2HType', fixture?: { __typename?: 'PredictionsH2HFixtureType', id?: number | null, referee?: string | null, timezone?: string | null, date?: any | null, timestamp?: number | null, periods?: { __typename?: 'PredictionsH2HFixturePeriodsType', first?: number | null, second?: number | null } | null, venue?: { __typename?: 'PredictionsH2HFixtureVenueType', id?: number | null, name?: string | null, city?: string | null } | null, status?: { __typename?: 'PredictionsH2HFixtureStatusType', long?: string | null, short?: string | null, elapsed?: number | null } | null } | null, league?: { __typename?: 'PredictionsH2HLeagueType', id?: number | null, name?: string | null, country?: string | null, logo?: string | null, flag?: string | null, season?: number | null, round?: string | null } | null, teams?: { __typename?: 'PredictionsH2HTeamsType', home?: { __typename?: 'PredictionsH2HTeamsHAType', id?: number | null, name?: string | null, logo?: string | null, winner?: boolean | null } | null, away?: { __typename?: 'PredictionsH2HTeamsHAType', id?: number | null, name?: string | null, logo?: string | null, winner?: boolean | null } | null } | null, goals?: { __typename?: 'StatHAType', home?: string | null, away?: string | null } | null, score?: { __typename?: 'PredictionsH2HScoreType', halftime?: { __typename?: 'StatHAType', home?: string | null, away?: string | null } | null, fulltime?: { __typename?: 'StatHAType', home?: string | null, away?: string | null } | null, extratime?: { __typename?: 'StatHAType', home?: string | null, away?: string | null } | null, penalty?: { __typename?: 'StatHAType', home?: string | null, away?: string | null } | null } | null }> | null } };

export type GetLineupsFromProviderQueryVariables = Exact<{
  fixture: Scalars['Int']['input'];
}>;


export type GetLineupsFromProviderQuery = { __typename?: 'Query', getLineupsFromProvider: Array<{ __typename?: 'LineupsType', id: string, fixture?: number | null, formation?: string | null, createdAt: any, updatedAt: any, team?: { __typename?: 'LineupTeamType', id?: number | null, name?: string | null, logo?: string | null, colors?: { __typename?: 'LineupColorType', player?: { __typename?: 'LineupColorIntType', primary?: string | null, number?: string | null, border?: string | null } | null, goalkeeper?: { __typename?: 'LineupColorIntType', primary?: string | null, number?: string | null, border?: string | null } | null } | null } | null, startXI?: Array<{ __typename?: 'LineupStartXIType', player?: { __typename?: 'LineupPlayerType', id?: number | null, name?: string | null, number?: number | null, pos?: string | null, grid?: string | null } | null }> | null, substitutes?: Array<{ __typename?: 'LineupStartXIType', player?: { __typename?: 'LineupPlayerType', id?: number | null, name?: string | null, number?: number | null, pos?: string | null, grid?: string | null } | null }> | null, coach?: { __typename?: 'LineupCoachType', id?: number | null, name?: string | null, photo?: string | null } | null }> };

export type GetPlayOffsByRoundQueryVariables = Exact<{
  round: RoundsEnum;
  league: Scalars['Int']['input'];
  season: Scalars['Int']['input'];
}>;


export type GetPlayOffsByRoundQuery = { __typename?: 'Query', getPlayOffsByRound: Array<{ __typename?: 'FixtureType', isUserSubscribedToFixtureEvents?: boolean | null, createdAt?: any | null, updatedAt?: any | null, fixture?: { __typename?: 'FixtureSubType', id?: number | null, date?: any | null, referee?: string | null, timezone?: string | null, timestamp?: number | null, venue?: { __typename?: 'FixtureVenueType', id?: number | null, name?: string | null, city?: string | null } | null, status?: { __typename?: 'FixtureStatusType', long?: string | null, short?: string | null, elapsed?: number | null } | null, periods?: { __typename?: 'FixturePeriodType', first?: number | null, second?: string | null } | null } | null, score?: { __typename?: 'FixtureScoreType', penalty?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, halftime?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, fulltime?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, extratime?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null } | null, teams?: { __typename?: 'FixtureTeamsType', home?: { __typename?: 'FixtureHAType', id?: number | null, name?: string | null, logo?: string | null, winner?: boolean | null } | null, away?: { __typename?: 'FixtureHAType', id?: number | null, name?: string | null, logo?: string | null, winner?: boolean | null } | null } | null, goals?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, league?: { __typename?: 'FixtureLeagueType', id?: number | null, name?: string | null, logo?: string | null, flag?: string | null, round?: string | null, season?: number | null, country?: string | null } | null }> };

export type GetPreMatchOddsFromProviderQueryVariables = Exact<{
  fixtureId: Scalars['Int']['input'];
}>;


export type GetPreMatchOddsFromProviderQuery = { __typename?: 'Query', getPreMatchOddsFromProvider: Array<{ __typename?: 'OddsWithBetsType', id: string, odds?: Array<{ __typename?: 'OddsBookmakersBetsType', id?: number | null, name?: string | null, values?: Array<{ __typename?: 'OddsBookmakersBetsValuesType', value?: string | null, odd?: string | null }> | null }> | null }> };

export type GetLiveFixturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLiveFixturesQuery = { __typename?: 'Query', getLiveFixtures: Array<{ __typename?: 'FixtureType', id: string, isUserSubscribedToFixtureEvents?: boolean | null, createdAt?: any | null, updatedAt?: any | null, fixture?: { __typename?: 'FixtureSubType', id?: number | null, date?: any | null, referee?: string | null, timezone?: string | null, timestamp?: number | null, venue?: { __typename?: 'FixtureVenueType', id?: number | null, name?: string | null, city?: string | null } | null, status?: { __typename?: 'FixtureStatusType', long?: string | null, short?: string | null, elapsed?: number | null } | null, periods?: { __typename?: 'FixturePeriodType', first?: number | null, second?: string | null } | null } | null, score?: { __typename?: 'FixtureScoreType', penalty?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, halftime?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, fulltime?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, extratime?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null } | null, teams?: { __typename?: 'FixtureTeamsType', home?: { __typename?: 'FixtureHAType', id?: number | null, name?: string | null, logo?: string | null, winner?: boolean | null } | null, away?: { __typename?: 'FixtureHAType', id?: number | null, name?: string | null, logo?: string | null, winner?: boolean | null } | null } | null, goals?: { __typename?: 'FixtureGoalsType', home?: number | null, away?: number | null } | null, league?: { __typename?: 'FixtureLeagueType', id?: number | null, name?: string | null, logo?: string | null, flag?: string | null, round?: string | null, season?: number | null, country?: string | null } | null }> };

export type FindOneByLeagueQueryVariables = Exact<{
  leagueId: Scalars['Int']['input'];
}>;


export type FindOneByLeagueQuery = { __typename?: 'Query', findOneByLeague: { __typename?: 'LeagueType', id: string, league?: { __typename?: 'LeagueObjType', id: number, name?: string | null, type?: LeagueTypeEnum | null, logo?: string | null } | null, country?: { __typename?: 'CountryProviderType', id?: string | null, name?: string | null, code?: string | null, flag?: string | null } | null, seasons?: Array<{ __typename?: 'SeasonsType', year?: string | null, start?: any | null, end?: any | null, current?: boolean | null, coverage?: { __typename?: 'CoverageType', standings?: boolean | null, players?: boolean | null, top_scorers?: boolean | null, top_assists?: boolean | null, top_cards?: boolean | null, injuries?: boolean | null, predictions?: boolean | null, odds?: boolean | null, fixtures?: { __typename?: 'LeagueFixtureType', events?: boolean | null, lineups?: boolean | null, statistics_fixtures?: boolean | null, statistics_players?: boolean | null } | null } | null }> | null } };

export type GetPlayerStatisticsFromProviderQueryVariables = Exact<{
  fixture: Scalars['Int']['input'];
}>;


export type GetPlayerStatisticsFromProviderQuery = { __typename?: 'Query', getPlayerStatisticsFromProvider: Array<{ __typename?: 'PlayerStatisticsType', id: string, fixture?: number | null, createdAt: any, updatedAt: any, team?: { __typename?: 'PlayerStatisticsTeamType', id?: number | null, name?: string | null, logo?: string | null, update?: any | null } | null, players?: Array<{ __typename?: 'PlayerStatisticsPlayersType', player?: { __typename?: 'PlayerStatisticsPlayerType', id?: number | null, name?: string | null, photo?: string | null } | null, statistics?: Array<{ __typename?: 'PlayerStatisticsStatisticsType', offsides?: number | null, games?: { __typename?: 'PlayerStatisticsGamesType', minutes?: number | null, number?: number | null, position?: string | null, rating?: string | null, captain?: boolean | null, substitute?: boolean | null } | null, shots?: { __typename?: 'PlayerStatisticsShotsType', total?: number | null, on?: number | null } | null, goals?: { __typename?: 'PlayerStatisticsGoalsType', total?: number | null, conceded?: number | null, assists?: number | null, saves?: number | null } | null, passes?: { __typename?: 'PlayerStatisticsPassesType', total?: number | null, key?: number | null, accuracy?: string | null } | null, tackles?: { __typename?: 'PlayerStatisticsTacklesType', total?: number | null, blocks?: number | null, interceptions?: number | null } | null, duels?: { __typename?: 'PlayerStatisticsDuelsType', total?: number | null, won?: number | null } | null, dribbles?: { __typename?: 'PlayerStatisticsDribblesType', attempts?: number | null, success?: number | null, past?: number | null } | null, fouls?: { __typename?: 'PlayerStatisticsFoulsType', drawn?: number | null, committed?: number | null } | null, cards?: { __typename?: 'PlayerStatisticsCardsType', yellow?: number | null, red?: number | null } | null, penalty?: { __typename?: 'PlayerStatisticsPenaltyType', won?: number | null, commited?: number | null, scored?: number | null, missed?: number | null, saved?: number | null } | null }> | null }> | null }> };

export type GetPlayersStatsWithFilterQueryVariables = Exact<{
  filter: PlayersStatsFilterInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetPlayersStatsWithFilterQuery = { __typename?: 'Query', getPlayersStatsWithFilter: { __typename?: 'PlayersStatsPaginateType', count?: number | null, isLast?: boolean | null, objects: Array<{ __typename?: 'PlayersStatsType', id: string, player?: { __typename?: 'PlayersPlayerType', id?: number | null, name?: string | null, firstname?: string | null, lastname?: string | null, age?: number | null, nationality?: string | null, height?: string | null, weight?: string | null, injured?: string | null, photo?: string | null, birth?: { __typename?: 'PlayersPlayerBirthType', date?: any | null, place?: string | null, country?: string | null } | null } | null, statistics?: Array<{ __typename?: 'PlayersStatisticsType', team?: { __typename?: 'PlayersStatisticsTeamType', id?: number | null, name?: string | null, logo?: string | null } | null, games?: { __typename?: 'PlayersStatisticsGamesType', position?: string | null } | null, goals?: { __typename?: 'PlayersStatisticsGoalsType', total?: number | null, conceded?: number | null, assists?: number | null, saves?: number | null } | null }> | null }> } };

export type GetPlayerByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  season: Scalars['Int']['input'];
}>;


export type GetPlayerByIdQuery = { __typename?: 'Query', getPlayerById: { __typename?: 'PlayersStatsType', id: string, player?: { __typename?: 'PlayersPlayerType', id?: number | null, name?: string | null, firstname?: string | null, lastname?: string | null, age?: number | null, nationality?: string | null, height?: string | null, weight?: string | null, injured?: string | null, photo?: string | null, birth?: { __typename?: 'PlayersPlayerBirthType', date?: any | null, place?: string | null, country?: string | null } | null } | null, statistics?: Array<{ __typename?: 'PlayersStatisticsType', team?: { __typename?: 'PlayersStatisticsTeamType', id?: number | null, name?: string | null, logo?: string | null } | null, league?: { __typename?: 'PlayersStatisticsLeagueType', id?: number | null, name?: string | null, country?: string | null, logo?: string | null, flag?: string | null, season?: string | null } | null, games?: { __typename?: 'PlayersStatisticsGamesType', appearences?: number | null, lineups?: number | null, minutes?: number | null, number?: number | null, position?: string | null, rating?: string | null, captain?: boolean | null } | null, substitutes?: { __typename?: 'PlayersStatisticsSubstituesType', teamIn?: number | null, teamOut?: number | null, bench?: number | null } | null, shots?: { __typename?: 'PlayersStatisticsShotsType', total?: number | null, on?: number | null } | null, goals?: { __typename?: 'PlayersStatisticsGoalsType', total?: number | null, conceded?: number | null, assists?: number | null, saves?: number | null } | null, passes?: { __typename?: 'PlayersStatisticsPassesType', total?: number | null, key?: number | null, accuracy?: number | null } | null, tackles?: { __typename?: 'PlayersStatisticsTacklesType', total?: number | null, blocks?: number | null, interceptions?: number | null } | null, duels?: { __typename?: 'PlayersStatisticsDuelsType', total?: number | null, won?: number | null } | null, dribbles?: { __typename?: 'PlayersStatisticsDribblesType', attempts?: number | null, success?: number | null, past?: number | null } | null, fouls?: { __typename?: 'PlayersStatisticsFoulsType', drawn?: number | null, committed?: number | null } | null, cards?: { __typename?: 'PlayersStatisticsCardsType', yellow?: number | null, yellowred?: number | null, red?: number | null } | null, penalty?: { __typename?: 'PlayersStatisticsPenaltyType', won?: number | null, commited?: number | null, scored?: number | null, missed?: number | null, saved?: number | null } | null }> | null } };

export type GetStandingsQueryVariables = Exact<{
  input: GetStandingsInput;
}>;


export type GetStandingsQuery = { __typename?: 'Query', getStandings: Array<{ __typename?: 'StandingsType', id: string, league?: { __typename?: 'StandingLeagueType', id?: number | null, name?: string | null, country?: string | null, logo?: string | null, flag?: string | null, season?: number | null, standings?: Array<Array<{ __typename?: 'StandingType', rank?: number | null, points?: number | null, goalsDiff?: number | null, group?: string | null, form?: string | null, status?: string | null, description?: string | null, update?: any | null, team?: { __typename?: 'StandingTeamType', id?: number | null, name?: string | null, logo?: string | null } | null, all?: { __typename?: 'StandingStatType', played?: number | null, win?: number | null, lose?: number | null, goals?: { __typename?: 'StandingStatGoalsType', forstat?: number | null, against?: number | null } | null } | null, home?: { __typename?: 'StandingStatType', played?: number | null, win?: number | null, lose?: number | null, goals?: { __typename?: 'StandingStatGoalsType', forstat?: number | null, against?: number | null } | null } | null, away?: { __typename?: 'StandingStatType', played?: number | null, win?: number | null, lose?: number | null, goals?: { __typename?: 'StandingStatGoalsType', forstat?: number | null, against?: number | null } | null } | null }>> | null } | null }> };

export type GetStatisticsFromProviderQueryVariables = Exact<{
  fixture: Scalars['Int']['input'];
}>;


export type GetStatisticsFromProviderQuery = { __typename?: 'Query', getStatisticsFromProvider: Array<{ __typename?: 'StatisticsType', id: string, createdAt: any, updatedAt: any, team?: { __typename?: 'StatisticsTeamsType', id?: number | null, name?: string | null, logo?: string | null } | null, statistics?: Array<{ __typename?: 'StatisticsIntType', type?: string | null, value?: string | null }> | null }> };

export type GetTopAssistsQueryVariables = Exact<{
  league: Scalars['Int']['input'];
  season: Scalars['Int']['input'];
}>;


export type GetTopAssistsQuery = { __typename?: 'Query', getTopAssists: Array<{ __typename?: 'TopAssistsType', id: string, season?: number | null, league?: number | null, createdAt: any, updatedAt: any, topAssists?: Array<{ __typename?: 'PlayersStatsType', player?: { __typename?: 'PlayersPlayerType', id?: number | null, name?: string | null, firstname?: string | null, lastname?: string | null, age?: number | null, nationality?: string | null, height?: string | null, weight?: string | null, injured?: string | null, photo?: string | null, birth?: { __typename?: 'PlayersPlayerBirthType', date?: any | null, place?: string | null, country?: string | null } | null } | null, statistics?: Array<{ __typename?: 'PlayersStatisticsType', team?: { __typename?: 'PlayersStatisticsTeamType', id?: number | null, name?: string | null, logo?: string | null } | null, league?: { __typename?: 'PlayersStatisticsLeagueType', id?: number | null, name?: string | null, country?: string | null, logo?: string | null, flag?: string | null, season?: string | null } | null, games?: { __typename?: 'PlayersStatisticsGamesType', appearences?: number | null, lineups?: number | null, minutes?: number | null, number?: number | null, position?: string | null, rating?: string | null, captain?: boolean | null } | null, substitutes?: { __typename?: 'PlayersStatisticsSubstituesType', teamIn?: number | null, teamOut?: number | null, bench?: number | null } | null, shots?: { __typename?: 'PlayersStatisticsShotsType', total?: number | null, on?: number | null } | null, goals?: { __typename?: 'PlayersStatisticsGoalsType', total?: number | null, conceded?: number | null, assists?: number | null, saves?: number | null } | null, passes?: { __typename?: 'PlayersStatisticsPassesType', total?: number | null, key?: number | null, accuracy?: number | null } | null, tackles?: { __typename?: 'PlayersStatisticsTacklesType', total?: number | null, blocks?: number | null, interceptions?: number | null } | null, duels?: { __typename?: 'PlayersStatisticsDuelsType', total?: number | null, won?: number | null } | null, dribbles?: { __typename?: 'PlayersStatisticsDribblesType', attempts?: number | null, success?: number | null, past?: number | null } | null, fouls?: { __typename?: 'PlayersStatisticsFoulsType', drawn?: number | null, committed?: number | null } | null, cards?: { __typename?: 'PlayersStatisticsCardsType', yellow?: number | null, yellowred?: number | null, red?: number | null } | null, penalty?: { __typename?: 'PlayersStatisticsPenaltyType', won?: number | null, commited?: number | null, scored?: number | null, missed?: number | null, saved?: number | null } | null }> | null }> | null }> };

export type GetTopRedCardsQueryVariables = Exact<{
  league: Scalars['Int']['input'];
  season: Scalars['Int']['input'];
}>;


export type GetTopRedCardsQuery = { __typename?: 'Query', getTopRedCards: Array<{ __typename?: 'TopRedCardsType', id: string, season?: number | null, league?: number | null, createdAt: any, updatedAt: any, topRedCards?: Array<{ __typename?: 'PlayersStatsType', player?: { __typename?: 'PlayersPlayerType', id?: number | null, name?: string | null, firstname?: string | null, lastname?: string | null, age?: number | null, nationality?: string | null, height?: string | null, weight?: string | null, injured?: string | null, photo?: string | null, birth?: { __typename?: 'PlayersPlayerBirthType', date?: any | null, place?: string | null, country?: string | null } | null } | null, statistics?: Array<{ __typename?: 'PlayersStatisticsType', team?: { __typename?: 'PlayersStatisticsTeamType', id?: number | null, name?: string | null, logo?: string | null } | null, league?: { __typename?: 'PlayersStatisticsLeagueType', id?: number | null, name?: string | null, country?: string | null, logo?: string | null, flag?: string | null, season?: string | null } | null, games?: { __typename?: 'PlayersStatisticsGamesType', appearences?: number | null, lineups?: number | null, minutes?: number | null, number?: number | null, position?: string | null, rating?: string | null, captain?: boolean | null } | null, substitutes?: { __typename?: 'PlayersStatisticsSubstituesType', teamIn?: number | null, teamOut?: number | null, bench?: number | null } | null, shots?: { __typename?: 'PlayersStatisticsShotsType', total?: number | null, on?: number | null } | null, goals?: { __typename?: 'PlayersStatisticsGoalsType', total?: number | null, conceded?: number | null, assists?: number | null, saves?: number | null } | null, passes?: { __typename?: 'PlayersStatisticsPassesType', total?: number | null, key?: number | null, accuracy?: number | null } | null, tackles?: { __typename?: 'PlayersStatisticsTacklesType', total?: number | null, blocks?: number | null, interceptions?: number | null } | null, duels?: { __typename?: 'PlayersStatisticsDuelsType', total?: number | null, won?: number | null } | null, dribbles?: { __typename?: 'PlayersStatisticsDribblesType', attempts?: number | null, success?: number | null, past?: number | null } | null, fouls?: { __typename?: 'PlayersStatisticsFoulsType', drawn?: number | null, committed?: number | null } | null, cards?: { __typename?: 'PlayersStatisticsCardsType', yellow?: number | null, yellowred?: number | null, red?: number | null } | null, penalty?: { __typename?: 'PlayersStatisticsPenaltyType', won?: number | null, commited?: number | null, scored?: number | null, missed?: number | null, saved?: number | null } | null }> | null }> | null }> };

export type GetTopScorersQueryVariables = Exact<{
  league: Scalars['Int']['input'];
  season: Scalars['Int']['input'];
}>;


export type GetTopScorersQuery = { __typename?: 'Query', getTopScorers: { __typename?: 'TopScorersType', id: string, season?: number | null, league?: number | null, createdAt: any, updatedAt: any, topScorers?: Array<{ __typename?: 'PlayersStatsType', player?: { __typename?: 'PlayersPlayerType', id?: number | null, name?: string | null, firstname?: string | null, lastname?: string | null, age?: number | null, nationality?: string | null, height?: string | null, weight?: string | null, injured?: string | null, photo?: string | null, birth?: { __typename?: 'PlayersPlayerBirthType', date?: any | null, place?: string | null, country?: string | null } | null } | null, statistics?: Array<{ __typename?: 'PlayersStatisticsType', team?: { __typename?: 'PlayersStatisticsTeamType', id?: number | null, name?: string | null, logo?: string | null } | null, league?: { __typename?: 'PlayersStatisticsLeagueType', id?: number | null, name?: string | null, country?: string | null, logo?: string | null, flag?: string | null, season?: string | null } | null, games?: { __typename?: 'PlayersStatisticsGamesType', appearences?: number | null, lineups?: number | null, minutes?: number | null, number?: number | null, position?: string | null, rating?: string | null, captain?: boolean | null } | null, substitutes?: { __typename?: 'PlayersStatisticsSubstituesType', teamIn?: number | null, teamOut?: number | null, bench?: number | null } | null, shots?: { __typename?: 'PlayersStatisticsShotsType', total?: number | null, on?: number | null } | null, goals?: { __typename?: 'PlayersStatisticsGoalsType', total?: number | null, conceded?: number | null, assists?: number | null, saves?: number | null } | null, passes?: { __typename?: 'PlayersStatisticsPassesType', total?: number | null, key?: number | null, accuracy?: number | null } | null, tackles?: { __typename?: 'PlayersStatisticsTacklesType', total?: number | null, blocks?: number | null, interceptions?: number | null } | null, duels?: { __typename?: 'PlayersStatisticsDuelsType', total?: number | null, won?: number | null } | null, dribbles?: { __typename?: 'PlayersStatisticsDribblesType', attempts?: number | null, success?: number | null, past?: number | null } | null, fouls?: { __typename?: 'PlayersStatisticsFoulsType', drawn?: number | null, committed?: number | null } | null, cards?: { __typename?: 'PlayersStatisticsCardsType', yellow?: number | null, yellowred?: number | null, red?: number | null } | null, penalty?: { __typename?: 'PlayersStatisticsPenaltyType', won?: number | null, commited?: number | null, scored?: number | null, missed?: number | null, saved?: number | null } | null }> | null }> | null } };

export type GetTopYellowCardsQueryVariables = Exact<{
  league: Scalars['Int']['input'];
  season: Scalars['Int']['input'];
}>;


export type GetTopYellowCardsQuery = { __typename?: 'Query', getTopYellowCards: { __typename?: 'TopYellowCardsType', id: string, season?: number | null, league?: number | null, createdAt: any, updatedAt: any, topYellowCards?: Array<{ __typename?: 'PlayersStatsType', player?: { __typename?: 'PlayersPlayerType', id?: number | null, name?: string | null, firstname?: string | null, lastname?: string | null, age?: number | null, nationality?: string | null, height?: string | null, weight?: string | null, injured?: string | null, photo?: string | null, birth?: { __typename?: 'PlayersPlayerBirthType', date?: any | null, place?: string | null, country?: string | null } | null } | null, statistics?: Array<{ __typename?: 'PlayersStatisticsType', team?: { __typename?: 'PlayersStatisticsTeamType', id?: number | null, name?: string | null, logo?: string | null } | null, league?: { __typename?: 'PlayersStatisticsLeagueType', id?: number | null, name?: string | null, country?: string | null, logo?: string | null, flag?: string | null, season?: string | null } | null, games?: { __typename?: 'PlayersStatisticsGamesType', appearences?: number | null, lineups?: number | null, minutes?: number | null, number?: number | null, position?: string | null, rating?: string | null, captain?: boolean | null } | null, substitutes?: { __typename?: 'PlayersStatisticsSubstituesType', teamIn?: number | null, teamOut?: number | null, bench?: number | null } | null, shots?: { __typename?: 'PlayersStatisticsShotsType', total?: number | null, on?: number | null } | null, goals?: { __typename?: 'PlayersStatisticsGoalsType', total?: number | null, conceded?: number | null, assists?: number | null, saves?: number | null } | null, passes?: { __typename?: 'PlayersStatisticsPassesType', total?: number | null, key?: number | null, accuracy?: number | null } | null, tackles?: { __typename?: 'PlayersStatisticsTacklesType', total?: number | null, blocks?: number | null, interceptions?: number | null } | null, duels?: { __typename?: 'PlayersStatisticsDuelsType', total?: number | null, won?: number | null } | null, dribbles?: { __typename?: 'PlayersStatisticsDribblesType', attempts?: number | null, success?: number | null, past?: number | null } | null, fouls?: { __typename?: 'PlayersStatisticsFoulsType', drawn?: number | null, committed?: number | null } | null, cards?: { __typename?: 'PlayersStatisticsCardsType', yellow?: number | null, yellowred?: number | null, red?: number | null } | null, penalty?: { __typename?: 'PlayersStatisticsPenaltyType', won?: number | null, commited?: number | null, scored?: number | null, missed?: number | null, saved?: number | null } | null }> | null }> | null } };

export type LoginUserByTargetMutationVariables = Exact<{
  input: LoginUserByTargetInput;
}>;


export type LoginUserByTargetMutation = { __typename?: 'Mutation', loginUserByTarget: { __typename?: 'LoginType', expiresIn: number, accessToken: string, user: { __typename?: 'UserType', id: string, email?: string | null, gender?: Gender | null, status?: UserStatus | null, lastName?: string | null, username?: string | null, firstName?: string | null, phone?: { __typename?: 'PhoneType', number?: string | null, isValid?: boolean | null, countryCode?: string | null, validationNumber?: number | null } | null, picture?: { __typename?: 'PictureType', baseUrl?: string | null, path?: string | null, width?: number | null, height?: number | null, x?: number | null, y?: number | null, alt?: string | null } | null } } };

export type LoginForTargetQueryVariables = Exact<{
  login?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<IPhoneInput>;
  password: Scalars['String']['input'];
  target: TargetAciInput;
}>;


export type LoginForTargetQuery = { __typename?: 'Query', loginForTarget: { __typename?: 'LoginType', expiresIn: number, accessToken: string, user: { __typename?: 'UserType', id: string } } };

export const GetFinishedBetOrdersByTargetPaginationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFinishedBetOrdersByTargetPagination"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFinishedBetOrdersByTargetPagination"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fixture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"short"}},{"kind":"Field","name":{"kind":"Name","value":"long"}},{"kind":"Field","name":{"kind":"Name","value":"elapsed"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"winner"}}]}},{"kind":"Field","name":{"kind":"Name","value":"away"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"winner"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"odds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"odd"}},{"kind":"Field","name":{"kind":"Name","value":"gains"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxWin"}},{"kind":"Field","name":{"kind":"Name","value":"finalWin"}},{"kind":"Field","name":{"kind":"Name","value":"fixture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFinishedBetOrdersByTargetPaginationGQL extends Apollo.Query<GetFinishedBetOrdersByTargetPaginationQuery, GetFinishedBetOrdersByTargetPaginationQueryVariables> {
    document = GetFinishedBetOrdersByTargetPaginationDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPendingBetOrdersByTargetPaginationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPendingBetOrdersByTargetPagination"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPendingBetOrdersByTargetPagination"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fixture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"short"}},{"kind":"Field","name":{"kind":"Name","value":"long"}},{"kind":"Field","name":{"kind":"Name","value":"elapsed"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"winner"}}]}},{"kind":"Field","name":{"kind":"Name","value":"away"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"winner"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"odds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"odd"}},{"kind":"Field","name":{"kind":"Name","value":"gains"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxWin"}},{"kind":"Field","name":{"kind":"Name","value":"finalWin"}},{"kind":"Field","name":{"kind":"Name","value":"fixture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPendingBetOrdersByTargetPaginationGQL extends Apollo.Query<GetPendingBetOrdersByTargetPaginationQuery, GetPendingBetOrdersByTargetPaginationQueryVariables> {
    document = GetPendingBetOrdersByTargetPaginationDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCurrentUserPendingBetOrdersPaginationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCurrentUserPendingBetOrdersPagination"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCurrentUserPendingBetOrdersPagination"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fixture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"short"}},{"kind":"Field","name":{"kind":"Name","value":"long"}},{"kind":"Field","name":{"kind":"Name","value":"elapsed"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"winner"}}]}},{"kind":"Field","name":{"kind":"Name","value":"away"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"winner"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"odds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"odd"}},{"kind":"Field","name":{"kind":"Name","value":"gains"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxWin"}},{"kind":"Field","name":{"kind":"Name","value":"finalWin"}},{"kind":"Field","name":{"kind":"Name","value":"fixture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCurrentUserPendingBetOrdersPaginationGQL extends Apollo.Query<GetCurrentUserPendingBetOrdersPaginationQuery, GetCurrentUserPendingBetOrdersPaginationQueryVariables> {
    document = GetCurrentUserPendingBetOrdersPaginationDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCurrentUserFinishedBetOrdersPaginationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCurrentUserFinishedBetOrdersPagination"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCurrentUserFinishedBetOrdersPagination"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fixture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"short"}},{"kind":"Field","name":{"kind":"Name","value":"long"}},{"kind":"Field","name":{"kind":"Name","value":"elapsed"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"winner"}}]}},{"kind":"Field","name":{"kind":"Name","value":"away"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"winner"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"odds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"odd"}},{"kind":"Field","name":{"kind":"Name","value":"gains"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"bet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxWin"}},{"kind":"Field","name":{"kind":"Name","value":"finalWin"}},{"kind":"Field","name":{"kind":"Name","value":"fixture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCurrentUserFinishedBetOrdersPaginationGQL extends Apollo.Query<GetCurrentUserFinishedBetOrdersPaginationQuery, GetCurrentUserFinishedBetOrdersPaginationQueryVariables> {
    document = GetCurrentUserFinishedBetOrdersPaginationDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PlaceBetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"placeBet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BetOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placeBet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxWin"}},{"kind":"Field","name":{"kind":"Name","value":"finalWin"}},{"kind":"Field","name":{"kind":"Name","value":"fixture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fixture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class PlaceBetGQL extends Apollo.Mutation<PlaceBetMutation, PlaceBetMutationVariables> {
    document = PlaceBetDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFixturesWithFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFixturesWithFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FixtureFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFixturesWithFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fixture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"referee"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"venue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"long"}},{"kind":"Field","name":{"kind":"Name","value":"short"}},{"kind":"Field","name":{"kind":"Name","value":"elapsed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"periods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first"}},{"kind":"Field","name":{"kind":"Name","value":"second"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"penalty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"halftime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fulltime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extratime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"winner"}}]}},{"kind":"Field","name":{"kind":"Name","value":"away"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"winner"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"flag"}},{"kind":"Field","name":{"kind":"Name","value":"round"}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isUserSubscribedToFixtureEvents"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFixturesWithFilterGQL extends Apollo.Query<GetFixturesWithFilterQuery, GetFixturesWithFilterQueryVariables> {
    document = GetFixturesWithFilterDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFixturesWithFilterWithSubsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFixturesWithFilterWithSubs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FixtureFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFixturesWithFilterWithSubs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fixture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"referee"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"venue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"long"}},{"kind":"Field","name":{"kind":"Name","value":"short"}},{"kind":"Field","name":{"kind":"Name","value":"elapsed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"periods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first"}},{"kind":"Field","name":{"kind":"Name","value":"second"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"penalty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"halftime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fulltime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extratime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"winner"}}]}},{"kind":"Field","name":{"kind":"Name","value":"away"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"winner"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"flag"}},{"kind":"Field","name":{"kind":"Name","value":"round"}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isUserSubscribedToFixtureEvents"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFixturesWithFilterWithSubsGQL extends Apollo.Query<GetFixturesWithFilterWithSubsQuery, GetFixturesWithFilterWithSubsQueryVariables> {
    document = GetFixturesWithFilterWithSubsDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFixturesWithFilterAndOddsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFixturesWithFilterAndOdds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FixtureFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFixturesWithFilterAndOdds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fixture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"referee"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"venue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"long"}},{"kind":"Field","name":{"kind":"Name","value":"short"}},{"kind":"Field","name":{"kind":"Name","value":"elapsed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"periods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first"}},{"kind":"Field","name":{"kind":"Name","value":"second"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"penalty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"halftime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fulltime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extratime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"winner"}}]}},{"kind":"Field","name":{"kind":"Name","value":"away"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"winner"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"flag"}},{"kind":"Field","name":{"kind":"Name","value":"round"}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"odds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"odd"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFixturesWithFilterAndOddsGQL extends Apollo.Query<GetFixturesWithFilterAndOddsQuery, GetFixturesWithFilterAndOddsQueryVariables> {
    document = GetFixturesWithFilterAndOddsDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindOneByFixtureIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findOneByFixtureId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fixtureId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findOneByFixtureId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fixtureId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fixtureId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fixture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"referee"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"venue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"long"}},{"kind":"Field","name":{"kind":"Name","value":"short"}},{"kind":"Field","name":{"kind":"Name","value":"elapsed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"periods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first"}},{"kind":"Field","name":{"kind":"Name","value":"second"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"penalty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"halftime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fulltime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extratime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"winner"}}]}},{"kind":"Field","name":{"kind":"Name","value":"away"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"winner"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"flag"}},{"kind":"Field","name":{"kind":"Name","value":"round"}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class FindOneByFixtureIdGQL extends Apollo.Query<FindOneByFixtureIdQuery, FindOneByFixtureIdQueryVariables> {
    document = FindOneByFixtureIdDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFavoriteLeagueDefinitionsPaginationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFavoriteLeagueDefinitionsPagination"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFavoriteLeagueDefinitionsPagination"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFavoriteLeagueDefinitionsPaginationGQL extends Apollo.Query<GetFavoriteLeagueDefinitionsPaginationQuery, GetFavoriteLeagueDefinitionsPaginationQueryVariables> {
    document = GetFavoriteLeagueDefinitionsPaginationDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventsFromProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEventsFromProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fixture"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEventsFromProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fixture"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fixture"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fixture"}},{"kind":"Field","name":{"kind":"Name","value":"time"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"elapsed"}},{"kind":"Field","name":{"kind":"Name","value":"extra"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"player"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEventsFromProviderGQL extends Apollo.Query<GetEventsFromProviderQuery, GetEventsFromProviderQueryVariables> {
    document = GetEventsFromProviderDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPredictionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPredictions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fixture"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPredictions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fixture"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fixture"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fixture"}},{"kind":"Field","name":{"kind":"Name","value":"predictions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"winner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"win_or_draw"}},{"kind":"Field","name":{"kind":"Name","value":"under_over"}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"advice"}},{"kind":"Field","name":{"kind":"Name","value":"percent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"draw"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"flag"}},{"kind":"Field","name":{"kind":"Name","value":"season"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"last_5"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"att"}},{"kind":"Field","name":{"kind":"Name","value":"def"}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forstat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"average"}}]}},{"kind":"Field","name":{"kind":"Name","value":"against"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"average"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"fixtures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"played"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"draws"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"loses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forstat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"average"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zeroToFifteen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sixteenToThirty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thirtyoneToFourtyfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fourtysixToSixty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fixtyoneToSeventyfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seventysixToNinety"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ninetyoneToHundredfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hundredsixToHundredtwenty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"against"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"average"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zeroToFifteen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sixteenToThirty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thirtyoneToFourtyfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fourtysixToSixty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fixtyoneToSeventyfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seventysixToNinety"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ninetyoneToHundredfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hundredsixToHundredtwenty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"biggest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wins"}},{"kind":"Field","name":{"kind":"Name","value":"draws"}},{"kind":"Field","name":{"kind":"Name","value":"loses"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"loses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forstat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"against"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"clean_sheet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"failed_to_score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"penalty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scored"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"missed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yellow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zeroToFifteen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sixteenToThirty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thirtyoneToFourtyfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fourtysixToSixty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fixtyoneToSeventyfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seventysixToNinety"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ninetyoneToHundredfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hundredsixToHundredtwenty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"red"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zeroToFifteen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sixteenToThirty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thirtyoneToFourtyfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fourtysixToSixty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fixtyoneToSeventyfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seventysixToNinety"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ninetyoneToHundredfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hundredsixToHundredtwenty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"away"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"last_5"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"att"}},{"kind":"Field","name":{"kind":"Name","value":"def"}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forstat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"average"}}]}},{"kind":"Field","name":{"kind":"Name","value":"against"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"average"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"fixtures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"played"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"draws"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"loses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forstat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"average"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zeroToFifteen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sixteenToThirty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thirtyoneToFourtyfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fourtysixToSixty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fixtyoneToSeventyfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seventysixToNinety"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ninetyoneToHundredfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hundredsixToHundredtwenty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"against"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"average"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zeroToFifteen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sixteenToThirty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thirtyoneToFourtyfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fourtysixToSixty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fixtyoneToSeventyfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seventysixToNinety"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ninetyoneToHundredfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hundredsixToHundredtwenty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"biggest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wins"}},{"kind":"Field","name":{"kind":"Name","value":"draws"}},{"kind":"Field","name":{"kind":"Name","value":"loses"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"loses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forstat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"against"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"clean_sheet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"failed_to_score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"penalty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scored"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"missed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yellow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zeroToFifteen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sixteenToThirty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thirtyoneToFourtyfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fourtysixToSixty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fixtyoneToSeventyfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seventysixToNinety"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ninetyoneToHundredfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hundredsixToHundredtwenty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"red"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zeroToFifteen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sixteenToThirty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thirtyoneToFourtyfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fourtysixToSixty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fixtyoneToSeventyfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seventysixToNinety"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ninetyoneToHundredfive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hundredsixToHundredtwenty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"comparison"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"att"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"def"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"poisson_distribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"h2h"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"h2h"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referee"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"periods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first"}},{"kind":"Field","name":{"kind":"Name","value":"second"}}]}},{"kind":"Field","name":{"kind":"Name","value":"venue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"long"}},{"kind":"Field","name":{"kind":"Name","value":"short"}},{"kind":"Field","name":{"kind":"Name","value":"elapsed"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"flag"}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"round"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"winner"}}]}},{"kind":"Field","name":{"kind":"Name","value":"away"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"winner"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"halftime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fulltime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extratime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"penalty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPredictionsGQL extends Apollo.Query<GetPredictionsQuery, GetPredictionsQueryVariables> {
    document = GetPredictionsDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLineupsFromProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLineupsFromProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fixture"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLineupsFromProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fixture"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fixture"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fixture"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"player"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"border"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goalkeeper"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"border"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formation"}},{"kind":"Field","name":{"kind":"Name","value":"startXI"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"player"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"pos"}},{"kind":"Field","name":{"kind":"Name","value":"grid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"substitutes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"player"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"pos"}},{"kind":"Field","name":{"kind":"Name","value":"grid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coach"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"photo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLineupsFromProviderGQL extends Apollo.Query<GetLineupsFromProviderQuery, GetLineupsFromProviderQueryVariables> {
    document = GetLineupsFromProviderDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPlayOffsByRoundDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPlayOffsByRound"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"round"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RoundsEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"league"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"season"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPlayOffsByRound"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"round"},"value":{"kind":"Variable","name":{"kind":"Name","value":"round"}}},{"kind":"Argument","name":{"kind":"Name","value":"league"},"value":{"kind":"Variable","name":{"kind":"Name","value":"league"}}},{"kind":"Argument","name":{"kind":"Name","value":"season"},"value":{"kind":"Variable","name":{"kind":"Name","value":"season"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"referee"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"venue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"long"}},{"kind":"Field","name":{"kind":"Name","value":"short"}},{"kind":"Field","name":{"kind":"Name","value":"elapsed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"periods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first"}},{"kind":"Field","name":{"kind":"Name","value":"second"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"penalty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"halftime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fulltime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extratime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"winner"}}]}},{"kind":"Field","name":{"kind":"Name","value":"away"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"winner"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"flag"}},{"kind":"Field","name":{"kind":"Name","value":"round"}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isUserSubscribedToFixtureEvents"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPlayOffsByRoundGQL extends Apollo.Query<GetPlayOffsByRoundQuery, GetPlayOffsByRoundQueryVariables> {
    document = GetPlayOffsByRoundDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPreMatchOddsFromProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPreMatchOddsFromProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fixtureId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPreMatchOddsFromProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fixtureId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fixtureId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"odds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"odd"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPreMatchOddsFromProviderGQL extends Apollo.Query<GetPreMatchOddsFromProviderQuery, GetPreMatchOddsFromProviderQueryVariables> {
    document = GetPreMatchOddsFromProviderDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLiveFixturesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLiveFixtures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLiveFixtures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fixture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"referee"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"venue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"long"}},{"kind":"Field","name":{"kind":"Name","value":"short"}},{"kind":"Field","name":{"kind":"Name","value":"elapsed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"periods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first"}},{"kind":"Field","name":{"kind":"Name","value":"second"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"penalty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"halftime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fulltime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extratime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"winner"}}]}},{"kind":"Field","name":{"kind":"Name","value":"away"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"winner"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home"}},{"kind":"Field","name":{"kind":"Name","value":"away"}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"flag"}},{"kind":"Field","name":{"kind":"Name","value":"round"}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isUserSubscribedToFixtureEvents"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLiveFixturesGQL extends Apollo.Query<GetLiveFixturesQuery, GetLiveFixturesQueryVariables> {
    document = GetLiveFixturesDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindOneByLeagueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findOneByLeague"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leagueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findOneByLeague"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"leagueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leagueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"flag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"coverage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixtures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"}},{"kind":"Field","name":{"kind":"Name","value":"lineups"}},{"kind":"Field","name":{"kind":"Name","value":"statistics_fixtures"}},{"kind":"Field","name":{"kind":"Name","value":"statistics_players"}}]}},{"kind":"Field","name":{"kind":"Name","value":"standings"}},{"kind":"Field","name":{"kind":"Name","value":"players"}},{"kind":"Field","name":{"kind":"Name","value":"top_scorers"}},{"kind":"Field","name":{"kind":"Name","value":"top_assists"}},{"kind":"Field","name":{"kind":"Name","value":"top_cards"}},{"kind":"Field","name":{"kind":"Name","value":"injuries"}},{"kind":"Field","name":{"kind":"Name","value":"predictions"}},{"kind":"Field","name":{"kind":"Name","value":"odds"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class FindOneByLeagueGQL extends Apollo.Query<FindOneByLeagueQuery, FindOneByLeagueQueryVariables> {
    document = FindOneByLeagueDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPlayerStatisticsFromProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPlayerStatisticsFromProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fixture"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPlayerStatisticsFromProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fixture"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fixture"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fixture"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"update"}}]}},{"kind":"Field","name":{"kind":"Name","value":"players"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"player"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"photo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"games"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"captain"}},{"kind":"Field","name":{"kind":"Name","value":"substitute"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offsides"}},{"kind":"Field","name":{"kind":"Name","value":"shots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"on"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"conceded"}},{"kind":"Field","name":{"kind":"Name","value":"assists"}},{"kind":"Field","name":{"kind":"Name","value":"saves"}}]}},{"kind":"Field","name":{"kind":"Name","value":"passes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"accuracy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tackles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}},{"kind":"Field","name":{"kind":"Name","value":"interceptions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"won"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dribbles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attempts"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"past"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fouls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"drawn"}},{"kind":"Field","name":{"kind":"Name","value":"committed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yellow"}},{"kind":"Field","name":{"kind":"Name","value":"red"}}]}},{"kind":"Field","name":{"kind":"Name","value":"penalty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"won"}},{"kind":"Field","name":{"kind":"Name","value":"commited"}},{"kind":"Field","name":{"kind":"Name","value":"scored"}},{"kind":"Field","name":{"kind":"Name","value":"missed"}},{"kind":"Field","name":{"kind":"Name","value":"saved"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPlayerStatisticsFromProviderGQL extends Apollo.Query<GetPlayerStatisticsFromProviderQuery, GetPlayerStatisticsFromProviderQueryVariables> {
    document = GetPlayerStatisticsFromProviderDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPlayersStatsWithFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPlayersStatsWithFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PlayersStatsFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPlayersStatsWithFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"isLast"}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"player"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"birth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"place"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nationality"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"injured"}},{"kind":"Field","name":{"kind":"Name","value":"photo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"games"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"conceded"}},{"kind":"Field","name":{"kind":"Name","value":"assists"}},{"kind":"Field","name":{"kind":"Name","value":"saves"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPlayersStatsWithFilterGQL extends Apollo.Query<GetPlayersStatsWithFilterQuery, GetPlayersStatsWithFilterQueryVariables> {
    document = GetPlayersStatsWithFilterDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPlayerByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPlayerById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"season"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPlayerById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"season"},"value":{"kind":"Variable","name":{"kind":"Name","value":"season"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"player"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"birth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"place"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nationality"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"injured"}},{"kind":"Field","name":{"kind":"Name","value":"photo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"flag"}},{"kind":"Field","name":{"kind":"Name","value":"season"}}]}},{"kind":"Field","name":{"kind":"Name","value":"games"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appearences"}},{"kind":"Field","name":{"kind":"Name","value":"lineups"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"captain"}}]}},{"kind":"Field","name":{"kind":"Name","value":"substitutes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamIn"}},{"kind":"Field","name":{"kind":"Name","value":"teamOut"}},{"kind":"Field","name":{"kind":"Name","value":"bench"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"on"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"conceded"}},{"kind":"Field","name":{"kind":"Name","value":"assists"}},{"kind":"Field","name":{"kind":"Name","value":"saves"}}]}},{"kind":"Field","name":{"kind":"Name","value":"passes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"accuracy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tackles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}},{"kind":"Field","name":{"kind":"Name","value":"interceptions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"won"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dribbles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attempts"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"past"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fouls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"drawn"}},{"kind":"Field","name":{"kind":"Name","value":"committed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yellow"}},{"kind":"Field","name":{"kind":"Name","value":"yellowred"}},{"kind":"Field","name":{"kind":"Name","value":"red"}}]}},{"kind":"Field","name":{"kind":"Name","value":"penalty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"won"}},{"kind":"Field","name":{"kind":"Name","value":"commited"}},{"kind":"Field","name":{"kind":"Name","value":"scored"}},{"kind":"Field","name":{"kind":"Name","value":"missed"}},{"kind":"Field","name":{"kind":"Name","value":"saved"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPlayerByIdGQL extends Apollo.Query<GetPlayerByIdQuery, GetPlayerByIdQueryVariables> {
    document = GetPlayerByIdDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStandingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStandings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetStandingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getStandings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"flag"}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"standings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"goalsDiff"}},{"kind":"Field","name":{"kind":"Name","value":"group"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"all"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"played"}},{"kind":"Field","name":{"kind":"Name","value":"win"}},{"kind":"Field","name":{"kind":"Name","value":"lose"}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forstat"}},{"kind":"Field","name":{"kind":"Name","value":"against"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"played"}},{"kind":"Field","name":{"kind":"Name","value":"win"}},{"kind":"Field","name":{"kind":"Name","value":"lose"}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forstat"}},{"kind":"Field","name":{"kind":"Name","value":"against"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"away"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"played"}},{"kind":"Field","name":{"kind":"Name","value":"win"}},{"kind":"Field","name":{"kind":"Name","value":"lose"}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forstat"}},{"kind":"Field","name":{"kind":"Name","value":"against"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStandingsGQL extends Apollo.Query<GetStandingsQuery, GetStandingsQueryVariables> {
    document = GetStandingsDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStatisticsFromProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStatisticsFromProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fixture"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getStatisticsFromProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fixture"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fixture"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStatisticsFromProviderGQL extends Apollo.Query<GetStatisticsFromProviderQuery, GetStatisticsFromProviderQueryVariables> {
    document = GetStatisticsFromProviderDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTopAssistsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTopAssists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"league"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"season"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTopAssists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"league"},"value":{"kind":"Variable","name":{"kind":"Name","value":"league"}}},{"kind":"Argument","name":{"kind":"Name","value":"season"},"value":{"kind":"Variable","name":{"kind":"Name","value":"season"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"league"}},{"kind":"Field","name":{"kind":"Name","value":"topAssists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"player"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"birth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"place"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nationality"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"injured"}},{"kind":"Field","name":{"kind":"Name","value":"photo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"flag"}},{"kind":"Field","name":{"kind":"Name","value":"season"}}]}},{"kind":"Field","name":{"kind":"Name","value":"games"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appearences"}},{"kind":"Field","name":{"kind":"Name","value":"lineups"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"captain"}}]}},{"kind":"Field","name":{"kind":"Name","value":"substitutes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamIn"}},{"kind":"Field","name":{"kind":"Name","value":"teamOut"}},{"kind":"Field","name":{"kind":"Name","value":"bench"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"on"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"conceded"}},{"kind":"Field","name":{"kind":"Name","value":"assists"}},{"kind":"Field","name":{"kind":"Name","value":"saves"}}]}},{"kind":"Field","name":{"kind":"Name","value":"passes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"accuracy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tackles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}},{"kind":"Field","name":{"kind":"Name","value":"interceptions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"won"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dribbles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attempts"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"past"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fouls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"drawn"}},{"kind":"Field","name":{"kind":"Name","value":"committed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yellow"}},{"kind":"Field","name":{"kind":"Name","value":"yellowred"}},{"kind":"Field","name":{"kind":"Name","value":"red"}}]}},{"kind":"Field","name":{"kind":"Name","value":"penalty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"won"}},{"kind":"Field","name":{"kind":"Name","value":"commited"}},{"kind":"Field","name":{"kind":"Name","value":"scored"}},{"kind":"Field","name":{"kind":"Name","value":"missed"}},{"kind":"Field","name":{"kind":"Name","value":"saved"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTopAssistsGQL extends Apollo.Query<GetTopAssistsQuery, GetTopAssistsQueryVariables> {
    document = GetTopAssistsDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTopRedCardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTopRedCards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"league"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"season"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTopRedCards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"league"},"value":{"kind":"Variable","name":{"kind":"Name","value":"league"}}},{"kind":"Argument","name":{"kind":"Name","value":"season"},"value":{"kind":"Variable","name":{"kind":"Name","value":"season"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"league"}},{"kind":"Field","name":{"kind":"Name","value":"topRedCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"player"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"birth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"place"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nationality"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"injured"}},{"kind":"Field","name":{"kind":"Name","value":"photo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"flag"}},{"kind":"Field","name":{"kind":"Name","value":"season"}}]}},{"kind":"Field","name":{"kind":"Name","value":"games"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appearences"}},{"kind":"Field","name":{"kind":"Name","value":"lineups"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"captain"}}]}},{"kind":"Field","name":{"kind":"Name","value":"substitutes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamIn"}},{"kind":"Field","name":{"kind":"Name","value":"teamOut"}},{"kind":"Field","name":{"kind":"Name","value":"bench"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"on"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"conceded"}},{"kind":"Field","name":{"kind":"Name","value":"assists"}},{"kind":"Field","name":{"kind":"Name","value":"saves"}}]}},{"kind":"Field","name":{"kind":"Name","value":"passes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"accuracy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tackles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}},{"kind":"Field","name":{"kind":"Name","value":"interceptions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"won"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dribbles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attempts"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"past"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fouls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"drawn"}},{"kind":"Field","name":{"kind":"Name","value":"committed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yellow"}},{"kind":"Field","name":{"kind":"Name","value":"yellowred"}},{"kind":"Field","name":{"kind":"Name","value":"red"}}]}},{"kind":"Field","name":{"kind":"Name","value":"penalty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"won"}},{"kind":"Field","name":{"kind":"Name","value":"commited"}},{"kind":"Field","name":{"kind":"Name","value":"scored"}},{"kind":"Field","name":{"kind":"Name","value":"missed"}},{"kind":"Field","name":{"kind":"Name","value":"saved"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTopRedCardsGQL extends Apollo.Query<GetTopRedCardsQuery, GetTopRedCardsQueryVariables> {
    document = GetTopRedCardsDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTopScorersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTopScorers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"league"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"season"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTopScorers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"league"},"value":{"kind":"Variable","name":{"kind":"Name","value":"league"}}},{"kind":"Argument","name":{"kind":"Name","value":"season"},"value":{"kind":"Variable","name":{"kind":"Name","value":"season"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"league"}},{"kind":"Field","name":{"kind":"Name","value":"topScorers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"player"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"birth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"place"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nationality"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"injured"}},{"kind":"Field","name":{"kind":"Name","value":"photo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"flag"}},{"kind":"Field","name":{"kind":"Name","value":"season"}}]}},{"kind":"Field","name":{"kind":"Name","value":"games"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appearences"}},{"kind":"Field","name":{"kind":"Name","value":"lineups"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"captain"}}]}},{"kind":"Field","name":{"kind":"Name","value":"substitutes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamIn"}},{"kind":"Field","name":{"kind":"Name","value":"teamOut"}},{"kind":"Field","name":{"kind":"Name","value":"bench"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"on"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"conceded"}},{"kind":"Field","name":{"kind":"Name","value":"assists"}},{"kind":"Field","name":{"kind":"Name","value":"saves"}}]}},{"kind":"Field","name":{"kind":"Name","value":"passes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"accuracy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tackles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}},{"kind":"Field","name":{"kind":"Name","value":"interceptions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"won"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dribbles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attempts"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"past"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fouls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"drawn"}},{"kind":"Field","name":{"kind":"Name","value":"committed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yellow"}},{"kind":"Field","name":{"kind":"Name","value":"yellowred"}},{"kind":"Field","name":{"kind":"Name","value":"red"}}]}},{"kind":"Field","name":{"kind":"Name","value":"penalty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"won"}},{"kind":"Field","name":{"kind":"Name","value":"commited"}},{"kind":"Field","name":{"kind":"Name","value":"scored"}},{"kind":"Field","name":{"kind":"Name","value":"missed"}},{"kind":"Field","name":{"kind":"Name","value":"saved"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTopScorersGQL extends Apollo.Query<GetTopScorersQuery, GetTopScorersQueryVariables> {
    document = GetTopScorersDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTopYellowCardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTopYellowCards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"league"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"season"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTopYellowCards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"league"},"value":{"kind":"Variable","name":{"kind":"Name","value":"league"}}},{"kind":"Argument","name":{"kind":"Name","value":"season"},"value":{"kind":"Variable","name":{"kind":"Name","value":"season"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"league"}},{"kind":"Field","name":{"kind":"Name","value":"topYellowCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"player"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"birth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"place"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nationality"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"injured"}},{"kind":"Field","name":{"kind":"Name","value":"photo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"flag"}},{"kind":"Field","name":{"kind":"Name","value":"season"}}]}},{"kind":"Field","name":{"kind":"Name","value":"games"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appearences"}},{"kind":"Field","name":{"kind":"Name","value":"lineups"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"captain"}}]}},{"kind":"Field","name":{"kind":"Name","value":"substitutes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamIn"}},{"kind":"Field","name":{"kind":"Name","value":"teamOut"}},{"kind":"Field","name":{"kind":"Name","value":"bench"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"on"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"conceded"}},{"kind":"Field","name":{"kind":"Name","value":"assists"}},{"kind":"Field","name":{"kind":"Name","value":"saves"}}]}},{"kind":"Field","name":{"kind":"Name","value":"passes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"accuracy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tackles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}},{"kind":"Field","name":{"kind":"Name","value":"interceptions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"won"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dribbles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attempts"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"past"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fouls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"drawn"}},{"kind":"Field","name":{"kind":"Name","value":"committed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yellow"}},{"kind":"Field","name":{"kind":"Name","value":"yellowred"}},{"kind":"Field","name":{"kind":"Name","value":"red"}}]}},{"kind":"Field","name":{"kind":"Name","value":"penalty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"won"}},{"kind":"Field","name":{"kind":"Name","value":"commited"}},{"kind":"Field","name":{"kind":"Name","value":"scored"}},{"kind":"Field","name":{"kind":"Name","value":"missed"}},{"kind":"Field","name":{"kind":"Name","value":"saved"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTopYellowCardsGQL extends Apollo.Query<GetTopYellowCardsQuery, GetTopYellowCardsQueryVariables> {
    document = GetTopYellowCardsDocument;
    client = 'sport';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginUserByTargetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"loginUserByTarget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginUserByTargetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginUserByTarget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expiresIn"}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"validationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginUserByTargetGQL extends Apollo.Mutation<LoginUserByTargetMutation, LoginUserByTargetMutationVariables> {
    document = LoginUserByTargetDocument;
    client = 'auth';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginForTargetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loginForTarget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"login"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IPhoneInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetACIInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginForTarget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"login"},"value":{"kind":"Variable","name":{"kind":"Name","value":"login"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expiresIn"}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginForTargetGQL extends Apollo.Query<LoginForTargetQuery, LoginForTargetQueryVariables> {
    document = LoginForTargetDocument;
    client = 'auth';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }